var startProcessing = new Date();
document._write = document.write;
document._writeln = document.writeln;
console._log = console.log;
console.log = function()
{
    var data = Array.prototype.slice.call(arguments, console.log.length);
    var timestampColor = 'color:#2980b9;';
    var componentColor = 'color:#8e44ad;';
    var typeColor = 'color:#16a085;';
    var normalColor = 'color:#ffffff;';
    var timestamp = '%c[' + new Date().toLocaleTimeString() + '] ';
    var isIE = document.querySelector('html').getAttribute('data-ua-browser') === 'msie'
        || document.querySelector('html').getAttribute('data-ua-browser') === 'edge';
    if (isIE) {
        console._log.apply(this, data);
    } else {
        var colors = [timestampColor, componentColor, typeColor, normalColor];
        if (data.indexOf('[DEBUG]') !== -1) {
            var debugColor = 'color:#d35400;';
            colors.splice(1, 0, debugColor);
        }
        for (var i = 0; i < data.length; i++) {
            if ((typeof data[i] === 'string' || typeof data[i] === 'number' || data[i] === null || data[i] === undefined) && i < colors.length - 1) {
                switch (data[i]) {
                    case null:
                        data[i] = '%cnull'; break;
                    case undefined:
                        data[i] = '%cundefined'; break;
                    default:
                        data[i] = '%c' + data[i];
                }
            }
        }
        var apply = [];
        apply.push(timestamp + data.join(' '));
        for(var i = 0; i <= data.length; i++) {
            if (colors[i]) {
                apply.push(colors[i]);
            }
        }
        console._log.apply(this, apply)
    }
};
(function () {
    if ( typeof window.CustomEvent === "function" ) return false;
    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();
( function( global, factory ) {
    "use strict";
    if ( typeof module === "object" && typeof module.exports === "object" ) {
        module.exports = global.document ?
            factory( global, true ) :
            function( w ) {
                if ( !w.document ) {
                    throw new Error( "jQuery requires a window with a document" );
                }
                return factory( w );
            };
    } else {
        factory( global );
    }
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
    "use strict";
    var arr = [];
    var document = window.document;
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var concat = arr.concat;
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call( Object );
    var support = {};
    var isFunction = function isFunction( obj ) {
        return typeof obj === "function" && typeof obj.nodeType !== "number";
    };
    var isWindow = function isWindow( obj ) {
        return obj != null && obj === obj.window;
    };
    var preservedScriptAttributes = {
        type: true,
        src: true,
        noModule: true
    };
    function DOMEval( code, doc, node ) {
        doc = doc || document;
        var i,
            script = doc.createElement( "script" );
        script.text = code;
        if ( node ) {
            for ( i in preservedScriptAttributes ) {
                if ( node[ i ] ) {
                    script[ i ] = node[ i ];
                }
            }
        }
        doc.head.appendChild( script ).parentNode.removeChild( script );
    }
    function toType( obj ) {
        if ( obj == null ) {
            return obj + "";
        }
        return typeof obj === "object" || typeof obj === "function" ?
            class2type[ toString.call( obj ) ] || "object" :
            typeof obj;
    }
    var
        version = "3.3.1",
        jQuery = function( selector, context ) {
            return new jQuery.fn.init( selector, context );
        },
        rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    jQuery.fn = jQuery.prototype = {
        jquery: version,
        constructor: jQuery,
        length: 0,
        toArray: function() {
            return slice.call( this );
        },
        get: function( num ) {
            if ( num == null ) {
                return slice.call( this );
            }
            return num < 0 ? this[ num + this.length ] : this[ num ];
        },
        pushStack: function( elems ) {
            var ret = jQuery.merge( this.constructor(), elems );
            ret.prevObject = this;
            return ret;
        },
        each: function( callback ) {
            return jQuery.each( this, callback );
        },
        map: function( callback ) {
            return this.pushStack( jQuery.map( this, function( elem, i ) {
                return callback.call( elem, i, elem );
            } ) );
        },
        slice: function() {
            return this.pushStack( slice.apply( this, arguments ) );
        },
        first: function() {
            return this.eq( 0 );
        },
        last: function() {
            return this.eq( -1 );
        },
        eq: function( i ) {
            var len = this.length,
                j = +i + ( i < 0 ? len : 0 );
            return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone,
            target = arguments[ 0 ] || {},
            i = 1,
            length = arguments.length,
            deep = false;
        if ( typeof target === "boolean" ) {
            deep = target;
            target = arguments[ i ] || {};
            i++;
        }
        if ( typeof target !== "object" && !isFunction( target ) ) {
            target = {};
        }
        if ( i === length ) {
            target = this;
            i--;
        }
        for ( ; i < length; i++ ) {
            if ( ( options = arguments[ i ] ) != null ) {
                for ( name in options ) {
                    src = target[ name ];
                    copy = options[ name ];
                    if ( target === copy ) {
                        continue;
                    }
                    if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                        ( copyIsArray = Array.isArray( copy ) ) ) ) {
                        if ( copyIsArray ) {
                            copyIsArray = false;
                            clone = src && Array.isArray( src ) ? src : [];
                        } else {
                            clone = src && jQuery.isPlainObject( src ) ? src : {};
                        }
                        target[ name ] = jQuery.extend( deep, clone, copy );
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy;
                    }
                }
            }
        }
        return target;
    };
    jQuery.extend( {
        expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
        isReady: true,
        error: function( msg ) {
            throw new Error( msg );
        },
        noop: function() {},
        isPlainObject: function( obj ) {
            var proto, Ctor;
            if ( !obj || toString.call( obj ) !== "[object Object]" ) {
                return false;
            }
            proto = getProto( obj );
            if ( !proto ) {
                return true;
            }
            Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
            return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
        },
        isEmptyObject: function( obj ) {
            var name;
            for ( name in obj ) {
                return false;
            }
            return true;
        },
        globalEval: function( code ) {
            DOMEval( code );
        },
        each: function( obj, callback ) {
            var length, i = 0;
            if ( isArrayLike( obj ) ) {
                length = obj.length;
                for ( ; i < length; i++ ) {
                    if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                        break;
                    }
                }
            } else {
                for ( i in obj ) {
                    if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                        break;
                    }
                }
            }
            return obj;
        },
        trim: function( text ) {
            return text == null ?
                "" :
                ( text + "" ).replace( rtrim, "" );
        },
        makeArray: function( arr, results ) {
            var ret = results || [];
            if ( arr != null ) {
                if ( isArrayLike( Object( arr ) ) ) {
                    jQuery.merge( ret,
                        typeof arr === "string" ?
                            [ arr ] : arr
                    );
                } else {
                    push.call( ret, arr );
                }
            }
            return ret;
        },
        inArray: function( elem, arr, i ) {
            return arr == null ? -1 : indexOf.call( arr, elem, i );
        },
        merge: function( first, second ) {
            var len = +second.length,
                j = 0,
                i = first.length;
            for ( ; j < len; j++ ) {
                first[ i++ ] = second[ j ];
            }
            first.length = i;
            return first;
        },
        grep: function( elems, callback, invert ) {
            var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;
            for ( ; i < length; i++ ) {
                callbackInverse = !callback( elems[ i ], i );
                if ( callbackInverse !== callbackExpect ) {
                    matches.push( elems[ i ] );
                }
            }
            return matches;
        },
        map: function( elems, callback, arg ) {
            var length, value,
                i = 0,
                ret = [];
            if ( isArrayLike( elems ) ) {
                length = elems.length;
                for ( ; i < length; i++ ) {
                    value = callback( elems[ i ], i, arg );
                    if ( value != null ) {
                        ret.push( value );
                    }
                }
            } else {
                for ( i in elems ) {
                    value = callback( elems[ i ], i, arg );
                    if ( value != null ) {
                        ret.push( value );
                    }
                }
            }
            return concat.apply( [], ret );
        },
        guid: 1,
        support: support
    } );
    if ( typeof Symbol === "function" ) {
        jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
    }
    jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
        function( i, name ) {
            class2type[ "[object " + name + "]" ] = name.toLowerCase();
        } );
    function isArrayLike( obj ) {
        var length = !!obj && "length" in obj && obj.length,
            type = toType( obj );
        if ( isFunction( obj ) || isWindow( obj ) ) {
            return false;
        }
        return type === "array" || length === 0 ||
            typeof length === "number" && length > 0 && ( length - 1 ) in obj;
    }
    var Sizzle =
        (function( window ) {
            var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                sortOrder = function( a, b ) {
                    if ( a === b ) {
                        hasDuplicate = true;
                    }
                    return 0;
                },
                hasOwn = ({}).hasOwnProperty,
                arr = [],
                pop = arr.pop,
                push_native = arr.push,
                push = arr.push,
                slice = arr.slice,
                indexOf = function( list, elem ) {
                    var i = 0,
                        len = list.length;
                    for ( ; i < len; i++ ) {
                        if ( list[i] === elem ) {
                            return i;
                        }
                    }
                    return -1;
                },
                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                whitespace = "[\\x20\\t\\r\\n\\f]",
                identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
                    "*([*^$|!~]?=)" + whitespace +
                    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
                    "*\\]",
                pseudos = ":(" + identifier + ")(?:\\((" +
                    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
                    ".*" +
                    ")\\)|)",
                rwhitespace = new RegExp( whitespace + "+", "g" ),
                rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
                rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
                rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
                rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
                rpseudo = new RegExp( pseudos ),
                ridentifier = new RegExp( "^" + identifier + "$" ),
                matchExpr = {
                    "ID": new RegExp( "^#(" + identifier + ")" ),
                    "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
                    "TAG": new RegExp( "^(" + identifier + "|[*])" ),
                    "ATTR": new RegExp( "^" + attributes ),
                    "PSEUDO": new RegExp( "^" + pseudos ),
                    "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
                        "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
                        "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
                    "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
                    "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                        whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
                },
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,
                rnative = /^[^{]+\{\s*\[native \w/,
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                rsibling = /[+~]/,
                runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
                funescape = function( _, escaped, escapedWhitespace ) {
                    var high = "0x" + escaped - 0x10000;
                    return high !== high || escapedWhitespace ?
                        escaped :
                        high < 0 ?
                            String.fromCharCode( high + 0x10000 ) :
                            String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
                },
                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function( ch, asCodePoint ) {
                    if ( asCodePoint ) {
                        if ( ch === "\0" ) {
                            return "\uFFFD";
                        }
                        return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
                    }
                    return "\\" + ch;
                },
                unloadHandler = function() {
                    setDocument();
                },
                disabledAncestor = addCombinator(
                    function( elem ) {
                        return elem.disabled === true && ("form" in elem || "label" in elem);
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                push.apply(
                    (arr = slice.call( preferredDoc.childNodes )),
                    preferredDoc.childNodes
                );
                arr[ preferredDoc.childNodes.length ].nodeType;
            } catch ( e ) {
                push = { apply: arr.length ?
                        function( target, els ) {
                            push_native.apply( target, slice.call(els) );
                        } :
                        function( target, els ) {
                            var j = target.length,
                                i = 0;
                            while ( (target[j++] = els[i++]) ) {}
                            target.length = j - 1;
                        }
                };
            }
            function Sizzle( selector, context, results, seed ) {
                var m, i, elem, nid, match, groups, newSelector,
                    newContext = context && context.ownerDocument,
                    nodeType = context ? context.nodeType : 9;
                results = results || [];
                if ( typeof selector !== "string" || !selector ||
                    nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
                    return results;
                }
                if ( !seed ) {
                    if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
                        setDocument( context );
                    }
                    context = context || document;
                    if ( documentIsHTML ) {
                        if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
                            if ( (m = match[1]) ) {
                                if ( nodeType === 9 ) {
                                    if ( (elem = context.getElementById( m )) ) {
                                        if ( elem.id === m ) {
                                            results.push( elem );
                                            return results;
                                        }
                                    } else {
                                        return results;
                                    }
                                } else {
                                    if ( newContext && (elem = newContext.getElementById( m )) &&
                                        contains( context, elem ) &&
                                        elem.id === m ) {
                                        results.push( elem );
                                        return results;
                                    }
                                }
                            } else if ( match[2] ) {
                                push.apply( results, context.getElementsByTagName( selector ) );
                                return results;
                            } else if ( (m = match[3]) && support.getElementsByClassName &&
                                context.getElementsByClassName ) {
                                push.apply( results, context.getElementsByClassName( m ) );
                                return results;
                            }
                        }
                        if ( support.qsa &&
                            !compilerCache[ selector + " " ] &&
                            (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
                            if ( nodeType !== 1 ) {
                                newContext = context;
                                newSelector = selector;
                            } else if ( context.nodeName.toLowerCase() !== "object" ) {
                                if ( (nid = context.getAttribute( "id" )) ) {
                                    nid = nid.replace( rcssescape, fcssescape );
                                } else {
                                    context.setAttribute( "id", (nid = expando) );
                                }
                                groups = tokenize( selector );
                                i = groups.length;
                                while ( i-- ) {
                                    groups[i] = "#" + nid + " " + toSelector( groups[i] );
                                }
                                newSelector = groups.join( "," );
                                newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                                    context;
                            }
                            if ( newSelector ) {
                                try {
                                    push.apply( results,
                                        newContext.querySelectorAll( newSelector )
                                    );
                                    return results;
                                } catch ( qsaError ) {
                                } finally {
                                    if ( nid === expando ) {
                                        context.removeAttribute( "id" );
                                    }
                                }
                            }
                        }
                    }
                }
                return select( selector.replace( rtrim, "$1" ), context, results, seed );
            }
            function createCache() {
                var keys = [];
                function cache( key, value ) {
                    if ( keys.push( key + " " ) > Expr.cacheLength ) {
                        delete cache[ keys.shift() ];
                    }
                    return (cache[ key + " " ] = value);
                }
                return cache;
            }
            function markFunction( fn ) {
                fn[ expando ] = true;
                return fn;
            }
            function assert( fn ) {
                var el = document.createElement("fieldset");
                try {
                    return !!fn( el );
                } catch (e) {
                    return false;
                } finally {
                    if ( el.parentNode ) {
                        el.parentNode.removeChild( el );
                    }
                    el = null;
                }
            }
            function addHandle( attrs, handler ) {
                var arr = attrs.split("|"),
                    i = arr.length;
                while ( i-- ) {
                    Expr.attrHandle[ arr[i] ] = handler;
                }
            }
            function siblingCheck( a, b ) {
                var cur = b && a,
                    diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                        a.sourceIndex - b.sourceIndex;
                if ( diff ) {
                    return diff;
                }
                if ( cur ) {
                    while ( (cur = cur.nextSibling) ) {
                        if ( cur === b ) {
                            return -1;
                        }
                    }
                }
                return a ? 1 : -1;
            }
            function createInputPseudo( type ) {
                return function( elem ) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === type;
                };
            }
            function createButtonPseudo( type ) {
                return function( elem ) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && elem.type === type;
                };
            }
            function createDisabledPseudo( disabled ) {
                return function( elem ) {
                    if ( "form" in elem ) {
                        if ( elem.parentNode && elem.disabled === false ) {
                            if ( "label" in elem ) {
                                if ( "label" in elem.parentNode ) {
                                    return elem.parentNode.disabled === disabled;
                                } else {
                                    return elem.disabled === disabled;
                                }
                            }
                            return elem.isDisabled === disabled ||
                                elem.isDisabled !== !disabled &&
                                disabledAncestor( elem ) === disabled;
                        }
                        return elem.disabled === disabled;
                    } else if ( "label" in elem ) {
                        return elem.disabled === disabled;
                    }
                    return false;
                };
            }
            function createPositionalPseudo( fn ) {
                return markFunction(function( argument ) {
                    argument = +argument;
                    return markFunction(function( seed, matches ) {
                        var j,
                            matchIndexes = fn( [], seed.length, argument ),
                            i = matchIndexes.length;
                        while ( i-- ) {
                            if ( seed[ (j = matchIndexes[i]) ] ) {
                                seed[j] = !(matches[j] = seed[j]);
                            }
                        }
                    });
                });
            }
            function testContext( context ) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
            }
            support = Sizzle.support = {};
            isXML = Sizzle.isXML = function( elem ) {
                var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                return documentElement ? documentElement.nodeName !== "HTML" : false;
            };
            setDocument = Sizzle.setDocument = function( node ) {
                var hasCompare, subWindow,
                    doc = node ? node.ownerDocument || node : preferredDoc;
                if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
                    return document;
                }
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML( document );
                if ( preferredDoc !== document &&
                    (subWindow = document.defaultView) && subWindow.top !== subWindow ) {
                    if ( subWindow.addEventListener ) {
                        subWindow.addEventListener( "unload", unloadHandler, false );
                    } else if ( subWindow.attachEvent ) {
                        subWindow.attachEvent( "onunload", unloadHandler );
                    }
                }
                support.attributes = assert(function( el ) {
                    el.className = "i";
                    return !el.getAttribute("className");
                });
                support.getElementsByTagName = assert(function( el ) {
                    el.appendChild( document.createComment("") );
                    return !el.getElementsByTagName("*").length;
                });
                support.getElementsByClassName = rnative.test( document.getElementsByClassName );
                support.getById = assert(function( el ) {
                    docElem.appendChild( el ).id = expando;
                    return !document.getElementsByName || !document.getElementsByName( expando ).length;
                });
                if ( support.getById ) {
                    Expr.filter["ID"] = function( id ) {
                        var attrId = id.replace( runescape, funescape );
                        return function( elem ) {
                            return elem.getAttribute("id") === attrId;
                        };
                    };
                    Expr.find["ID"] = function( id, context ) {
                        if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                            var elem = context.getElementById( id );
                            return elem ? [ elem ] : [];
                        }
                    };
                } else {
                    Expr.filter["ID"] =  function( id ) {
                        var attrId = id.replace( runescape, funescape );
                        return function( elem ) {
                            var node = typeof elem.getAttributeNode !== "undefined" &&
                                elem.getAttributeNode("id");
                            return node && node.value === attrId;
                        };
                    };
                    Expr.find["ID"] = function( id, context ) {
                        if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                            var node, i, elems,
                                elem = context.getElementById( id );
                            if ( elem ) {
                                node = elem.getAttributeNode("id");
                                if ( node && node.value === id ) {
                                    return [ elem ];
                                }
                                elems = context.getElementsByName( id );
                                i = 0;
                                while ( (elem = elems[i++]) ) {
                                    node = elem.getAttributeNode("id");
                                    if ( node && node.value === id ) {
                                        return [ elem ];
                                    }
                                }
                            }
                            return [];
                        }
                    };
                }
                Expr.find["TAG"] = support.getElementsByTagName ?
                    function( tag, context ) {
                        if ( typeof context.getElementsByTagName !== "undefined" ) {
                            return context.getElementsByTagName( tag );
                        } else if ( support.qsa ) {
                            return context.querySelectorAll( tag );
                        }
                    } :
                    function( tag, context ) {
                        var elem,
                            tmp = [],
                            i = 0,
                            results = context.getElementsByTagName( tag );
                        if ( tag === "*" ) {
                            while ( (elem = results[i++]) ) {
                                if ( elem.nodeType === 1 ) {
                                    tmp.push( elem );
                                }
                            }
                            return tmp;
                        }
                        return results;
                    };
                Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
                    if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
                        return context.getElementsByClassName( className );
                    }
                };
                rbuggyMatches = [];
                rbuggyQSA = [];
                if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
                    assert(function( el ) {
                        docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                            "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                            "<option selected=''></option></select>";
                        if ( el.querySelectorAll("[msallowcapture^='']").length ) {
                            rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
                        }
                        if ( !el.querySelectorAll("[selected]").length ) {
                            rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
                        }
                        if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                            rbuggyQSA.push("~=");
                        }
                        if ( !el.querySelectorAll(":checked").length ) {
                            rbuggyQSA.push(":checked");
                        }
                        if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                            rbuggyQSA.push(".#.+[+~]");
                        }
                    });
                    assert(function( el ) {
                        el.innerHTML = "<a href='' disabled='disabled'></a>" +
                            "<select disabled='disabled'><option/></select>";
                        var input = document.createElement("input");
                        input.setAttribute( "type", "hidden" );
                        el.appendChild( input ).setAttribute( "name", "D" );
                        if ( el.querySelectorAll("[name=d]").length ) {
                            rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
                        }
                        if ( el.querySelectorAll(":enabled").length !== 2 ) {
                            rbuggyQSA.push( ":enabled", ":disabled" );
                        }
                        docElem.appendChild( el ).disabled = true;
                        if ( el.querySelectorAll(":disabled").length !== 2 ) {
                            rbuggyQSA.push( ":enabled", ":disabled" );
                        }
                        el.querySelectorAll("*,:x");
                        rbuggyQSA.push(",.*:");
                    });
                }
                if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
                    docElem.webkitMatchesSelector ||
                    docElem.mozMatchesSelector ||
                    docElem.oMatchesSelector ||
                    docElem.msMatchesSelector) )) ) {
                    assert(function( el ) {
                        support.disconnectedMatch = matches.call( el, "*" );
                        matches.call( el, "[s!='']:x" );
                        rbuggyMatches.push( "!=", pseudos );
                    });
                }
                rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
                rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
                hasCompare = rnative.test( docElem.compareDocumentPosition );
                contains = hasCompare || rnative.test( docElem.contains ) ?
                    function( a, b ) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                            bup = b && b.parentNode;
                        return a === bup || !!( bup && bup.nodeType === 1 && (
                            adown.contains ?
                                adown.contains( bup ) :
                                a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
                        ));
                    } :
                    function( a, b ) {
                        if ( b ) {
                            while ( (b = b.parentNode) ) {
                                if ( b === a ) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                sortOrder = hasCompare ?
                    function( a, b ) {
                        if ( a === b ) {
                            hasDuplicate = true;
                            return 0;
                        }
                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                        if ( compare ) {
                            return compare;
                        }
                        compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
                            a.compareDocumentPosition( b ) :
                            1;
                        if ( compare & 1 ||
                            (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
                            if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
                                return -1;
                            }
                            if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
                                return 1;
                            }
                            return sortInput ?
                                ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                0;
                        }
                        return compare & 4 ? -1 : 1;
                    } :
                    function( a, b ) {
                        if ( a === b ) {
                            hasDuplicate = true;
                            return 0;
                        }
                        var cur,
                            i = 0,
                            aup = a.parentNode,
                            bup = b.parentNode,
                            ap = [ a ],
                            bp = [ b ];
                        if ( !aup || !bup ) {
                            return a === document ? -1 :
                                b === document ? 1 :
                                    aup ? -1 :
                                        bup ? 1 :
                                            sortInput ?
                                                ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                                0;
                        } else if ( aup === bup ) {
                            return siblingCheck( a, b );
                        }
                        cur = a;
                        while ( (cur = cur.parentNode) ) {
                            ap.unshift( cur );
                        }
                        cur = b;
                        while ( (cur = cur.parentNode) ) {
                            bp.unshift( cur );
                        }
                        while ( ap[i] === bp[i] ) {
                            i++;
                        }
                        return i ?
                            siblingCheck( ap[i], bp[i] ) :
                            ap[i] === preferredDoc ? -1 :
                                bp[i] === preferredDoc ? 1 :
                                    0;
                    };
                return document;
            };
            Sizzle.matches = function( expr, elements ) {
                return Sizzle( expr, null, null, elements );
            };
            Sizzle.matchesSelector = function( elem, expr ) {
                if ( ( elem.ownerDocument || elem ) !== document ) {
                    setDocument( elem );
                }
                expr = expr.replace( rattributeQuotes, "='$1']" );
                if ( support.matchesSelector && documentIsHTML &&
                    !compilerCache[ expr + " " ] &&
                    ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
                    ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
                    try {
                        var ret = matches.call( elem, expr );
                        if ( ret || support.disconnectedMatch ||
                            elem.document && elem.document.nodeType !== 11 ) {
                            return ret;
                        }
                    } catch (e) {}
                }
                return Sizzle( expr, document, null, [ elem ] ).length > 0;
            };
            Sizzle.contains = function( context, elem ) {
                if ( ( context.ownerDocument || context ) !== document ) {
                    setDocument( context );
                }
                return contains( context, elem );
            };
            Sizzle.attr = function( elem, name ) {
                if ( ( elem.ownerDocument || elem ) !== document ) {
                    setDocument( elem );
                }
                var fn = Expr.attrHandle[ name.toLowerCase() ],
                    val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
                        fn( elem, name, !documentIsHTML ) :
                        undefined;
                return val !== undefined ?
                    val :
                    support.attributes || !documentIsHTML ?
                        elem.getAttribute( name ) :
                        (val = elem.getAttributeNode(name)) && val.specified ?
                            val.value :
                            null;
            };
            Sizzle.escape = function( sel ) {
                return (sel + "").replace( rcssescape, fcssescape );
            };
            Sizzle.error = function( msg ) {
                throw new Error( "Syntax error, unrecognized expression: " + msg );
            };
            Sizzle.uniqueSort = function( results ) {
                var elem,
                    duplicates = [],
                    j = 0,
                    i = 0;
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice( 0 );
                results.sort( sortOrder );
                if ( hasDuplicate ) {
                    while ( (elem = results[i++]) ) {
                        if ( elem === results[ i ] ) {
                            j = duplicates.push( i );
                        }
                    }
                    while ( j-- ) {
                        results.splice( duplicates[ j ], 1 );
                    }
                }
                sortInput = null;
                return results;
            };
            getText = Sizzle.getText = function( elem ) {
                var node,
                    ret = "",
                    i = 0,
                    nodeType = elem.nodeType;
                if ( !nodeType ) {
                    while ( (node = elem[i++]) ) {
                        ret += getText( node );
                    }
                } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
                    if ( typeof elem.textContent === "string" ) {
                        return elem.textContent;
                    } else {
                        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                            ret += getText( elem );
                        }
                    }
                } else if ( nodeType === 3 || nodeType === 4 ) {
                    return elem.nodeValue;
                }
                return ret;
            };
            Expr = Sizzle.selectors = {
                cacheLength: 50,
                createPseudo: markFunction,
                match: matchExpr,
                attrHandle: {},
                find: {},
                relative: {
                    ">": { dir: "parentNode", first: true },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: true },
                    "~": { dir: "previousSibling" }
                },
                preFilter: {
                    "ATTR": function( match ) {
                        match[1] = match[1].replace( runescape, funescape );
                        match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
                        if ( match[2] === "~=" ) {
                            match[3] = " " + match[3] + " ";
                        }
                        return match.slice( 0, 4 );
                    },
                    "CHILD": function( match ) {
                        match[1] = match[1].toLowerCase();
                        if ( match[1].slice( 0, 3 ) === "nth" ) {
                            if ( !match[3] ) {
                                Sizzle.error( match[0] );
                            }
                            match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
                            match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
                        } else if ( match[3] ) {
                            Sizzle.error( match[0] );
                        }
                        return match;
                    },
                    "PSEUDO": function( match ) {
                        var excess,
                            unquoted = !match[6] && match[2];
                        if ( matchExpr["CHILD"].test( match[0] ) ) {
                            return null;
                        }
                        if ( match[3] ) {
                            match[2] = match[4] || match[5] || "";
                        } else if ( unquoted && rpseudo.test( unquoted ) &&
                            (excess = tokenize( unquoted, true )) &&
                            (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
                            match[0] = match[0].slice( 0, excess );
                            match[2] = unquoted.slice( 0, excess );
                        }
                        return match.slice( 0, 3 );
                    }
                },
                filter: {
                    "TAG": function( nodeNameSelector ) {
                        var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
                        return nodeNameSelector === "*" ?
                            function() { return true; } :
                            function( elem ) {
                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                            };
                    },
                    "CLASS": function( className ) {
                        var pattern = classCache[ className + " " ];
                        return pattern ||
                            (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
                            classCache( className, function( elem ) {
                                return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
                            });
                    },
                    "ATTR": function( name, operator, check ) {
                        return function( elem ) {
                            var result = Sizzle.attr( elem, name );
                            if ( result == null ) {
                                return operator === "!=";
                            }
                            if ( !operator ) {
                                return true;
                            }
                            result += "";
                            return operator === "=" ? result === check :
                                operator === "!=" ? result !== check :
                                    operator === "^=" ? check && result.indexOf( check ) === 0 :
                                        operator === "*=" ? check && result.indexOf( check ) > -1 :
                                            operator === "$=" ? check && result.slice( -check.length ) === check :
                                                operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                                                    operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                                                        false;
                        };
                    },
                    "CHILD": function( type, what, argument, first, last ) {
                        var simple = type.slice( 0, 3 ) !== "nth",
                            forward = type.slice( -4 ) !== "last",
                            ofType = what === "of-type";
                        return first === 1 && last === 0 ?
                            function( elem ) {
                                return !!elem.parentNode;
                            } :
                            function( elem, context, xml ) {
                                var cache, uniqueCache, outerCache, node, nodeIndex, start,
                                    dir = simple !== forward ? "nextSibling" : "previousSibling",
                                    parent = elem.parentNode,
                                    name = ofType && elem.nodeName.toLowerCase(),
                                    useCache = !xml && !ofType,
                                    diff = false;
                                if ( parent ) {
                                    if ( simple ) {
                                        while ( dir ) {
                                            node = elem;
                                            while ( (node = node[ dir ]) ) {
                                                if ( ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1 ) {
                                                    return false;
                                                }
                                            }
                                            start = dir = type === "only" && !start && "nextSibling";
                                        }
                                        return true;
                                    }
                                    start = [ forward ? parent.firstChild : parent.lastChild ];
                                    if ( forward && useCache ) {
                                        node = parent;
                                        outerCache = node[ expando ] || (node[ expando ] = {});
                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                            (outerCache[ node.uniqueID ] = {});
                                        cache = uniqueCache[ type ] || [];
                                        nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                        diff = nodeIndex && cache[ 2 ];
                                        node = nodeIndex && parent.childNodes[ nodeIndex ];
                                        while ( (node = ++nodeIndex && node && node[ dir ] ||
                                            (diff = nodeIndex = 0) || start.pop()) ) {
                                            if ( node.nodeType === 1 && ++diff && node === elem ) {
                                                uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                                break;
                                            }
                                        }
                                    } else {
                                        if ( useCache ) {
                                            node = elem;
                                            outerCache = node[ expando ] || (node[ expando ] = {});
                                            uniqueCache = outerCache[ node.uniqueID ] ||
                                                (outerCache[ node.uniqueID ] = {});
                                            cache = uniqueCache[ type ] || [];
                                            nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                            diff = nodeIndex;
                                        }
                                        if ( diff === false ) {
                                            while ( (node = ++nodeIndex && node && node[ dir ] ||
                                                (diff = nodeIndex = 0) || start.pop()) ) {
                                                if ( ( ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1 ) &&
                                                    ++diff ) {
                                                    if ( useCache ) {
                                                        outerCache = node[ expando ] || (node[ expando ] = {});
                                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                                            (outerCache[ node.uniqueID ] = {});
                                                        uniqueCache[ type ] = [ dirruns, diff ];
                                                    }
                                                    if ( node === elem ) {
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    diff -= last;
                                    return diff === first || ( diff % first === 0 && diff / first >= 0 );
                                }
                            };
                    },
                    "PSEUDO": function( pseudo, argument ) {
                        var args,
                            fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                                Sizzle.error( "unsupported pseudo: " + pseudo );
                        if ( fn[ expando ] ) {
                            return fn( argument );
                        }
                        if ( fn.length > 1 ) {
                            args = [ pseudo, pseudo, "", argument ];
                            return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                                markFunction(function( seed, matches ) {
                                    var idx,
                                        matched = fn( seed, argument ),
                                        i = matched.length;
                                    while ( i-- ) {
                                        idx = indexOf( seed, matched[i] );
                                        seed[ idx ] = !( matches[ idx ] = matched[i] );
                                    }
                                }) :
                                function( elem ) {
                                    return fn( elem, 0, args );
                                };
                        }
                        return fn;
                    }
                },
                pseudos: {
                    "not": markFunction(function( selector ) {
                        var input = [],
                            results = [],
                            matcher = compile( selector.replace( rtrim, "$1" ) );
                        return matcher[ expando ] ?
                            markFunction(function( seed, matches, context, xml ) {
                                var elem,
                                    unmatched = matcher( seed, null, xml, [] ),
                                    i = seed.length;
                                while ( i-- ) {
                                    if ( (elem = unmatched[i]) ) {
                                        seed[i] = !(matches[i] = elem);
                                    }
                                }
                            }) :
                            function( elem, context, xml ) {
                                input[0] = elem;
                                matcher( input, null, xml, results );
                                input[0] = null;
                                return !results.pop();
                            };
                    }),
                    "has": markFunction(function( selector ) {
                        return function( elem ) {
                            return Sizzle( selector, elem ).length > 0;
                        };
                    }),
                    "contains": markFunction(function( text ) {
                        text = text.replace( runescape, funescape );
                        return function( elem ) {
                            return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
                        };
                    }),
                    "lang": markFunction( function( lang ) {
                        if ( !ridentifier.test(lang || "") ) {
                            Sizzle.error( "unsupported lang: " + lang );
                        }
                        lang = lang.replace( runescape, funescape ).toLowerCase();
                        return function( elem ) {
                            var elemLang;
                            do {
                                if ( (elemLang = documentIsHTML ?
                                    elem.lang :
                                    elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
                                    elemLang = elemLang.toLowerCase();
                                    return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                                }
                            } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
                            return false;
                        };
                    }),
                    "target": function( elem ) {
                        var hash = window.location && window.location.hash;
                        return hash && hash.slice( 1 ) === elem.id;
                    },
                    "root": function( elem ) {
                        return elem === docElem;
                    },
                    "focus": function( elem ) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },
                    "enabled": createDisabledPseudo( false ),
                    "disabled": createDisabledPseudo( true ),
                    "checked": function( elem ) {
                        var nodeName = elem.nodeName.toLowerCase();
                        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
                    },
                    "selected": function( elem ) {
                        if ( elem.parentNode ) {
                            elem.parentNode.selectedIndex;
                        }
                        return elem.selected === true;
                    },
                    "empty": function( elem ) {
                        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                            if ( elem.nodeType < 6 ) {
                                return false;
                            }
                        }
                        return true;
                    },
                    "parent": function( elem ) {
                        return !Expr.pseudos["empty"]( elem );
                    },
                    "header": function( elem ) {
                        return rheader.test( elem.nodeName );
                    },
                    "input": function( elem ) {
                        return rinputs.test( elem.nodeName );
                    },
                    "button": function( elem ) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === "button" || name === "button";
                    },
                    "text": function( elem ) {
                        var attr;
                        return elem.nodeName.toLowerCase() === "input" &&
                            elem.type === "text" &&
                            ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
                    },
                    "first": createPositionalPseudo(function() {
                        return [ 0 ];
                    }),
                    "last": createPositionalPseudo(function( matchIndexes, length ) {
                        return [ length - 1 ];
                    }),
                    "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        return [ argument < 0 ? argument + length : argument ];
                    }),
                    "even": createPositionalPseudo(function( matchIndexes, length ) {
                        var i = 0;
                        for ( ; i < length; i += 2 ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),
                    "odd": createPositionalPseudo(function( matchIndexes, length ) {
                        var i = 1;
                        for ( ; i < length; i += 2 ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),
                    "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        var i = argument < 0 ? argument + length : argument;
                        for ( ; --i >= 0; ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),
                    "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        var i = argument < 0 ? argument + length : argument;
                        for ( ; ++i < length; ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    })
                }
            };
            Expr.pseudos["nth"] = Expr.pseudos["eq"];
            for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
                Expr.pseudos[ i ] = createInputPseudo( i );
            }
            for ( i in { submit: true, reset: true } ) {
                Expr.pseudos[ i ] = createButtonPseudo( i );
            }
            function setFilters() {}
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();
            tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
                var matched, match, tokens, type,
                    soFar, groups, preFilters,
                    cached = tokenCache[ selector + " " ];
                if ( cached ) {
                    return parseOnly ? 0 : cached.slice( 0 );
                }
                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;
                while ( soFar ) {
                    if ( !matched || (match = rcomma.exec( soFar )) ) {
                        if ( match ) {
                            soFar = soFar.slice( match[0].length ) || soFar;
                        }
                        groups.push( (tokens = []) );
                    }
                    matched = false;
                    if ( (match = rcombinators.exec( soFar )) ) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            type: match[0].replace( rtrim, " " )
                        });
                        soFar = soFar.slice( matched.length );
                    }
                    for ( type in Expr.filter ) {
                        if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
                            (match = preFilters[ type ]( match ))) ) {
                            matched = match.shift();
                            tokens.push({
                                value: matched,
                                type: type,
                                matches: match
                            });
                            soFar = soFar.slice( matched.length );
                        }
                    }
                    if ( !matched ) {
                        break;
                    }
                }
                return parseOnly ?
                    soFar.length :
                    soFar ?
                        Sizzle.error( selector ) :
                        tokenCache( selector, groups ).slice( 0 );
            };
            function toSelector( tokens ) {
                var i = 0,
                    len = tokens.length,
                    selector = "";
                for ( ; i < len; i++ ) {
                    selector += tokens[i].value;
                }
                return selector;
            }
            function addCombinator( matcher, combinator, base ) {
                var dir = combinator.dir,
                    skip = combinator.next,
                    key = skip || dir,
                    checkNonElements = base && key === "parentNode",
                    doneName = done++;
                return combinator.first ?
                    function( elem, context, xml ) {
                        while ( (elem = elem[ dir ]) ) {
                            if ( elem.nodeType === 1 || checkNonElements ) {
                                return matcher( elem, context, xml );
                            }
                        }
                        return false;
                    } :
                    function( elem, context, xml ) {
                        var oldCache, uniqueCache, outerCache,
                            newCache = [ dirruns, doneName ];
                        if ( xml ) {
                            while ( (elem = elem[ dir ]) ) {
                                if ( elem.nodeType === 1 || checkNonElements ) {
                                    if ( matcher( elem, context, xml ) ) {
                                        return true;
                                    }
                                }
                            }
                        } else {
                            while ( (elem = elem[ dir ]) ) {
                                if ( elem.nodeType === 1 || checkNonElements ) {
                                    outerCache = elem[ expando ] || (elem[ expando ] = {});
                                    uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
                                    if ( skip && skip === elem.nodeName.toLowerCase() ) {
                                        elem = elem[ dir ] || elem;
                                    } else if ( (oldCache = uniqueCache[ key ]) &&
                                        oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
                                        return (newCache[ 2 ] = oldCache[ 2 ]);
                                    } else {
                                        uniqueCache[ key ] = newCache;
                                        if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
            }
            function elementMatcher( matchers ) {
                return matchers.length > 1 ?
                    function( elem, context, xml ) {
                        var i = matchers.length;
                        while ( i-- ) {
                            if ( !matchers[i]( elem, context, xml ) ) {
                                return false;
                            }
                        }
                        return true;
                    } :
                    matchers[0];
            }
            function multipleContexts( selector, contexts, results ) {
                var i = 0,
                    len = contexts.length;
                for ( ; i < len; i++ ) {
                    Sizzle( selector, contexts[i], results );
                }
                return results;
            }
            function condense( unmatched, map, filter, context, xml ) {
                var elem,
                    newUnmatched = [],
                    i = 0,
                    len = unmatched.length,
                    mapped = map != null;
                for ( ; i < len; i++ ) {
                    if ( (elem = unmatched[i]) ) {
                        if ( !filter || filter( elem, context, xml ) ) {
                            newUnmatched.push( elem );
                            if ( mapped ) {
                                map.push( i );
                            }
                        }
                    }
                }
                return newUnmatched;
            }
            function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
                if ( postFilter && !postFilter[ expando ] ) {
                    postFilter = setMatcher( postFilter );
                }
                if ( postFinder && !postFinder[ expando ] ) {
                    postFinder = setMatcher( postFinder, postSelector );
                }
                return markFunction(function( seed, results, context, xml ) {
                    var temp, i, elem,
                        preMap = [],
                        postMap = [],
                        preexisting = results.length,
                        elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
                        matcherIn = preFilter && ( seed || !selector ) ?
                            condense( elems, preMap, preFilter, context, xml ) :
                            elems,
                        matcherOut = matcher ?
                            postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
                                [] :
                                results :
                            matcherIn;
                    if ( matcher ) {
                        matcher( matcherIn, matcherOut, context, xml );
                    }
                    if ( postFilter ) {
                        temp = condense( matcherOut, postMap );
                        postFilter( temp, [], context, xml );
                        i = temp.length;
                        while ( i-- ) {
                            if ( (elem = temp[i]) ) {
                                matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
                            }
                        }
                    }
                    if ( seed ) {
                        if ( postFinder || preFilter ) {
                            if ( postFinder ) {
                                temp = [];
                                i = matcherOut.length;
                                while ( i-- ) {
                                    if ( (elem = matcherOut[i]) ) {
                                        temp.push( (matcherIn[i] = elem) );
                                    }
                                }
                                postFinder( null, (matcherOut = []), temp, xml );
                            }
                            i = matcherOut.length;
                            while ( i-- ) {
                                if ( (elem = matcherOut[i]) &&
                                    (temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
                                    seed[temp] = !(results[temp] = elem);
                                }
                            }
                        }
                    } else {
                        matcherOut = condense(
                            matcherOut === results ?
                                matcherOut.splice( preexisting, matcherOut.length ) :
                                matcherOut
                        );
                        if ( postFinder ) {
                            postFinder( null, results, matcherOut, xml );
                        } else {
                            push.apply( results, matcherOut );
                        }
                    }
                });
            }
            function matcherFromTokens( tokens ) {
                var checkContext, matcher, j,
                    len = tokens.length,
                    leadingRelative = Expr.relative[ tokens[0].type ],
                    implicitRelative = leadingRelative || Expr.relative[" "],
                    i = leadingRelative ? 1 : 0,
                    matchContext = addCombinator( function( elem ) {
                        return elem === checkContext;
                    }, implicitRelative, true ),
                    matchAnyContext = addCombinator( function( elem ) {
                        return indexOf( checkContext, elem ) > -1;
                    }, implicitRelative, true ),
                    matchers = [ function( elem, context, xml ) {
                        var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                            (checkContext = context).nodeType ?
                                matchContext( elem, context, xml ) :
                                matchAnyContext( elem, context, xml ) );
                        checkContext = null;
                        return ret;
                    } ];
                for ( ; i < len; i++ ) {
                    if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
                        matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
                    } else {
                        matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
                        if ( matcher[ expando ] ) {
                            j = ++i;
                            for ( ; j < len; j++ ) {
                                if ( Expr.relative[ tokens[j].type ] ) {
                                    break;
                                }
                            }
                            return setMatcher(
                                i > 1 && elementMatcher( matchers ),
                                i > 1 && toSelector(
                                tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
                                ).replace( rtrim, "$1" ),
                                matcher,
                                i < j && matcherFromTokens( tokens.slice( i, j ) ),
                                j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
                                j < len && toSelector( tokens )
                            );
                        }
                        matchers.push( matcher );
                    }
                }
                return elementMatcher( matchers );
            }
            function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
                var bySet = setMatchers.length > 0,
                    byElement = elementMatchers.length > 0,
                    superMatcher = function( seed, context, xml, results, outermost ) {
                        var elem, j, matcher,
                            matchedCount = 0,
                            i = "0",
                            unmatched = seed && [],
                            setMatched = [],
                            contextBackup = outermostContext,
                            elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
                            dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                            len = elems.length;
                        if ( outermost ) {
                            outermostContext = context === document || context || outermost;
                        }
                        for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
                            if ( byElement && elem ) {
                                j = 0;
                                if ( !context && elem.ownerDocument !== document ) {
                                    setDocument( elem );
                                    xml = !documentIsHTML;
                                }
                                while ( (matcher = elementMatchers[j++]) ) {
                                    if ( matcher( elem, context || document, xml) ) {
                                        results.push( elem );
                                        break;
                                    }
                                }
                                if ( outermost ) {
                                    dirruns = dirrunsUnique;
                                }
                            }
                            if ( bySet ) {
                                if ( (elem = !matcher && elem) ) {
                                    matchedCount--;
                                }
                                if ( seed ) {
                                    unmatched.push( elem );
                                }
                            }
                        }
                        matchedCount += i;
                        if ( bySet && i !== matchedCount ) {
                            j = 0;
                            while ( (matcher = setMatchers[j++]) ) {
                                matcher( unmatched, setMatched, context, xml );
                            }
                            if ( seed ) {
                                if ( matchedCount > 0 ) {
                                    while ( i-- ) {
                                        if ( !(unmatched[i] || setMatched[i]) ) {
                                            setMatched[i] = pop.call( results );
                                        }
                                    }
                                }
                                setMatched = condense( setMatched );
                            }
                            push.apply( results, setMatched );
                            if ( outermost && !seed && setMatched.length > 0 &&
                                ( matchedCount + setMatchers.length ) > 1 ) {
                                Sizzle.uniqueSort( results );
                            }
                        }
                        if ( outermost ) {
                            dirruns = dirrunsUnique;
                            outermostContext = contextBackup;
                        }
                        return unmatched;
                    };
                return bySet ?
                    markFunction( superMatcher ) :
                    superMatcher;
            }
            compile = Sizzle.compile = function( selector, match  ) {
                var i,
                    setMatchers = [],
                    elementMatchers = [],
                    cached = compilerCache[ selector + " " ];
                if ( !cached ) {
                    if ( !match ) {
                        match = tokenize( selector );
                    }
                    i = match.length;
                    while ( i-- ) {
                        cached = matcherFromTokens( match[i] );
                        if ( cached[ expando ] ) {
                            setMatchers.push( cached );
                        } else {
                            elementMatchers.push( cached );
                        }
                    }
                    cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
                    cached.selector = selector;
                }
                return cached;
            };
            select = Sizzle.select = function( selector, context, results, seed ) {
                var i, tokens, token, type, find,
                    compiled = typeof selector === "function" && selector,
                    match = !seed && tokenize( (selector = compiled.selector || selector) );
                results = results || [];
                if ( match.length === 1 ) {
                    tokens = match[0] = match[0].slice( 0 );
                    if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                        context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
                        context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
                        if ( !context ) {
                            return results;
                        } else if ( compiled ) {
                            context = context.parentNode;
                        }
                        selector = selector.slice( tokens.shift().value.length );
                    }
                    i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
                    while ( i-- ) {
                        token = tokens[i];
                        if ( Expr.relative[ (type = token.type) ] ) {
                            break;
                        }
                        if ( (find = Expr.find[ type ]) ) {
                            if ( (seed = find(
                                token.matches[0].replace( runescape, funescape ),
                                rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
                            )) ) {
                                tokens.splice( i, 1 );
                                selector = seed.length && toSelector( tokens );
                                if ( !selector ) {
                                    push.apply( results, seed );
                                    return results;
                                }
                                break;
                            }
                        }
                    }
                }
                ( compiled || compile( selector, match ) )(
                    seed,
                    context,
                    !documentIsHTML,
                    results,
                    !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
                );
                return results;
            };
            support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
            support.detectDuplicates = !!hasDuplicate;
            setDocument();
            support.sortDetached = assert(function( el ) {
                return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
            });
            if ( !assert(function( el ) {
                el.innerHTML = "<a href='#'></a>";
                return el.firstChild.getAttribute("href") === "#" ;
            }) ) {
                addHandle( "type|href|height|width", function( elem, name, isXML ) {
                    if ( !isXML ) {
                        return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
                    }
                });
            }
            if ( !support.attributes || !assert(function( el ) {
                el.innerHTML = "<input/>";
                el.firstChild.setAttribute( "value", "" );
                return el.firstChild.getAttribute( "value" ) === "";
            }) ) {
                addHandle( "value", function( elem, name, isXML ) {
                    if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
                        return elem.defaultValue;
                    }
                });
            }
            if ( !assert(function( el ) {
                return el.getAttribute("disabled") == null;
            }) ) {
                addHandle( booleans, function( elem, name, isXML ) {
                    var val;
                    if ( !isXML ) {
                        return elem[ name ] === true ? name.toLowerCase() :
                            (val = elem.getAttributeNode( name )) && val.specified ?
                                val.value :
                                null;
                    }
                });
            }
            return Sizzle;
        })( window );
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    jQuery.expr[ ":" ] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function( elem, dir, until ) {
        var matched = [],
            truncate = until !== undefined;
        while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
            if ( elem.nodeType === 1 ) {
                if ( truncate && jQuery( elem ).is( until ) ) {
                    break;
                }
                matched.push( elem );
            }
        }
        return matched;
    };
    var siblings = function( n, elem ) {
        var matched = [];
        for ( ; n; n = n.nextSibling ) {
            if ( n.nodeType === 1 && n !== elem ) {
                matched.push( n );
            }
        }
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName( elem, name ) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    };
    var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
    function winnow( elements, qualifier, not ) {
        if ( isFunction( qualifier ) ) {
            return jQuery.grep( elements, function( elem, i ) {
                return !!qualifier.call( elem, i, elem ) !== not;
            } );
        }
        if ( qualifier.nodeType ) {
            return jQuery.grep( elements, function( elem ) {
                return ( elem === qualifier ) !== not;
            } );
        }
        if ( typeof qualifier !== "string" ) {
            return jQuery.grep( elements, function( elem ) {
                return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
            } );
        }
        return jQuery.filter( qualifier, elements, not );
    }
    jQuery.filter = function( expr, elems, not ) {
        var elem = elems[ 0 ];
        if ( not ) {
            expr = ":not(" + expr + ")";
        }
        if ( elems.length === 1 && elem.nodeType === 1 ) {
            return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
        }
        return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
            return elem.nodeType === 1;
        } ) );
    };
    jQuery.fn.extend( {
        find: function( selector ) {
            var i, ret,
                len = this.length,
                self = this;
            if ( typeof selector !== "string" ) {
                return this.pushStack( jQuery( selector ).filter( function() {
                    for ( i = 0; i < len; i++ ) {
                        if ( jQuery.contains( self[ i ], this ) ) {
                            return true;
                        }
                    }
                } ) );
            }
            ret = this.pushStack( [] );
            for ( i = 0; i < len; i++ ) {
                jQuery.find( selector, self[ i ], ret );
            }
            return len > 1 ? jQuery.uniqueSort( ret ) : ret;
        },
        filter: function( selector ) {
            return this.pushStack( winnow( this, selector || [], false ) );
        },
        not: function( selector ) {
            return this.pushStack( winnow( this, selector || [], true ) );
        },
        is: function( selector ) {
            return !!winnow(
                this,
                typeof selector === "string" && rneedsContext.test( selector ) ?
                    jQuery( selector ) :
                    selector || [],
                false
            ).length;
        }
    } );
    var rootjQuery,
        rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
        init = jQuery.fn.init = function( selector, context, root ) {
            var match, elem;
            if ( !selector ) {
                return this;
            }
            root = root || rootjQuery;
            if ( typeof selector === "string" ) {
                if ( selector[ 0 ] === "<" &&
                    selector[ selector.length - 1 ] === ">" &&
                    selector.length >= 3 ) {
                    match = [ null, selector, null ];
                } else {
                    match = rquickExpr.exec( selector );
                }
                if ( match && ( match[ 1 ] || !context ) ) {
                    if ( match[ 1 ] ) {
                        context = context instanceof jQuery ? context[ 0 ] : context;
                        jQuery.merge( this, jQuery.parseHTML(
                            match[ 1 ],
                            context && context.nodeType ? context.ownerDocument || context : document,
                            true
                        ) );
                        if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                            for ( match in context ) {
                                if ( isFunction( this[ match ] ) ) {
                                    this[ match ]( context[ match ] );
                                } else {
                                    this.attr( match, context[ match ] );
                                }
                            }
                        }
                        return this;
                    } else {
                        elem = document.getElementById( match[ 2 ] );
                        if ( elem ) {
                            this[ 0 ] = elem;
                            this.length = 1;
                        }
                        return this;
                    }
                } else if ( !context || context.jquery ) {
                    return ( context || root ).find( selector );
                } else {
                    return this.constructor( context ).find( selector );
                }
            } else if ( selector.nodeType ) {
                this[ 0 ] = selector;
                this.length = 1;
                return this;
            } else if ( isFunction( selector ) ) {
                return root.ready !== undefined ?
                    root.ready( selector ) :
                    selector( jQuery );
            }
            return jQuery.makeArray( selector, this );
        };
    init.prototype = jQuery.fn;
    rootjQuery = jQuery( document );
    var rparentsprev = /^(?:parents|prev(?:Until|All))/,
        guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
        };
    jQuery.fn.extend( {
        has: function( target ) {
            var targets = jQuery( target, this ),
                l = targets.length;
            return this.filter( function() {
                var i = 0;
                for ( ; i < l; i++ ) {
                    if ( jQuery.contains( this, targets[ i ] ) ) {
                        return true;
                    }
                }
            } );
        },
        closest: function( selectors, context ) {
            var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery( selectors );
            if ( !rneedsContext.test( selectors ) ) {
                for ( ; i < l; i++ ) {
                    for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
                        if ( cur.nodeType < 11 && ( targets ?
                            targets.index( cur ) > -1 :
                            cur.nodeType === 1 &&
                            jQuery.find.matchesSelector( cur, selectors ) ) ) {
                            matched.push( cur );
                            break;
                        }
                    }
                }
            }
            return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
        },
        index: function( elem ) {
            if ( !elem ) {
                return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
            }
            if ( typeof elem === "string" ) {
                return indexOf.call( jQuery( elem ), this[ 0 ] );
            }
            return indexOf.call( this,
                elem.jquery ? elem[ 0 ] : elem
            );
        },
        add: function( selector, context ) {
            return this.pushStack(
                jQuery.uniqueSort(
                    jQuery.merge( this.get(), jQuery( selector, context ) )
                )
            );
        },
        addBack: function( selector ) {
            return this.add( selector == null ?
                this.prevObject : this.prevObject.filter( selector )
            );
        }
    } );
    function sibling( cur, dir ) {
        while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
        return cur;
    }
    jQuery.each( {
        parent: function( elem ) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function( elem ) {
            return dir( elem, "parentNode" );
        },
        parentsUntil: function( elem, i, until ) {
            return dir( elem, "parentNode", until );
        },
        next: function( elem ) {
            return sibling( elem, "nextSibling" );
        },
        prev: function( elem ) {
            return sibling( elem, "previousSibling" );
        },
        nextAll: function( elem ) {
            return dir( elem, "nextSibling" );
        },
        prevAll: function( elem ) {
            return dir( elem, "previousSibling" );
        },
        nextUntil: function( elem, i, until ) {
            return dir( elem, "nextSibling", until );
        },
        prevUntil: function( elem, i, until ) {
            return dir( elem, "previousSibling", until );
        },
        siblings: function( elem ) {
            return siblings( ( elem.parentNode || {} ).firstChild, elem );
        },
        children: function( elem ) {
            return siblings( elem.firstChild );
        },
        contents: function( elem ) {
            if ( nodeName( elem, "iframe" ) ) {
                return elem.contentDocument;
            }
            if ( nodeName( elem, "template" ) ) {
                elem = elem.content || elem;
            }
            return jQuery.merge( [], elem.childNodes );
        }
    }, function( name, fn ) {
        jQuery.fn[ name ] = function( until, selector ) {
            var matched = jQuery.map( this, fn, until );
            if ( name.slice( -5 ) !== "Until" ) {
                selector = until;
            }
            if ( selector && typeof selector === "string" ) {
                matched = jQuery.filter( selector, matched );
            }
            if ( this.length > 1 ) {
                if ( !guaranteedUnique[ name ] ) {
                    jQuery.uniqueSort( matched );
                }
                if ( rparentsprev.test( name ) ) {
                    matched.reverse();
                }
            }
            return this.pushStack( matched );
        };
    } );
    var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
    function createOptions( options ) {
        var object = {};
        jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
            object[ flag ] = true;
        } );
        return object;
    }
    jQuery.Callbacks = function( options ) {
        options = typeof options === "string" ?
            createOptions( options ) :
            jQuery.extend( {}, options );
        var
            firing,
            memory,
            fired,
            locked,
            list = [],
            queue = [],
            firingIndex = -1,
            fire = function() {
                locked = locked || options.once;
                fired = firing = true;
                for ( ; queue.length; firingIndex = -1 ) {
                    memory = queue.shift();
                    while ( ++firingIndex < list.length ) {
                        if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                            options.stopOnFalse ) {
                            firingIndex = list.length;
                            memory = false;
                        }
                    }
                }
                if ( !options.memory ) {
                    memory = false;
                }
                firing = false;
                if ( locked ) {
                    if ( memory ) {
                        list = [];
                    } else {
                        list = "";
                    }
                }
            },
            self = {
                add: function() {
                    if ( list ) {
                        if ( memory && !firing ) {
                            firingIndex = list.length - 1;
                            queue.push( memory );
                        }
                        ( function add( args ) {
                            jQuery.each( args, function( _, arg ) {
                                if ( isFunction( arg ) ) {
                                    if ( !options.unique || !self.has( arg ) ) {
                                        list.push( arg );
                                    }
                                } else if ( arg && arg.length && toType( arg ) !== "string" ) {
                                    add( arg );
                                }
                            } );
                        } )( arguments );
                        if ( memory && !firing ) {
                            fire();
                        }
                    }
                    return this;
                },
                remove: function() {
                    jQuery.each( arguments, function( _, arg ) {
                        var index;
                        while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                            list.splice( index, 1 );
                            if ( index <= firingIndex ) {
                                firingIndex--;
                            }
                        }
                    } );
                    return this;
                },
                has: function( fn ) {
                    return fn ?
                        jQuery.inArray( fn, list ) > -1 :
                        list.length > 0;
                },
                empty: function() {
                    if ( list ) {
                        list = [];
                    }
                    return this;
                },
                disable: function() {
                    locked = queue = [];
                    list = memory = "";
                    return this;
                },
                disabled: function() {
                    return !list;
                },
                lock: function() {
                    locked = queue = [];
                    if ( !memory && !firing ) {
                        list = memory = "";
                    }
                    return this;
                },
                locked: function() {
                    return !!locked;
                },
                fireWith: function( context, args ) {
                    if ( !locked ) {
                        args = args || [];
                        args = [ context, args.slice ? args.slice() : args ];
                        queue.push( args );
                        if ( !firing ) {
                            fire();
                        }
                    }
                    return this;
                },
                fire: function() {
                    self.fireWith( this, arguments );
                    return this;
                },
                fired: function() {
                    return !!fired;
                }
            };
        return self;
    };
    function Identity( v ) {
        return v;
    }
    function Thrower( ex ) {
        throw ex;
    }
    function adoptValue( value, resolve, reject, noValue ) {
        var method;
        try {
            if ( value && isFunction( ( method = value.promise ) ) ) {
                method.call( value ).done( resolve ).fail( reject );
            } else if ( value && isFunction( ( method = value.then ) ) ) {
                method.call( value, resolve, reject );
            } else {
                resolve.apply( undefined, [ value ].slice( noValue ) );
            }
        } catch ( value ) {
            reject.apply( undefined, [ value ] );
        }
    }
    jQuery.extend( {
        Deferred: function( func ) {
            var tuples = [
                    [ "notify", "progress", jQuery.Callbacks( "memory" ),
                        jQuery.Callbacks( "memory" ), 2 ],
                    [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                        jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                    [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                        jQuery.Callbacks( "once memory" ), 1, "rejected" ]
                ],
                state = "pending",
                promise = {
                    state: function() {
                        return state;
                    },
                    always: function() {
                        deferred.done( arguments ).fail( arguments );
                        return this;
                    },
                    "catch": function( fn ) {
                        return promise.then( null, fn );
                    },
                    pipe: function(  ) {
                        var fns = arguments;
                        return jQuery.Deferred( function( newDefer ) {
                            jQuery.each( tuples, function( i, tuple ) {
                                var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
                                deferred[ tuple[ 1 ] ]( function() {
                                    var returned = fn && fn.apply( this, arguments );
                                    if ( returned && isFunction( returned.promise ) ) {
                                        returned.promise()
                                            .progress( newDefer.notify )
                                            .done( newDefer.resolve )
                                            .fail( newDefer.reject );
                                    } else {
                                        newDefer[ tuple[ 0 ] + "With" ](
                                            this,
                                            fn ? [ returned ] : arguments
                                        );
                                    }
                                } );
                            } );
                            fns = null;
                        } ).promise();
                    },
                    then: function( onFulfilled, onRejected, onProgress ) {
                        var maxDepth = 0;
                        function resolve( depth, deferred, handler, special ) {
                            return function() {
                                var that = this,
                                    args = arguments,
                                    mightThrow = function() {
                                        var returned, then;
                                        if ( depth < maxDepth ) {
                                            return;
                                        }
                                        returned = handler.apply( that, args );
                                        if ( returned === deferred.promise() ) {
                                            throw new TypeError( "Thenable self-resolution" );
                                        }
                                        then = returned &&
                                            ( typeof returned === "object" ||
                                                typeof returned === "function" ) &&
                                            returned.then;
                                        if ( isFunction( then ) ) {
                                            if ( special ) {
                                                then.call(
                                                    returned,
                                                    resolve( maxDepth, deferred, Identity, special ),
                                                    resolve( maxDepth, deferred, Thrower, special )
                                                );
                                            } else {
                                                maxDepth++;
                                                then.call(
                                                    returned,
                                                    resolve( maxDepth, deferred, Identity, special ),
                                                    resolve( maxDepth, deferred, Thrower, special ),
                                                    resolve( maxDepth, deferred, Identity,
                                                        deferred.notifyWith )
                                                );
                                            }
                                        } else {
                                            if ( handler !== Identity ) {
                                                that = undefined;
                                                args = [ returned ];
                                            }
                                            ( special || deferred.resolveWith )( that, args );
                                        }
                                    },
                                    process = special ?
                                        mightThrow :
                                        function() {
                                            try {
                                                mightThrow();
                                            } catch ( e ) {
                                                if ( jQuery.Deferred.exceptionHook ) {
                                                    jQuery.Deferred.exceptionHook( e,
                                                        process.stackTrace );
                                                }
                                                if ( depth + 1 >= maxDepth ) {
                                                    if ( handler !== Thrower ) {
                                                        that = undefined;
                                                        args = [ e ];
                                                    }
                                                    deferred.rejectWith( that, args );
                                                }
                                            }
                                        };
                                if ( depth ) {
                                    process();
                                } else {
                                    if ( jQuery.Deferred.getStackHook ) {
                                        process.stackTrace = jQuery.Deferred.getStackHook();
                                    }
                                    window.setTimeout( process );
                                }
                            };
                        }
                        return jQuery.Deferred( function( newDefer ) {
                            tuples[ 0 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction( onProgress ) ?
                                        onProgress :
                                        Identity,
                                    newDefer.notifyWith
                                )
                            );
                            tuples[ 1 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction( onFulfilled ) ?
                                        onFulfilled :
                                        Identity
                                )
                            );
                            tuples[ 2 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction( onRejected ) ?
                                        onRejected :
                                        Thrower
                                )
                            );
                        } ).promise();
                    },
                    promise: function( obj ) {
                        return obj != null ? jQuery.extend( obj, promise ) : promise;
                    }
                },
                deferred = {};
            jQuery.each( tuples, function( i, tuple ) {
                var list = tuple[ 2 ],
                    stateString = tuple[ 5 ];
                promise[ tuple[ 1 ] ] = list.add;
                if ( stateString ) {
                    list.add(
                        function() {
                            state = stateString;
                        },
                        tuples[ 3 - i ][ 2 ].disable,
                        tuples[ 3 - i ][ 3 ].disable,
                        tuples[ 0 ][ 2 ].lock,
                        tuples[ 0 ][ 3 ].lock
                    );
                }
                list.add( tuple[ 3 ].fire );
                deferred[ tuple[ 0 ] ] = function() {
                    deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                    return this;
                };
                deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
            } );
            promise.promise( deferred );
            if ( func ) {
                func.call( deferred, deferred );
            }
            return deferred;
        },
        when: function( singleValue ) {
            var
                remaining = arguments.length,
                i = remaining,
                resolveContexts = Array( i ),
                resolveValues = slice.call( arguments ),
                master = jQuery.Deferred(),
                updateFunc = function( i ) {
                    return function( value ) {
                        resolveContexts[ i ] = this;
                        resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                        if ( !( --remaining ) ) {
                            master.resolveWith( resolveContexts, resolveValues );
                        }
                    };
                };
            if ( remaining <= 1 ) {
                adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
                    !remaining );
                if ( master.state() === "pending" ||
                    isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
                    return master.then();
                }
            }
            while ( i-- ) {
                adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
            }
            return master.promise();
        }
    } );
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function( error, stack ) {
        if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
            window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
        }
    };
    jQuery.readyException = function( error ) {
        window.setTimeout( function() {
            throw error;
        } );
    };
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function( fn ) {
        readyList
            .then( fn )
            .catch( function( error ) {
                jQuery.readyException( error );
            } );
        return this;
    };
    jQuery.extend( {
        isReady: false,
        readyWait: 1,
        ready: function( wait ) {
            if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
                return;
            }
            jQuery.isReady = true;
            if ( wait !== true && --jQuery.readyWait > 0 ) {
                return;
            }
            readyList.resolveWith( document, [ jQuery ] );
        }
    } );
    jQuery.ready.then = readyList.then;
    function completed() {
        document.removeEventListener( "DOMContentLoaded", completed );
        window.removeEventListener( "load", completed );
        jQuery.ready();
    }
    if ( document.readyState === "complete" ||
        ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
        window.setTimeout( jQuery.ready );
    } else {
        document.addEventListener( "DOMContentLoaded", completed );
        window.addEventListener( "load", completed );
    }
    var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
        var i = 0,
            len = elems.length,
            bulk = key == null;
        if ( toType( key ) === "object" ) {
            chainable = true;
            for ( i in key ) {
                access( elems, fn, i, key[ i ], true, emptyGet, raw );
            }
        } else if ( value !== undefined ) {
            chainable = true;
            if ( !isFunction( value ) ) {
                raw = true;
            }
            if ( bulk ) {
                if ( raw ) {
                    fn.call( elems, value );
                    fn = null;
                } else {
                    bulk = fn;
                    fn = function( elem, key, value ) {
                        return bulk.call( jQuery( elem ), value );
                    };
                }
            }
            if ( fn ) {
                for ( ; i < len; i++ ) {
                    fn(
                        elems[ i ], key, raw ?
                            value :
                            value.call( elems[ i ], i, fn( elems[ i ], key ) )
                    );
                }
            }
        }
        if ( chainable ) {
            return elems;
        }
        if ( bulk ) {
            return fn.call( elems );
        }
        return len ? fn( elems[ 0 ], key ) : emptyGet;
    };
    var rmsPrefix = /^-ms-/,
        rdashAlpha = /-([a-z])/g;
    function fcamelCase( all, letter ) {
        return letter.toUpperCase();
    }
    function camelCase( string ) {
        return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
    }
    var acceptData = function( owner ) {
        return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function( owner ) {
            var value = owner[ this.expando ];
            if ( !value ) {
                value = {};
                if ( acceptData( owner ) ) {
                    if ( owner.nodeType ) {
                        owner[ this.expando ] = value;
                    } else {
                        Object.defineProperty( owner, this.expando, {
                            value: value,
                            configurable: true
                        } );
                    }
                }
            }
            return value;
        },
        set: function( owner, data, value ) {
            var prop,
                cache = this.cache( owner );
            if ( typeof data === "string" ) {
                cache[ camelCase( data ) ] = value;
            } else {
                for ( prop in data ) {
                    cache[ camelCase( prop ) ] = data[ prop ];
                }
            }
            return cache;
        },
        get: function( owner, key ) {
            return key === undefined ?
                this.cache( owner ) :
                owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
        },
        access: function( owner, key, value ) {
            if ( key === undefined ||
                ( ( key && typeof key === "string" ) && value === undefined ) ) {
                return this.get( owner, key );
            }
            this.set( owner, key, value );
            return value !== undefined ? value : key;
        },
        remove: function( owner, key ) {
            var i,
                cache = owner[ this.expando ];
            if ( cache === undefined ) {
                return;
            }
            if ( key !== undefined ) {
                if ( Array.isArray( key ) ) {
                    key = key.map( camelCase );
                } else {
                    key = camelCase( key );
                    key = key in cache ?
                        [ key ] :
                        ( key.match( rnothtmlwhite ) || [] );
                }
                i = key.length;
                while ( i-- ) {
                    delete cache[ key[ i ] ];
                }
            }
            if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
                if ( owner.nodeType ) {
                    owner[ this.expando ] = undefined;
                } else {
                    delete owner[ this.expando ];
                }
            }
        },
        hasData: function( owner ) {
            var cache = owner[ this.expando ];
            return cache !== undefined && !jQuery.isEmptyObject( cache );
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        rmultiDash = /[A-Z]/g;
    function getData( data ) {
        if ( data === "true" ) {
            return true;
        }
        if ( data === "false" ) {
            return false;
        }
        if ( data === "null" ) {
            return null;
        }
        if ( data === +data + "" ) {
            return +data;
        }
        if ( rbrace.test( data ) ) {
            return JSON.parse( data );
        }
        return data;
    }
    function dataAttr( elem, key, data ) {
        var name;
        if ( data === undefined && elem.nodeType === 1 ) {
            name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
            data = elem.getAttribute( name );
            if ( typeof data === "string" ) {
                try {
                    data = getData( data );
                } catch ( e ) {}
                dataUser.set( elem, key, data );
            } else {
                data = undefined;
            }
        }
        return data;
    }
    jQuery.extend( {
        hasData: function( elem ) {
            return dataUser.hasData( elem ) || dataPriv.hasData( elem );
        },
        data: function( elem, name, data ) {
            return dataUser.access( elem, name, data );
        },
        removeData: function( elem, name ) {
            dataUser.remove( elem, name );
        },
        _data: function( elem, name, data ) {
            return dataPriv.access( elem, name, data );
        },
        _removeData: function( elem, name ) {
            dataPriv.remove( elem, name );
        }
    } );
    jQuery.fn.extend( {
        data: function( key, value ) {
            var i, name, data,
                elem = this[ 0 ],
                attrs = elem && elem.attributes;
            if ( key === undefined ) {
                if ( this.length ) {
                    data = dataUser.get( elem );
                    if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                        i = attrs.length;
                        while ( i-- ) {
                            if ( attrs[ i ] ) {
                                name = attrs[ i ].name;
                                if ( name.indexOf( "data-" ) === 0 ) {
                                    name = camelCase( name.slice( 5 ) );
                                    dataAttr( elem, name, data[ name ] );
                                }
                            }
                        }
                        dataPriv.set( elem, "hasDataAttrs", true );
                    }
                }
                return data;
            }
            if ( typeof key === "object" ) {
                return this.each( function() {
                    dataUser.set( this, key );
                } );
            }
            return access( this, function( value ) {
                var data;
                if ( elem && value === undefined ) {
                    data = dataUser.get( elem, key );
                    if ( data !== undefined ) {
                        return data;
                    }
                    data = dataAttr( elem, key );
                    if ( data !== undefined ) {
                        return data;
                    }
                    return;
                }
                this.each( function() {
                    dataUser.set( this, key, value );
                } );
            }, null, value, arguments.length > 1, null, true );
        },
        removeData: function( key ) {
            return this.each( function() {
                dataUser.remove( this, key );
            } );
        }
    } );
    jQuery.extend( {
        queue: function( elem, type, data ) {
            var queue;
            if ( elem ) {
                type = ( type || "fx" ) + "queue";
                queue = dataPriv.get( elem, type );
                if ( data ) {
                    if ( !queue || Array.isArray( data ) ) {
                        queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                    } else {
                        queue.push( data );
                    }
                }
                return queue || [];
            }
        },
        dequeue: function( elem, type ) {
            type = type || "fx";
            var queue = jQuery.queue( elem, type ),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks( elem, type ),
                next = function() {
                    jQuery.dequeue( elem, type );
                };
            if ( fn === "inprogress" ) {
                fn = queue.shift();
                startLength--;
            }
            if ( fn ) {
                if ( type === "fx" ) {
                    queue.unshift( "inprogress" );
                }
                delete hooks.stop;
                fn.call( elem, next, hooks );
            }
            if ( !startLength && hooks ) {
                hooks.empty.fire();
            }
        },
        _queueHooks: function( elem, type ) {
            var key = type + "queueHooks";
            return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
                empty: jQuery.Callbacks( "once memory" ).add( function() {
                    dataPriv.remove( elem, [ type + "queue", key ] );
                } )
            } );
        }
    } );
    jQuery.fn.extend( {
        queue: function( type, data ) {
            var setter = 2;
            if ( typeof type !== "string" ) {
                data = type;
                type = "fx";
                setter--;
            }
            if ( arguments.length < setter ) {
                return jQuery.queue( this[ 0 ], type );
            }
            return data === undefined ?
                this :
                this.each( function() {
                    var queue = jQuery.queue( this, type, data );
                    jQuery._queueHooks( this, type );
                    if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                        jQuery.dequeue( this, type );
                    }
                } );
        },
        dequeue: function( type ) {
            return this.each( function() {
                jQuery.dequeue( this, type );
            } );
        },
        clearQueue: function( type ) {
            return this.queue( type || "fx", [] );
        },
        promise: function( type, obj ) {
            var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function() {
                    if ( !( --count ) ) {
                        defer.resolveWith( elements, [ elements ] );
                    }
                };
            if ( typeof type !== "string" ) {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while ( i-- ) {
                tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
                if ( tmp && tmp.empty ) {
                    count++;
                    tmp.empty.add( resolve );
                }
            }
            resolve();
            return defer.promise( obj );
        }
    } );
    var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
    var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
    var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
    var isHiddenWithinTree = function( elem, el ) {
        elem = el || elem;
        return elem.style.display === "none" ||
            elem.style.display === "" &&
            jQuery.contains( elem.ownerDocument, elem ) &&
            jQuery.css( elem, "display" ) === "none";
    };
    var swap = function( elem, options, callback, args ) {
        var ret, name,
            old = {};
        for ( name in options ) {
            old[ name ] = elem.style[ name ];
            elem.style[ name ] = options[ name ];
        }
        ret = callback.apply( elem, args || [] );
        for ( name in options ) {
            elem.style[ name ] = old[ name ];
        }
        return ret;
    };
    function adjustCSS( elem, prop, valueParts, tween ) {
        var adjusted, scale,
            maxIterations = 20,
            currentValue = tween ?
                function() {
                    return tween.cur();
                } :
                function() {
                    return jQuery.css( elem, prop, "" );
                },
            initial = currentValue(),
            unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
            initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
                rcssNum.exec( jQuery.css( elem, prop ) );
        if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
            initial = initial / 2;
            unit = unit || initialInUnit[ 3 ];
            initialInUnit = +initial || 1;
            while ( maxIterations-- ) {
                jQuery.style( elem, prop, initialInUnit + unit );
                if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
                    maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style( elem, prop, initialInUnit + unit );
            valueParts = valueParts || [];
        }
        if ( valueParts ) {
            initialInUnit = +initialInUnit || +initial || 0;
            adjusted = valueParts[ 1 ] ?
                initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
                +valueParts[ 2 ];
            if ( tween ) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay( elem ) {
        var temp,
            doc = elem.ownerDocument,
            nodeName = elem.nodeName,
            display = defaultDisplayMap[ nodeName ];
        if ( display ) {
            return display;
        }
        temp = doc.body.appendChild( doc.createElement( nodeName ) );
        display = jQuery.css( temp, "display" );
        temp.parentNode.removeChild( temp );
        if ( display === "none" ) {
            display = "block";
        }
        defaultDisplayMap[ nodeName ] = display;
        return display;
    }
    function showHide( elements, show ) {
        var display, elem,
            values = [],
            index = 0,
            length = elements.length;
        for ( ; index < length; index++ ) {
            elem = elements[ index ];
            if ( !elem.style ) {
                continue;
            }
            display = elem.style.display;
            if ( show ) {
                if ( display === "none" ) {
                    values[ index ] = dataPriv.get( elem, "display" ) || null;
                    if ( !values[ index ] ) {
                        elem.style.display = "";
                    }
                }
                if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                    values[ index ] = getDefaultDisplay( elem );
                }
            } else {
                if ( display !== "none" ) {
                    values[ index ] = "none";
                    dataPriv.set( elem, "display", display );
                }
            }
        }
        for ( index = 0; index < length; index++ ) {
            if ( values[ index ] != null ) {
                elements[ index ].style.display = values[ index ];
            }
        }
        return elements;
    }
    jQuery.fn.extend( {
        show: function() {
            return showHide( this, true );
        },
        hide: function() {
            return showHide( this );
        },
        toggle: function( state ) {
            if ( typeof state === "boolean" ) {
                return state ? this.show() : this.hide();
            }
            return this.each( function() {
                if ( isHiddenWithinTree( this ) ) {
                    jQuery( this ).show();
                } else {
                    jQuery( this ).hide();
                }
            } );
        }
    } );
    var rcheckableType = ( /^(?:checkbox|radio)$/i );
    var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
    var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
    var wrapMap = {
        option: [ 1, "<select multiple='multiple'>", "</select>" ],
        thead: [ 1, "<table>", "</table>" ],
        col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
        tr: [ 2, "<table><tbody>", "</tbody></table>" ],
        td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
        _default: [ 0, "", "" ]
    };
    wrapMap.optgroup = wrapMap.option;
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll( context, tag ) {
        var ret;
        if ( typeof context.getElementsByTagName !== "undefined" ) {
            ret = context.getElementsByTagName( tag || "*" );
        } else if ( typeof context.querySelectorAll !== "undefined" ) {
            ret = context.querySelectorAll( tag || "*" );
        } else {
            ret = [];
        }
        if ( tag === undefined || tag && nodeName( context, tag ) ) {
            return jQuery.merge( [ context ], ret );
        }
        return ret;
    }
    function setGlobalEval( elems, refElements ) {
        var i = 0,
            l = elems.length;
        for ( ; i < l; i++ ) {
            dataPriv.set(
                elems[ i ],
                "globalEval",
                !refElements || dataPriv.get( refElements[ i ], "globalEval" )
            );
        }
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment( elems, context, scripts, selection, ignored ) {
        var elem, tmp, tag, wrap, contains, j,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i = 0,
            l = elems.length;
        for ( ; i < l; i++ ) {
            elem = elems[ i ];
            if ( elem || elem === 0 ) {
                if ( toType( elem ) === "object" ) {
                    jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
                } else if ( !rhtml.test( elem ) ) {
                    nodes.push( context.createTextNode( elem ) );
                } else {
                    tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
                    tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                    wrap = wrapMap[ tag ] || wrapMap._default;
                    tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
                    j = wrap[ 0 ];
                    while ( j-- ) {
                        tmp = tmp.lastChild;
                    }
                    jQuery.merge( nodes, tmp.childNodes );
                    tmp = fragment.firstChild;
                    tmp.textContent = "";
                }
            }
        }
        fragment.textContent = "";
        i = 0;
        while ( ( elem = nodes[ i++ ] ) ) {
            if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
                if ( ignored ) {
                    ignored.push( elem );
                }
                continue;
            }
            contains = jQuery.contains( elem.ownerDocument, elem );
            tmp = getAll( fragment.appendChild( elem ), "script" );
            if ( contains ) {
                setGlobalEval( tmp );
            }
            if ( scripts ) {
                j = 0;
                while ( ( elem = tmp[ j++ ] ) ) {
                    if ( rscriptType.test( elem.type || "" ) ) {
                        scripts.push( elem );
                    }
                }
            }
        }
        return fragment;
    }
    ( function() {
        var fragment = document.createDocumentFragment(),
            div = fragment.appendChild( document.createElement( "div" ) ),
            input = document.createElement( "input" );
        input.setAttribute( "type", "radio" );
        input.setAttribute( "checked", "checked" );
        input.setAttribute( "name", "t" );
        div.appendChild( input );
        support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
    } )();
    var documentElement = document.documentElement;
    var
        rkeyEvent = /^key/,
        rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch ( err ) { }
    }
    function on( elem, types, selector, data, fn, one ) {
        var origFn, type;
        if ( typeof types === "object" ) {
            if ( typeof selector !== "string" ) {
                data = data || selector;
                selector = undefined;
            }
            for ( type in types ) {
                on( elem, type, selector, data, types[ type ], one );
            }
            return elem;
        }
        if ( data == null && fn == null ) {
            fn = selector;
            data = selector = undefined;
        } else if ( fn == null ) {
            if ( typeof selector === "string" ) {
                fn = data;
                data = undefined;
            } else {
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if ( fn === false ) {
            fn = returnFalse;
        } else if ( !fn ) {
            return elem;
        }
        if ( one === 1 ) {
            origFn = fn;
            fn = function( event ) {
                jQuery().off( event );
                return origFn.apply( this, arguments );
            };
            fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
        }
        return elem.each( function() {
            jQuery.event.add( this, types, fn, data, selector );
        } );
    }
    jQuery.event = {
        global: {},
        add: function( elem, types, handler, data, selector ) {
            var handleObjIn, eventHandle, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.get( elem );
            if ( !elemData ) {
                return;
            }
            if ( handler.handler ) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            if ( selector ) {
                jQuery.find.matchesSelector( documentElement, selector );
            }
            if ( !handler.guid ) {
                handler.guid = jQuery.guid++;
            }
            if ( !( events = elemData.events ) ) {
                events = elemData.events = {};
            }
            if ( !( eventHandle = elemData.handle ) ) {
                eventHandle = elemData.handle = function( e ) {
                    return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                        jQuery.event.dispatch.apply( elem, arguments ) : undefined;
                };
            }
            types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
            t = types.length;
            while ( t-- ) {
                tmp = rtypenamespace.exec( types[ t ] ) || [];
                type = origType = tmp[ 1 ];
                namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
                if ( !type ) {
                    continue;
                }
                special = jQuery.event.special[ type ] || {};
                type = ( selector ? special.delegateType : special.bindType ) || type;
                special = jQuery.event.special[ type ] || {};
                handleObj = jQuery.extend( {
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                    namespace: namespaces.join( "." )
                }, handleObjIn );
                if ( !( handlers = events[ type ] ) ) {
                    handlers = events[ type ] = [];
                    handlers.delegateCount = 0;
                    if ( !special.setup ||
                        special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
                        if ( elem.addEventListener ) {
                            elem.addEventListener( type, eventHandle );
                        }
                    }
                }
                if ( special.add ) {
                    special.add.call( elem, handleObj );
                    if ( !handleObj.handler.guid ) {
                        handleObj.handler.guid = handler.guid;
                    }
                }
                if ( selector ) {
                    handlers.splice( handlers.delegateCount++, 0, handleObj );
                } else {
                    handlers.push( handleObj );
                }
                jQuery.event.global[ type ] = true;
            }
        },
        remove: function( elem, types, handler, selector, mappedTypes ) {
            var j, origCount, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
            if ( !elemData || !( events = elemData.events ) ) {
                return;
            }
            types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
            t = types.length;
            while ( t-- ) {
                tmp = rtypenamespace.exec( types[ t ] ) || [];
                type = origType = tmp[ 1 ];
                namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
                if ( !type ) {
                    for ( type in events ) {
                        jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                    }
                    continue;
                }
                special = jQuery.event.special[ type ] || {};
                type = ( selector ? special.delegateType : special.bindType ) || type;
                handlers = events[ type ] || [];
                tmp = tmp[ 2 ] &&
                    new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
                origCount = j = handlers.length;
                while ( j-- ) {
                    handleObj = handlers[ j ];
                    if ( ( mappedTypes || origType === handleObj.origType ) &&
                        ( !handler || handler.guid === handleObj.guid ) &&
                        ( !tmp || tmp.test( handleObj.namespace ) ) &&
                        ( !selector || selector === handleObj.selector ||
                            selector === "**" && handleObj.selector ) ) {
                        handlers.splice( j, 1 );
                        if ( handleObj.selector ) {
                            handlers.delegateCount--;
                        }
                        if ( special.remove ) {
                            special.remove.call( elem, handleObj );
                        }
                    }
                }
                if ( origCount && !handlers.length ) {
                    if ( !special.teardown ||
                        special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
                        jQuery.removeEvent( elem, type, elemData.handle );
                    }
                    delete events[ type ];
                }
            }
            if ( jQuery.isEmptyObject( events ) ) {
                dataPriv.remove( elem, "handle events" );
            }
        },
        dispatch: function( nativeEvent ) {
            var event = jQuery.event.fix( nativeEvent );
            var i, j, ret, matched, handleObj, handlerQueue,
                args = new Array( arguments.length ),
                handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
                special = jQuery.event.special[ event.type ] || {};
            args[ 0 ] = event;
            for ( i = 1; i < arguments.length; i++ ) {
                args[ i ] = arguments[ i ];
            }
            event.delegateTarget = this;
            if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
                return;
            }
            handlerQueue = jQuery.event.handlers.call( this, event, handlers );
            i = 0;
            while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
                event.currentTarget = matched.elem;
                j = 0;
                while ( ( handleObj = matched.handlers[ j++ ] ) &&
                !event.isImmediatePropagationStopped() ) {
                    if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
                        event.handleObj = handleObj;
                        event.data = handleObj.data;
                        ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                            handleObj.handler ).apply( matched.elem, args );
                        if ( ret !== undefined ) {
                            if ( ( event.result = ret ) === false ) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }
                }
            }
            if ( special.postDispatch ) {
                special.postDispatch.call( this, event );
            }
            return event.result;
        },
        handlers: function( event, handlers ) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;
            if ( delegateCount &&
                cur.nodeType &&
                !( event.type === "click" && event.button >= 1 ) ) {
                for ( ; cur !== this; cur = cur.parentNode || this ) {
                    if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                        matchedHandlers = [];
                        matchedSelectors = {};
                        for ( i = 0; i < delegateCount; i++ ) {
                            handleObj = handlers[ i ];
                            sel = handleObj.selector + " ";
                            if ( matchedSelectors[ sel ] === undefined ) {
                                matchedSelectors[ sel ] = handleObj.needsContext ?
                                    jQuery( sel, this ).index( cur ) > -1 :
                                    jQuery.find( sel, this, null, [ cur ] ).length;
                            }
                            if ( matchedSelectors[ sel ] ) {
                                matchedHandlers.push( handleObj );
                            }
                        }
                        if ( matchedHandlers.length ) {
                            handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                        }
                    }
                }
            }
            cur = this;
            if ( delegateCount < handlers.length ) {
                handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
            }
            return handlerQueue;
        },
        addProp: function( name, hook ) {
            Object.defineProperty( jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction( hook ) ?
                    function() {
                        if ( this.originalEvent ) {
                            return hook( this.originalEvent );
                        }
                    } :
                    function() {
                        if ( this.originalEvent ) {
                            return this.originalEvent[ name ];
                        }
                    },
                set: function( value ) {
                    Object.defineProperty( this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    } );
                }
            } );
        },
        fix: function( originalEvent ) {
            return originalEvent[ jQuery.expando ] ?
                originalEvent :
                new jQuery.Event( originalEvent );
        },
        special: {
            load: {
                noBubble: true
            },
            focus: {
                trigger: function() {
                    if ( this !== safeActiveElement() && this.focus ) {
                        this.focus();
                        return false;
                    }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if ( this === safeActiveElement() && this.blur ) {
                        this.blur();
                        return false;
                    }
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
                        this.click();
                        return false;
                    }
                },
                _default: function( event ) {
                    return nodeName( event.target, "a" );
                }
            },
            beforeunload: {
                postDispatch: function( event ) {
                    if ( event.result !== undefined && event.originalEvent ) {
                        event.originalEvent.returnValue = event.result;
                    }
                }
            }
        }
    };
    jQuery.removeEvent = function( elem, type, handle ) {
        if ( elem.removeEventListener ) {
            elem.removeEventListener( type, handle );
        }
    };
    jQuery.Event = function( src, props ) {
        if ( !( this instanceof jQuery.Event ) ) {
            return new jQuery.Event( src, props );
        }
        if ( src && src.type ) {
            this.originalEvent = src;
            this.type = src.type;
            this.isDefaultPrevented = src.defaultPrevented ||
            src.defaultPrevented === undefined &&
            src.returnValue === false ?
                returnTrue :
                returnFalse;
            this.target = ( src.target && src.target.nodeType === 3 ) ?
                src.target.parentNode :
                src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        } else {
            this.type = src;
        }
        if ( props ) {
            jQuery.extend( this, props );
        }
        this.timeStamp = src && src.timeStamp || Date.now();
        this[ jQuery.expando ] = true;
    };
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if ( e && !this.isSimulated ) {
                e.preventDefault();
            }
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if ( e && !this.isSimulated ) {
                e.stopPropagation();
            }
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if ( e && !this.isSimulated ) {
                e.stopImmediatePropagation();
            }
            this.stopPropagation();
        }
    };
    jQuery.each( {
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: function( event ) {
            var button = event.button;
            if ( event.which == null && rkeyEvent.test( event.type ) ) {
                return event.charCode != null ? event.charCode : event.keyCode;
            }
            if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
                if ( button & 1 ) {
                    return 1;
                }
                if ( button & 2 ) {
                    return 3;
                }
                if ( button & 4 ) {
                    return 2;
                }
                return 0;
            }
            return event.which;
        }
    }, jQuery.event.addProp );
    jQuery.each( {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function( orig, fix ) {
        jQuery.event.special[ orig ] = {
            delegateType: fix,
            bindType: fix,
            handle: function( event ) {
                var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;
                if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply( this, arguments );
                    event.type = fix;
                }
                return ret;
            }
        };
    } );
    jQuery.fn.extend( {
        on: function( types, selector, data, fn ) {
            return on( this, types, selector, data, fn );
        },
        one: function( types, selector, data, fn ) {
            return on( this, types, selector, data, fn, 1 );
        },
        off: function( types, selector, fn ) {
            var handleObj, type;
            if ( types && types.preventDefault && types.handleObj ) {
                handleObj = types.handleObj;
                jQuery( types.delegateTarget ).off(
                    handleObj.namespace ?
                        handleObj.origType + "." + handleObj.namespace :
                        handleObj.origType,
                    handleObj.selector,
                    handleObj.handler
                );
                return this;
            }
            if ( typeof types === "object" ) {
                for ( type in types ) {
                    this.off( type, selector, types[ type ] );
                }
                return this;
            }
            if ( selector === false || typeof selector === "function" ) {
                fn = selector;
                selector = undefined;
            }
            if ( fn === false ) {
                fn = returnFalse;
            }
            return this.each( function() {
                jQuery.event.remove( this, types, fn, selector );
            } );
        }
    } );
    var
        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        rnoInnerhtml = /<script|<style|<link/i,
        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
        rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function manipulationTarget( elem, content ) {
        if ( nodeName( elem, "table" ) &&
            nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
            return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
        }
        return elem;
    }
    function disableScript( elem ) {
        elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
        return elem;
    }
    function restoreScript( elem ) {
        if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
            elem.type = elem.type.slice( 5 );
        } else {
            elem.removeAttribute( "type" );
        }
        return elem;
    }
    function cloneCopyEvent( src, dest ) {
        var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
        if ( dest.nodeType !== 1 ) {
            return;
        }
        if ( dataPriv.hasData( src ) ) {
            pdataOld = dataPriv.access( src );
            pdataCur = dataPriv.set( dest, pdataOld );
            events = pdataOld.events;
            if ( events ) {
                delete pdataCur.handle;
                pdataCur.events = {};
                for ( type in events ) {
                    for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                        jQuery.event.add( dest, type, events[ type ][ i ] );
                    }
                }
            }
        }
        if ( dataUser.hasData( src ) ) {
            udataOld = dataUser.access( src );
            udataCur = jQuery.extend( {}, udataOld );
            dataUser.set( dest, udataCur );
        }
    }
    function fixInput( src, dest ) {
        var nodeName = dest.nodeName.toLowerCase();
        if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
            dest.checked = src.checked;
        } else if ( nodeName === "input" || nodeName === "textarea" ) {
            dest.defaultValue = src.defaultValue;
        }
    }
    function domManip( collection, args, callback, ignored ) {
        args = concat.apply( [], args );
        var fragment, first, scripts, hasScripts, node, doc,
            i = 0,
            l = collection.length,
            iNoClone = l - 1,
            value = args[ 0 ],
            valueIsFunction = isFunction( value );
        if ( valueIsFunction ||
            ( l > 1 && typeof value === "string" &&
                !support.checkClone && rchecked.test( value ) ) ) {
            return collection.each( function( index ) {
                var self = collection.eq( index );
                if ( valueIsFunction ) {
                    args[ 0 ] = value.call( this, index, self.html() );
                }
                domManip( self, args, callback, ignored );
            } );
        }
        if ( l ) {
            fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
            first = fragment.firstChild;
            if ( fragment.childNodes.length === 1 ) {
                fragment = first;
            }
            if ( first || ignored ) {
                scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
                hasScripts = scripts.length;
                for ( ; i < l; i++ ) {
                    node = fragment;
                    if ( i !== iNoClone ) {
                        node = jQuery.clone( node, true, true );
                        if ( hasScripts ) {
                            jQuery.merge( scripts, getAll( node, "script" ) );
                        }
                    }
                    callback.call( collection[ i ], node, i );
                }
                if ( hasScripts ) {
                    doc = scripts[ scripts.length - 1 ].ownerDocument;
                    jQuery.map( scripts, restoreScript );
                    for ( i = 0; i < hasScripts; i++ ) {
                        node = scripts[ i ];
                        if ( rscriptType.test( node.type || "" ) &&
                            !dataPriv.access( node, "globalEval" ) &&
                            jQuery.contains( doc, node ) ) {
                            if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
                                if ( jQuery._evalUrl ) {
                                    jQuery._evalUrl( node.src );
                                }
                            } else {
                                DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
                            }
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove( elem, selector, keepData ) {
        var node,
            nodes = selector ? jQuery.filter( selector, elem ) : elem,
            i = 0;
        for ( ; ( node = nodes[ i ] ) != null; i++ ) {
            if ( !keepData && node.nodeType === 1 ) {
                jQuery.cleanData( getAll( node ) );
            }
            if ( node.parentNode ) {
                if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
                    setGlobalEval( getAll( node, "script" ) );
                }
                node.parentNode.removeChild( node );
            }
        }
        return elem;
    }
    jQuery.extend( {
        htmlPrefilter: function( html ) {
            return html.replace( rxhtmlTag, "<$1></$2>" );
        },
        clone: function( elem, dataAndEvents, deepDataAndEvents ) {
            var i, l, srcElements, destElements,
                clone = elem.cloneNode( true ),
                inPage = jQuery.contains( elem.ownerDocument, elem );
            if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                !jQuery.isXMLDoc( elem ) ) {
                destElements = getAll( clone );
                srcElements = getAll( elem );
                for ( i = 0, l = srcElements.length; i < l; i++ ) {
                    fixInput( srcElements[ i ], destElements[ i ] );
                }
            }
            if ( dataAndEvents ) {
                if ( deepDataAndEvents ) {
                    srcElements = srcElements || getAll( elem );
                    destElements = destElements || getAll( clone );
                    for ( i = 0, l = srcElements.length; i < l; i++ ) {
                        cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                    }
                } else {
                    cloneCopyEvent( elem, clone );
                }
            }
            destElements = getAll( clone, "script" );
            if ( destElements.length > 0 ) {
                setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
            }
            return clone;
        },
        cleanData: function( elems ) {
            var data, elem, type,
                special = jQuery.event.special,
                i = 0;
            for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
                if ( acceptData( elem ) ) {
                    if ( ( data = elem[ dataPriv.expando ] ) ) {
                        if ( data.events ) {
                            for ( type in data.events ) {
                                if ( special[ type ] ) {
                                    jQuery.event.remove( elem, type );
                                } else {
                                    jQuery.removeEvent( elem, type, data.handle );
                                }
                            }
                        }
                        elem[ dataPriv.expando ] = undefined;
                    }
                    if ( elem[ dataUser.expando ] ) {
                        elem[ dataUser.expando ] = undefined;
                    }
                }
            }
        }
    } );
    jQuery.fn.extend( {
        detach: function( selector ) {
            return remove( this, selector, true );
        },
        remove: function( selector ) {
            return remove( this, selector );
        },
        text: function( value ) {
            return access( this, function( value ) {
                return value === undefined ?
                    jQuery.text( this ) :
                    this.empty().each( function() {
                        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                            this.textContent = value;
                        }
                    } );
            }, null, value, arguments.length );
        },
        append: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                    var target = manipulationTarget( this, elem );
                    target.appendChild( elem );
                }
            } );
        },
        prepend: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                    var target = manipulationTarget( this, elem );
                    target.insertBefore( elem, target.firstChild );
                }
            } );
        },
        before: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.parentNode ) {
                    this.parentNode.insertBefore( elem, this );
                }
            } );
        },
        after: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.parentNode ) {
                    this.parentNode.insertBefore( elem, this.nextSibling );
                }
            } );
        },
        empty: function() {
            var elem,
                i = 0;
            for ( ; ( elem = this[ i ] ) != null; i++ ) {
                if ( elem.nodeType === 1 ) {
                    jQuery.cleanData( getAll( elem, false ) );
                    elem.textContent = "";
                }
            }
            return this;
        },
        clone: function( dataAndEvents, deepDataAndEvents ) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map( function() {
                return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
            } );
        },
        html: function( value ) {
            return access( this, function( value ) {
                var elem = this[ 0 ] || {},
                    i = 0,
                    l = this.length;
                if ( value === undefined && elem.nodeType === 1 ) {
                    return elem.innerHTML;
                }
                if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                    !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
                    value = jQuery.htmlPrefilter( value );
                    try {
                        for ( ; i < l; i++ ) {
                            elem = this[ i ] || {};
                            if ( elem.nodeType === 1 ) {
                                jQuery.cleanData( getAll( elem, false ) );
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    } catch ( e ) {}
                }
                if ( elem ) {
                    this.empty().append( value );
                }
            }, null, value, arguments.length );
        },
        replaceWith: function() {
            var ignored = [];
            return domManip( this, arguments, function( elem ) {
                var parent = this.parentNode;
                if ( jQuery.inArray( this, ignored ) < 0 ) {
                    jQuery.cleanData( getAll( this ) );
                    if ( parent ) {
                        parent.replaceChild( elem, this );
                    }
                }
            }, ignored );
        }
    } );
    jQuery.each( {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function( name, original ) {
        jQuery.fn[ name ] = function( selector ) {
            var elems,
                ret = [],
                insert = jQuery( selector ),
                last = insert.length - 1,
                i = 0;
            for ( ; i <= last; i++ ) {
                elems = i === last ? this : this.clone( true );
                jQuery( insert[ i ] )[ original ]( elems );
                push.apply( ret, elems.get() );
            }
            return this.pushStack( ret );
        };
    } );
    var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
    var getStyles = function( elem ) {
        var view = elem.ownerDocument.defaultView;
        if ( !view || !view.opener ) {
            view = window;
        }
        return view.getComputedStyle( elem );
    };
    var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
    ( function() {
        function computeStyleTests() {
            if ( !div ) {
                return;
            }
            container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
            div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
            documentElement.appendChild( container ).appendChild( div );
            var divStyle = window.getComputedStyle( div );
            pixelPositionVal = divStyle.top !== "1%";
            reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
            boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
            div.style.position = "absolute";
            scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
            documentElement.removeChild( container );
            div = null;
        }
        function roundPixelMeasures( measure ) {
            return Math.round( parseFloat( measure ) );
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
            reliableMarginLeftVal,
            container = document.createElement( "div" ),
            div = document.createElement( "div" );
        if ( !div.style ) {
            return;
        }
        div.style.backgroundClip = "content-box";
        div.cloneNode( true ).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend( support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            }
        } );
    } )();
    function curCSS( elem, name, computed ) {
        var width, minWidth, maxWidth, ret,
            style = elem.style;
        computed = computed || getStyles( elem );
        if ( computed ) {
            ret = computed.getPropertyValue( name ) || computed[ name ];
            if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
                ret = jQuery.style( elem, name );
            }
            if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ?
            ret + "" :
            ret;
    }
    function addGetHookIf( conditionFn, hookFn ) {
        return {
            get: function() {
                if ( conditionFn() ) {
                    delete this.get;
                    return;
                }
                return ( this.get = hookFn ).apply( this, arguments );
            }
        };
    }
    var
        rdisplayswap = /^(none|table(?!-c[ea]).+)/,
        rcustomProp = /^--/,
        cssShow = { position: "absolute", visibility: "hidden", display: "block" },
        cssNormalTransform = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        cssPrefixes = [ "Webkit", "Moz", "ms" ],
        emptyStyle = document.createElement( "div" ).style;
    function vendorPropName( name ) {
        if ( name in emptyStyle ) {
            return name;
        }
        var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
            i = cssPrefixes.length;
        while ( i-- ) {
            name = cssPrefixes[ i ] + capName;
            if ( name in emptyStyle ) {
                return name;
            }
        }
    }
    function finalPropName( name ) {
        var ret = jQuery.cssProps[ name ];
        if ( !ret ) {
            ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
        }
        return ret;
    }
    function setPositiveNumber( elem, value, subtract ) {
        var matches = rcssNum.exec( value );
        return matches ?
            Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
            value;
    }
    function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
        var i = dimension === "width" ? 1 : 0,
            extra = 0,
            delta = 0;
        if ( box === ( isBorderBox ? "border" : "content" ) ) {
            return 0;
        }
        for ( ; i < 4; i += 2 ) {
            if ( box === "margin" ) {
                delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
            }
            if ( !isBorderBox ) {
                delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
                if ( box !== "padding" ) {
                    delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                } else {
                    extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                }
            } else {
                if ( box === "content" ) {
                    delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
                }
                if ( box !== "margin" ) {
                    delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                }
            }
        }
        if ( !isBorderBox && computedVal >= 0 ) {
            delta += Math.max( 0, Math.ceil(
                elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                computedVal -
                delta -
                extra -
                0.5
            ) );
        }
        return delta;
    }
    function getWidthOrHeight( elem, dimension, extra ) {
        var styles = getStyles( elem ),
            val = curCSS( elem, dimension, styles ),
            isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
            valueIsBorderBox = isBorderBox;
        if ( rnumnonpx.test( val ) ) {
            if ( !extra ) {
                return val;
            }
            val = "auto";
        }
        valueIsBorderBox = valueIsBorderBox &&
            ( support.boxSizingReliable() || val === elem.style[ dimension ] );
        if ( val === "auto" ||
            !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
            val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
            valueIsBorderBox = true;
        }
        val = parseFloat( val ) || 0;
        return ( val +
            boxModelAdjustment(
                elem,
                dimension,
                extra || ( isBorderBox ? "border" : "content" ),
                valueIsBorderBox,
                styles,
                val
            )
        ) + "px";
    }
    jQuery.extend( {
        cssHooks: {
            opacity: {
                get: function( elem, computed ) {
                    if ( computed ) {
                        var ret = curCSS( elem, "opacity" );
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        cssProps: {},
        style: function( elem, name, value, extra ) {
            if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
                return;
            }
            var ret, type, hooks,
                origName = camelCase( name ),
                isCustomProp = rcustomProp.test( name ),
                style = elem.style;
            if ( !isCustomProp ) {
                name = finalPropName( origName );
            }
            hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
            if ( value !== undefined ) {
                type = typeof value;
                if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                    value = adjustCSS( elem, name, ret );
                    type = "number";
                }
                if ( value == null || value !== value ) {
                    return;
                }
                if ( type === "number" ) {
                    value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
                }
                if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                    style[ name ] = "inherit";
                }
                if ( !hooks || !( "set" in hooks ) ||
                    ( value = hooks.set( elem, value, extra ) ) !== undefined ) {
                    if ( isCustomProp ) {
                        style.setProperty( name, value );
                    } else {
                        style[ name ] = value;
                    }
                }
            } else {
                if ( hooks && "get" in hooks &&
                    ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
                    return ret;
                }
                return style[ name ];
            }
        },
        css: function( elem, name, extra, styles ) {
            var val, num, hooks,
                origName = camelCase( name ),
                isCustomProp = rcustomProp.test( name );
            if ( !isCustomProp ) {
                name = finalPropName( origName );
            }
            hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
            if ( hooks && "get" in hooks ) {
                val = hooks.get( elem, true, extra );
            }
            if ( val === undefined ) {
                val = curCSS( elem, name, styles );
            }
            if ( val === "normal" && name in cssNormalTransform ) {
                val = cssNormalTransform[ name ];
            }
            if ( extra === "" || extra ) {
                num = parseFloat( val );
                return extra === true || isFinite( num ) ? num || 0 : val;
            }
            return val;
        }
    } );
    jQuery.each( [ "height", "width" ], function( i, dimension ) {
        jQuery.cssHooks[ dimension ] = {
            get: function( elem, computed, extra ) {
                if ( computed ) {
                    return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
                    ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                        swap( elem, cssShow, function() {
                            return getWidthOrHeight( elem, dimension, extra );
                        } ) :
                        getWidthOrHeight( elem, dimension, extra );
                }
            },
            set: function( elem, value, extra ) {
                var matches,
                    styles = getStyles( elem ),
                    isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                    subtract = extra && boxModelAdjustment(
                        elem,
                        dimension,
                        extra,
                        isBorderBox,
                        styles
                    );
                if ( isBorderBox && support.scrollboxSize() === styles.position ) {
                    subtract -= Math.ceil(
                        elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                        parseFloat( styles[ dimension ] ) -
                        boxModelAdjustment( elem, dimension, "border", false, styles ) -
                        0.5
                    );
                }
                if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                    ( matches[ 3 ] || "px" ) !== "px" ) {
                    elem.style[ dimension ] = value;
                    value = jQuery.css( elem, dimension );
                }
                return setPositiveNumber( elem, value, subtract );
            }
        };
    } );
    jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
        function( elem, computed ) {
            if ( computed ) {
                return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                    elem.getBoundingClientRect().left -
                    swap( elem, { marginLeft: 0 }, function() {
                        return elem.getBoundingClientRect().left;
                    } )
                ) + "px";
            }
        }
    );
    jQuery.each( {
        margin: "",
        padding: "",
        border: "Width"
    }, function( prefix, suffix ) {
        jQuery.cssHooks[ prefix + suffix ] = {
            expand: function( value ) {
                var i = 0,
                    expanded = {},
                    parts = typeof value === "string" ? value.split( " " ) : [ value ];
                for ( ; i < 4; i++ ) {
                    expanded[ prefix + cssExpand[ i ] + suffix ] =
                        parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
                }
                return expanded;
            }
        };
        if ( prefix !== "margin" ) {
            jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
        }
    } );
    jQuery.fn.extend( {
        css: function( name, value ) {
            return access( this, function( elem, name, value ) {
                var styles, len,
                    map = {},
                    i = 0;
                if ( Array.isArray( name ) ) {
                    styles = getStyles( elem );
                    len = name.length;
                    for ( ; i < len; i++ ) {
                        map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                    }
                    return map;
                }
                return value !== undefined ?
                    jQuery.style( elem, name, value ) :
                    jQuery.css( elem, name );
            }, name, value, arguments.length > 1 );
        }
    } );
    function Tween( elem, options, prop, end, easing ) {
        return new Tween.prototype.init( elem, options, prop, end, easing );
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function( elem, options, prop, end, easing, unit ) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
        },
        cur: function() {
            var hooks = Tween.propHooks[ this.prop ];
            return hooks && hooks.get ?
                hooks.get( this ) :
                Tween.propHooks._default.get( this );
        },
        run: function( percent ) {
            var eased,
                hooks = Tween.propHooks[ this.prop ];
            if ( this.options.duration ) {
                this.pos = eased = jQuery.easing[ this.easing ](
                    percent, this.options.duration * percent, 0, 1, this.options.duration
                );
            } else {
                this.pos = eased = percent;
            }
            this.now = ( this.end - this.start ) * eased + this.start;
            if ( this.options.step ) {
                this.options.step.call( this.elem, this.now, this );
            }
            if ( hooks && hooks.set ) {
                hooks.set( this );
            } else {
                Tween.propHooks._default.set( this );
            }
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function( tween ) {
                var result;
                if ( tween.elem.nodeType !== 1 ||
                    tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                    return tween.elem[ tween.prop ];
                }
                result = jQuery.css( tween.elem, tween.prop, "" );
                return !result || result === "auto" ? 0 : result;
            },
            set: function( tween ) {
                if ( jQuery.fx.step[ tween.prop ] ) {
                    jQuery.fx.step[ tween.prop ]( tween );
                } else if ( tween.elem.nodeType === 1 &&
                    ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
                        jQuery.cssHooks[ tween.prop ] ) ) {
                    jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
                } else {
                    tween.elem[ tween.prop ] = tween.now;
                }
            }
        }
    };
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function( tween ) {
            if ( tween.elem.nodeType && tween.elem.parentNode ) {
                tween.elem[ tween.prop ] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function( p ) {
            return p;
        },
        swing: function( p ) {
            return 0.5 - Math.cos( p * Math.PI ) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    jQuery.fx.step = {};
    var
        fxNow, inProgress,
        rfxtypes = /^(?:toggle|show|hide)$/,
        rrun = /queueHooks$/;
    function schedule() {
        if ( inProgress ) {
            if ( document.hidden === false && window.requestAnimationFrame ) {
                window.requestAnimationFrame( schedule );
            } else {
                window.setTimeout( schedule, jQuery.fx.interval );
            }
            jQuery.fx.tick();
        }
    }
    function createFxNow() {
        window.setTimeout( function() {
            fxNow = undefined;
        } );
        return ( fxNow = Date.now() );
    }
    function genFx( type, includeWidth ) {
        var which,
            i = 0,
            attrs = { height: type };
        includeWidth = includeWidth ? 1 : 0;
        for ( ; i < 4; i += 2 - includeWidth ) {
            which = cssExpand[ i ];
            attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
        }
        if ( includeWidth ) {
            attrs.opacity = attrs.width = type;
        }
        return attrs;
    }
    function createTween( value, prop, animation ) {
        var tween,
            collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
            index = 0,
            length = collection.length;
        for ( ; index < length; index++ ) {
            if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
                return tween;
            }
        }
    }
    function defaultPrefilter( elem, props, opts ) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
            isBox = "width" in props || "height" in props,
            anim = this,
            orig = {},
            style = elem.style,
            hidden = elem.nodeType && isHiddenWithinTree( elem ),
            dataShow = dataPriv.get( elem, "fxshow" );
        if ( !opts.queue ) {
            hooks = jQuery._queueHooks( elem, "fx" );
            if ( hooks.unqueued == null ) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if ( !hooks.unqueued ) {
                        oldfire();
                    }
                };
            }
            hooks.unqueued++;
            anim.always( function() {
                anim.always( function() {
                    hooks.unqueued--;
                    if ( !jQuery.queue( elem, "fx" ).length ) {
                        hooks.empty.fire();
                    }
                } );
            } );
        }
        for ( prop in props ) {
            value = props[ prop ];
            if ( rfxtypes.test( value ) ) {
                delete props[ prop ];
                toggle = toggle || value === "toggle";
                if ( value === ( hidden ? "hide" : "show" ) ) {
                    if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                        hidden = true;
                    } else {
                        continue;
                    }
                }
                orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
            }
        }
        propTween = !jQuery.isEmptyObject( props );
        if ( !propTween && jQuery.isEmptyObject( orig ) ) {
            return;
        }
        if ( isBox && elem.nodeType === 1 ) {
            opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
            restoreDisplay = dataShow && dataShow.display;
            if ( restoreDisplay == null ) {
                restoreDisplay = dataPriv.get( elem, "display" );
            }
            display = jQuery.css( elem, "display" );
            if ( display === "none" ) {
                if ( restoreDisplay ) {
                    display = restoreDisplay;
                } else {
                    showHide( [ elem ], true );
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css( elem, "display" );
                    showHide( [ elem ] );
                }
            }
            if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
                if ( jQuery.css( elem, "float" ) === "none" ) {
                    if ( !propTween ) {
                        anim.done( function() {
                            style.display = restoreDisplay;
                        } );
                        if ( restoreDisplay == null ) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if ( opts.overflow ) {
            style.overflow = "hidden";
            anim.always( function() {
                style.overflow = opts.overflow[ 0 ];
                style.overflowX = opts.overflow[ 1 ];
                style.overflowY = opts.overflow[ 2 ];
            } );
        }
        propTween = false;
        for ( prop in orig ) {
            if ( !propTween ) {
                if ( dataShow ) {
                    if ( "hidden" in dataShow ) {
                        hidden = dataShow.hidden;
                    }
                } else {
                    dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
                }
                if ( toggle ) {
                    dataShow.hidden = !hidden;
                }
                if ( hidden ) {
                    showHide( [ elem ], true );
                }
                anim.done( function() {
                    if ( !hidden ) {
                        showHide( [ elem ] );
                    }
                    dataPriv.remove( elem, "fxshow" );
                    for ( prop in orig ) {
                        jQuery.style( elem, prop, orig[ prop ] );
                    }
                } );
            }
            propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
            if ( !( prop in dataShow ) ) {
                dataShow[ prop ] = propTween.start;
                if ( hidden ) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter( props, specialEasing ) {
        var index, name, easing, value, hooks;
        for ( index in props ) {
            name = camelCase( index );
            easing = specialEasing[ name ];
            value = props[ index ];
            if ( Array.isArray( value ) ) {
                easing = value[ 1 ];
                value = props[ index ] = value[ 0 ];
            }
            if ( index !== name ) {
                props[ name ] = value;
                delete props[ index ];
            }
            hooks = jQuery.cssHooks[ name ];
            if ( hooks && "expand" in hooks ) {
                value = hooks.expand( value );
                delete props[ name ];
                for ( index in value ) {
                    if ( !( index in props ) ) {
                        props[ index ] = value[ index ];
                        specialEasing[ index ] = easing;
                    }
                }
            } else {
                specialEasing[ name ] = easing;
            }
        }
    }
    function Animation( elem, properties, options ) {
        var result,
            stopped,
            index = 0,
            length = Animation.prefilters.length,
            deferred = jQuery.Deferred().always( function() {
                delete tick.elem;
            } ),
            tick = function() {
                if ( stopped ) {
                    return false;
                }
                var currentTime = fxNow || createFxNow(),
                    remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
                    temp = remaining / animation.duration || 0,
                    percent = 1 - temp,
                    index = 0,
                    length = animation.tweens.length;
                for ( ; index < length; index++ ) {
                    animation.tweens[ index ].run( percent );
                }
                deferred.notifyWith( elem, [ animation, percent, remaining ] );
                if ( percent < 1 && length ) {
                    return remaining;
                }
                if ( !length ) {
                    deferred.notifyWith( elem, [ animation, 1, 0 ] );
                }
                deferred.resolveWith( elem, [ animation ] );
                return false;
            },
            animation = deferred.promise( {
                elem: elem,
                props: jQuery.extend( {}, properties ),
                opts: jQuery.extend( true, {
                    specialEasing: {},
                    easing: jQuery.easing._default
                }, options ),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function( prop, end ) {
                    var tween = jQuery.Tween( elem, animation.opts, prop, end,
                        animation.opts.specialEasing[ prop ] || animation.opts.easing );
                    animation.tweens.push( tween );
                    return tween;
                },
                stop: function( gotoEnd ) {
                    var index = 0,
                        length = gotoEnd ? animation.tweens.length : 0;
                    if ( stopped ) {
                        return this;
                    }
                    stopped = true;
                    for ( ; index < length; index++ ) {
                        animation.tweens[ index ].run( 1 );
                    }
                    if ( gotoEnd ) {
                        deferred.notifyWith( elem, [ animation, 1, 0 ] );
                        deferred.resolveWith( elem, [ animation, gotoEnd ] );
                    } else {
                        deferred.rejectWith( elem, [ animation, gotoEnd ] );
                    }
                    return this;
                }
            } ),
            props = animation.props;
        propFilter( props, animation.opts.specialEasing );
        for ( ; index < length; index++ ) {
            result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
            if ( result ) {
                if ( isFunction( result.stop ) ) {
                    jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                        result.stop.bind( result );
                }
                return result;
            }
        }
        jQuery.map( props, createTween, animation );
        if ( isFunction( animation.opts.start ) ) {
            animation.opts.start.call( elem, animation );
        }
        animation
            .progress( animation.opts.progress )
            .done( animation.opts.done, animation.opts.complete )
            .fail( animation.opts.fail )
            .always( animation.opts.always );
        jQuery.fx.timer(
            jQuery.extend( tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue
            } )
        );
        return animation;
    }
    jQuery.Animation = jQuery.extend( Animation, {
        tweeners: {
            "*": [ function( prop, value ) {
                var tween = this.createTween( prop, value );
                adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
                return tween;
            } ]
        },
        tweener: function( props, callback ) {
            if ( isFunction( props ) ) {
                callback = props;
                props = [ "*" ];
            } else {
                props = props.match( rnothtmlwhite );
            }
            var prop,
                index = 0,
                length = props.length;
            for ( ; index < length; index++ ) {
                prop = props[ index ];
                Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
                Animation.tweeners[ prop ].unshift( callback );
            }
        },
        prefilters: [ defaultPrefilter ],
        prefilter: function( callback, prepend ) {
            if ( prepend ) {
                Animation.prefilters.unshift( callback );
            } else {
                Animation.prefilters.push( callback );
            }
        }
    } );
    jQuery.speed = function( speed, easing, fn ) {
        var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
            complete: fn || !fn && easing ||
                isFunction( speed ) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction( easing ) && easing
        };
        if ( jQuery.fx.off ) {
            opt.duration = 0;
        } else {
            if ( typeof opt.duration !== "number" ) {
                if ( opt.duration in jQuery.fx.speeds ) {
                    opt.duration = jQuery.fx.speeds[ opt.duration ];
                } else {
                    opt.duration = jQuery.fx.speeds._default;
                }
            }
        }
        if ( opt.queue == null || opt.queue === true ) {
            opt.queue = "fx";
        }
        opt.old = opt.complete;
        opt.complete = function() {
            if ( isFunction( opt.old ) ) {
                opt.old.call( this );
            }
            if ( opt.queue ) {
                jQuery.dequeue( this, opt.queue );
            }
        };
        return opt;
    };
    jQuery.fn.extend( {
        fadeTo: function( speed, to, easing, callback ) {
            return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
                .end().animate( { opacity: to }, speed, easing, callback );
        },
        animate: function( prop, speed, easing, callback ) {
            var empty = jQuery.isEmptyObject( prop ),
                optall = jQuery.speed( speed, easing, callback ),
                doAnimation = function() {
                    var anim = Animation( this, jQuery.extend( {}, prop ), optall );
                    if ( empty || dataPriv.get( this, "finish" ) ) {
                        anim.stop( true );
                    }
                };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ?
                this.each( doAnimation ) :
                this.queue( optall.queue, doAnimation );
        },
        stop: function( type, clearQueue, gotoEnd ) {
            var stopQueue = function( hooks ) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop( gotoEnd );
            };
            if ( typeof type !== "string" ) {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if ( clearQueue && type !== false ) {
                this.queue( type || "fx", [] );
            }
            return this.each( function() {
                var dequeue = true,
                    index = type != null && type + "queueHooks",
                    timers = jQuery.timers,
                    data = dataPriv.get( this );
                if ( index ) {
                    if ( data[ index ] && data[ index ].stop ) {
                        stopQueue( data[ index ] );
                    }
                } else {
                    for ( index in data ) {
                        if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                            stopQueue( data[ index ] );
                        }
                    }
                }
                for ( index = timers.length; index--; ) {
                    if ( timers[ index ].elem === this &&
                        ( type == null || timers[ index ].queue === type ) ) {
                        timers[ index ].anim.stop( gotoEnd );
                        dequeue = false;
                        timers.splice( index, 1 );
                    }
                }
                if ( dequeue || !gotoEnd ) {
                    jQuery.dequeue( this, type );
                }
            } );
        },
        finish: function( type ) {
            if ( type !== false ) {
                type = type || "fx";
            }
            return this.each( function() {
                var index,
                    data = dataPriv.get( this ),
                    queue = data[ type + "queue" ],
                    hooks = data[ type + "queueHooks" ],
                    timers = jQuery.timers,
                    length = queue ? queue.length : 0;
                data.finish = true;
                jQuery.queue( this, type, [] );
                if ( hooks && hooks.stop ) {
                    hooks.stop.call( this, true );
                }
                for ( index = timers.length; index--; ) {
                    if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                        timers[ index ].anim.stop( true );
                        timers.splice( index, 1 );
                    }
                }
                for ( index = 0; index < length; index++ ) {
                    if ( queue[ index ] && queue[ index ].finish ) {
                        queue[ index ].finish.call( this );
                    }
                }
                delete data.finish;
            } );
        }
    } );
    jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
        var cssFn = jQuery.fn[ name ];
        jQuery.fn[ name ] = function( speed, easing, callback ) {
            return speed == null || typeof speed === "boolean" ?
                cssFn.apply( this, arguments ) :
                this.animate( genFx( name, true ), speed, easing, callback );
        };
    } );
    jQuery.each( {
        slideDown: genFx( "show" ),
        slideUp: genFx( "hide" ),
        slideToggle: genFx( "toggle" ),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
    }, function( name, props ) {
        jQuery.fn[ name ] = function( speed, easing, callback ) {
            return this.animate( props, speed, easing, callback );
        };
    } );
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer,
            i = 0,
            timers = jQuery.timers;
        fxNow = Date.now();
        for ( ; i < timers.length; i++ ) {
            timer = timers[ i ];
            if ( !timer() && timers[ i ] === timer ) {
                timers.splice( i--, 1 );
            }
        }
        if ( !timers.length ) {
            jQuery.fx.stop();
        }
        fxNow = undefined;
    };
    jQuery.fx.timer = function( timer ) {
        jQuery.timers.push( timer );
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if ( inProgress ) {
            return;
        }
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    };
    jQuery.fn.delay = function( time, type ) {
        time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
        type = type || "fx";
        return this.queue( type, function( next, hooks ) {
            var timeout = window.setTimeout( next, time );
            hooks.stop = function() {
                window.clearTimeout( timeout );
            };
        } );
    };
    ( function() {
        var input = document.createElement( "input" ),
            select = document.createElement( "select" ),
            opt = select.appendChild( document.createElement( "option" ) );
        input.type = "checkbox";
        support.checkOn = input.value !== "";
        support.optSelected = opt.selected;
        input = document.createElement( "input" );
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    } )();
    var boolHook,
        attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend( {
        attr: function( name, value ) {
            return access( this, jQuery.attr, name, value, arguments.length > 1 );
        },
        removeAttr: function( name ) {
            return this.each( function() {
                jQuery.removeAttr( this, name );
            } );
        }
    } );
    jQuery.extend( {
        attr: function( elem, name, value ) {
            var ret, hooks,
                nType = elem.nodeType;
            if ( nType === 3 || nType === 8 || nType === 2 ) {
                return;
            }
            if ( typeof elem.getAttribute === "undefined" ) {
                return jQuery.prop( elem, name, value );
            }
            if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
                hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                    ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
            }
            if ( value !== undefined ) {
                if ( value === null ) {
                    jQuery.removeAttr( elem, name );
                    return;
                }
                if ( hooks && "set" in hooks &&
                    ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                    return ret;
                }
                elem.setAttribute( name, value + "" );
                return value;
            }
            if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                return ret;
            }
            ret = jQuery.find.attr( elem, name );
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function( elem, value ) {
                    if ( !support.radioValue && value === "radio" &&
                        nodeName( elem, "input" ) ) {
                        var val = elem.value;
                        elem.setAttribute( "type", value );
                        if ( val ) {
                            elem.value = val;
                        }
                        return value;
                    }
                }
            }
        },
        removeAttr: function( elem, value ) {
            var name,
                i = 0,
                attrNames = value && value.match( rnothtmlwhite );
            if ( attrNames && elem.nodeType === 1 ) {
                while ( ( name = attrNames[ i++ ] ) ) {
                    elem.removeAttribute( name );
                }
            }
        }
    } );
    boolHook = {
        set: function( elem, value, name ) {
            if ( value === false ) {
                jQuery.removeAttr( elem, name );
            } else {
                elem.setAttribute( name, name );
            }
            return name;
        }
    };
    jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
        var getter = attrHandle[ name ] || jQuery.find.attr;
        attrHandle[ name ] = function( elem, name, isXML ) {
            var ret, handle,
                lowercaseName = name.toLowerCase();
            if ( !isXML ) {
                handle = attrHandle[ lowercaseName ];
                attrHandle[ lowercaseName ] = ret;
                ret = getter( elem, name, isXML ) != null ?
                    lowercaseName :
                    null;
                attrHandle[ lowercaseName ] = handle;
            }
            return ret;
        };
    } );
    var rfocusable = /^(?:input|select|textarea|button)$/i,
        rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend( {
        prop: function( name, value ) {
            return access( this, jQuery.prop, name, value, arguments.length > 1 );
        },
        removeProp: function( name ) {
            return this.each( function() {
                delete this[ jQuery.propFix[ name ] || name ];
            } );
        }
    } );
    jQuery.extend( {
        prop: function( elem, name, value ) {
            var ret, hooks,
                nType = elem.nodeType;
            if ( nType === 3 || nType === 8 || nType === 2 ) {
                return;
            }
            if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
                name = jQuery.propFix[ name ] || name;
                hooks = jQuery.propHooks[ name ];
            }
            if ( value !== undefined ) {
                if ( hooks && "set" in hooks &&
                    ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                    return ret;
                }
                return ( elem[ name ] = value );
            }
            if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                return ret;
            }
            return elem[ name ];
        },
        propHooks: {
            tabIndex: {
                get: function( elem ) {
                    var tabindex = jQuery.find.attr( elem, "tabindex" );
                    if ( tabindex ) {
                        return parseInt( tabindex, 10 );
                    }
                    if (
                        rfocusable.test( elem.nodeName ) ||
                        rclickable.test( elem.nodeName ) &&
                        elem.href
                    ) {
                        return 0;
                    }
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    } );
    if ( !support.optSelected ) {
        jQuery.propHooks.selected = {
            get: function( elem ) {
                var parent = elem.parentNode;
                if ( parent && parent.parentNode ) {
                    parent.parentNode.selectedIndex;
                }
                return null;
            },
            set: function( elem ) {
                var parent = elem.parentNode;
                if ( parent ) {
                    parent.selectedIndex;
                    if ( parent.parentNode ) {
                        parent.parentNode.selectedIndex;
                    }
                }
            }
        };
    }
    jQuery.each( [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[ this.toLowerCase() ] = this;
    } );
    function stripAndCollapse( value ) {
        var tokens = value.match( rnothtmlwhite ) || [];
        return tokens.join( " " );
    }
    function getClass( elem ) {
        return elem.getAttribute && elem.getAttribute( "class" ) || "";
    }
    function classesToArray( value ) {
        if ( Array.isArray( value ) ) {
            return value;
        }
        if ( typeof value === "string" ) {
            return value.match( rnothtmlwhite ) || [];
        }
        return [];
    }
    jQuery.fn.extend( {
        addClass: function( value ) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;
            if ( isFunction( value ) ) {
                return this.each( function( j ) {
                    jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
                } );
            }
            classes = classesToArray( value );
            if ( classes.length ) {
                while ( ( elem = this[ i++ ] ) ) {
                    curValue = getClass( elem );
                    cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
                    if ( cur ) {
                        j = 0;
                        while ( ( clazz = classes[ j++ ] ) ) {
                            if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                                cur += clazz + " ";
                            }
                        }
                        finalValue = stripAndCollapse( cur );
                        if ( curValue !== finalValue ) {
                            elem.setAttribute( "class", finalValue );
                        }
                    }
                }
            }
            return this;
        },
        removeClass: function( value ) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;
            if ( isFunction( value ) ) {
                return this.each( function( j ) {
                    jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
                } );
            }
            if ( !arguments.length ) {
                return this.attr( "class", "" );
            }
            classes = classesToArray( value );
            if ( classes.length ) {
                while ( ( elem = this[ i++ ] ) ) {
                    curValue = getClass( elem );
                    cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
                    if ( cur ) {
                        j = 0;
                        while ( ( clazz = classes[ j++ ] ) ) {
                            while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
                                cur = cur.replace( " " + clazz + " ", " " );
                            }
                        }
                        finalValue = stripAndCollapse( cur );
                        if ( curValue !== finalValue ) {
                            elem.setAttribute( "class", finalValue );
                        }
                    }
                }
            }
            return this;
        },
        toggleClass: function( value, stateVal ) {
            var type = typeof value,
                isValidValue = type === "string" || Array.isArray( value );
            if ( typeof stateVal === "boolean" && isValidValue ) {
                return stateVal ? this.addClass( value ) : this.removeClass( value );
            }
            if ( isFunction( value ) ) {
                return this.each( function( i ) {
                    jQuery( this ).toggleClass(
                        value.call( this, i, getClass( this ), stateVal ),
                        stateVal
                    );
                } );
            }
            return this.each( function() {
                var className, i, self, classNames;
                if ( isValidValue ) {
                    i = 0;
                    self = jQuery( this );
                    classNames = classesToArray( value );
                    while ( ( className = classNames[ i++ ] ) ) {
                        if ( self.hasClass( className ) ) {
                            self.removeClass( className );
                        } else {
                            self.addClass( className );
                        }
                    }
                } else if ( value === undefined || type === "boolean" ) {
                    className = getClass( this );
                    if ( className ) {
                        dataPriv.set( this, "__className__", className );
                    }
                    if ( this.setAttribute ) {
                        this.setAttribute( "class",
                            className || value === false ?
                                "" :
                                dataPriv.get( this, "__className__" ) || ""
                        );
                    }
                }
            } );
        },
        hasClass: function( selector ) {
            var className, elem,
                i = 0;
            className = " " + selector + " ";
            while ( ( elem = this[ i++ ] ) ) {
                if ( elem.nodeType === 1 &&
                    ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                    return true;
                }
            }
            return false;
        }
    } );
    var rreturn = /\r/g;
    jQuery.fn.extend( {
        val: function( value ) {
            var hooks, ret, valueIsFunction,
                elem = this[ 0 ];
            if ( !arguments.length ) {
                if ( elem ) {
                    hooks = jQuery.valHooks[ elem.type ] ||
                        jQuery.valHooks[ elem.nodeName.toLowerCase() ];
                    if ( hooks &&
                        "get" in hooks &&
                        ( ret = hooks.get( elem, "value" ) ) !== undefined
                    ) {
                        return ret;
                    }
                    ret = elem.value;
                    if ( typeof ret === "string" ) {
                        return ret.replace( rreturn, "" );
                    }
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction( value );
            return this.each( function( i ) {
                var val;
                if ( this.nodeType !== 1 ) {
                    return;
                }
                if ( valueIsFunction ) {
                    val = value.call( this, i, jQuery( this ).val() );
                } else {
                    val = value;
                }
                if ( val == null ) {
                    val = "";
                } else if ( typeof val === "number" ) {
                    val += "";
                } else if ( Array.isArray( val ) ) {
                    val = jQuery.map( val, function( value ) {
                        return value == null ? "" : value + "";
                    } );
                }
                hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
                if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                    this.value = val;
                }
            } );
        }
    } );
    jQuery.extend( {
        valHooks: {
            option: {
                get: function( elem ) {
                    var val = jQuery.find.attr( elem, "value" );
                    return val != null ?
                        val :
                        stripAndCollapse( jQuery.text( elem ) );
                }
            },
            select: {
                get: function( elem ) {
                    var value, option, i,
                        options = elem.options,
                        index = elem.selectedIndex,
                        one = elem.type === "select-one",
                        values = one ? null : [],
                        max = one ? index + 1 : options.length;
                    if ( index < 0 ) {
                        i = max;
                    } else {
                        i = one ? index : 0;
                    }
                    for ( ; i < max; i++ ) {
                        option = options[ i ];
                        if ( ( option.selected || i === index ) &&
                            !option.disabled &&
                            ( !option.parentNode.disabled ||
                                !nodeName( option.parentNode, "optgroup" ) ) ) {
                            value = jQuery( option ).val();
                            if ( one ) {
                                return value;
                            }
                            values.push( value );
                        }
                    }
                    return values;
                },
                set: function( elem, value ) {
                    var optionSet, option,
                        options = elem.options,
                        values = jQuery.makeArray( value ),
                        i = options.length;
                    while ( i-- ) {
                        option = options[ i ];
                        if ( option.selected =
                            jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                        ) {
                            optionSet = true;
                        }
                    }
                    if ( !optionSet ) {
                        elem.selectedIndex = -1;
                    }
                    return values;
                }
            }
        }
    } );
    jQuery.each( [ "radio", "checkbox" ], function() {
        jQuery.valHooks[ this ] = {
            set: function( elem, value ) {
                if ( Array.isArray( value ) ) {
                    return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
                }
            }
        };
        if ( !support.checkOn ) {
            jQuery.valHooks[ this ].get = function( elem ) {
                return elem.getAttribute( "value" ) === null ? "on" : elem.value;
            };
        }
    } );
    support.focusin = "onfocusin" in window;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
        stopPropagationCallback = function( e ) {
            e.stopPropagation();
        };
    jQuery.extend( jQuery.event, {
        trigger: function( event, data, elem, onlyHandlers ) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
                eventPath = [ elem || document ],
                type = hasOwn.call( event, "type" ) ? event.type : event,
                namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
            cur = lastElement = tmp = elem = elem || document;
            if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
                return;
            }
            if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
                return;
            }
            if ( type.indexOf( "." ) > -1 ) {
                namespaces = type.split( "." );
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf( ":" ) < 0 && "on" + type;
            event = event[ jQuery.expando ] ?
                event :
                new jQuery.Event( type, typeof event === "object" && event );
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join( "." );
            event.rnamespace = event.namespace ?
                new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
                null;
            event.result = undefined;
            if ( !event.target ) {
                event.target = elem;
            }
            data = data == null ?
                [ event ] :
                jQuery.makeArray( data, [ event ] );
            special = jQuery.event.special[ type ] || {};
            if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
                return;
            }
            if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
                bubbleType = special.delegateType || type;
                if ( !rfocusMorph.test( bubbleType + type ) ) {
                    cur = cur.parentNode;
                }
                for ( ; cur; cur = cur.parentNode ) {
                    eventPath.push( cur );
                    tmp = cur;
                }
                if ( tmp === ( elem.ownerDocument || document ) ) {
                    eventPath.push( tmp.defaultView || tmp.parentWindow || window );
                }
            }
            i = 0;
            while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
                lastElement = cur;
                event.type = i > 1 ?
                    bubbleType :
                    special.bindType || type;
                handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
                    dataPriv.get( cur, "handle" );
                if ( handle ) {
                    handle.apply( cur, data );
                }
                handle = ontype && cur[ ontype ];
                if ( handle && handle.apply && acceptData( cur ) ) {
                    event.result = handle.apply( cur, data );
                    if ( event.result === false ) {
                        event.preventDefault();
                    }
                }
            }
            event.type = type;
            if ( !onlyHandlers && !event.isDefaultPrevented() ) {
                if ( ( !special._default ||
                    special._default.apply( eventPath.pop(), data ) === false ) &&
                    acceptData( elem ) ) {
                    if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
                        tmp = elem[ ontype ];
                        if ( tmp ) {
                            elem[ ontype ] = null;
                        }
                        jQuery.event.triggered = type;
                        if ( event.isPropagationStopped() ) {
                            lastElement.addEventListener( type, stopPropagationCallback );
                        }
                        elem[ type ]();
                        if ( event.isPropagationStopped() ) {
                            lastElement.removeEventListener( type, stopPropagationCallback );
                        }
                        jQuery.event.triggered = undefined;
                        if ( tmp ) {
                            elem[ ontype ] = tmp;
                        }
                    }
                }
            }
            return event.result;
        },
        simulate: function( type, elem, event ) {
            var e = jQuery.extend(
                new jQuery.Event(),
                event,
                {
                    type: type,
                    isSimulated: true
                }
            );
            jQuery.event.trigger( e, null, elem );
        }
    } );
    jQuery.fn.extend( {
        trigger: function( type, data ) {
            return this.each( function() {
                jQuery.event.trigger( type, data, this );
            } );
        },
        triggerHandler: function( type, data ) {
            var elem = this[ 0 ];
            if ( elem ) {
                return jQuery.event.trigger( type, data, elem, true );
            }
        }
    } );
    if ( !support.focusin ) {
        jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
            var handler = function( event ) {
                jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
            };
            jQuery.event.special[ fix ] = {
                setup: function() {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access( doc, fix );
                    if ( !attaches ) {
                        doc.addEventListener( orig, handler, true );
                    }
                    dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
                },
                teardown: function() {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access( doc, fix ) - 1;
                    if ( !attaches ) {
                        doc.removeEventListener( orig, handler, true );
                        dataPriv.remove( doc, fix );
                    } else {
                        dataPriv.access( doc, fix, attaches );
                    }
                }
            };
        } );
    }
    var location = window.location;
    var nonce = Date.now();
    var rquery = ( /\?/ );
    jQuery.parseXML = function( data ) {
        var xml;
        if ( !data || typeof data !== "string" ) {
            return null;
        }
        try {
            xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
        } catch ( e ) {
            xml = undefined;
        }
        if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
            jQuery.error( "Invalid XML: " + data );
        }
        return xml;
    };
    var
        rbracket = /\[\]$/,
        rCRLF = /\r?\n/g,
        rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
        rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams( prefix, obj, traditional, add ) {
        var name;
        if ( Array.isArray( obj ) ) {
            jQuery.each( obj, function( i, v ) {
                if ( traditional || rbracket.test( prefix ) ) {
                    add( prefix, v );
                } else {
                    buildParams(
                        prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                        v,
                        traditional,
                        add
                    );
                }
            } );
        } else if ( !traditional && toType( obj ) === "object" ) {
            for ( name in obj ) {
                buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
            }
        } else {
            add( prefix, obj );
        }
    }
    jQuery.param = function( a, traditional ) {
        var prefix,
            s = [],
            add = function( key, valueOrFunction ) {
                var value = isFunction( valueOrFunction ) ?
                    valueOrFunction() :
                    valueOrFunction;
                s[ s.length ] = encodeURIComponent( key ) + "=" +
                    encodeURIComponent( value == null ? "" : value );
            };
        if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
            jQuery.each( a, function() {
                add( this.name, this.value );
            } );
        } else {
            for ( prefix in a ) {
                buildParams( prefix, a[ prefix ], traditional, add );
            }
        }
        return s.join( "&" );
    };
    jQuery.fn.extend( {
        serialize: function() {
            return jQuery.param( this.serializeArray() );
        },
        serializeArray: function() {
            return this.map( function() {
                var elements = jQuery.prop( this, "elements" );
                return elements ? jQuery.makeArray( elements ) : this;
            } )
                .filter( function() {
                    var type = this.type;
                    return this.name && !jQuery( this ).is( ":disabled" ) &&
                        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                        ( this.checked || !rcheckableType.test( type ) );
                } )
                .map( function( i, elem ) {
                    var val = jQuery( this ).val();
                    if ( val == null ) {
                        return null;
                    }
                    if ( Array.isArray( val ) ) {
                        return jQuery.map( val, function( val ) {
                            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                        } );
                    }
                    return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                } ).get();
        }
    } );
    var
        r20 = /%20/g,
        rhash = /#.*$/,
        rantiCache = /([?&])_=[^&]*/,
        rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
        rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        rnoContent = /^(?:GET|HEAD)$/,
        rprotocol = /^\/\//,
        prefilters = {},
        transports = {},
        allTypes = "*/".concat( "*" ),
        originAnchor = document.createElement( "a" );
    originAnchor.href = location.href;
    function addToPrefiltersOrTransports( structure ) {
        return function( dataTypeExpression, func ) {
            if ( typeof dataTypeExpression !== "string" ) {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType,
                i = 0,
                dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
            if ( isFunction( func ) ) {
                while ( ( dataType = dataTypes[ i++ ] ) ) {
                    if ( dataType[ 0 ] === "+" ) {
                        dataType = dataType.slice( 1 ) || "*";
                        ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
                    } else {
                        ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                    }
                }
            }
        };
    }
    function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
        var inspected = {},
            seekingTransport = ( structure === transports );
        function inspect( dataType ) {
            var selected;
            inspected[ dataType ] = true;
            jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
                var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
                if ( typeof dataTypeOrTransport === "string" &&
                    !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
                    options.dataTypes.unshift( dataTypeOrTransport );
                    inspect( dataTypeOrTransport );
                    return false;
                } else if ( seekingTransport ) {
                    return !( selected = dataTypeOrTransport );
                }
            } );
            return selected;
        }
        return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
    }
    function ajaxExtend( target, src ) {
        var key, deep,
            flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for ( key in src ) {
            if ( src[ key ] !== undefined ) {
                ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
            }
        }
        if ( deep ) {
            jQuery.extend( true, target, deep );
        }
        return target;
    }
    function ajaxHandleResponses( s, jqXHR, responses ) {
        var ct, type, finalDataType, firstDataType,
            contents = s.contents,
            dataTypes = s.dataTypes;
        while ( dataTypes[ 0 ] === "*" ) {
            dataTypes.shift();
            if ( ct === undefined ) {
                ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
            }
        }
        if ( ct ) {
            for ( type in contents ) {
                if ( contents[ type ] && contents[ type ].test( ct ) ) {
                    dataTypes.unshift( type );
                    break;
                }
            }
        }
        if ( dataTypes[ 0 ] in responses ) {
            finalDataType = dataTypes[ 0 ];
        } else {
            for ( type in responses ) {
                if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                    finalDataType = type;
                    break;
                }
                if ( !firstDataType ) {
                    firstDataType = type;
                }
            }
            finalDataType = finalDataType || firstDataType;
        }
        if ( finalDataType ) {
            if ( finalDataType !== dataTypes[ 0 ] ) {
                dataTypes.unshift( finalDataType );
            }
            return responses[ finalDataType ];
        }
    }
    function ajaxConvert( s, response, jqXHR, isSuccess ) {
        var conv2, current, conv, tmp, prev,
            converters = {},
            dataTypes = s.dataTypes.slice();
        if ( dataTypes[ 1 ] ) {
            for ( conv in s.converters ) {
                converters[ conv.toLowerCase() ] = s.converters[ conv ];
            }
        }
        current = dataTypes.shift();
        while ( current ) {
            if ( s.responseFields[ current ] ) {
                jqXHR[ s.responseFields[ current ] ] = response;
            }
            if ( !prev && isSuccess && s.dataFilter ) {
                response = s.dataFilter( response, s.dataType );
            }
            prev = current;
            current = dataTypes.shift();
            if ( current ) {
                if ( current === "*" ) {
                    current = prev;
                } else if ( prev !== "*" && prev !== current ) {
                    conv = converters[ prev + " " + current ] || converters[ "* " + current ];
                    if ( !conv ) {
                        for ( conv2 in converters ) {
                            tmp = conv2.split( " " );
                            if ( tmp[ 1 ] === current ) {
                                conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                    converters[ "* " + tmp[ 0 ] ];
                                if ( conv ) {
                                    if ( conv === true ) {
                                        conv = converters[ conv2 ];
                                    } else if ( converters[ conv2 ] !== true ) {
                                        current = tmp[ 0 ];
                                        dataTypes.unshift( tmp[ 1 ] );
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    if ( conv !== true ) {
                        if ( conv && s.throws ) {
                            response = conv( response );
                        } else {
                            try {
                                response = conv( response );
                            } catch ( e ) {
                                return {
                                    state: "parsererror",
                                    error: conv ? e : "No conversion from " + prev + " to " + current
                                };
                            }
                        }
                    }
                }
            }
        }
        return { state: "success", data: response };
    }
    jQuery.extend( {
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test( location.protocol ),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": true,
                "text json": JSON.parse,
                "text xml": jQuery.parseXML
            },
            flatOptions: {
                url: true,
                context: true
            }
        },
        ajaxSetup: function( target, settings ) {
            return settings ?
                ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
                ajaxExtend( jQuery.ajaxSettings, target );
        },
        ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
        ajaxTransport: addToPrefiltersOrTransports( transports ),
        ajax: function( url, options ) {
            if ( typeof url === "object" ) {
                options = url;
                url = undefined;
            }
            options = options || {};
            var transport,
                cacheURL,
                responseHeadersString,
                responseHeaders,
                timeoutTimer,
                urlAnchor,
                completed,
                fireGlobals,
                i,
                uncached,
                s = jQuery.ajaxSetup( {}, options ),
                callbackContext = s.context || s,
                globalEventContext = s.context &&
                ( callbackContext.nodeType || callbackContext.jquery ) ?
                    jQuery( callbackContext ) :
                    jQuery.event,
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks( "once memory" ),
                statusCode = s.statusCode || {},
                requestHeaders = {},
                requestHeadersNames = {},
                strAbort = "canceled",
                jqXHR = {
                    readyState: 0,
                    getResponseHeader: function( key ) {
                        var match;
                        if ( completed ) {
                            if ( !responseHeaders ) {
                                responseHeaders = {};
                                while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                    responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
                                }
                            }
                            match = responseHeaders[ key.toLowerCase() ];
                        }
                        return match == null ? null : match;
                    },
                    getAllResponseHeaders: function() {
                        return completed ? responseHeadersString : null;
                    },
                    setRequestHeader: function( name, value ) {
                        if ( completed == null ) {
                            name = requestHeadersNames[ name.toLowerCase() ] =
                                requestHeadersNames[ name.toLowerCase() ] || name;
                            requestHeaders[ name ] = value;
                        }
                        return this;
                    },
                    overrideMimeType: function( type ) {
                        if ( completed == null ) {
                            s.mimeType = type;
                        }
                        return this;
                    },
                    statusCode: function( map ) {
                        var code;
                        if ( map ) {
                            if ( completed ) {
                                jqXHR.always( map[ jqXHR.status ] );
                            } else {
                                for ( code in map ) {
                                    statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                                }
                            }
                        }
                        return this;
                    },
                    abort: function( statusText ) {
                        var finalText = statusText || strAbort;
                        if ( transport ) {
                            transport.abort( finalText );
                        }
                        done( 0, finalText );
                        return this;
                    }
                };
            deferred.promise( jqXHR );
            s.url = ( ( url || s.url || location.href ) + "" )
                .replace( rprotocol, location.protocol + "//" );
            s.type = options.method || options.type || s.method || s.type;
            s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
            if ( s.crossDomain == null ) {
                urlAnchor = document.createElement( "a" );
                try {
                    urlAnchor.href = s.url;
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                        urlAnchor.protocol + "//" + urlAnchor.host;
                } catch ( e ) {
                    s.crossDomain = true;
                }
            }
            if ( s.data && s.processData && typeof s.data !== "string" ) {
                s.data = jQuery.param( s.data, s.traditional );
            }
            inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
            if ( completed ) {
                return jqXHR;
            }
            fireGlobals = jQuery.event && s.global;
            if ( fireGlobals && jQuery.active++ === 0 ) {
                jQuery.event.trigger( "ajaxStart" );
            }
            s.type = s.type.toUpperCase();
            s.hasContent = !rnoContent.test( s.type );
            cacheURL = s.url.replace( rhash, "" );
            if ( !s.hasContent ) {
                uncached = s.url.slice( cacheURL.length );
                if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
                    cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
                    delete s.data;
                }
                if ( s.cache === false ) {
                    cacheURL = cacheURL.replace( rantiCache, "$1" );
                    uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
                }
                s.url = cacheURL + uncached;
            } else if ( s.data && s.processData &&
                ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
                s.data = s.data.replace( r20, "+" );
            }
            if ( s.ifModified ) {
                if ( jQuery.lastModified[ cacheURL ] ) {
                    jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
                }
                if ( jQuery.etag[ cacheURL ] ) {
                    jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
                }
            }
            if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
                jqXHR.setRequestHeader( "Content-Type", s.contentType );
            }
            jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                    s.accepts[ s.dataTypes[ 0 ] ] +
                    ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                    s.accepts[ "*" ]
            );
            for ( i in s.headers ) {
                jqXHR.setRequestHeader( i, s.headers[ i ] );
            }
            if ( s.beforeSend &&
                ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
                return jqXHR.abort();
            }
            strAbort = "abort";
            completeDeferred.add( s.complete );
            jqXHR.done( s.success );
            jqXHR.fail( s.error );
            transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
            if ( !transport ) {
                done( -1, "No Transport" );
            } else {
                jqXHR.readyState = 1;
                if ( fireGlobals ) {
                    globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
                }
                if ( completed ) {
                    return jqXHR;
                }
                if ( s.async && s.timeout > 0 ) {
                    timeoutTimer = window.setTimeout( function() {
                        jqXHR.abort( "timeout" );
                    }, s.timeout );
                }
                try {
                    completed = false;
                    transport.send( requestHeaders, done );
                } catch ( e ) {
                    if ( completed ) {
                        throw e;
                    }
                    done( -1, e );
                }
            }
            function done( status, nativeStatusText, responses, headers ) {
                var isSuccess, success, error, response, modified,
                    statusText = nativeStatusText;
                if ( completed ) {
                    return;
                }
                completed = true;
                if ( timeoutTimer ) {
                    window.clearTimeout( timeoutTimer );
                }
                transport = undefined;
                responseHeadersString = headers || "";
                jqXHR.readyState = status > 0 ? 4 : 0;
                isSuccess = status >= 200 && status < 300 || status === 304;
                if ( responses ) {
                    response = ajaxHandleResponses( s, jqXHR, responses );
                }
                response = ajaxConvert( s, response, jqXHR, isSuccess );
                if ( isSuccess ) {
                    if ( s.ifModified ) {
                        modified = jqXHR.getResponseHeader( "Last-Modified" );
                        if ( modified ) {
                            jQuery.lastModified[ cacheURL ] = modified;
                        }
                        modified = jqXHR.getResponseHeader( "etag" );
                        if ( modified ) {
                            jQuery.etag[ cacheURL ] = modified;
                        }
                    }
                    if ( status === 204 || s.type === "HEAD" ) {
                        statusText = "nocontent";
                    } else if ( status === 304 ) {
                        statusText = "notmodified";
                    } else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    error = statusText;
                    if ( status || !statusText ) {
                        statusText = "error";
                        if ( status < 0 ) {
                            status = 0;
                        }
                    }
                }
                jqXHR.status = status;
                jqXHR.statusText = ( nativeStatusText || statusText ) + "";
                if ( isSuccess ) {
                    deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
                } else {
                    deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
                }
                jqXHR.statusCode( statusCode );
                statusCode = undefined;
                if ( fireGlobals ) {
                    globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                        [ jqXHR, s, isSuccess ? success : error ] );
                }
                completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
                if ( fireGlobals ) {
                    globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
                    if ( !( --jQuery.active ) ) {
                        jQuery.event.trigger( "ajaxStop" );
                    }
                }
            }
            return jqXHR;
        },
        getJSON: function( url, data, callback ) {
            return jQuery.get( url, data, callback, "json" );
        },
        getScript: function( url, callback ) {
            return jQuery.get( url, undefined, callback, "script" );
        }
    } );
    jQuery.each( [ "get", "post" ], function( i, method ) {
        jQuery[ method ] = function( url, data, callback, type ) {
            if ( isFunction( data ) ) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            return jQuery.ajax( jQuery.extend( {
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject( url ) && url ) );
        };
    } );
    jQuery._evalUrl = function( url ) {
        return jQuery.ajax( {
            url: url,
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            "throws": true
        } );
    };
    jQuery.fn.extend( {
        wrapAll: function( html ) {
            var wrap;
            if ( this[ 0 ] ) {
                if ( isFunction( html ) ) {
                    html = html.call( this[ 0 ] );
                }
                wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
                if ( this[ 0 ].parentNode ) {
                    wrap.insertBefore( this[ 0 ] );
                }
                wrap.map( function() {
                    var elem = this;
                    while ( elem.firstElementChild ) {
                        elem = elem.firstElementChild;
                    }
                    return elem;
                } ).append( this );
            }
            return this;
        },
        wrapInner: function( html ) {
            if ( isFunction( html ) ) {
                return this.each( function( i ) {
                    jQuery( this ).wrapInner( html.call( this, i ) );
                } );
            }
            return this.each( function() {
                var self = jQuery( this ),
                    contents = self.contents();
                if ( contents.length ) {
                    contents.wrapAll( html );
                } else {
                    self.append( html );
                }
            } );
        },
        wrap: function( html ) {
            var htmlIsFunction = isFunction( html );
            return this.each( function( i ) {
                jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
            } );
        },
        unwrap: function( selector ) {
            this.parent( selector ).not( "body" ).each( function() {
                jQuery( this ).replaceWith( this.childNodes );
            } );
            return this;
        }
    } );
    jQuery.expr.pseudos.hidden = function( elem ) {
        return !jQuery.expr.pseudos.visible( elem );
    };
    jQuery.expr.pseudos.visible = function( elem ) {
        return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window.XMLHttpRequest();
        } catch ( e ) {}
    };
    var xhrSuccessStatus = {
            0: 200,
            1223: 204
        },
        xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport( function( options ) {
        var callback, errorCallback;
        if ( support.cors || xhrSupported && !options.crossDomain ) {
            return {
                send: function( headers, complete ) {
                    var i,
                        xhr = options.xhr();
                    xhr.open(
                        options.type,
                        options.url,
                        options.async,
                        options.username,
                        options.password
                    );
                    if ( options.xhrFields ) {
                        for ( i in options.xhrFields ) {
                            xhr[ i ] = options.xhrFields[ i ];
                        }
                    }
                    if ( options.mimeType && xhr.overrideMimeType ) {
                        xhr.overrideMimeType( options.mimeType );
                    }
                    if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                        headers[ "X-Requested-With" ] = "XMLHttpRequest";
                    }
                    for ( i in headers ) {
                        xhr.setRequestHeader( i, headers[ i ] );
                    }
                    callback = function( type ) {
                        return function() {
                            if ( callback ) {
                                callback = errorCallback = xhr.onload =
                                    xhr.onerror = xhr.onabort = xhr.ontimeout =
                                        xhr.onreadystatechange = null;
                                if ( type === "abort" ) {
                                    xhr.abort();
                                } else if ( type === "error" ) {
                                    if ( typeof xhr.status !== "number" ) {
                                        complete( 0, "error" );
                                    } else {
                                        complete(
                                            xhr.status,
                                            xhr.statusText
                                        );
                                    }
                                } else {
                                    complete(
                                        xhrSuccessStatus[ xhr.status ] || xhr.status,
                                        xhr.statusText,
                                        ( xhr.responseType || "text" ) !== "text"  ||
                                        typeof xhr.responseText !== "string" ?
                                            { binary: xhr.response } :
                                            { text: xhr.responseText },
                                        xhr.getAllResponseHeaders()
                                    );
                                }
                            }
                        };
                    };
                    xhr.onload = callback();
                    errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
                    if ( xhr.onabort !== undefined ) {
                        xhr.onabort = errorCallback;
                    } else {
                        xhr.onreadystatechange = function() {
                            if ( xhr.readyState === 4 ) {
                                window.setTimeout( function() {
                                    if ( callback ) {
                                        errorCallback();
                                    }
                                } );
                            }
                        };
                    }
                    callback = callback( "abort" );
                    try {
                        xhr.send( options.hasContent && options.data || null );
                    } catch ( e ) {
                        if ( callback ) {
                            throw e;
                        }
                    }
                },
                abort: function() {
                    if ( callback ) {
                        callback();
                    }
                }
            };
        }
    } );
    jQuery.ajaxPrefilter( function( s ) {
        if ( s.crossDomain ) {
            s.contents.script = false;
        }
    } );
    jQuery.ajaxSetup( {
        accepts: {
            script: "text/javascript, application/javascript, " +
                "application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function( text ) {
                jQuery.globalEval( text );
                return text;
            }
        }
    } );
    jQuery.ajaxPrefilter( "script", function( s ) {
        if ( s.cache === undefined ) {
            s.cache = false;
        }
        if ( s.crossDomain ) {
            s.type = "GET";
        }
    } );
    jQuery.ajaxTransport( "script", function( s ) {
        if ( s.crossDomain ) {
            var script, callback;
            return {
                send: function( _, complete ) {
                    script = jQuery( "<script>" ).prop( {
                        charset: s.scriptCharset,
                        src: s.url
                    } ).on(
                        "load error",
                        callback = function( evt ) {
                            script.remove();
                            callback = null;
                            if ( evt ) {
                                complete( evt.type === "error" ? 404 : 200, evt.type );
                            }
                        }
                    );
                    document.head.appendChild( script[ 0 ] );
                },
                abort: function() {
                    if ( callback ) {
                        callback();
                    }
                }
            };
        }
    } );
    var oldCallbacks = [],
        rjsonp = /(=)\?(?=&|$)|\?\?/;
    jQuery.ajaxSetup( {
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
            this[ callback ] = true;
            return callback;
        }
    } );
    jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
        var callbackName, overwritten, responseContainer,
            jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
                    "url" :
                    typeof s.data === "string" &&
                    ( s.contentType || "" )
                        .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                    rjsonp.test( s.data ) && "data"
            );
        if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
            callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
                s.jsonpCallback() :
                s.jsonpCallback;
            if ( jsonProp ) {
                s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
            } else if ( s.jsonp !== false ) {
                s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
            }
            s.converters[ "script json" ] = function() {
                if ( !responseContainer ) {
                    jQuery.error( callbackName + " was not called" );
                }
                return responseContainer[ 0 ];
            };
            s.dataTypes[ 0 ] = "json";
            overwritten = window[ callbackName ];
            window[ callbackName ] = function() {
                responseContainer = arguments;
            };
            jqXHR.always( function() {
                if ( overwritten === undefined ) {
                    jQuery( window ).removeProp( callbackName );
                } else {
                    window[ callbackName ] = overwritten;
                }
                if ( s[ callbackName ] ) {
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    oldCallbacks.push( callbackName );
                }
                if ( responseContainer && isFunction( overwritten ) ) {
                    overwritten( responseContainer[ 0 ] );
                }
                responseContainer = overwritten = undefined;
            } );
            return "script";
        }
    } );
    support.createHTMLDocument = ( function() {
        var body = document.implementation.createHTMLDocument( "" ).body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    } )();
    jQuery.parseHTML = function( data, context, keepScripts ) {
        if ( typeof data !== "string" ) {
            return [];
        }
        if ( typeof context === "boolean" ) {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if ( !context ) {
            if ( support.createHTMLDocument ) {
                context = document.implementation.createHTMLDocument( "" );
                base = context.createElement( "base" );
                base.href = document.location.href;
                context.head.appendChild( base );
            } else {
                context = document;
            }
        }
        parsed = rsingleTag.exec( data );
        scripts = !keepScripts && [];
        if ( parsed ) {
            return [ context.createElement( parsed[ 1 ] ) ];
        }
        parsed = buildFragment( [ data ], context, scripts );
        if ( scripts && scripts.length ) {
            jQuery( scripts ).remove();
        }
        return jQuery.merge( [], parsed.childNodes );
    };
    jQuery.fn.load = function( url, params, callback ) {
        var selector, type, response,
            self = this,
            off = url.indexOf( " " );
        if ( off > -1 ) {
            selector = stripAndCollapse( url.slice( off ) );
            url = url.slice( 0, off );
        }
        if ( isFunction( params ) ) {
            callback = params;
            params = undefined;
        } else if ( params && typeof params === "object" ) {
            type = "POST";
        }
        if ( self.length > 0 ) {
            jQuery.ajax( {
                url: url,
                type: type || "GET",
                dataType: "html",
                data: params
            } ).done( function( responseText ) {
                response = arguments;
                self.html( selector ?
                    jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
                    responseText );
            } ).always( callback && function( jqXHR, status ) {
                self.each( function() {
                    callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
                } );
            } );
        }
        return this;
    };
    jQuery.each( [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function( i, type ) {
        jQuery.fn[ type ] = function( fn ) {
            return this.on( type, fn );
        };
    } );
    jQuery.expr.pseudos.animated = function( elem ) {
        return jQuery.grep( jQuery.timers, function( fn ) {
            return elem === fn.elem;
        } ).length;
    };
    jQuery.offset = {
        setOffset: function( elem, options, i ) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                position = jQuery.css( elem, "position" ),
                curElem = jQuery( elem ),
                props = {};
            if ( position === "static" ) {
                elem.style.position = "relative";
            }
            curOffset = curElem.offset();
            curCSSTop = jQuery.css( elem, "top" );
            curCSSLeft = jQuery.css( elem, "left" );
            calculatePosition = ( position === "absolute" || position === "fixed" ) &&
                ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
            if ( calculatePosition ) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat( curCSSTop ) || 0;
                curLeft = parseFloat( curCSSLeft ) || 0;
            }
            if ( isFunction( options ) ) {
                options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
            }
            if ( options.top != null ) {
                props.top = ( options.top - curOffset.top ) + curTop;
            }
            if ( options.left != null ) {
                props.left = ( options.left - curOffset.left ) + curLeft;
            }
            if ( "using" in options ) {
                options.using.call( elem, props );
            } else {
                curElem.css( props );
            }
        }
    };
    jQuery.fn.extend( {
        offset: function( options ) {
            if ( arguments.length ) {
                return options === undefined ?
                    this :
                    this.each( function( i ) {
                        jQuery.offset.setOffset( this, options, i );
                    } );
            }
            var rect, win,
                elem = this[ 0 ];
            if ( !elem ) {
                return;
            }
            if ( !elem.getClientRects().length ) {
                return { top: 0, left: 0 };
            }
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        position: function() {
            if ( !this[ 0 ] ) {
                return;
            }
            var offsetParent, offset, doc,
                elem = this[ 0 ],
                parentOffset = { top: 0, left: 0 };
            if ( jQuery.css( elem, "position" ) === "fixed" ) {
                offset = elem.getBoundingClientRect();
            } else {
                offset = this.offset();
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while ( offsetParent &&
                ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
                jQuery.css( offsetParent, "position" ) === "static" ) {
                    offsetParent = offsetParent.parentNode;
                }
                if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
                    parentOffset = jQuery( offsetParent ).offset();
                    parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
                    parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
                }
            }
            return {
                top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
                left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
            };
        },
        offsetParent: function() {
            return this.map( function() {
                var offsetParent = this.offsetParent;
                while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                    offsetParent = offsetParent.offsetParent;
                }
                return offsetParent || documentElement;
            } );
        }
    } );
    jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
        var top = "pageYOffset" === prop;
        jQuery.fn[ method ] = function( val ) {
            return access( this, function( elem, method, val ) {
                var win;
                if ( isWindow( elem ) ) {
                    win = elem;
                } else if ( elem.nodeType === 9 ) {
                    win = elem.defaultView;
                }
                if ( val === undefined ) {
                    return win ? win[ prop ] : elem[ method ];
                }
                if ( win ) {
                    win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                    );
                } else {
                    elem[ method ] = val;
                }
            }, method, val, arguments.length );
        };
    } );
    jQuery.each( [ "top", "left" ], function( i, prop ) {
        jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
            function( elem, computed ) {
                if ( computed ) {
                    computed = curCSS( elem, prop );
                    return rnumnonpx.test( computed ) ?
                        jQuery( elem ).position()[ prop ] + "px" :
                        computed;
                }
            }
        );
    } );
    jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
        jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
            function( defaultExtra, funcName ) {
                jQuery.fn[ funcName ] = function( margin, value ) {
                    var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                        extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
                    return access( this, function( elem, type, value ) {
                        var doc;
                        if ( isWindow( elem ) ) {
                            return funcName.indexOf( "outer" ) === 0 ?
                                elem[ "inner" + name ] :
                                elem.document.documentElement[ "client" + name ];
                        }
                        if ( elem.nodeType === 9 ) {
                            doc = elem.documentElement;
                            return Math.max(
                                elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                                elem.body[ "offset" + name ], doc[ "offset" + name ],
                                doc[ "client" + name ]
                            );
                        }
                        return value === undefined ?
                            jQuery.css( elem, type, extra ) :
                            jQuery.style( elem, type, value, extra );
                    }, type, chainable ? margin : undefined, chainable );
                };
            } );
    } );
    jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
        "change select submit keydown keypress keyup contextmenu" ).split( " " ),
        function( i, name ) {
            jQuery.fn[ name ] = function( data, fn ) {
                return arguments.length > 0 ?
                    this.on( name, null, data, fn ) :
                    this.trigger( name );
            };
        } );
    jQuery.fn.extend( {
        hover: function( fnOver, fnOut ) {
            return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
        }
    } );
    jQuery.fn.extend( {
        bind: function( types, data, fn ) {
            return this.on( types, null, data, fn );
        },
        unbind: function( types, fn ) {
            return this.off( types, null, fn );
        },
        delegate: function( selector, types, data, fn ) {
            return this.on( types, selector, data, fn );
        },
        undelegate: function( selector, types, fn ) {
            return arguments.length === 1 ?
                this.off( selector, "**" ) :
                this.off( types, selector || "**", fn );
        }
    } );
    jQuery.proxy = function( fn, context ) {
        var tmp, args, proxy;
        if ( typeof context === "string" ) {
            tmp = fn[ context ];
            context = fn;
            fn = tmp;
        }
        if ( !isFunction( fn ) ) {
            return undefined;
        }
        args = slice.call( arguments, 2 );
        proxy = function() {
            return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
        };
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function( hold ) {
        if ( hold ) {
            jQuery.readyWait++;
        } else {
            jQuery.ready( true );
        }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function( obj ) {
        var type = jQuery.type( obj );
        return ( type === "number" || type === "string" ) &&
            !isNaN( obj - parseFloat( obj ) );
    };
    if ( typeof define === "function" && define.amd ) {
        define( "jquery", [], function() {
            return jQuery;
        } );
    }
    var
        _jQuery = window.jQuery,
        _$ = window.$;
    jQuery.noConflict = function( deep ) {
        if ( window.$ === jQuery ) {
            window.$ = _$;
        }
        if ( deep && window.jQuery === jQuery ) {
            window.jQuery = _jQuery;
        }
        return jQuery;
    };
    if ( !noGlobal ) {
        window.jQuery = window.$ = jQuery;
    }
    return jQuery;
} );
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

;(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] ||
            window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
})();
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('before')) {
            return;
        }
        Object.defineProperty(item, 'before', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function before() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();
                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
                this.parentNode.insertBefore(docFrag, this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
(function () {
    var $html = $('html');
    window.SiteInfo = {
        site: 'gmxnet',
        brand: 'gmx',
        brandNameExtended: 'GMX.NET',
        brandName: 'GMX',
        country: $html.attr('data-country'),
        tld: 'de',
        stage: window.PageConfig.stage,
        portal: $html.attr('data-portal'),
        status: $html.attr('data-status'),
        loginFailed: getUrlParam('status') === 'login-failed',
        loggedIn: $html.attr('data-toolbar-loggedin') == 'true' ? true : false,
        _isVisible: true,
        isVisible: function () {
            if (document.visibilityState) {
                return document.visibilityState === 'visible';
            }
            return SiteInfo._isVisible;
        },
        prvMode: undefined,
        animationEnabled: true,
        ssl: (!!window.location.protocol.match(/https/)),
        columns: 4,
        lastActivity: (new Date()).getTime(),
        gamesSliderOnTop: window.PageConfig.gamesSliderOnTop == '1',
        emotionHeader: !!$('html.hasEmotionHeader').length,
        message: !!$('html.hasMessage').length,
        breakingNews: !!$('html.hasBreakingNews').length,
        sitespect: $('html').attr('data-variant-name')
    };
    if (window.SiteInfo.country === 'de') {
        window.SiteInfo.tld = 'net';
    } else if (window.SiteInfo.country === 'at') {
        window.SiteInfo.brandNameExtended = 'GMX.AT';
        window.SiteInfo.tld = 'at';
    } else if (window.SiteInfo.country === 'ch') {
        window.SiteInfo.brandNameExtended = 'GMX.CH';
        window.SiteInfo.tld = 'ch';
    }
    $(window).on({
        blur: function () {
            SiteInfo._isVisible = false;
        },
        focus: function () {
            SiteInfo._isVisible = true;
        }
    });
    $(window).on('click scroll mousemove keyup suggest-keyup', function () {
        window.SiteInfo.lastActivity = (new Date()).getTime();
    });
})();
function transferOptOutPixel() {
    var qaPrefix = (['qa', 'qa-bs', 'qa-ba', 'dev'].indexOf(SiteInfo.stage) !== -1) ? '-qa' : '';
    var img = new Image();
    img.src = 'https://wa' + qaPrefix + '.ui-portal.de/opt-out-transfer/gmx/';
}

transferOptOutPixel();
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fn, scope) {
        for (var i=0, len=this.length; i<len; ++i) {
            fn.call(scope, this[i], i, this);
        }
    }
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(searchElement) {
        var len = this.length,
              i = +arguments[1] || 0;
        if (len===0 || isNaN(i) || i>=len) {
            return -1;
        }
        if (i < 0) {
            i = len + i;
            i < 0 && (i = 0);
        }
        for (; i < len; ++i) {
            if (this.hasOwnProperty(String(i)) && this[i]===searchElement) {
                return i;
            }
        }
        return -1;
    };
}

function tohtml(text) {
    return (''+text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;');
}

Math.rand = function(l,h) {
    return Math.floor((Math.random() * (h-1+1))+1);
}

String.rand = function(size) {
    var chars = "0123456789abcdefghijklmnopqurstuvwxyzABCDEFGHIJKLMNOPQURSTUVWXYZ";
    var str   = "";
        for (var i = 0; i < size; i++){
            str += chars.substr( Math.floor(Math.random() * 62), 1);
        }
    return str;
}

function getUrlParams () {
    var params = {};
    var search = window.location.search.substring(1);
    if (search) {
        var urlParams = search.split('&');
        for (var i = 0; i < urlParams.length; i++) {
            var param = urlParams[i].split('=');
            params[param[0]] = param[1];
        }
    }
    return params;
}

function getUrlParam (param) {
    var params = getUrlParams();
    if (typeof params[param] !== 'undefined') {
        return params[param];
    } else {
        return undefined;
    }
}

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function isEmptyObject(obj) {
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) { return false; }
    }
    return true;
}

function eraseWhitespaceNodes(container) {
    var items = $(container).get(0).childNodes;
    for (var i=items.length-1; i>=0; i--) {
        if (items[i].nodeType === 3 && !(/[^\t\n\r ]/.test(items[i].nodeValue))) {
            items[i].parentNode.removeChild(items[i]);
        }
    }
}

function getWindowInnerWidth() {
    return window.innerWidth - PageLayout.getScrollbarWidth() || $(window).innerWidth();
};
function getWindowInnerHeight() {
    return window.innerHeight || $(window).innerHeight();
};
if (['prelive', 'qa-ba', 'qa-bs'].indexOf(SiteInfo.stage) !== -1) {
    var svariant = getUrlParam('_svariant');
    if (svariant) {
        if (!$('html').attr('data-variant-name')) {
            $('html').attr('data-variant-name', svariant);
            window.SiteInfo.sitespect = svariant;
        }
    }
}

if (typeof getUrlParam('SS_PREVIEW_EXP') !== 'undefined') {
    var expires = new Date();
    expires.setTime(expires.getTime() + 1 * 86400000);
    var domain = location.host.replace('www.', '');
    document.cookie = "SSLB=.1; expires=" + expires.toGMTString() + "; path=/; domain=." + domain;
}

if (['prelive', 'qa-ba', 'qa-bs'].indexOf(SiteInfo.stage) !== -1) {
    var recovariant = getUrlParam('_reco');
    if (recovariant) {
        if (!PageConfig.reco) {
            PageConfig.reco = recovariant;
        }
    }
}

(function ($) {
    var methods = {
        create: function (options) {
            options.lists = [];
            if (options.evenSplit) {
                options.maxItemsPerList = Math.ceil(options.content.length / 2);
            }
            var currentList = -1;
            for (var i = 0; i < options.content.length; i++) {
                if (i === 0 || (options.maxItemsPerList && i % options.maxItemsPerList === 0)) {
                    currentList++;
                    options.lists.push({
                        class: (options.css.list.className && options.css.list.className[currentList]) ? options.css.list.className[currentList] : undefined,
                        data: []
                    });
                }
                var item = options.content[i];
                options.lists[currentList].data.push({
                    title: item[0],
                    url: ((item[1].indexOf('aHR0cDovL') == 0 || item[1].indexOf('aHR0cHM6Ly') == 0 || item[1].indexOf('Ly') == 0) ? atob(item[1]) : item[1]) + (options.linkSuffix ? options.linkSuffix : ''),
                    background: item[2],
                    target: item[3],
                });
            }
            var html = Mustache.render(ContentService.templates[options.template], options);
            var $target = $(options.after);
            $target.on('isVisibleInViewport', function () {
                methods.insertInDom($target, html);
            });
            ModuleService.add($target);
        },
        insertInDom: function ($target, html) {
            $target.after(html);
            var $closestContentSlider = $target.closest('.content-slider');
            if ($closestContentSlider.length && $target.is('script')) {
                $target.remove();
            }
            if ($closestContentSlider.length) {
                $closestContentSlider.trigger('slider-update');
            }
        }
    };
    $.rectangle = function (method, args) {
        var options = $.extend(true, {
            template: 'jquery-rectangle',
            html: {
                headerText: '',
                container: 'h:nav'
            },
            css: {
                className: null,
                section: {
                    id: null,
                    className: null
                },
                list: {
                    className: null
                },
                container: {
                    className: null
                }
            },
            rect: 0,
            after: null,
            mode: 'module',
            listType: 'ul',
            headerInContainer: false,
            maxItemsPerList: false,
            offset: 0,
            content: null,
            crypt: null,
            iconType: 'className'
        }, args);
        if (typeof options.after == 'string') {
            if (options.after.indexOf('#') < 0) {
                if (options.after.indexOf('.') < 0) {
                    $.error('$.rectangle. Please add for "after" the definition of HTML Class or ID.');
                }
            }
        } else {
            $.error('$.rectangle. Please add the value "after".');
        }
        if (methods[method]) {
            return methods[method].call(this, options);
        } else {
            $.error('Method ' + method + ' does not exist on $.rectangle');
        }
    };
})(jQuery);
(function ($) {
    $.fn.ellipsis = function (options) {
        var defaults = {
            'row': 1,
            'onlyFullWords': true,
            'ellipsis': '...',
            'position': 'tail',
            'select': null,
            'subselect': 'a, span',
            'callback': function () {
            },
            'setTitle': 'title',
            '_': 0
        };
        options = $.extend(defaults, options);
        this.each(function () {
            var $root = $(this),
                $this = $root,
                $select = $root;
            if (options.subselect && $this.has(options.subselect).length) {
                $this = $this.find(options.subselect).first();
            }
            if (options.select) {
                if ($.isFunction(options.select)) {
                    $select = options.select.apply(this);
                } else {
                    $select = $(options.select);
                }
            }
            var origText = $root.data('ellipsis-origText');
            if (!origText) {
                origText = $this.text();
                $root.data('ellipsis-origText', origText);
            }
            var text = origText;
            $this.text(origText);
            var origHeight = $select.height();
            $this.text('x');
            var lineHeight = parseFloat($this.css('lineHeight'), 10),
                targetHeight = lineHeight * (typeof options.row === 'function' ? options.row($this) : options.row);
            if (origHeight <= targetHeight) {
                $this.text(text);
                options.callback.call(this);
                return;
            }
            var start = 1,
                length = 0,
                end = text.length;
            if (options.position === 'tail') {
                while (start < end) {
                    length = Math.ceil((start + end) / 2);
                    $this.text(text.slice(0, length) + options['ellipsis']);
                    if ($select.height() <= targetHeight) {
                        start = length;
                    } else {
                        end = length - 1;
                    }
                }
                text = text.slice(0, start);
                if (options.onlyFullWords) {
                    text = text.replace(/[\u00AD\wäöüÄÖÜß\uac00-\ud7af]+$/, '');
                }
                if (text !== origText) {
                    text += options['ellipsis'];
                }
            } else if (options.position === 'middle') {
                var origLength = origText.length;
                var sliceLength = 0;
                while (start < end) {
                    length = Math.ceil((start + end) / 2);
                    sliceLength = Math.max(origLength - length, 0);
                    $this.text(
                        origText.slice(0, Math.floor((origLength - sliceLength) / 2)) +
                        options['ellipsis'] +
                        origText.slice(Math.floor((origLength + sliceLength) / 2), origLength)
                    );
                    if ($select.height() <= targetHeight) {
                        start = length;
                    } else {
                        end = length - 1;
                    }
                }
                sliceLength = Math.max(origLength - start, 0);
                var head = origText.slice(0, Math.floor((origLength - sliceLength) / 2));
                var tail = origText.slice(Math.floor((origLength + sliceLength) / 2), origLength);
                if (options.onlyFullWords) {
                    head = head.replace(/[\u00AD\wäöüÄÖÜß\uac00-\ud7af]+$/, '');
                }
                if (head + tail !== origText) {
                    text = head + options['ellipsis'] + tail;
                }
            }
            $this.text(text);
            if (options.setTitle) {
                $this.attr(options.setTitle, text !== origText ? origText : '');
            }
            options.callback.call(this);
        });
        return this;
    };
})(jQuery);
(function ($) {
    'use strict';
var Version = (function () {
    function versionPart(p) {
        var intp;
        if (p == null) return 0;
        intp = parseInt(p, 10);
        if (!isNaN(intp) && intp.toString() === p) return intp;
        return p;
    }
    function getVersionInfo(v) {
        var vinfo = (v || '').toString().replace(/^\s+|\s+$/g, '').split(/[._]|(?=\D+)/g);
        return {
            major: versionPart(vinfo[0]),
            minor: versionPart(vinfo[1]),
            build: versionPart(vinfo[2]),
            revision: versionPart(vinfo[3])
        };
    }
    function Version(v) {
        var vi = getVersionInfo(v);
        this.major = vi.major;
        this.minor = vi.minor;
        this.build = vi.build;
        this.revision = vi.revision;
        return this;
    }
    function _gt(a, b) {
        return a > b;
    }
    function _gte(a, b) {
        return a >= b;
    }
    function compgt(v1, v2, eq) {
        return (v1.major > v2.major) ||
            (v1.major === v2.major && v1.minor > v2.minor) ||
            (v1.major === v2.major && v1.minor === v2.minor && v1.build > v2.build) ||
            (v1.major === v2.major && v1.minor === v2.minor && v1.build === v2.build && eq(v1.revision, v2.revision))
        ;
    }
    Version.prototype = {
        eq: function (v) {
            var vi = getVersionInfo(v);
            return this.major === vi.major &&
                this.minor === vi.minor &&
                this.build === vi.build &&
                this.revision === vi.revision
            ;
        },
        gt: function (v) {
            return compgt(this, getVersionInfo(v), _gt);
        },
        gte: function (v) {
            return compgt(this, getVersionInfo(v), _gte);
        },
        lt: function (v) {
            return compgt(getVersionInfo(v), this, _gt);
        },
        lte: function (v) {
            return compgt(getVersionInfo(v), this, _gte);
        },
        valueOf: function () {
            return  this.major    * 1000000 +
                    this.minor    * 10000 +
                    this.build    * 100 +
                    this.revision * 1
            ;
        },
        toString: function (minlen) {
            var a = [this.major, this.minor, this.build, this.revision];
            if (!(minlen > 0)) minlen = 1;
            while (a.length > minlen) {
                if (a[a.length - 1] !== 0) break;
                a.pop();
            }
            return a.join('.');
        }
    };
    Version.constructor = Version;
    return Version;
})();
    var ret = {
        browser: {},
        os: {}
    };
    var ua = navigator.userAgent.toLowerCase();
    var msieIndex = 0;
    var browserIndex = -1;
    var browser = ['msie', 'edge', 'opera', 'seamonkey', 'camino', 'arora', 'iron', 'chrome', 'safari', 'firefox'];
    var ntVersions = {
        '5.0': '2000',
        '5.1': 'xp',
        '5.2': '2003',
        '6.0': 'vista',
        '6.1': '7',
        '6.2': '8',
        '6.3': '8.1',
        '10.0': '10'
    };
    var commentMatch = {
        'win(dows)?\\s*(nt)?\\s*(\\d*(\\.\\d+)*)': {
            os: {
                name: 'windows',
                versionName: function (_, _2, nt, versionTok) {
                    if (versionTok && versionTok !== '32' && versionTok !== '64') {
                        if (nt) {
                            return ntVersions[versionTok] || versionTok;
                        } else {
                            return versionTok;
                        }
                    }
                },
                version: function (_, _2, nt, versionTok) {
                    if (versionTok && versionTok !== '32' && versionTok !== '64') {
                        return new Version(versionTok);
                    }
                }
            }
        },
        'linux|blackberry': {
            os: {
                name: '$0'
            }
        },
        'android': {
            os: {
                '!name': '$0',
                version: '$_'
            }
        },
        'cpu .*?os ([\\d_.]+)': {
            os: {
                version: '$1'
            }
        },
        '\\barm(v\\d\\w+)?\\b': {
            os: {
                arm: true
            }
        },
        'iphone|ipad|ipod': {
            os: {
                name: 'ios',
                versionName: '$0',
                mobile: function (m) {
                    if (m != 'iPad') return true;
                },
                tablet: function (m) {
                    if (m == 'iPad') return true;
                }
            }
        },
        '(intel|ppc) mac os x': {
            os: {
                name: 'mac os',
                versionName: 'x',
                version: '$_'
            }
        },
        'mobile': {
            os: {
                mobile: true
            }
        },
        'tablet': {
            os: {
                tablet: true
            }
        },
        '\\b(wow64|win64|x64|x86_64)\\b': {
            os: {
                '64bit': true
            }
        },
        '(ms|^)ie\\s+((\\d+)(\\.\\w+)*)': {
            browser: {
                name: function () {
                    browserIndex = msieIndex;
                    return 'msie';
                },
                renderMode: function (_, _2, versionTok) {
                    return (new Version(versionTok)).major;
                },
                version: function (_, _2, versionTok) {
                    return new Version(versionTok);
                }
            }
        },
        'trident/(\\d+)\\.(\\d+)': {
            browser: {
                name: function () {
                    browserIndex = msieIndex;
                    return 'msie';
                },
                '!version': function (_, tmaj, tmin) {
                    if (tmin == '0') {
                        return new Version((parseInt(tmaj, 10) + 4));
                    }
                }
            }
        },
        '\\.net\\s+clr\\s+(\\d+(\\.\\d+)*)': {
            os: {
                dotnet: function (_, versionTok) {
                    var ret = {};
                    var version = new Version(versionTok);
                    if (version && (version.major != 0 || version.minor != 0)) {
                        ret[version.major + '.' + version.minor] = version;
                        return ret;
                    }
                }
            }
        },
        'tb-(webde|gmx)': {
            browser: {
                '$name': '$0',
                '$value': true
            }
        }
    };
    function parseComment(comment) {
        comment.replace(/\s*([^;]+)(;|$)/g, function (matchedText, data) {
            function mergeProperty(m, type, name, value) {
                var result;
                if (typeof value == 'function') {
                    result = value.apply(null, m);
                } else {
                    result = value;
                }
                if (result == null) return;
                var forceOverwrite = false;
                if (name.substr(0, 1) == '!') {
                    forceOverwrite = true;
                    name = name.substr(1);
                }
                if (typeof result == 'string') {
                    var rest = data.substr(m.index + m[0].length);
                    result = result
                                .replace(/\$_/g, rest)
                                .replace(/\$(\d+)/g, function (_, d) {
                                    return m[d];
                                })
                    ;
                    if (name === 'version') {
                        result = result ? new Version(result) : null;
                    }
                }
                if (result != null) {
                    if (typeof ret[type][name] == 'object' && typeof result == 'object') {
                        $.extend(true, ret[type][name], result);
                    }
                    if (ret[type][name] == null || forceOverwrite) {
                        ret[type][name] = result;
                    }
                }
            }
            for (var k in commentMatch) {
                var m = data.match(commentMatch[k]._regexp);
                if (m) {
                    var merge = commentMatch[k];
                    for (var proptype in merge) {
                        if (proptype === '_regexp') continue;
                        for (var propname in merge[proptype]) {
                            if (propname === '$value') continue;
                            if (propname === '$name') {
                                var pname = merge[proptype][propname].replace(/\$(\d+)/g, function (_, d) {
                                    return m[d];
                                })
                                mergeProperty(m, proptype, pname, merge[proptype]['$value']);
                                continue;
                            }
                            mergeProperty(m, proptype, propname, merge[proptype][propname]);
                        }
                    }
                }
            }
            return;
        });
    }
    for (var k in commentMatch) {
        commentMatch[k]._regexp = new RegExp(k);
    }
    ua.replace(/([^\/ \()]+)(\/([^ \()]+))?\s*(\(([^\)]*)(\)\s*|$))?/g, function (_, product, _2, versionTok, _3, commentTok) {
        var version = null, i;
        if (versionTok != null && versionTok !== '') {
            version = new Version(versionTok);
        } else {
            if (product === 'like' || product === 'gecko') return;
        }
        if (product === 'opr') product = 'opera';
        if (product !== 'mozilla') {
            if (ret.browser[product] == null) {
                ret.browser[product] = version || true;
            }
            for (i = 0; i < browser.length; i++) {
                if (browser[i] === product) {
                    if (browserIndex === -1 || browserIndex > i) browserIndex = i;
                }
            }
        }
        if (commentTok != null && commentTok !== '') {
            parseComment(commentTok);
        }
    });
    if (browserIndex != -1) {
        var b = ret.browser;
        b.name = browser[browserIndex];
        if (b.version == null) {
            b.version = b[browser[browserIndex]];
        }
        if (b.version != null) {
            if (b.version.major != null) {
                b[browser[browserIndex]] = b.version.major;
                if (b.version.minor != null) {
                    if (b.version.minor < 10) {
                        b[browser[browserIndex]] += b.version.minor / 10;
                    } else {
                        b[browser[browserIndex]] = b.version.major + '.' + b.version.minor;
                    }
                }
            } else {
                b[browser[browserIndex]] = b.version;
            }
        }
        for (var i = 0; i < browser.length; i++) {
            if (i === browserIndex) continue;
            delete b[browser[i]];
        }
    }
    ret = $.extend(true, {
        browser: {
            name: '',
            version: new Version('0')
        },
        os: {
            name: '',
            version: new Version('0'),
            '64bit': false
        }
    }, ret);
    $.ua = ret;
})(jQuery);
(function (ua) {
    if (ua == null) return;
    ua.support = {
        touch: undefined,
        transitions: undefined,
        gps: undefined,
        localstorage: undefined
    };
    ua.support.touch = !!('ontouchstart' in window);
    var style = document.createElement('p').style;
    ua.support.transitions = !!('transition' in style || 'WebkitTransition' in style || 'MozTransition' in style || 'OTransition' in style);
})($.ua);
(function ($) {
    $.cookie = new function () {
        this.parse = function () {
            this.jar = {};
            if (!document.cookie || !document.cookie.length || document.cookie.length == 0) {
                return;
            }
            document.cookie.replace(/([^=;\ ]+)=([^;]*)/g, function (c) {
                return function (full, key, data) {
                    c.jar[unescape(key)] = unescape(data);
                }
            }(this));
        }
        this.parse();
        this.get = function (name, def) {
            return this.jar[name] || def;
        }
        this.getInt = function (name, def) {
            var value = parseInt(this.jar[name]);
            return !isNaN(value) ? value : def;
        }
        var timespans = {y: 30758400000, m: 2592000000, d: 86400000, h: 3600000, i: 60000, s: 1000};
        this.set = function (name, value, expires, path, domain, secure) {
            var date = false;
            if (expires) {
                date = (expires instanceof Date ? expires : new Date());
                if ('string' == typeof(expires)) {
                    expires.replace(/([\-\d.]+)([ymdhis])/g, function (f, t, m) {
                        if (f) {
                            date.setTime(date.getTime() + parseFloat(t) * timespans[m] || 0);
                        }
                    });
                }
            }
            document.cookie = encodeURIComponent(new String(name)) + '=' +
                encodeURIComponent(new String(value)) +
                (date ? '; expires=' + date.toGMTString() : '') +
                (path !== null ? '; path=' + (path || '/') : '') +
                (domain ? '; domain=' + domain : '') +
                (secure ? '; secure' : '');
            this.parse();
        }
        this.inc = function (name, value, def, expires, path, domain, secure) {
            var val = this.getInt(name, def) + (value || 1);
            this.set(name, val, expires, path, domain, secure);
            return val;
        }
        this.del = function (name, path, domain) {
            if (!name || !this.jar[name]) {
                return false;
            }
            this.set(name, '', '-1s', path, domain);
            try {
                delete this.jar[name];
            } catch (e) {
            }
        }
    }
})(jQuery);
(function () {
    wrapLink = {
        init: function (options) {
            var settings = $.extend({
                linkSelector: 'header a',
                wrapLinkTo: [],
                instant: false
            }, options);
            if (wrapLink.hasSeoSpans(this)) {
                wrapLink.convertSeoSpans(this);
            }
            if ($.ua.browser.name === 'chrome' || $.ua.os.name === 'ios' || settings.instant) {
                $(this).each(function () {
                    wrapLink.moveLink(this, settings);
                });
            } else {
                $(this).one({
                    mouseenter: function () {
                        wrapLink.moveLink(this, settings);
                        $(this).addClass('hover');
                    },
                    mouseleave: function () {
                        $(this).removeClass('hover');
                    }
                });
            }
        },
        hasSeoSpans: function (container) {
            return !!$('span.toAnchor[data-toanchor-url]', container).length
        },
        convertSeoSpans: function (container) {
            $('span.toAnchor[data-toanchor-url]', container).each(function () {
                var $this = $(this);
                var attrsToCopy = [
                    'title',
                    'target',
                    'data-popup-name',
                    'data-popup-disabled',
                    'data-popup-style',
                    'data-ab-testid',
                    'data-ab-name',
                    'data-teaser-id',
                    'data-teaser-type'
                ];
                var $link = $('<a/>');
                $link.attr('href', atob($this.attr('data-toanchor-url')));
                if ($this.attr('data-toanchor-target')) {
                    $link.attr('target', $this.attr('data-toanchor-target'));
                }
                for (var i = 0; i < attrsToCopy.length; i++) {
                    var attrValue = $this.attr(attrsToCopy[i]);
                    if (attrValue) {
                        $link.attr(attrsToCopy[i], attrValue);
                    }
                }
                $link.html($this.html());
                $this.after($link).remove();
            });
        },
        moveLink: function (container, settings) {
            var $link = $(settings.linkSelector, container);
            $link.before($link.contents());
            if (settings.wrapLinkTo.length > 0) {
                for (var i = 0; i < settings.wrapLinkTo.length; i++) {
                    if (typeof settings.wrapLinkTo[i] === 'string') {
                        settings.wrapLinkTo[i] = {
                            selector: settings.wrapLinkTo[i]
                        };
                    }
                    var $clone = $link.clone(true);
                    var $target = settings.wrapLinkTo[i].selector ? $(settings.wrapLinkTo[i].selector, container) : $(container);
                    $clone.prependTo($target);
                    $clone.siblings().not(settings.wrapLinkTo[i].exclude).appendTo($clone);
                }
                $link.remove();
            } else {
                $link.prependTo(container);
                $link.siblings().not(settings.exclude).appendTo($link);
            }
            $(container).addClass('wrapped');
        }
    };
    $.fn.wrapLink = function (method) {
        if (typeof method === 'object' || !method) {
            return wrapLink.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.wrapLink');
        }
    };
})();
var Swipe = new function () {
    var isTouched, isMoved, touchmoveCounter, isScrolling, currentTranslate, startTranslate, allowThresholdMove,
        touchStartTime, currentActiveContainer;
    this.settings = {
        direction: 'horizontal',
        swipeTreshold: 30
    };
    this.touches = {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
    };
    this.registeredSlider = [];
    this.registerSlider = function (options) {
        var settings = $.extend({
            parentContainer: undefined,
            slideContainer: undefined,
            nextCallback: undefined,
            prevCallback: undefined
        }, options);
        this.registeredSlider.push(settings);
    };
    this.init = function () {
        if ($.ua.os.name === 'android' && $.ua.os.version.major <= 4) {
            return;
        }
        document.addEventListener('touchstart', this.touchstartHandler, {passive: true, capture: false});
        document.addEventListener('touchmove', this.touchmoveHandler);
        document.addEventListener('touchend', this.touchendHandler, {passive: true, capture: false});
    };
    this.allowClick = true;
    this.touchstartHandler = function (e) {
        if (e.originalEvent) e = e.originalEvent;
        if (!Swipe.registeredSlider.length) {
            return;
        }
        currentActiveContainer = undefined;
        for (var i = 0; i < Swipe.registeredSlider.length; i++) {
            if (Swipe.registeredSlider[i].parentContainer.is(e.target) || $(e.target).closest(Swipe.registeredSlider[i].parentContainer).length) {
                currentActiveContainer = Swipe.registeredSlider[i];
                break;
            }
        }
        if (!currentActiveContainer) {
            return;
        }
        currentActiveContainer.startX = parseInt($(currentActiveContainer.slideContainer).css('marginLeft'), 10);
        $(currentActiveContainer.slideContainer).addClass('noTransition');
        var startX = Swipe.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        var startY = Swipe.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        isTouched = true;
        isMoved = false;
        isScrolling = undefined;
        startMoving = undefined;
        touchStartTime = Date.now();
        startTranslate = 0;
        Swipe.touches.startX = startX;
        Swipe.touches.startY = startY;
        Swipe.allowClick = true;
    };
    this.touchmoveHandler = function (e) {
        if (!currentActiveContainer) {
            return;
        }
        if (e.originalEvent) e = e.originalEvent;
        if (e.preventedByNestedSwiper) {
            Swipe.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            Swipe.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
            return;
        }
        if (e.targetTouches && e.targetTouches.length > 1) {
            return;
        }
        Swipe.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        Swipe.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (typeof isScrolling === 'undefined') {
            var touchAngle;
            if (Swipe.isHorizontal() && Swipe.touches.currentY === Swipe.touches.startY || !Swipe.isHorizontal() && Swipe.touches.currentX === Swipe.touches.startX) {
                isScrolling = false;
            } else {
                touchAngle = Math.atan2(Math.abs(Swipe.touches.currentY - Swipe.touches.startY), Math.abs(Swipe.touches.currentX - Swipe.touches.startX)) * 180 / Math.PI;
                isScrolling = Swipe.isHorizontal() ? touchAngle > 45 : (90 - touchAngle > 45);
            }
        }
        if (typeof startMoving === 'undefined') {
            if (Swipe.touches.currentX !== Swipe.touches.startX || Swipe.touches.currentY !== Swipe.touches.startY) {
                startMoving = true;
            }
        }
        if (!isTouched) {
            return;
        }
        if (isScrolling) {
            isTouched = false;
            return;
        }
        if (!startMoving) {
            return;
        }
        Swipe.allowClick = false;
        isMoved = true;
        var diff = Swipe.touches.diff = Swipe.isHorizontal() ? Swipe.touches.currentX - Swipe.touches.startX : Swipe.touches.currentY - Swipe.touches.startY;
        currentTranslate = diff + startTranslate;
        $(currentActiveContainer.slideContainer).css({
            marginLeft: currentActiveContainer.startX + currentTranslate + 'px'
        });
    };
    this.minTranslate = function () {
        return 0;
    };
    this.maxTranslate = function () {
        return 300;
    };
    this.touchendHandler = function (e) {
        if (!currentActiveContainer) {
            return;
        }
        if (e.originalEvent) e = e.originalEvent;
        $(currentActiveContainer.slideContainer).removeClass('noTransition');
        if (!isTouched) return;
        var touchEndTime = Date.now();
        var timeDiff = touchEndTime - touchStartTime;
        lastClickTime = Date.now();
        setTimeout(function () {
            if (Swipe) Swipe.allowClick = true;
        }, 0);
        if (!isTouched || !isMoved || Swipe.touches.diff === 0 || currentTranslate === startTranslate) {
            isTouched = isMoved = false;
            return;
        }
        isTouched = isMoved = false;
        var currentPos = -currentTranslate;
        if (Math.abs(currentTranslate) > Swipe.settings.swipeTreshold) {
            if (currentTranslate > 0) {
                if (typeof currentActiveContainer.prevCallback === 'function') {
                    currentActiveContainer.prevCallback();
                }
            } else if (currentTranslate < 0) {
                if (typeof currentActiveContainer.nextCallback === 'function') {
                    currentActiveContainer.nextCallback();
                }
            }
        } else {
            $(currentActiveContainer.slideContainer).css({
                marginLeft: currentActiveContainer.startX + 'px'
            });
        }
    };
    this.isHorizontal = function () {
        return this.settings.direction == 'horizontal';
    };
    this.init();
}

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function ($) {
    if ($.support.cors || !$.ajaxTransport || !window.XDomainRequest) {
        return $;
    }
    var httpRegEx = /^(https?:)?\/\//i;
    var getOrPostRegEx = /^get|post$/i;
    var sameSchemeRegEx = new RegExp('^(\/\/|' + location.protocol + ')', 'i');
    $.ajaxTransport('* text html xml json', function (options, userOptions, jqXHR) {
        if (!options.crossDomain || !options.async || !getOrPostRegEx.test(options.type) || !httpRegEx.test(options.url) || !sameSchemeRegEx.test(options.url)) {
            return;
        }
        var xdr = null;
        return {
            send: function (headers, complete) {
                var postData = '';
                var userType = (userOptions.dataType || '').toLowerCase();
                xdr = new XDomainRequest();
                if (/^\d+$/.test(userOptions.timeout)) {
                    xdr.timeout = userOptions.timeout;
                }
                xdr.ontimeout = function () {
                    complete(500, 'timeout');
                };
                xdr.onload = function () {
                    var allResponseHeaders = 'Content-Length: ' + xdr.responseText.length + '\r\nContent-Type: ' + xdr.contentType;
                    var status = {
                        code: 200,
                        message: 'success'
                    };
                    var responses = {
                        text: xdr.responseText
                    };
                    try {
                        if (userType === 'html' || /text\/html/i.test(xdr.contentType)) {
                            responses.html = xdr.responseText;
                        } else if (userType === 'json' || (userType !== 'text' && /\/json/i.test(xdr.contentType))) {
                            try {
                                responses.json = $.parseJSON(xdr.responseText);
                            } catch (e) {
                                status.code = 500;
                                status.message = 'parseerror';
                            }
                        } else if (userType === 'xml' || (userType !== 'text' && /\/xml/i.test(xdr.contentType))) {
                            var doc = new ActiveXObject('Microsoft.XMLDOM');
                            doc.async = false;
                            try {
                                doc.loadXML(xdr.responseText);
                            } catch (e) {
                                doc = undefined;
                            }
                            if (!doc || !doc.documentElement || doc.getElementsByTagName('parsererror').length) {
                                status.code = 500;
                                status.message = 'parseerror';
                                throw 'Invalid XML: ' + xdr.responseText;
                            }
                            responses.xml = doc;
                        }
                    } catch (parseMessage) {
                        throw parseMessage;
                    } finally {
                        complete(status.code, status.message, responses, allResponseHeaders);
                    }
                };
                xdr.onprogress = function () {
                };
                xdr.onerror = function () {
                    complete(500, 'error', {
                        text: xdr.responseText
                    });
                };
                if (userOptions.data) {
                    postData = ($.type(userOptions.data) === 'string') ? userOptions.data : $.param(userOptions.data);
                }
                xdr.open(options.type, options.url);
                xdr.send(postData);
            },
            abort: function () {
                if (xdr) {
                    xdr.abort();
                }
            }
        };
    });
    return $;
}));
(function() {
  var supports = (function() {
    var supports = {};
    var html;
    var work = this.document.createElement('div');
    html = '<P><I></P></I>';
    work.innerHTML = html;
    supports.tagSoup = work.innerHTML !== html;
    work.innerHTML = '<P><i><P></P></i></P>';
    supports.selfClose = work.childNodes.length === 2;
    return supports;
  })();
  var startTag = /^<([\-A-Za-z0-9_:]+)((?:\s+[\w\-]+(?:\s*=?\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/;
  var endTag = /^<\/([\-A-Za-z0-9_:]+)[^>]*>/;
  var attr = /([\-A-Za-z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))?/g;
  var fillAttr = /^(checked|compact|declare|defer|disabled|ismap|multiple|nohref|noresize|noshade|nowrap|readonly|selected)$/i;
  var entity = /(&#?[\w.\-]+?;)/gm;
  var DEBUG = false;
  function htmlParser(stream, options) {
    stream = stream || '';
    options = options || {};
    for(var key in supports) {
      if(supports.hasOwnProperty(key)) {
        if(options.autoFix) {
          options['fix_'+key] = true;
        }
        options.fix = options.fix || options['fix_'+key];
      }
    }
    var stack = [];
    var unescapeHTMLEntities = function(html) {
      return typeof html === 'string' ? html.replace(entity, function(match) {
        if (!unescapeHTMLEntities.cache[match]) {
            unescapeHTMLEntities.element.innerHTML = match;
            unescapeHTMLEntities.cache[match] = unescapeHTMLEntities.element.innerText || unescapeHTMLEntities.element.textContent;
        }
        return unescapeHTMLEntities.cache[match];
      }) : html;
    };
    unescapeHTMLEntities.element = document.createElement('div');
    unescapeHTMLEntities.cache = {'&amp;':'&'};
    var append = function(str) {
      try {
        str = escapeIframe(str);
      } catch (e) { }
      stream += str;
    };
    var prepend = function(str) {
      stream = str + stream;
    };
    var detect = {
      comment: /^<!--/,
      endTag: /^<\//,
      atomicTag: /^<\s*(script|style|noscript|iframe|textarea)[\s\/>]/i,
      startTag: /^</,
      chars: /^[^<]/
    };
    var reader = {
      comment: function() {
        var index = stream.indexOf('-->');
        if ( index >= 0 ) {
          return {
            content: stream.substr(4, index),
            length: index + 3
          };
        }
      },
      endTag: function() {
        var match = stream.match( endTag );
        if ( match ) {
          return {
            tagName: match[1],
            length: match[0].length
          };
        }
      },
      atomicTag: function() {
        var start = reader.startTag();
        if(start) {
          var rest = stream.slice(start.length);
          if(rest.match(new RegExp('<\/\\s*' + start.tagName + '\\s*>', 'i'))) {
            var match = rest.match(new RegExp('([\\s\\S]*?)<\/\\s*' + start.tagName + '\\s*>', 'i'));
            if(match) {
              return {
                tagName: start.tagName,
                attrs: start.attrs,
                content: match[1],
                length: match[0].length + start.length
              };
            }
          }
        }
      },
      startTag: function() {
        var match = stream.match( startTag );
        if ( match ) {
          var attrs = {};
          match[2].replace(attr, function(match, name) {
            var value = arguments[2] || arguments[3] || arguments[4] ||
              fillAttr.test(name) && name || null;
            attrs[name] = unescapeHTMLEntities(value);
          });
          return {
            tagName: match[1],
            attrs: attrs,
            unary: !!match[3],
            length: match[0].length
          };
        }
      },
      chars: function() {
        var index = stream.indexOf('<');
        return {
          length: index >= 0 ? index : stream.length
        };
      }
    };
    var readToken = function() {
      for (var type in detect) {
        if(detect[type].test(stream)) {
          if(DEBUG) { console.log('suspected ' + type); }
          var token = reader[type]();
          if(token) {
            if(DEBUG) { console.log('parsed ' + type, token); }
            token.type = token.type || type;
            token.text = stream.substr(0, token.length);
            stream = stream.slice(token.length);
            return token;
          }
          return null;
        }
      }
    };
    var readTokens = function(handlers) {
      var tok;
      while((tok = readToken())) {
        if(handlers[tok.type] && handlers[tok.type](tok) === false) {
          return;
        }
      }
    };
    var clear = function() {
      var rest = stream;
      stream = '';
      return rest;
    };
    var rest = function() {
      return stream;
    };
    if(options.fix) {
      (function() {
        var EMPTY = /^(AREA|BASE|BASEFONT|BR|COL|FRAME|HR|IMG|INPUT|ISINDEX|LINK|META|PARAM|EMBED)$/i;
        var CLOSESELF = /^(COLGROUP|DD|DT|LI|OPTIONS|P|TD|TFOOT|TH|THEAD|TR)$/i;
        var stack = [];
        stack.last = function() {
          return this[this.length - 1];
        };
        stack.lastTagNameEq = function(tagName) {
          var last = this.last();
          return last && last.tagName &&
            last.tagName.toUpperCase() === tagName.toUpperCase();
        };
        stack.containsTagName = function(tagName) {
          for(var i = 0, tok; (tok = this[i]); i++) {
            if(tok.tagName === tagName) {
              return true;
            }
          }
          return false;
        };
        var correct = function(tok) {
          if(tok && tok.type === 'startTag') {
            tok.unary = EMPTY.test(tok.tagName) || tok.unary;
          }
          return tok;
        };
        var readTokenImpl = readToken;
        var peekToken = function() {
          var tmp = stream;
          var tok = correct(readTokenImpl());
          stream = tmp;
          return tok;
        };
        var closeLast = function() {
          var tok = stack.pop();
          prepend('</'+tok.tagName+'>');
        };
        var handlers = {
          startTag: function(tok) {
            var tagName = tok.tagName;
            if(tagName.toUpperCase() === 'TR' && stack.lastTagNameEq('TABLE')) {
              prepend('<TBODY>');
              prepareNextToken();
            } else if(options.fix_selfClose && CLOSESELF.test(tagName) && stack.containsTagName(tagName)) {
              if(stack.lastTagNameEq(tagName)) {
                closeLast();
              } else {
                prepend('</'+tok.tagName+'>');
                prepareNextToken();
              }
            } else if (!tok.unary) {
              stack.push(tok);
            }
          },
          endTag: function(tok) {
            var last = stack.last();
            if(last) {
              if(options.fix_tagSoup && !stack.lastTagNameEq(tok.tagName)) {
                closeLast();
              } else {
                stack.pop();
              }
            } else if (options.fix_tagSoup) {
              skipToken();
            }
          }
        };
        var skipToken = function() {
          readTokenImpl();
          prepareNextToken();
        };
        var prepareNextToken = function() {
          var tok = peekToken();
          if(tok && handlers[tok.type]) {
            handlers[tok.type](tok);
          }
        };
        readToken = function() {
          prepareNextToken();
          return correct(readTokenImpl());
        };
      })();
    }
    return {
      append: append,
      readToken: readToken,
      readTokens: readTokens,
      clear: clear,
      rest: rest,
      stack: stack
    };
  }
  htmlParser.supports = supports;
  htmlParser.tokenToString = function(tok) {
    var handler = {
      comment: function(tok) {
        return '<--' + tok.content + '-->';
      },
      endTag: function(tok) {
        return '</'+tok.tagName+'>';
      },
      atomicTag: function(tok) {
        console.log(tok);
        return handler.startTag(tok) +
              tok.content +
              handler.endTag(tok);
      },
      startTag: function(tok) {
        var str = '<'+tok.tagName;
        for (var key in tok.attrs) {
          var val = tok.attrs[key];
          str += ' '+key+'="'+(val ? val.replace(/(^|[^\\])"/g, '$1\\\"') : '')+'"';
        }
        return str + (tok.unary ? '/>' : '>');
      },
      chars: function(tok) {
        return tok.text;
      }
    };
    return handler[tok.type](tok);
  };
  htmlParser.escapeAttributes = function(attrs) {
    var escapedAttrs = {};
    for(var name in attrs) {
      var value = attrs[name];
      escapedAttrs[name] = value && value.replace(/(^|[^\\])"/g, '$1\\\"');
    }
    return escapedAttrs;
  };
  for(var key in supports) {
    htmlParser.browserHasFlaw = htmlParser.browserHasFlaw || (!supports[key]) && key;
  }
  this.htmlParser = htmlParser;
})();
(function() {
  function doNothing() {}
  var OPTIONS = {
    afterAsync: doNothing,
    afterDequeue: doNothing,
    afterStreamStart: doNothing,
    afterWrite: doNothing,
    beforeEnqueue: doNothing,
    beforeWrite: function(str) { return str; },
    done: doNothing,
    error: function(e) {
    },
    releaseAsync: false,
    highPriority: false
  };
  var global = this;
  var UNDEFINED = void 0;
  function existy(thing) {
    return thing !== UNDEFINED && thing !== null;
  }
  if (global.postscribe) {
    return;
  }
  var DEBUG_CHUNK = false;
  var slice = Array.prototype.slice;
  function isFunction(x) {
    return 'function' === typeof x;
  }
  function each(arr, fn, _this) {
    var i, len = (arr && arr.length) || 0;
    for(i = 0; i < len; i++) {
      fn.call(_this, arr[i], i);
    }
  }
  function eachKey(obj, fn, _this) {
    var key;
    for(key in obj) {
      if(obj.hasOwnProperty(key)) {
        fn.call(_this, key, obj[key]);
      }
    }
  }
  function set(obj, props) {
    eachKey(props, function(key, value) {
      obj[key] = value;
    });
    return obj;
  }
  function defaults(options, _defaults) {
    options = options || {};
    eachKey(_defaults, function(key, val) {
      if(!existy(options[key])) {
        options[key] = val;
      }
    });
    return options;
  }
  function toArray(obj) {
    try {
      return slice.call(obj);
    } catch(e) {
      var ret = [];
      each(obj, function(val) {
        ret.push(val);
      });
      return ret;
    }
  }
  var last = function(array) {
    return array[array.length - 1];
  };
  function isScript(tok) {
    return !tok || !('tagName' in tok) ? !1 : !!~tok.tagName.toLowerCase().indexOf('script');
  }
  function isStyle(tok) {
    return !tok || !('tagName' in tok) ? !1 : !!~tok.tagName.toLowerCase().indexOf('style');
  }
  var WriteStream = (function(){
    var BASEATTR = 'data-ps-';
    function data(el, name, value) {
      var attr = BASEATTR + name;
      if(arguments.length === 2) {
        var val = el.getAttribute(attr);
        return !existy(val) ? val : String(val);
      } else if(existy(value) && value !== '') {
        el.setAttribute(attr, value);
      } else {
        el.removeAttribute(attr);
      }
    }
    function WriteStream(root, options) {
      var doc = root.ownerDocument;
      set(this, {
        root: root,
        options: options,
        win: doc.defaultView || doc.parentWindow,
        doc: doc,
        parser: htmlParser('', { autoFix: false }),
        actuals: [root],
        proxyHistory: '',
        proxyRoot: doc.createElement(root.nodeName),
        scriptStack: [],
        writeQueue: []
      });
      data(this.proxyRoot, 'proxyof', 0);
    }
    WriteStream.prototype.write = function() {
      [].push.apply(this.writeQueue, arguments);
      var arg;
      while(!this.deferredRemote &&
            this.writeQueue.length) {
        arg = this.writeQueue.shift();
        if(isFunction(arg)) {
          this.callFunction(arg);
        } else {
          this.writeImpl(arg);
        }
      }
    };
    WriteStream.prototype.callFunction = function(fn) {
      var tok = { type: 'function', value: fn.name || fn.toString() };
      this.onScriptStart(tok);
      fn.call(this.win, this.doc);
      this.onScriptDone(tok);
    };
    WriteStream.prototype.writeImpl = function(html) {
      this.parser.append(html);
      var tok, tokens = [], script, style;
      while((tok = this.parser.readToken()) && !(script=isScript(tok)) && !(style=isStyle(tok))) {
        tokens.push(tok);
      }
      this.writeStaticTokens(tokens);
      if(script) {
        this.handleScriptToken(tok);
      }
      if(style){
        this.handleStyleToken(tok);
      }
    };
    WriteStream.prototype.writeStaticTokens = function(tokens) {
      var chunk = this.buildChunk(tokens);
      if(!chunk.actual) {
        return;
      }
      chunk.html = this.proxyHistory + chunk.actual;
      this.proxyHistory += chunk.proxy;
      this.proxyRoot.innerHTML = chunk.html;
      if(DEBUG_CHUNK) {
        chunk.proxyInnerHTML = this.proxyRoot.innerHTML;
      }
      this.walkChunk();
      if(DEBUG_CHUNK) {
        chunk.actualInnerHTML = this.root.innerHTML;
      }
      return chunk;
    };
    WriteStream.prototype.buildChunk = function (tokens) {
      var nextId = this.actuals.length,
          raw = [],
          actual = [],
          proxy = [];
      each(tokens, function(tok) {
        raw.push(tok.text);
        if(tok.attrs) {
          if(!(/^noscript$/i).test(tok.tagName)) {
            var id = nextId++;
            actual.push(
              tok.text.replace(/(\/?>)/, ' '+BASEATTR+'id='+id+' $1')
            );
            if(tok.attrs.id !== 'ps-script' && tok.attrs.id !== 'ps-style') {
              proxy.push(
                tok.type === 'atomicTag' ? '' :
                  '<'+tok.tagName+' '+BASEATTR+'proxyof='+id+(tok.unary ? ' />' : '>')
              );
            }
          }
        } else {
          actual.push(tok.text);
          proxy.push(tok.type === 'endTag' ? tok.text : '');
        }
      });
      return {
        tokens: tokens,
        raw: raw.join(''),
        actual: actual.join(''),
        proxy: proxy.join('')
      };
    };
    WriteStream.prototype.walkChunk = function() {
      var node, stack = [this.proxyRoot];
      while(existy(node = stack.shift())) {
        var isElement = node.nodeType === 1;
        var isProxy = isElement && data(node, 'proxyof');
        if(!isProxy) {
          if(isElement) {
            this.actuals[data(node, 'id')] = node;
            data(node, 'id', null);
          }
          var parentIsProxyOf = node.parentNode && data(node.parentNode, 'proxyof');
          if(parentIsProxyOf) {
            this.actuals[parentIsProxyOf].appendChild(node);
          }
        }
        stack.unshift.apply(stack, toArray(node.childNodes));
      }
    };
    WriteStream.prototype.handleScriptToken = function(tok) {
      var remainder = this.parser.clear();
      if(remainder) {
        this.writeQueue.unshift(remainder);
      }
      tok.src = tok.attrs.src || tok.attrs.SRC;
      if(tok.src && this.scriptStack.length) {
        this.deferredRemote = tok;
      } else {
        this.onScriptStart(tok);
      }
      var _this = this;
      this.writeScriptToken(tok, function() {
        _this.onScriptDone(tok);
      });
    };
    WriteStream.prototype.handleStyleToken = function(tok) {
      var remainder = this.parser.clear();
      if(remainder) {
        this.writeQueue.unshift(remainder);
      }
      tok.type = tok.attrs.type || tok.attrs.TYPE || 'text/css';
      this.writeStyleToken(tok);
      if(remainder) {
        this.write();
      }
    };
    WriteStream.prototype.writeStyleToken = function(tok) {
      var el = this.buildStyle(tok);
      this.insertStyle(el);
      if(tok.content) {
        if(el.styleSheet && !el.sheet) {
          el.styleSheet.cssText=tok.content;
        }
        else {
          el.appendChild(this.doc.createTextNode(tok.content));
        }
      }
    };
    WriteStream.prototype.buildStyle = function(tok) {
      var el = this.doc.createElement(tok.tagName);
      el.setAttribute('type', tok.type);
      eachKey(tok.attrs, function(name, value) {
        el.setAttribute(name, value);
      });
      return el;
    };
    WriteStream.prototype.insertStyle = function(el) {
      this.writeImpl('<span id="ps-style"/>');
      var cursor = this.doc.getElementById('ps-style');
      cursor.parentNode.replaceChild(el, cursor);
    };
    WriteStream.prototype.onScriptStart = function(tok) {
      tok.outerWrites = this.writeQueue;
      this.writeQueue = [];
      this.scriptStack.unshift(tok);
    };
    WriteStream.prototype.onScriptDone = function(tok) {
      if(tok !== this.scriptStack[0]) {
        this.options.error({ message: 'Bad script nesting or script finished twice' });
        return;
      }
      this.scriptStack.shift();
      this.write.apply(this, tok.outerWrites);
      if(!this.scriptStack.length && this.deferredRemote) {
        this.onScriptStart(this.deferredRemote);
        this.deferredRemote = null;
      }
    };
    WriteStream.prototype.writeScriptToken = function(tok, done) {
      var el = this.buildScript(tok);
      var asyncRelease = this.shouldRelease(el);
      var afterAsync = this.options.afterAsync;
      if(tok.src) {
        el.src = tok.src;
        this.scriptLoadHandler(el, !asyncRelease ? function() {
          done();
          afterAsync();
        } : afterAsync);
      }
      try {
        this.insertScript(el);
        if(!tok.src || asyncRelease) {
          done();
        }
      } catch(e) {
        this.options.error(e);
        done();
      }
    };
    WriteStream.prototype.buildScript = function(tok) {
      var el = this.doc.createElement(tok.tagName);
      eachKey(tok.attrs, function(name, value) {
        el.setAttribute(name, value);
      });
      if(tok.content) {
        el.text = tok.content;
      }
      return el;
    };
    WriteStream.prototype.insertScript = function(el) {
      this.writeImpl('<span id="ps-script"/>');
      var cursor = this.doc.getElementById('ps-script');
      cursor.parentNode.replaceChild(el, cursor);
    };
    WriteStream.prototype.scriptLoadHandler = function(el, done) {
      function cleanup() {
        el = el.onload = el.onreadystatechange = el.onerror = null;
      }
      var error = this.options.error;
      function success() {
        cleanup();
        done();
      }
      function failure(err) {
        cleanup();
        error(err);
        done();
      }
      set(el, {
        onload: function() {
          success();
        },
        onreadystatechange: function() {
          if(/^(loaded|complete)$/.test( el.readyState )) {
            success();
          }
        },
        onerror: function() {
          failure({ message: 'remote script failed ' + el.src });
        }
      });
    };
    WriteStream.prototype.shouldRelease = function(el) {
      var isScript = /^script$/i.test(el.nodeName);
      return !isScript || !!(this.options.releaseAsync && el.src && el.hasAttribute('async'));
    };
    return WriteStream;
  }());
  global.postscribe = (function() {
    var nextId = 0;
    var queue = [];
    var active = null;
    function nextStream() {
      var args = queue.shift();
      var options;
      if(args) {
        options = last(args);
        options.afterDequeue();
        args.stream = runStream.apply(null, args);
        options.afterStreamStart();
      }
    }
    function runStream(el, html, options) {
      active = new WriteStream(el, options);
      active.id = nextId++;
      active.name = options.name || active.id;
      postscribe.streams[active.name] = active;
      var doc = el.ownerDocument;
      var stash = {
        close: doc.close,
        open: doc.open,
        write: doc.write,
        writeln: doc.writeln
      };
      function write(str) {
        str = options.beforeWrite(str);
        active.write(str);
        options.afterWrite(str);
      }
      set(doc, {
        close: doNothing,
        open: doNothing,
        write: function(){
          return write(toArray(arguments).join(''));
        },
        writeln: function() {
          return write(toArray(arguments).join('') + '\n');
        }
      });
      var oldOnError = active.win.onerror || doNothing;
      active.win.onerror = function(msg, url, line) {
        options.error({ msg: msg + ' - ' + url + ':' + line });
        oldOnError.apply(active.win, arguments);
      };
      active.write(html, function streamDone() {
        set(doc, stash);
        active.win.onerror = oldOnError;
        options.done();
        active = null;
        nextStream();
      });
      return active;
    }
    function postscribe(el, html, options) {
      if(isFunction(options)) {
        options = { done: options };
      }
      options = defaults(options, OPTIONS);
      el =
        (/^#/).test(el) ? global.document.getElementById(el.substr(1)) :
        el.jquery ? el[0] : el;
      var args = [el, html, options];
      el.postscribe = {
        cancel: function() {
          if(args.stream) {
            args.stream.abort();
          } else {
            args[1] = doNothing;
          }
        }
      };
      options.beforeEnqueue(args);
      if(options.highPriority) {
        queue.unshift(args);
      } else {
        queue.push(args);
      }
      if(!active) {
        nextStream();
      }
      return el.postscribe;
    }
    return set(postscribe, {
      streams: {},
      queue: queue,
      WriteStream: WriteStream
    });
  }());
}());
var Storage = new function () {
    try {
        this.supportLocalStorage = 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        this.supportLocalStorage = false;
    }
    this.save = function (key, value) {
        if (this.supportLocalStorage) {
            localStorage.setItem(key, value);
        }
    };
    this.get = function (key) {
        if (this.supportLocalStorage) {
            return localStorage.getItem(key);
        } else {
            return null;
        }
    }
    this.remove = function (key) {
        if (this.supportLocalStorage) {
            return localStorage.removeItem(key);
        }
    }
};
var ModuleService = new function () {
    this.storage = [];
    this.preloadDistance = 100;
    this.init = function () {
        window.viewport = window.viewport || {};
        $(window).on({
            resize: function () {
                ModuleService.calcViewport();
                ModuleService.calcModulesPositions();
                ModuleService.checkModulesVisibility();
            },
            scroll: function () {
                ModuleService.calcViewport();
                ModuleService.checkModulesVisibility();
            }
        });
        this.calcViewport();
    };
    this.add = function ($modules) {
        $modules = $modules instanceof jQuery ? $modules : $($modules);
        $modules.each(function () {
            ModuleService.addSingleModule($(this));
        });
    };
    this.addSingleModule = function ($module) {
        $module = $module instanceof jQuery ? $module : $($module);
        this.storage.push({
            jQueryObject: $module,
            offset: this.calcModulePosition($module)
        });
        this.checkModuleVisibility(this.storage[this.storage.length - 1]);
    };
    this.calcModulesPositions = function () {
        for (var i = 0; i < this.storage.length; i++) {
            this.storage[i].offset = this.calcModulePosition(this.storage[i].jQueryObject);
        }
    };
    this.calcModulePosition = function ($module) {
        if ($module.length) {
            if ($module.is(':visible')) {
                return $module.offset();
            } else {
                return this.calcModulePosition($module.parent());
            }
        }
    };
    this.calcViewport = function () {
        $window = $(window);
        window.viewport.top = $window.scrollTop();
        window.viewport.bottom = window.viewport.top + $window.innerHeight();
    };
    this.checkModulesVisibility = function () {
        for (var i = 0; i < this.storage.length; i++) {
            this.checkModuleVisibility(this.storage[i]);
        }
    };
    this.checkModuleVisibility = function (module) {
        if (!module.visible) {
            if (module.offset.top <= window.viewport.bottom + this.preloadDistance) {
                module.visible = true;
                module.jQueryObject.trigger('isVisibleInViewport');
            }
        }
    };
    this.init();
};
var ContentService = {
    settings: {
        disabled: false,
        renderMoment: 'immediate',
        targetContainer: '.wrapper-center.first + .wrapper-center .wrapper-intent',
        targetContainerPosition: 'append'
    },
    storage: {},
    prepareData: function (data) {
        return data;
    },
    layouts: {},
    moduleGroups: {},
    basicModuleData: {},
    moduleTemplates: {
        'hero': 'hero',
        'pointOfView': 'news-fullsize',
        'channels': 'content-slider-empty-with-wrapper',
        'topSearches': 'top-search',
        'lotto': 'lotto-eurojackpot',
        'breaking': 'breaking-news',
        'topViewedVideos': 'small-content-module',
        'contentModule1': 'small-content-module',
        'news': 'news-fullsize',
        'games': 'placeholder',
        'top-5-product': 'top-5-article',
        'icon1': 'icons',
        'icon2': 'icons',
        'promoline_container': 'promoline-container'
    },
    adModules: {
        'promoline': true,
        'box': true,
        'rectangle': true,
        'rectangleEvent': true,
        'middle': true,
        'sky_right': true
    },
    simpleModules: {
        "s1": true,
        "s2": true,
        "s3": true,
        'maxiadcontent': true,
        'games': true,
        'promoline_container': true
    },
    editorialModules: {},
    ads: {},
    FinishedHook: new FunctionHook(),
    finished: function () {
        ContentService.FinishedHook.check = function () {
            return true;
        };
        ContentService.FinishedHook.run();
    },
    isEnabled: function () {
        if (ContentService.settings.disabled) {
            $('#promoline').css('display', 'none');
            return false;
        } else {
            return true;
        }
    },
    enoughDataAvailable: function (requiredModules) {
        var available = true;
        $.each(requiredModules, function (type, value) {
            if (typeof ContentService.editorialModules[type] !== 'undefined') {
                if (typeof ContentService.storage[type] === 'undefined' || ContentService.storage[type].length === 0) {
                    available = false;
                    return false;
                }
            } else if (typeof ContentService.adModules[type] === 'undefined' && typeof ContentService.simpleModules[type] === 'undefined') {
                available = false;
                return false;
            }
        });
        return available;
    },
    getLayout: function () {
        var deviceclient = AdService.getParam('deviceclient');
        if (AdService.isBlocked) {
            return "abd";
        } else if ((deviceclient === 'browser_clean') || (Array.isArray(deviceclient) && deviceclient.indexOf('browser_clean') >= 0)) {
            return "indirect";
        } else if (PageLayout.config.layout === "halfpage") {
            return "halfpage";
        } else if (PageLayout.config.layout === "maxiadcontent") {
            return "maxiadcontent";
        } else if (['billboard', 'skyright', 'default'].indexOf(PageLayout.config.adType) !== -1) {
            return "50";
        } else {
            return "25";
        }
    },
    getTypeFromModule: function (module) {
        return typeof module.type !== 'undefined' ? module.type : module._type;
    },
    getNextModuleData: function (type) {
        return ContentService.storage[type].shift();
    },
    getChannel: function (channelId) {
        if (ContentService.storage && ContentService.storage.channels && ContentService.storage.channels.length) {
            for (var i = 0; i < ContentService.storage.channels.length; i++) {
                if (ContentService.storage.channels[i].channelId === channelId) {
                    return ContentService.storage.channels[i];
                }
            }
        }
        return null;
    },
    getTemplateName: function (module) {
        var templateName;
        if (module.template) {
            templateName = module.template;
        } else {
            var type = ContentService.getTypeFromModule(module);
            if (typeof ContentService.moduleTemplates[type] !== 'undefined') {
                templateName = ContentService.moduleTemplates[type];
            } else {
                templateName = type;
            }
        }
        if (!!ContentService.adModules[type] && AdService.isBlocked) {
            templateName = type + '-abd';
        }
        return templateName;
    },
    extendStorage: function (data) {
        data = this.prepareData(data);
        $.each(data, function (moduleType, moduleData) {
            if (typeof ContentService.storage[moduleType] !== 'undefined' && $.isArray(ContentService.storage[key])) {
                ContentService.storage[moduleType] = ContentService.storage[moduleType].concat(moduleData);
            } else {
                ContentService.storage[moduleType] = moduleData;
                ContentService.editorialModules[moduleType] = true;
            }
        });
        var event = new CustomEvent('ContentServiceStorageReady', { bubbles: true, cancelable: true });
        document.querySelector('body').dispatchEvent(event);
    },
    upgradeData: function (data) {
        for (var i = 0; i < data.channels.length; i++) {
            data.channels[i].title = data.channels[i].headline || data.channels[i].name;
            if (!data.channels[i].link && data.channels[i].clickurl) {
                data.channels[i].link = {
                    url: data.channels[i].clickurl,
                    target: data.channels[i].target
                };
                delete data.channels[i].headline;
                delete data.channels[i].clickurl;
            }
        }
        if (!data.headline && data.channels.length) {
            data.headline = data.channels.shift();
        }
        data.links = data.channels;
        delete data.channels;
        return data;
    },
    init: function (data) {
        if (data) {
            ContentService.extendStorage(data, 'initial');
        }
        switch (ContentService.settings.renderMoment) {
            case 'custom':
                break;
            case 'immediate':
            default:
                ContentService.render();
                break;
        }
    },
    render: function () {
        if (ContentService.isEnabled()) {
            var layout = ContentService.getLayout();
            if (ContentService.layouts[layout]) {
                ContentService.renderLayout(layout);
            } else {
            }
        } else {
            ContentService.finished();
        }
    },
    renderLayout: function (layout) {
        if (ContentService.isEnabled()) {
            for (var i = 0; i < ContentService.layouts[layout].length; i++) {
                ContentService.renderModuleGroup(ContentService.layouts[layout][i]);
            }
            PageLayout.forceRefresh();
        }
        ContentService.finished();
    },
    renderModuleGroup: function (groupName) {
        if (typeof ContentService.moduleGroups[groupName] != 'undefined') {
            for (var i = 0; i < ContentService.moduleGroups[groupName].length; i++) {
                ContentService.renderModule(ContentService.moduleGroups[groupName][i]);
            }
            $(window).trigger('contentloaded');
        } else {
        }
    },
    renderModule: function (module) {
        module = (typeof module !== 'object') ? { _type: module } : module;
        var repeat = '1';
        if (module._type.match(/[*+?]$/)) {
            repeat = module._type.match(/[*+?]$/)[0];
            if (repeat === '*' || repeat === '+') {
                var callback = (function (module) {
                    return function () {
                        ContentService.renderModule(module);
                    }
                })($.extend({}, module));
            }
            module._type = module._type.substring(0, module._type.length - 1);
        }
        var type = ContentService.getTypeFromModule(module);
        if (typeof ContentService.editorialModules[type] !== 'undefined') {
            var nextData = ContentService.getNextModuleData(type);
            if (typeof nextData !== 'undefined') {
                module = $.extend(true, module, nextData);
            } else {
                module._disabled = true;
                if (repeat === '+' || repeat === '*') {
                    callback = null;
                }
            }
        } else if (type === 'channel_news') {
            if (this.currentChannel instanceof Array && this.currentChannel.length) {
                var nextTeaser = this.currentChannel.shift();
                module = $.extend(true, module, {
                    template: 'news-fullsize',
                    type: 'news-fullsize',
                    teasers: [nextTeaser]
                });
            } else {
                module._disabled = true;
                callback = null;
            }
        } else {
            callback = null;
        }
        if (typeof ContentService.basicModuleData[type] !== 'undefined') {
            var basicData = null;
            if (ContentService.basicModuleData[type] instanceof Array) {
                if (ContentService.basicModuleData[type].length > 0) {
                    basicData = ContentService.basicModuleData[type].shift();
                }
            } else {
                basicData = ContentService.basicModuleData[type]
            }
            if (typeof basicData === 'function') {
                basicData = basicData();
            }
            module = $.extend({}, basicData, module);
        }
        if (typeof module.dataCheck === 'function' && !module.dataCheck(module)) {
            module._disabled = true;
        }
        if (module._disabled) {
            return true;
        }
        module = ContentService.filterData(module, true);
        if (module.preRendered) {
            var $module = $(module.selector);
        } else {
            var templateName = ContentService.getTemplateName(module);
            var content = ContentService.renderTemplate(templateName, module);
            var $module = $(content);
            if (module._targetContainer) {
                if (module._targetContainerPosition) {
                    $(module._targetContainer)[module._targetContainerPosition]($module);
                } else {
                    $(module._targetContainer).append($module);
                }
            } else {
                if ($(ContentService.settings.targetContainer).length) {
                    $(ContentService.settings.targetContainer)[ContentService.settings.targetContainerPosition]($module);
                } else {
                    $('body > .wrapper-center.first + .wrapper-center .wrapper-indent').append($module);
                }
            }
        }
        $module.each(function () {
            var $this = $(this);
            var type = ContentService.getTypeFromModule(module);
            if (!!ContentService.adModules[type]) {
                ContentService.requestAd($this, module);
            }
            ModuleService.add($this);
        });
        if (type === 'channels') {
            this.currentChannel = module.teasers;
        }
        if (typeof module.children !== 'undefined') {
            for (var i = 0; i < module.children.length; i++) {
                var childData = module.children[i] === 'object' ? module.children[i] : {
                    _type: module.children[i]
                };
                childData._targetContainer = module.childTarget ? $(module.childTarget, $module) : $module;
                ContentService.renderModule(childData);
            }
        }
        if (typeof module.callback === 'function') {
            module.callback($module, module);
        }
        if (typeof callback === 'function') {
            callback();
        }
    },
    renderTemplate: function (templateName, data) {
        if (ContentService.templates[templateName]) {
            return Mustache.render(ContentService.templates[templateName], data);
        } else {
            return '<section><div class="r1"></div></section>';
        }
    },
    checkAdSlot: function (slotName, $target) {
        if (AdService.getPositionParam(slotName, '_lazyLoad') || AdService.getPositionParam(slotName, '_prebid')) {
            var $module = $target || $('[data-adservice-slot="' + slotName + '"]');
            ContentService.storeAd(slotName, $module);
            if (AdService.getPositionParam(slotName, '_lazyLoad')) {
                AdService.setPositionParam(slotName, '_handledByContentService', true);
                $module.one('isVisibleOutOfViewport', function () {
                    DoPostscribe.add(function () {
                        if (AdService.getPositionParam(slotName, '_prebid') && PrebidConnector.isAllowed() && !AdService.getPositionParam(slotName, '_prebidBiddingEnded')) {
                            PrebidConnector.startBidding([slotName]);
                        } else {
                            ContentService.createPosition(slotName, $module);
                        }
                    });
                });
            } else if (AdService.getPositionParam(slotName, '_prebid') && PrebidConnector.isAllowed() && !AdService.getPositionParam(slotName, '_prebidBiddingEnded')) {
                AdService.setPositionParam(slotName, '_handledByContentService', true);
            } else {
                return true;
            }
            if (AdService.getPositionParam(slotName, '_pauseContentService')) {
                PrebidConnector.startBidding(['rectangle']);
                $('body').addClass('content-service-paused');
                $('.wrapper-center.first + .wrapper-center .wrapper-indent').append('<div class="content-service-loader"><span>Seite wird geladen</span></div>');
                ContentService.settings.renderMoment = 'custom';
            }
            return false;
        }
        return true;
    },
    requestAd: function ($module, module) {
        if (module.tagid) {
            if (module.backfillTagid) {
                AdService.setPositionParam(module.tagid, '_backfillTagid', module.backfillTagid);
            }
            ContentService.storeAd(module.tagid, $module);
            var $adTarget = module.adTargetSelector ? $(module.adTargetSelector, $module) : $module;
            AdService.setPositionParam(module.tagid, '_container', $adTarget);
            if (ContentService.checkAdSlot(module.tagid, $adTarget)) {
                if (!module.loadIfVisible) {
                    ContentService.createPosition(module.tagid, $adTarget, module);
                } else {
                    (function (tagid, $adTarget, module, $module) {
                        $module.addClass('position-' + tagid);
                        $module.one('isVisibleOutOfViewport', function () {
                            if (SiteInfo.portal === 'homepage') {
                                DoPostscribe.add(function () {
                                    ContentService.createPosition(tagid, $adTarget, module);
                                });
                            } else {
                                ContentService.createPosition(tagid, $adTarget, module);
                            }
                        });
                    })(module.tagid, $adTarget, module, $module);
                }
            }
        }
    },
    createdPositions: [],
    resetPosition: function (positionName) {
        var index = ContentService.createdPositions.indexOf(positionName);
        if (index !== -1) {
            ContentService.createdPositions.splice(index, 1);
        }
    },
    createPosition: function (position, $adTarget, module, additionalParams) {
        if (AdService.getPositionParam(position, '_disabled')) {
            return;
        }
        if (ContentService.createdPositions.indexOf(position) !== -1) {
            return;
        }
        module = module || {};
        $adTarget = $adTarget || $('[data-adservice-slot="' + position + '"]');
        var child = AdService.getPositionParam(position, '_child');
        if (child) {
            $adTarget = $(child, $adTarget);
        }
        if (typeof ContentService.ads[position] === 'undefined' || position === 'rectangle_layer') {
            ContentService.storeAd(position, $adTarget);
        }
        if ($adTarget && $adTarget.length) {
            ContentService.createdPositions.push(position);
            if (['rectangle', 'uniteaser', 'rectangleEvent'].indexOf(position) !== -1 && (!AdService.getPositionParam(position, '_handledByContentService'))) {
                AdService.createPosition(position, false, document.write, {}, additionalParams);
                return true;
            }
            DoPostscribe.add(function () {
                AdService.createPosition(position, $adTarget, window.postscribe, {
                    done: function () {
                        if (position === 'sky_right') {
                            if ($('.adv-generic-container > *:not("script"):not("uim\\:ad")', ContentService.ads[position]).length > 1) {
                                var meta = AdService.metaData['sky_right'];
                                AdService.createAd({
                                    type: 'sky_right',
                                    components: {
                                        skyright: {
                                            dom: $('.adv-generic-container', ContentService.ads[position]).get(0),
                                            width: (+(meta || {}).width || 160),
                                            height: (+(meta || {}).height || 600)
                                        }
                                    }
                                });
                                AdRefresh.checkPositionAndRegister({
                                    position: position,
                                    meta: meta
                                });
                            }
                        }
                        if (AdService.getPositionParam(position, '_pauseContentService')) {
                            $('body').removeClass('content-service-paused');
                            $('.content-service-loader').remove();
                            ContentService.render();
                        }
                        if (ContentService.ads[position]) {
                            var sandbox = ContentService.adSandbox(position);
                            unescapeIframe(ContentService.ads[position], sandbox);
                            var $divToIframe = ContentService.ads[position].find('div[data-iframe-url]');
                            if ($divToIframe && $divToIframe.length > 0) {
                                var iframeUrl = $divToIframe.data('iframe-url');
                                var iframe = $('<iframe>').attr({
                                    frameborder: 0,
                                    scrolling: 'no',
                                    width: 1260,
                                    height: 104,
                                    src: iframeUrl,
                                    sandbox: sandbox
                                });
                                $divToIframe.after(iframe).remove();
                            }
                            var adTag = ContentService.ads[position];
                            adTag.attr('data-adservice-slot', position);
                            adTag.removeClass('empty');
                            adTag.closest('.empty').removeClass('empty');
                            var componentCreatedEvent = new CustomEvent (position + ':created', { bubbles: true, cancelable: true });
                            document.querySelector('body').dispatchEvent(componentCreatedEvent);
                        }
                    },
                    highPriority: typeof module._highPriority !== 'undefined' ? module._highPriority : false
                }, additionalParams);
            });
        }
    },
    adSandbox: function (position) {
        if(position) {
            var sandbox = AdService.getPositionParam(position, 'sandbox');
            if(sandbox) {
                return sandbox;
            }
            return '';
        }
    },
    storeAd: function (slotName, $module) {
        ContentService.ads[slotName] = $module;
    },
    getSkyMaxWidth: function () {
        return window.innerWidth - PageLayout.config.minFitsAllBrowserWidth;
    },
    resizeTeaserImage: function (teaser, width, height, suffix) {
        if (teaser instanceof Array) {
            for (var i = 0; i < teaser.length; i++) {
                teaser[i] = ContentService.resizeTeaserImage(teaser[i], width, height, suffix)
            }
        } else {
            if (typeof teaser !== 'undefined' && typeof teaser.image !== 'undefined' && typeof teaser.image.url !== 'undefined') {
                var sizePosition;
                if (teaser.image.coreMediaImage === true) {
                    var url = teaser.image.url.replace(/,?[wh]=\d+/g, '');
                    var pdRegex = new RegExp('pd=[0-9]*');
                    var pdParam = url.match(pdRegex);
                    if (pdParam && pdParam[0]) {
                        sizePosition = url.search(pdRegex) + pdParam[0].length;
                    } else {
                        sizePosition = url.lastIndexOf('.');
                    }
                    teaser.image['teaserUrl' + (suffix ? suffix : '')] = [url.slice(0, sizePosition), ',h=' + height + ',w=' + width, url.slice(sizePosition)].join('');
                } else {
                    teaser.image.teaserUrl = teaser.image.url;
                }
                teaser.image.width = width;
                teaser.image.height = height;
            }
        }
        return teaser;
    },
    filterData: function (data, isRoot) {
        if (data) {
            if (isRoot) {
                $.each(ContentService.dataFilter, function (k, filter) {
                    if (typeof filter == 'function') {
                        var new_data = filter(data, 'root');
                        if (new_data != data) {
                            data = new_data;
                        }
                    }
                });
            }
            $.each(data, function (key, value) {
                if (value && typeof value === 'object' && !(value instanceof jQuery || value.getElementsByTagName)) {
                    value = ContentService.filterData(value, false);
                }
                $.each(ContentService.dataFilter, function (k, filter) {
                    if (typeof filter == 'function') {
                        var new_val = filter(value, key);
                        if (new_val != value) {
                            value = new_val;
                        }
                    }
                });
                try {
                    data[key] = value;
                } catch (e) {
                }
            });
        }
        return data;
    },
    dataFilter: [
        function (value, key) {
            if ($.isArray(value)) {
                for (var k = 0; k < value.length; k++) {
                    if (typeof value[k] === 'object') {
                        if (k == 0) {
                            value[k]['_first'] = true;
                        }
                        if (k + 1 == value.length) {
                            value[k]['_last'] = true;
                        }
                        value[k]['_index'] = k;
                        value[k]['_count'] = typeof value[k]['_count'] != 'undefined' ? value[k]['_count'] : k + 1;
                        if ((k + 1) % 2) {
                            value[k]['_odd'] = true;
                        } else {
                            value[k]['_even'] = true;
                        }
                    }
                }
            }
            return value;
        },
        function (value, key) {
            if (key === 'teasers') {
                for (var i = 0; i < value.length; i++) {
                    if (value[i].contentType !== 'undefined') {
                        value[i]['icons'] = [];
                        switch (value[i].contentType) {
                            case 'VIDEO':
                                value[i]['icons'].push('video');
                                break;
                        }
                    }
                }
            }
            return value;
        },
        function (value, key) {
            if (key == 'root' && typeof value != 'undefined') {
                var type = ContentService.getTypeFromModule(value);
                if (typeof type != 'undefined') {
                    switch (type) {
                        case 'top-search':
                            value['firstLinks'] = [];
                            for (var i = 0; i < value['links'].length; i++) {
                                value['links'][i].targetUrl += '&origin=hs_fm';
                                if (i < 5) {
                                    value['firstLinks'].push(value['links'][i]);
                                }
                            }
                            break;
                        case 'hero':
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 480, 250, 'Large');
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 300, 250, 'Small');
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 140, 70, 'Thumbnail');
                            break;
                        case 'pointOfView':
                        case 'news':
                        case 'news-fullsize':
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 300, 250);
                            break;
                        case 'small-content-module':
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 300, 192);
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 72, 54, 'Thumbnail');
                            break;
                        case 'trm':
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 940, 250, 'Large');
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 620, 250, 'Medium');
                            value.teasers = ContentService.resizeTeaserImage(value.teasers, 300, 250, 'Small');
                            break;
                        default:
                            break;
                    }
                }
            }
            return value;
        },
        function (value, key) {
            if (value && typeof value === 'object' && value['linkTarget'] === 'EXTERN') {
                value['target'] = '_blank';
            }
            return value;
        }
    ]
};
ContentService.templates = {
    "promoline": "<div class=\"oms-promoline\"></div>\r\n",
    "promoline-abd": "<div class=\"oms-promoline\"></div>\r\n",
    "box": "<section class=\"ad empty\"{{#containerId}} id=\"{{containerId}}\"{{/containerId}}><div class=\"r1\"></div></section>\r\n",
    "box-abd": "<section class=\"info empty\"{{#containerId}} id=\"{{containerId}}\"{{/containerId}}><div class=\"r1\"></div></section>\r\n",
    "rectangle": "<section class=\"ad\"{{#containerId}} id=\"{{containerId}}\"{{/containerId}}><div></div></section>\r\n",
    "rectangle-abd": "<section class=\"info\"{{#containerId}} id=\"{{containerId}}\"{{/containerId}}><div></div></section>\r\n",
    "middle": "<div class=\"r4\"></div>\r\n",
    "middle-abd": "<div class=\"r4\"></div>\r\n",
    "hero-small": "<section class=\"teaser news multi-news hero small\">\r\n <div class=\"r1\">\r\n <div class=\"slider-container\" data-active-slide=\"1\">\r\n <div class=\"slider\">\r\n {{#teasers}}\r\n <div class=\"teaser-content\" data-slide-id=\"{{_count}}\">\r\n <div class=\"teaser-img\">\r\n <img width=\"300\" height=\"250\" src=\"{{image.teaserUrlSmall}}\" alt=\"{{image.alttext}}\" />\r\n {{#icons}}\r\n <span class=\"{{icons}}\"></span>\r\n {{/icons}}\r\n </div>\r\n <div class=\"details teaser-text\">\r\n <header>\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>{{headline}}</a>\r\n </header>\r\n <p>\r\n <span class=\"subline\">{{text}}</span>\r\n <span class=\"more\"></span>\r\n </p>\r\n </div>\r\n </div>\r\n {{/teasers}}\r\n </div>\r\n </div>\r\n <ul class=\"news-list\">\r\n {{#teasers}}\r\n <li class=\"{{#_first}}first active{{/_first}}{{#_last}}last{{/_last}}\">\r\n <figure class=\"news-list-teaser\">\r\n <figcaption>\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\r\n <span class=\"placeholder\"></span>\r\n <span>{{headline}}</span>\r\n </a>\r\n </figcaption>\r\n </figure>\r\n </li>\r\n {{/teasers}}\r\n </ul>\r\n </div>\r\n</section>\r\n",
    "hero": "<section class=\"teaser news multi-news hero\">\r\n <div class=\"r2\">\r\n <div class=\"slider-container\" data-active-slide=\"1\">\r\n <div class=\"slider\">\r\n {{#teasers}}\r\n <div class=\"teaser-content\" data-slide-id=\"{{_count}}\">\r\n <div class=\"teaser-img\">\r\n <img width=\"475\" height=\"250\" src=\"{{image.teaserUrlLarge}}\" alt=\"{{image.alttext}}\" data-imgsrc-small=\"{{image.teaserUrlSmall}}\"/>\r\n {{#icons}}\r\n <span class=\"{{icons}}\"></span>\r\n {{/icons}}\r\n </div>\r\n <div class=\"details teaser-text\">\r\n <header>\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>{{headline}}</a>\r\n </header>\r\n {{#text}}\r\n <p>\r\n <span class=\"subline\">{{text}}</span>\r\n <span class=\"more\"></span>\r\n </p>\r\n {{/text}}\r\n {{#additionalLinks.0}}\r\n <ul class=\"link-list\">\r\n {{#additionalLinks}}\r\n <li><a href=\"{{targetUrl}}\"{{#target}} target=\"{{target}}\"{{/target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>{{title}}</a></li>\r\n {{/additionalLinks}}\r\n </ul>\r\n {{/additionalLinks.0}}\r\n </div>\r\n </div>\r\n {{/teasers}}\r\n </div>\r\n </div>\r\n <ul class=\"news-list\">\r\n {{#teasers}}\r\n <li class=\"{{#_first}}first active{{/_first}}{{#_last}}last{{/_last}}\">\r\n <figure class=\"news-list-teaser\">\r\n <img src=\"{{image.teaserUrlThumbnail}}\" alt=\"{{image.alttext}}\" width=\"140\" height=\"70\"/>\r\n <figcaption>\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\r\n <span class=\"placeholder\"></span>\r\n <span>{{headline}}</span>\r\n </a>\r\n </figcaption>\r\n </figure>\r\n </li>\r\n {{/teasers}}\r\n </ul>\r\n </div>\r\n</section>\r\n",
    "news-fullsize": "{{#teasers}}\r\n<section class=\"news-fullsize\">\r\n <section class=\"news news-fullsize-item\"{{#id}} data-module-name=\"{{id}}\"{{/id}}>\r\n <div class=\"r1\">\r\n <div class=\"news-content\">\r\n <div class=\"teaser-content\">\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\r\n <div class=\"teaser-img\">\r\n <img width=\"300\" height=\"250\" src=\"{{image.teaserUrl}}\" alt=\"{{image.alttext}}\">\r\n {{#icons}}\r\n <span class=\"{{.}}\"></span>\r\n {{/icons}}\r\n </div>\r\n <div class=\"details teaser-text\">\r\n <header>{{headline}}</header>\r\n <p>\r\n <span class=\"subline\">{{text}}</span>\r\n <span class=\"more\"></span>\r\n </p>\r\n </div>\r\n </a>\r\n </div>\r\n </div>\r\n </div>\r\n </section>\r\n</section>\r\n{{/teasers}}\r\n",
    "small-content-module": "<section class=\"teaser news multi-news\"{{#id}} data-module-name=\"{{id}}\"{{/id}}>\r\n <div class=\"r1\">\r\n <div class=\"slider-container\" data-active-slide=\"1\">\r\n <div class=\"slider\">\r\n {{#teasers}}\r\n <div class=\"teaser-content\" data-slide-id=\"{{_count}}\">\r\n <div class=\"teaser-img\">\r\n <img width=\"300\" height=\"192\" src=\"{{image.teaserUrl}}\" alt=\"{{image.alttext}}\"/>\r\n {{#icons}}\r\n <span class=\"{{.}}\"></span>\r\n {{/icons}}\r\n </div>\r\n <div class=\"details teaser-text\">\r\n <header>\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>{{headline}}</a>\r\n </header>\r\n </div>\r\n </div>\r\n {{/teasers}}\r\n </div>\r\n </div>\r\n <ul class=\"news-list\">\r\n {{#teasers}}\r\n <li class=\"{{#_first}}first active{{/_first}}{{#_last}}last{{/_last}}\">\r\n <figure class=\"news-list-teaser\">\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\r\n <img src=\"{{image.teaserUrlThumbnail}}\" alt=\"{{image.alttext}}\" width=\"72\" height=\"54\"/>\r\n </a>\r\n <figcaption>\r\n <span>{{headline}}</span>\r\n </figcaption>\r\n </figure>\r\n </li>\r\n {{/teasers}}\r\n </ul>\r\n </div>\r\n</section>\r\n",
    "breaking-news": "<div class=\"breaking-news\">\r\n <div class=\"breaking-news-inner\">\r\n {{#teasers}}\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}><span>EILMELDUNG +++ {{headline}} +++ </span></a>\r\n {{/teasers}}\r\n </div>\r\n</div>\r\n",
    "top-search": "<section class=\"service top-search\">\r\n	<div class=\"r1\">\r\n		<div class=\"service-content\">\r\n			<header>Top-Suchen: {{title}}</header>\r\n			<ol class=\"first\">\r\n				{{#firstLinks}}\r\n <li><a href=\"{{targetUrl}}\"{{#target}} target=\"{{target}}\"{{/target}}>{{title}}</a></li>\r\n				{{/firstLinks}}\r\n			</ol>\r\n		</div>\r\n	</div>\r\n</section>\r\n",
    "top-5-article": "<section class=\"service top-article\">\r\n <div class=\"r1\">\r\n <div class=\"service-content\">\r\n <header>{{header}}</header>\r\n <ul class=\"link-list\">\r\n {{#teasers}}\r\n <li{{#_first}} class=\"first\"{{/_first}}{{#_last}} class=\"first\"{{/_last}}><a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}><span>{{headline}}</span> <span class=\"more\">mehr</span></a></li>\r\n {{/teasers}}\r\n </ul>\r\n <a href=\"{{footerLink}}\">Weitere Nachrichten</a>\r\n </div>\r\n </div>\r\n</section>\r\n",
    "lotto-eurojackpot": "<section class=\"service lotto lotto-slider\">\r\n <div class=\"r1\">\r\n <div class=\"slider-container\" data-active-slide=\"1\">\r\n <div class=\"slider\">\r\n {{#data.lotto}}\r\n <div class=\"service-content slide-lotto{{#showJackpotView}}{{#hasJackpot}} standalone{{/hasJackpot}}{{/showJackpotView}}{{^hasJackpot}} no-jackpot{{/hasJackpot}}\" data-slide-id=\"1\">\r\n <header><span>{{data.header}}</span></header>\r\n <div class=\"next-draw\">\r\n <header>Jackpothöhe am {{upcomingDrawingDate}}</header>\r\n <div class=\"next-draw-content\">\r\n <div class=\"jackpot-info\">\r\n <span class=\"jackpot\">{{#hasJackpot}}{{jackpot}}{{/hasJackpot}}{{^hasJackpot}}?{{/hasJackpot}}</span>\r\n <span class=\"headline\">{{#hasJackpot}}MIO &euro;{{/hasJackpot}}{{^hasJackpot}}Millionär{{/hasJackpot}}</span>\r\n <span class=\"subline\">{{#hasJackpot}}{{#showJackpotView}}am {{upcomingDrawingDay}}{{/showJackpotView}}{{^showJackpotView}}Jackpot{{/showJackpotView}}{{/hasJackpot}}{{^hasJackpot}}werden...{{/hasJackpot}}</span>\r\n </div>\r\n <div class=\"jackpot-button\">\r\n <a href=\"{{jackpotServiceUrl}}\">\r\n <span class=\"btn-wrapper btn-xs btn-service btn-fix\">\r\n <em tabindex=\"3\" >Lotto spielen</em>\r\n </span>\r\n </a>\r\n <span class=\"chance\">Chance 1:140 Mio.</span>\r\n </div>\r\n <span class=\"btn-wrapper btn-m btn-service btn-fix\">\r\n <em tabindex=\"3\" >Lotto spielen</em>\r\n </span>\r\n </div>\r\n </div>\r\n <div class=\"last-draw\">\r\n <header>Ziehung vom {{drawingDate}}</header>\r\n <div class=\"winning-numbers\">\r\n <ol class=\"numbers\">\r\n {{#drawingNumbers}}\r\n <li><span>{{.}}</span></li>\r\n {{/drawingNumbers}}\r\n </ol>\r\n <span class=\"sz\">SZ</span>\r\n <ol class=\"numbers\">\r\n <li><span>{{additionalNumbers}}</span></li>\r\n </ol>\r\n </div>\r\n </div>\r\n <div class=\"additional-links\">\r\n <ul>\r\n <li><a href=\"{{quicktippLink1}}\">6er Quicktipp</a></li>\r\n <li><a href=\"{{quicktippLink2}}\">12er Quicktipp</a></li>\r\n </ul>\r\n </div>\r\n <footer>Ab 18 Jahren. Suchtgefahr. Hilfe bei www.bzga.de.<!-- Alle Angaben ohne Gewähr --></footer>\r\n </div>\r\n {{/data.lotto}}\r\n {{#data.eurojackpot}}\r\n <div class=\"service-content slide-eurojackpot{{#showJackpotView}}{{#hasJackpot}} standalone{{/hasJackpot}}{{/showJackpotView}}{{^hasJackpot}} no-jackpot{{/hasJackpot}}\" data-slide-id=\"2\">\r\n <header><span>{{data.header}}</span></header>\r\n <div class=\"next-draw\">\r\n <header>Jackpothöhe am {{upcomingDrawingDate}}</header>\r\n <div class=\"next-draw-content\">\r\n <div class=\"jackpot-info\">\r\n <span class=\"jackpot\">{{#hasJackpot}}{{jackpot}}{{/hasJackpot}}{{^hasJackpot}}?{{/hasJackpot}}</span>\r\n <span class=\"headline\">{{#hasJackpot}}MIO &euro;{{/hasJackpot}}{{^hasJackpot}}Millionär{{/hasJackpot}}</span>\r\n <span class=\"subline\">{{#hasJackpot}}{{#showJackpotView}}am {{upcomingDrawingDay}}{{/showJackpotView}}{{^showJackpotView}}Jackpot{{/showJackpotView}}{{/hasJackpot}}{{^hasJackpot}}werden...{{/hasJackpot}}</span>\r\n </div>\r\n <div class=\"jackpot-button\">\r\n <a href=\"{{jackpotServiceUrl}}\">\r\n <span class=\"btn-wrapper btn-xs btn-service btn-fix\">\r\n <em tabindex=\"3\" >Lotto spielen</em>\r\n </span>\r\n </a>\r\n <span class=\"chance\">Chance 1:95 Mio.</span>\r\n </div>\r\n <span class=\"btn-wrapper btn-m btn-service btn-fix\">\r\n <em tabindex=\"3\" >Jetzt spielen</em>\r\n </span>\r\n </div>\r\n </div>\r\n <div class=\"last-draw\">\r\n <header>Ziehung vom {{drawingDate}}</header>\r\n <div class=\"winning-numbers\">\r\n <ol class=\"numbers\">\r\n {{#drawingNumbers}}\r\n <li><span>{{.}}</span></li>\r\n {{/drawingNumbers}}\r\n </ol>\r\n <span class=\"sz\">EZ</span>\r\n <ol class=\"numbers\">\r\n {{#additionalNumbers}}\r\n <li><span>{{.}}</span></li>\r\n {{/additionalNumbers}}\r\n </ol>\r\n </div>\r\n </div>\r\n <div class=\"additional-links\">\r\n <ul>\r\n <li><a href=\"{{quicktippLink1}}\">4er Quicktipp</a></li>\r\n <li><a href=\"{{quicktippLink2}}\">8er Quicktipp</a></li>\r\n </ul>\r\n </div>\r\n <footer>Ab 18 Jahren. Suchtgefahr. Hilfe bei www.bzga.de.<!-- Alle Angaben ohne Gewähr --></footer>\r\n </div>\r\n {{/data.eurojackpot}}\r\n </div>\r\n </div>\r\n <div class=\"slide-navigation\">\r\n <ul>\r\n <li class=\"active\">1</li>\r\n <li>2</li>\r\n </ul>\r\n </div>\r\n </div>\r\n</section>\r\n",
    "content-slider": "<section class=\"content-slider{{#type}} {{type}}{{/type}}\">\r\n <div class=\"r4\">\r\n <div class=\"slider-headnav\">\r\n {{#logo}}\r\n <div class=\"logo\">\r\n {{#link}}\r\n <a href=\"{{link.targetUrl}}\">\r\n {{/link}}\r\n <img src=\"{{url}}\" />\r\n {{#link}}\r\n </a>\r\n {{/link}}\r\n </div>\r\n {{/logo}}\r\n\r\n {{#headline}}\r\n <header>\r\n {{#targetUrl}}\r\n <a href=\"{{targetUrl}}\"{{#target}} target=\"{{target}}\"{{/target}}>{{title}}</a>\r\n {{/targetUrl}}\r\n {{^targetUrl}}\r\n {{title}}\r\n {{/targetUrl}}\r\n </header>\r\n {{/headline}}\r\n <ul>\r\n {{#links}}\r\n <li{{#class}} class=\"{{class}}\"{{/class}}><a href=\"{{link.url}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>{{title}}</a></li>\r\n {{/links}}\r\n </ul>\r\n </div>\r\n <div class=\"slider-container\">\r\n <div class=\"slider\">\r\n {{#teasers}}\r\n <article class=\"slider-item\">\r\n <section class=\"news news-fullsize-item\">\r\n <div class=\"r1\">\r\n <div class=\"news-content\">\r\n <div class=\"teaser-content\">\r\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>\r\n <div class=\"teaser-img\">\r\n <img width=\"300\" height=\"250\" src=\"{{image.url}}\" alt=\"{{image.alttext}}\">\r\n {{#icons}}\r\n <span class=\"{{.}}\"></span>\r\n {{/icons}}\r\n </div>\r\n <div class=\"details teaser-text\">\r\n <header>\r\n {{headline}}\r\n </header>\r\n <p>\r\n <span class=\"subline\">{{text}}</span>\r\n <span class=\"more\"></span>\r\n </p>\r\n </div>\r\n </a>\r\n </div>\r\n </div>\r\n </div>\r\n </section>\r\n </article>\r\n {{/teasers}}\r\n </div>\r\n </div>\r\n </div>\r\n</section>\r\n",
    "icons": "<section class=\"service icons\">\n <div class=\"r1\">\n <div class=\"service-content\">\n {{#data}}\n <section class=\"icon-wrapper wrapped\">\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>\n <figure>\n <span class=\"icon\" style=\"background-image: url(\'{{image.url}}\')\"></span>\n <figcaption>\n <header>{{headline}}</header>\n <footer>{{text}}</footer>\n </figcaption>\n </figure>\n </a>\n </section>\n {{/data}}\n </div>\n </div>\n</section>\r\n",
    "slider": "<section class=\"content-slider{{#_type}} {{_type}}{{/_type}}\">\r\n <div class=\"r4\">\r\n <div class=\"slider-headnav\">\r\n {{#headline}}\r\n <header>\r\n {{#targetUrl}}\r\n <a href=\"{{url}}\"{{#target}} target=\"{{target}}\"{{/target}}>{{title}}</a>\r\n {{/targetUrl}}\r\n {{^targetUrl}}\r\n {{title}}\r\n {{/targetUrl}}\r\n </header>\r\n {{/headline}}\r\n <ul>\r\n {{#links}}\r\n <li{{#class}} class=\"{{class}}\"{{/class}}><a href=\"{{link.url}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>{{title}}</a></li>\r\n {{/links}}\r\n </ul>\r\n </div>\r\n <div class=\"slider-container\">\r\n <div class=\"slider\">\r\n </div>\r\n </div>\r\n </div>\r\n</section>\r\n",
    "content-slider-with-wrapper": "{{#type}}<div class=\"wrapper-themed {{type}}\">{{/type}}<div class=\"wrapper-center\">\n <div class=\"wrapper-border\">\n <div class=\"wrapper-indent\">\n <section class=\"content-slider{{#type}} {{type}}{{/type}}\">\n <div class=\"r4\">\n <div class=\"slider-headnav\">\n {{#logo}}\n <div class=\"logo\">\n {{#link}}\n <a href=\"{{link.targetUrl}}\">\n {{/link}}\n <img src=\"{{url}}\" />\n {{#link}}\n </a>\n {{/link}}\n </div>\n {{/logo}}\n\n {{#headline}}\n <header>\n {{#link.url}}\n <a href=\"{{link.url}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>{{title}}</a>\n {{/link.url}}\n {{^link.url}}\n {{title}}\n {{/link.url}}\n </header>\n {{/headline}}\n <ul>\n {{#links}}\n <li{{#class}} class=\"{{class}}\"{{/class}}><a href=\"{{link.url}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>{{title}}</a></li>\n {{/links}}\n </ul>\n </div>\n <div class=\"slider-container\">\n <div class=\"slider\">\n {{#teasers}}\n <article class=\"slider-item\">\n <section class=\"news news-fullsize-item\">\n <div class=\"r1\">\n <div class=\"news-content\">\n <div class=\"teaser-content\">\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>\n <div class=\"teaser-img\">\n <img width=\"300\" height=\"250\" src=\"{{image.url}}\" alt=\"{{image.alttext}}\">\n {{#icons}}\n <span class=\"{{.}}\"></span>\n {{/icons}}\n </div>\n <div class=\"details teaser-text\">\n <header>\n {{headline}}\n </header>\n <p>\n <span class=\"subline\">{{text}}</span>\n <span class=\"more\"></span>\n </p>\n </div>\n </a>\n </div>\n </div>\n </div>\n </section>\n </article>\n {{/teasers}}\n </div>\n </div>\n </div>\n </section>\n </div>\n </div>\n</div>\n{{#backgroundColor}}\n{{#primaryColor}}\n <style type=\"text/css\">\n :root {\n --slider-special-background: {{backgroundColor}};\n --slider-special-primary: {{primaryColor}};\n }\n </style>\n</div>\n{{/primaryColor}}\n{{/backgroundColor}}\r\n",
    "content-slider-empty-with-wrapper": "{{#type}}<div class=\"wrapper-themed {{type}}\">{{/type}}<div class=\"wrapper-center\">\n <div class=\"wrapper-border\">\n <div class=\"wrapper-indent\">\n <section class=\"content-slider{{#type}} {{type}}{{/type}}\">\n <div class=\"r4\">\n <div class=\"slider-headnav\">\n {{#logo}}\n <div class=\"logo\">\n {{#link}}\n <a href=\"{{link.targetUrl}}\">\n {{/link}}\n <img src=\"{{url}}\" />\n {{#link}}\n </a>\n {{/link}}\n </div>\n {{/logo}}\n\n {{#headline}}\n <header>\n {{#targetUrl}}\n <a href=\"{{targetUrl}}\"{{#target}} target=\"{{target}}\"{{/target}}>{{title}}</a>\n {{/targetUrl}}\n {{^targetUrl}}\n {{title}}\n {{/targetUrl}}\n </header>\n {{/headline}}\n <ul>\n {{#links}}\n <li{{#class}} class=\"{{class}}\"{{/class}}><a href=\"{{link.url}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}>{{title}}</a></li>\n {{/links}}\n </ul>\n </div>\n <div class=\"slider-container\">\n <div class=\"slider\">\n </div>\n </div>\n </div>\n </section>\n </div>\n </div>\n</div>\n{{#backgroundColor}}\n{{#primaryColor}}\n <style type=\"text/css\">\n :root {\n --slider-special-background: {{backgroundColor}};\n --slider-special-primary: {{primaryColor}};\n }\n </style>\n</div>\n{{/primaryColor}}\n{{/backgroundColor}}\r\n",
    "info-layer-inactive": "<div class=\"info-layer info-layer-inactive\">\n <div class=\"layer-content\">\n <a href=\"#\" onclick=\"return false;\" class=\"tooltip-closer\"></a>\n <div class=\"layer-main\">\n <div class=\"layer-content-inner\">\n <div class=\"stage\">\n <h1>Wir haben aktuelle News für Sie.</h1>\n <span class=\"btn-wrapper btn-xl btn-service btn-fix\">\n <a href=\"{{homepageUrl}}\"{{#isHomepage}}onclick=\"window.setTimeout(function() { if (location.href === \'{{homepageUrl}}\') { location.reload() } else { location.href = \'{{homepageUrl}}\' } ; }, 10);\"{{/isHomepage}}>{{homepageButtonText}}</a>\n </span>\n </div>\n <h2>Das könnte Sie auch interessieren:</h2>\n <section class=\"reco-teaser\">\n {{#teaserGroup.0}}\n <section class=\"news-fullsize\">\n {{#teasers}}\n <section class=\"news news-fullsize-item\">\n <div class=\"r1\">\n <div class=\"news-content\">\n <div class=\"teaser-content wrapped\">\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\n {{#image}}\n <div class=\"teaser-img\">\n <img width=\"{{image.width}}\" height=\"{{image.height}}\" src=\"{{image.teaserUrl}}\" alt=\"{{image.alttext}}\" />\n {{#icons}}\n <span class=\"{{icons}}\"></span>\n {{/icons}}\n </div>\n {{/image}}\n <div class=\"details teaser-text\">\n <header>\n {{headline}}\n </header>\n <p>\n <span class=\"subline\">{{text}}</span>\n <span class=\"more\"></span>\n </p>\n </div>\n </a>\n </div>\n </div>\n </div>\n </section>\n {{/teasers}}\n </section>\n {{/teaserGroup.0}}\n {{#teaserGroup.1}}\n <section class=\"news-image-list\">\n {{#teasers}}\n <section class=\"news news-image-list-item\">\n <div class=\"r1\">\n <div class=\"news-content\">\n <div class=\"teaser-content wrapped\">\n <a href=\"{{link.targetUrl}}\"{{#link.target}} target=\"{{link.target}}\"{{/link.target}}{{#abTestid}} data-ab-testid=\"{{abTestid}}\"{{/abTestid}}{{#abName}} data-ab-name=\"{{abName}}\"{{/abName}}>\n {{#image}}\n <div class=\"teaser-img\">\n <img width=\"{{image.width}}\" height=\"{{image.height}}\" src=\"{{image.teaserUrl}}\" alt=\"{{image.alttext}}\" />\n {{#icons}}\n <span class=\"{{icons}}\"></span>\n {{/icons}}\n </div>\n {{/image}}\n <div class=\"details teaser-text\">\n <header>\n {{headline}}\n </header>\n <p>\n <span class=\"subline\">{{text}}</span>\n <span class=\"more\"></span>\n </p>\n </div>\n </a>\n </div>\n </div>\n </div>\n </section>\n {{/teasers}}\n </section>\n {{/teaserGroup.1}}\n </section>\n <div class=\"search-wrapper\">\n <div class=\"search\">\n <form class=\"form-l\" novalidate=\"novalidate\" method=\"get\" action=\"{{searchFormactionUrl}}\">\n <input type=\"hidden\" name=\"origin\" value=\"wbl_mono_sf\" />\n <fieldset>\n <legend>Suche</legend>\n <div class=\"search-field-wrapper\">\n <input type=\"text\" maxlength=\"1024\" value=\"\" class=\"search-field\" name=\"q\" autocomplete=\"off\" placeholder=\"Suchen mit {{brand}}\" />\n {{#formSubmitWithIcon}}\n <span class=\"btn-wrapper btn-m btn-service {{.}}\">\n {{/formSubmitWithIcon}}\n {{^formSubmitWithIcon}}\n <span class=\"btn-wrapper btn-m btn-service btn-fix\">\n {{/formSubmitWithIcon}}\n <label>\n <input type=\"submit\" value=\"Suchen\">\n\n {{#glassInIcon}}\n <svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n <path d=\"M22.13,23.82,16.35,18.1,18,16.4l5.78,5.73a.6.6,0,0,1,0,.85l-.85.85A.6.6,0,0,1,22.13,23.82Z\"/>\n <path d=\"M10.2,20.4A10.2,10.2,0,1,1,20.4,10.2,10.21,10.21,0,0,1,10.2,20.4Zm0-18A7.8,7.8,0,1,0,18,10.2,7.81,7.81,0,0,0,10.2,2.4Z\"/>\n </svg>\n {{/glassInIcon}}\n {{#formSubmitWithIcon}}\n <span class=\"btn-icon\"></span>\n {{/formSubmitWithIcon}}\n </label>\n </span>\n </div>\n </fieldset>\n </form>\n </div>\n </div>\n {{#localStorage}}\n {{/localStorage}}\n </div>\n <section class=\"layer-side\">\n <div class=\"r1\"></div>\n </section>\n </div>\n <div class=\"footer\">\n <a href=\"#\" class=\"blockInfoLayer\">Nicht mehr anzeigen</a>\n </div>\n </div>\n</div>\r\n",
    "s1": "<div class=\"sepLoginExpander\" id=\"sepResp1\"></div>\r\n",
    "s2": "<div class=\"sepLoginExpander\" id=\"sepResp2\"></div>\r\n",
    "s3": "<div class=\"sepLoginExpander\" id=\"sepResp3\"></div>\r\n",
    "maxiadcontent": "<script id=\"maxiadcontent-position\">\n	$maxiAdContent = $(\'.ad-component-maxiadcontent\');\n	$hero = $(\'.teaser.news.multi-news.hero\');\n $maxiAdContent.before($hero);\n	$(\'iframe\', $maxiAdContent).removeAttr(\'data-iframe-blocked\');\n	unescapeIframe($maxiAdContent);\n</script>\r\n",
    "placeholder": "<span class=\"placeholder\"></span>\r\n",
    "pagination-default": "<ul class=\"slider-pagination\">\n <li class=\"prev\">\n <a href=\"#prev\"></a>\n </li>\n <li class=\"next\">\n <a href=\"#next\"></a>\n </li>\n</ul>\r\n",
    "pagination-content-slider": "<ul class=\"slider-pagination\">\n <li class=\"prev\">\n <a href=\"#prev\">\n <svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n <g>\n <path class=\"st1\" d=\"M8.8,16.9l12.3,12.3c0.3,0.3,0.8,0.3,1.1,0l1.1-1.1c0.3-0.3,0.3-0.8,0-1.1L10.9,14.8c-0.3-0.3-0.8-0.3-1.1,0 l-1.1,1.1C8.5,16.1,8.5,16.6,8.8,16.9z\"/>\n <path class=\"st1\" d=\"M21,3.7L8.8,15.8c-0.3,0.3-0.3,0.8,0,1.1L9.9,18c0.3,0.3,0.8,0.3,1.1,0L23.1,5.8c0.3-0.3,0.3-0.8,0-1.1 L22,3.7C21.7,3.4,21.3,3.4,21,3.7z\"/>\n </g>\n </svg>\n </a>\n </li>\n <li class=\"next\">\n <a href=\"#next\">\n <svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" style=\"enable-background:new 0 0 32 32;\" xml:space=\"preserve\">\n <g>\n <path class=\"st1\" d=\"M23.2,16.9L10.9,29.2c-0.3,0.3-0.8,0.3-1.1,0l-1.1-1.1c-0.3-0.3-0.3-0.8,0-1.1l12.3-12.3 c0.3-0.3,0.8-0.3,1.1,0l1.1,1.1C23.5,16.1,23.5,16.6,23.2,16.9z\"/>\n <path class=\"st1\" d=\"M11,3.7l12.2,12.2c0.3,0.3,0.3,0.8,0,1.1L22.1,18c-0.3,0.3-0.8,0.3-1.1,0L8.9,5.8C8.6,5.5,8.6,5,8.9,4.8 L10,3.7C10.3,3.4,10.7,3.4,11,3.7z\"/>\n </g>\n </svg>\n </a>\n </li>\n</ul>\r\n",
    "jquery-rectangle": "<section{{#css.section.className}} class=\"{{css.section.className}}\"{{/css.section.className}}{{#css.section.id}} id=\"{{css.section.id}}\"{{/css.section.id}}>\n <div class=\"r{{rect}}\">\n 	{{^headerInContainer}}\n <header>{{{html.headerText}}}</header>\n 	{{/headerInContainer}}\n <{{html.container}}{{#css.container.className}} class=\"{{css.container.className}}\"{{/css.container.className}}>\n	 	{{#headerInContainer}}\n	 <header>{{html.headerText}}</header>\n	 	{{/headerInContainer}}\n 	{{#lists}}\n <{{listType}}{{#class}} class=\"{{class}}\"{{/class}}>\n 	{{#data}}\n <li{{#background}} style=\"background-image: url(\'{{background}}\');\"{{/background}}>\n 	<a href=\"{{url}}\"{{#target}} target=\"{{target}}\"{{/target}}>{{title}}</a>\n 	</li>\n 	{{/data}}\n </{{listType}}>\n 	{{/lists}}\n </{{html.container}}>\n </div>\n</section>\r\n",
    '': ''
};
ContentService.prepareData = function (data) {
    if (typeof data['pointOfView'] !== 'undefined') {
        var tmp = [];
        $.each(data['pointOfView'], function (key, singleModule) {
            $.each(singleModule.teasers, function (key, singleTeaser) {
                var tmpPOV = $.extend(true, {}, singleModule);
                tmpPOV.teasers = [singleTeaser];
                tmp = tmp.concat(tmpPOV);
            });
        });
        data['pointOfView'] = tmp;
    }
    if (data.channels) {
        for (var i = 0; i < data.channels.length; i++) {
            data.channels[i].headline = data.channels[i].links.shift();
            if (data.channels[i].links.length > 5) {
                data.channels[i].links = data.channels[i].links.slice(0, 5);
            }
            for (var linksIndex = 0; linksIndex < data.channels[i].links.length; linksIndex++) {
                data.channels[i].links[linksIndex].link = {};
                data.channels[i].links[linksIndex].link.target = data.channels[i].links[linksIndex].linkTarget;
                data.channels[i].links[linksIndex].link.url = data.channels[i].links[linksIndex].targetUrl;
                delete data.channels[i].links[linksIndex].linkTarget;
                delete data.channels[i].links[linksIndex].targetUrl;
            }
        }
    }
    return data;
};
ContentService.basicModuleData = {
    'rectangleEvent': [
        {
            tagid: 'rectangleEvent',
            adTargetSelector: '> div',
            preRendered: true,
            selector: '[data-adservice-slot="rectangle"]'
        },
    ],
    'hero': [
        {
            callback: function () {
                heroReady();
            }
        }
    ],
    'breaking': [
        {
            _targetContainer: '#promoline', _targetContainerPosition: 'before', dataCheck: function (data) {
                return !!data.teasers;
            }, callback: function () {
                AdService.disablePosition('topline_1');
            }
        }
    ],
    'promoline': [
        {tagid: 'topline_1', _targetContainer: '#promoline'}
    ],
    'box': [
        {tagid: 'box_1_1', backfillTagid: 'box_1_2', adTargetSelector: '> div'},
        {tagid: 'box_2_1', backfillTagid: 'box_2_2', adTargetSelector: '> div'},
        {tagid: 'box_3_1', backfillTagid: 'box_3_2', adTargetSelector: '> div'},
        {tagid: 'box_4_1', backfillTagid: 'box_4_2', adTargetSelector: '> div'},
        {tagid: 'box_5_1', backfillTagid: 'box_5_2', adTargetSelector: '> div'},
        {tagid: 'box_6_1', backfillTagid: 'box_6_2', adTargetSelector: '> div'},
        {tagid: 'box_7_1', backfillTagid: 'box_7_2', adTargetSelector: '> div'},
        {tagid: 'box_8_1', backfillTagid: 'box_8_2', adTargetSelector: '> div'},
        {tagid: 'box_9_1', backfillTagid: 'box_9_2', adTargetSelector: '> div'}
    ],
    'rectangle': [
        {tagid: 'rectangle_2', adTargetSelector: '> div'},
        {tagid: 'rectangle_3', adTargetSelector: '> div'}
    ],
    'middle': [
        function () {
            if (AdService.getParam('section') === 'loginfailed') {
                if (SiteInfo.status === 'ipblocked' || SiteInfo.status === 'deleteaccount') {
                    return {_disabled: true};
                } else {
                    return {_targetContainer: '#loginsearch-ad', tagid: 'middle_1'};
                }
            } else {
                return {_disabled: true};
            }
        }
    ],
    'sky_right': [
        function () {
            if (AdService.positions.sky_right._disabled || ContentService.getSkyMaxWidth() < 120) {
                return {_disabled: true};
            } else {
                AdService.setPositionParam('sky_right', 'maxwidth', ContentService.getSkyMaxWidth());
                return {tagid: 'sky_right', _targetContainer: '.statistics:last()'}
            }
        }
    ],
    'games': [
        {
            _disabled: SiteInfo.country !== 'de',
            _targetContainer: 'body > .wrapper-center:eq(-2)',
            _targetContainerPosition: 'before',
            callback: function ($module) {
                if (PageConfig.games) {
                    $(document).ready(function () {
                        GamesSlider.init({
                            selector: $module,
                            insertPosition: 'after'
                        });
                    });
                }
            }
        }
    ],
    'channels': {
        _targetContainer: 'body > .wrapper-center:last',
        _targetContainerPosition: 'before',
        childTarget: '.content-slider > .r4 > .slider-container > .slider',
        callback: function ($module, moduleData) {
            var sliderIndex = $module.index('.wrapper-center') - 2;
            $module.slider({
                listParent: '.r4 > .slider-container > .slider',
                listItem: '> *',
                visibleArea: '.r4 > .slider-container',
                paginationContainer: $('.r4', $module),
                paginationTemplate: 'pagination-content-slider',
                fillLastPage: true,
                touchGestures: true,
                cssTransitions: true,
                tracking: {
                    prevPage: function () {
                        track('slide_' + sliderIndex + '_left', 'event');
                    },
                    nextPage: function () {
                        track('slide_' + sliderIndex + '_right', 'event');
                    }
                }
            });
        }
    }
};
ContentService.layouts = {
    'default': ['start_50', 'slider_50', 'slider_end'],
    'halfpage': ['start_halfpage', 'slider_50', 'slider_end'],
    'maxiadcontent': ['start_maxiadcontent', 'slider_maxiadcontent', 'slider_end'],
    'abd': ['start_condensed', 'slider_end'],
    'indirect': ['start_condensed', 'slider_end'],
    '25': ['start_25', 'slider_25', 'slider_end'],
    '50': ['start_50', 'slider_50', 'slider_end']
};
ContentService.moduleGroups = {
    start_50: [
        'breaking', 'promoline',
        'hero', 's2', 'box', 's3',
        'middle', 'sky_right',
        'services', 'rectangle', 'box', 'services',
        'news', 'services', 'rectangle', 'services', 'news'
    ],
    start_25: [
        'breaking', 'promoline',
        'hero', 's2', 'services', 's3',
        'middle', 'sky_right',
        'rectangle', 'news', 'news', 'services',
        'news', 'rectangle', 'news', 'services', 'news'
    ],
    start_halfpage: [
        'breaking', 'promoline',
        'hero', 's2', 'box', 's3',
        'middle', 'sky_right',
        'services', 'rectangle', 'services',
        'news', 'services', 'services', 'news'
    ],
    start_maxiadcontent: [
        'breaking', 'promoline',
        'hero', 'maxiadcontent',
        'middle', 'sky_right',
        'services', 'services',
        'rectangle', 'box', 'news', 'services', 'news'
    ],
    start_condensed: [
        'breaking', 'promoline',
        'hero', 's2', 'box', 's3',
        'middle', 'sky_right',
        'services', 'rectangle', 'box', 'services',
        'news', 'services', 'rectangle', 'services', 'news'
    ],
    slider_50: [
        {_type: 'channels', children: ['box', 'channel_news', 'box', 'channel_news*']},
        {_type: 'channels', children: ['channel_news', 'box', 'channel_news', 'box', 'channel_news*']},
        {_type: 'channels', children: ['box', 'channel_news', 'box', 'channel_news*']}
    ],
    slider_25: [
        {_type: 'channels', children: ['channel_news', 'channel_news', 'services', 'channel_news*']},
        {_type: 'channels', children: ['channel_news', 'channel_news', 'channel_news', 'box', 'channel_news*']},
        {_type: 'channels', children: ['box', 'channel_news*']}
    ],
    slider_maxiadcontent: [
        {_type: 'channels', children: ['box', 'services', 'channel_news*']},
        {_type: 'channels', children: ['channel_news', 'box', 'channel_news', 'box', 'channel_news*']},
        {_type: 'channels', children: ['box', 'box', 'channel_news*']}
    ],
    slider_end: [
        {_type: 'channels*', children: ['channel_news*']},
        'games'
    ]
};
function FunctionHook() {
    this._functionList = [];
}

FunctionHook.prototype.check = function (func) {
    return false;
};
FunctionHook.prototype.add = function (func) {
    this._functionList.push(func);
    if (this.check()) {
        func.apply(this, Array.prototype.slice.call(arguments, 1));
    }
};
FunctionHook.prototype.run = function () {
    for (var i = 0; i < this._functionList.length; i++) {
        try {
            this._functionList[i].apply(this, arguments);
        } catch (e) {
        }
    }
};
FunctionHook.prototype.clear = function () {
    this.onclear();
    this._functionList = [];
};
FunctionHook.prototype.onclear = function () {
};
$('html').removeClass('jsDisabled').addClass('jsEnabled');
var BodyStarted = new FunctionHook();
function bodyStarted() {
    BodyStarted.check = function () {
        return true;
    }
    BodyStarted.run();
}

var BodyStartedAfter = new FunctionHook();
function bodyStartedAfter() {
    BodyStartedAfter.check = function () {
        return true;
    }
    BodyStartedAfter.run();
}

var SearchCreated = new FunctionHook();
function searchCreated() {
    SearchCreated.check = function () {
        return true;
    }
    SearchCreated.run();
}

var LoginReady = new FunctionHook();
function loginReady() {
    LoginReady.check = function () {
        return true;
    }
    LoginReady.run();
}

var LoginReadyAfter = new FunctionHook();
function loginReadyAfter() {
    LoginReadyAfter.check = function () {
        return true;
    }
    LoginReadyAfter.run();
}

LoginReady.add(function () {
    if (PageLayout && PageLayout._isSmallScreen) {
        $('#loginsearch-login a.icon-demail').parent('li').hide();
    }
    if ($.ua.browser.msie <= 9) {
        $('#loginsearch-login a.icon-demail').parent('li').hide();
        $('#loginsearch-login a.icon-domain').parent('li').hide();
    }
    PageLayout.onchange(function (alignment, cols) {
        if ($('#loginsearch-login[data-tab-active="5"]').length && (cols !== 4 || $('#halfpage').length)) {
            $('.tab-nav ul:first li:first a').click();
            $('#loginsearch input').blur();
        }
    });
});
var TopEditorialReady = new FunctionHook();
function topEditorialReady() {
    TopEditorialReady.check = function () {
        return true;
    }
    TopEditorialReady.run();
}

var HeroReady = new FunctionHook();
function heroReady() {
    HeroReady.check = function () {
        return true;
    }
    HeroReady.run();
}

var Seperator2Ready = new FunctionHook();
function seperator2Ready() {
    Seperator2Ready.check = function () {
        return true;
    }
    Seperator2Ready.run();
}

var SpotlightReady = new FunctionHook();
function spotlightReady() {
    SpotlightReady.check = function () {
        return true;
    }
    SpotlightReady.run();
}

var BodyEnded = new FunctionHook();
function bodyEnded() {
    BodyEnded.check = function () {
        return true;
    }
    BodyEnded.run();
}

var BodyEndedBefore = new FunctionHook();
function bodyEndedBefore() {
    BodyEndedBefore.check = function () {
        return true;
    }
    BodyEndedBefore.run();
}

var DoPostscribe = new FunctionHook();
function doPostscribe() {
    DoPostscribe.check = function () {
        return true;
    }
    DoPostscribe.run();
}

;(function () {
    var object = typeof exports != 'undefined' ? exports : self;
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    function InvalidCharacterError(message) {
        this.message = message;
    }
    InvalidCharacterError.prototype = new Error;
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    object.btoa || (
        object.btoa = function (input) {
            var str = String(input);
            for (
                var block, charCode, idx = 0, map = chars, output = '';
                str.charAt(idx | 0) || (map = '=', idx % 1);
                output += map.charAt(63 & block >> 8 - idx % 1 * 8)
            ) {
                charCode = str.charCodeAt(idx += 3 / 4);
                if (charCode > 0xFF) {
                    throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
                }
                block = block << 8 | charCode;
            }
            return output;
        });
    object.atob || (
        object.atob = function (input) {
            var str = String(input).replace(/=+$/, '');
            if (str.length % 4 == 1) {
                throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
            }
            for (
                var bc = 0, bs, buffer, idx = 0, output = '';
                buffer = str.charAt(idx++);
                ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
                bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
            ) {
                buffer = chars.indexOf(buffer);
            }
            return output;
        });
}());
function checkCssTransition() {
    if (checkCssTransition.transition !== undefined) {
        return checkCssTransition.transition;
    }
    var testing = document.createElement('div');
    testing.innerHTML = '<div style="transition: all 1s; -webkit-transition: all 1s; -moz-transition: all 1s; -ms-transition: all 1s; -o-transition: all 1s;"></div>';
    var test = testing.getElementsByTagName('div')[0];
    checkCssTransition.transition = (
        'transitionProperty' in test.style ||
        'webkitTransitionProperty' in test.style ||
        'mozTransitionProperty' in test.style ||
        'oTransitionProperty' in test.style ||
        'msTransitionProperty' in test.style
    );
    if ($.ua.browser.msie === 11 || $.ua.browser.name === 'edge') {
        checkCssTransition.transition = false;
    }
    if ($.ua.browser.name === 'safari') {
        checkCssTransition.transition = false;
    }
    if (checkCssTransition.transition) {
        $('html').addClass('hasCssTransitions');
    }
    return checkCssTransition.transition;
}

checkCssTransition();
var checkButtonFix = function () {
    if ($.ua && $.ua.browser) {
        if (($.ua.browser.name !== 'msie' || $.ua.browser.msie >= 10) &&
            ($.ua.browser.name !== 'opera' || $.ua.browser.opera >= 12) &&
            ($.ua.browser.name !== 'safari' || $.ua.browser.safari >= 5.1) &&
            ($.ua.browser.name !== 'firefox' || $.ua.browser.firefox >= 4)) {
            $('.btn-wrapper').removeClass('btn-fix');
        }
    }
};
var initButtonEvents = function () {
    $(document).on('mouseenter', '.btn-wrapper', function () {
        $(this).addClass('btn-over');
    });
    $(document).on('mouseleave', '.btn-wrapper', function () {
        $(this).removeClass('btn-over btn-pressed');
    });
    $(document).on('mouseup', '.btn-wrapper', function () {
        $(this).removeClass('btn-pressed');
    });
    $(document).on('mousedown', '.btn-wrapper', function () {
        if (!$(this).hasClass('btn-disabled')) {
            $(this).addClass('btn-pressed');
        }
    });
    $(document).on('focus', '.btn-wrapper a, .btn-wrapper input, .btn-wrapper button', function () {
        if (!$(this).hasClass('btn-disabled')) {
            $(this).closest('.btn-wrapper').addClass('btn-over');
        }
    });
    $(document).on('blur', '.btn-wrapper a, .btn-wrapper input, .btn-wrapper button', function () {
        $(this).closest('.btn-wrapper').removeClass('btn-over');
    });
    $(document).on('click', '.btn-disabled input, .btn-disabled a', function (e) {
        e.preventDefault();
    });
    $(document).on('click', '.btn-onlyonce:not(.btn-disabled)>*', function (e) {
        $(e.target).closest('.btn-wrapper').addClass('btn-disabled');
    });
    $(document).on('dblclick', '.btn-onlyonce>*', function (e) {
        e.preventDefault();
    });
    $(document).on('click mouseenter mouseleave mouseup mousedown focus blur', 'span.btn-fix, span.btn-wrapper.hasIcon', function (e) {
        if ($(e.target).is('a, input, em')) {
            return true;
        } else {
            if (e.type === 'click') {
                $(this).children('a').each(function () {
                    window.open(this.href, this.target || '_self');
                });
                $(this).children('input').each(function () {
                    $(this).trigger(e.type);
                });
            }
        }
    });
};
$(function () {
    checkButtonFix();
    initButtonEvents();
});
var Tooltip = new function () {
    this.activeInitiator;
    this.container = $('<div class="tooltip-enlarged"><div class="tooltip-wrapper"><div class="txt"></div><div class="nose" /></div></div>').hide();
    this.init = function () {
        $(document).on('mouseenter focus click', '.tooltip', function (e) {
            var $this = $(this);
            if (e.type == 'focusin' && $this.data('tooltip-event') == 'focus') {
                Tooltip.show(this);
            } else if (e.type == 'mouseenter' && $this.data('tooltip-event') != 'focus' && $this.data('tooltip-event') != 'click') {
                Tooltip.show(this);
            } else if (e.type == 'click') {
                e.preventDefault();
                e.stopPropagation();
                Tooltip.show(this);
            }
        });
        $(document).on('mouseleave', '.tooltip,.tooltip-enlarged', function (e) {
            if ($(e.toElement || e.relatedTarget || e.delegateTarget).closest('.tooltip-enlarged').length === 0) {
                var $this = $(this);
                if (Tooltip.activeInitiator && Tooltip.activeInitiator.data('tooltip-event') !== 'focus' && Tooltip.activeInitiator.data('tooltip-event') !== 'manual') {
                    Tooltip.hide(this);
                }
            }
        });
    };
    this.show = function (initiator) {
        var $this = $(initiator);
        if (!$this.is(':visible')) {
            return;
        }
        if ($this.hasClass('tooltip-active')) {
            return;
        }
        if (Tooltip.activeInitiator) {
            Tooltip.hide(Tooltip.activeInitiator);
        }
        Tooltip.activeInitiator = $this;
        var settings = {
            offset: $this.offset(),
            spaceTop: parseInt($(document).scrollTop(), 10),
            align: ($this.attr('data-tooltip-align') == 'x') ? 'x' : 'y',
            name: $this.data('tooltip-name') ? $this.data('tooltip-name') : false,
            parentWidth: parseInt($('body').width(), 10),
            id: $this.data('tooltip-id') ? $this.data('tooltip-id') : false,
            blockable: $this.data('tooltip-blockable') ? true : false,
            position: $this.data('tooltip-position') ? $this.data('tooltip-position') : false,
            closer: $this.data('tooltip-closer') ? true : false,
            closeon: $this.data('tooltip-closeon') ? $this.data('tooltip-closeon') : false,
            outsidecloser: $this.data('tooltip-outsidecloser') ? true : false,
            parent: $this.data('tooltip-parent') ? $this.data('tooltip-parent') : false
        };
        if (settings.id && Tooltip._isBlocked(settings.id)) {
            return;
        }
        if (settings.name) {
            Tooltip.container.addClass('tooltip-name-' + settings.name);
        }
        var content;
        if ($this.data('tooltip-query')) {
            content = $this.find($this.data('tooltip-query')).contents();
        } else if ($this.data('tooltip-query-global')) {
            content = $($this.data('tooltip-query-global')).contents();
        } else if ($this.data('tooltip')) {
            content = $this.data('tooltip');
        } else {
            content = $this.attr('title');
        }
        Tooltip.container.find('.txt').empty().append(content);
        if (settings.parent) {
            $(settings.parent).append(Tooltip.container);
            settings.offset = Tooltip.offsetTo($this, settings.parent);
            settings.parentWidth = parseInt($this.parents(settings.parent).width(), 10);
        } else {
            Tooltip.container.appendTo('body');
        }
        if (!settings.position) {
            if (settings.align == 'x') {
                if (parseInt(settings.offset.left + Tooltip.container.width() + $this.width(), 10) >= settings.parentWidth) {
                    if (parseInt(settings.offset.top - settings.spaceTop, 10) < Tooltip.container.height()) {
                        settings.position = 'right-top';
                    } else {
                        settings.position = 'right-bottom';
                    }
                }
                if (parseInt(settings.offset.left + Tooltip.container.width() + $this.width(), 10) < settings.parentWidth) {
                    if (parseInt(settings.offset.top - settings.spaceTop, 10) < Tooltip.container.height()) {
                        settings.position = 'left-top';
                    } else {
                        settings.position = 'left-bottom';
                    }
                }
            } else {
                if (parseInt(settings.offset.top - settings.spaceTop, 10) < Tooltip.container.height()) {
                    if (parseInt(settings.offset.left + Tooltip.container.width() + 40, 10) >= settings.parentWidth) {
                        settings.position = 'top-right';
                    } else {
                        settings.position = 'top-left';
                    }
                }
                if (parseInt(settings.offset.top - settings.spaceTop, 10) > Tooltip.container.height()) {
                    if (parseInt(settings.offset.left + Tooltip.container.width() + 40, 10) >= settings.parentWidth) {
                        settings.position = 'bottom-right';
                    } else {
                        settings.position = 'bottom-left';
                    }
                }
            }
        }
        Tooltip.container.addClass('tooltip-' + settings.position);
        Tooltip._calcPosition($this, settings);
        $(window).on('resize scroll', function () {
            Tooltip._calcPosition($this, settings);
        });
        if (settings.closer) {
            Tooltip.container.find('.tooltip-wrapper').append($('<a>').attr({href: '#'}).addClass('tooltip-closer').on('click', function (e) {
                e.preventDefault();
                Tooltip.hide($this);
                $this.trigger('tooltip-hide');
            }));
        }
        if (settings.closeon) {
            $(document).one('click', settings.closeon, function (e) {
                Tooltip.hide($this);
            });
        }
        if (settings.outsidecloser) {
            var handleClick = function (e) {
                if (!$(e.target).closest(Tooltip.container).length) {
                    $(document).off('click', handleClick);
                    Tooltip.hide($this);
                }
            };
            $(document).on('click', handleClick);
        }
        if (settings.blockable && Storage.supportLocalStorage) {
            Tooltip.container.find('.tooltip-wrapper').append($('<p>').addClass('tooltip-blocker').append($('<a>').attr({href: '#'}).html('Diese Meldung nicht mehr anzeigen').on('click', function (e) {
                e.preventDefault();
                Tooltip.hide($this);
                Tooltip._block($this);
            })));
        }
        Tooltip.container.show();
        $this.addClass('tooltip-active');
        if (settings.name) {
            $('body').attr('data-tooltip-active', settings.name);
        }
        LayerConflict.addLayer(Tooltip.container, this.hide);
    };
    this.offsetTo = function (element, parent) {
        var childOffset = $(element).offset();
        var parentOffset = $(parent).offset();
        return {top: childOffset.top - parentOffset.top, left: childOffset.left - parentOffset.left};
    };
    this._calcPosition = function (initiator, settings) {
        var $this = initiator;
        if (settings.parent) {
            settings.offset = Tooltip.offsetTo($(initiator), settings.parent);
        }
        switch (settings.position) {
            case 'right-top':
                Tooltip.container.css('left', parseInt(settings.offset.left - Tooltip.container.width() - 20, 10));
                Tooltip.container.css('top', parseInt(settings.offset.top - 30, 10));
                break;
            case 'right-bottom':
                Tooltip.container.css('left', parseInt(settings.offset.left - Tooltip.container.width() - 20, 10));
                Tooltip.container.css('top', parseInt(settings.offset.top - Tooltip.container.height() + 30, 10));
                break;
            case 'left-top':
                Tooltip.container.css('left', parseInt(settings.offset.left + $this.width(), 10));
                Tooltip.container.css('top', parseInt(settings.offset.top - 30, 10));
                break;
            case 'left-bottom':
                Tooltip.container.css('left', parseInt(settings.offset.left + $this.width(), 10));
                Tooltip.container.css('top', parseInt(settings.offset.top - Tooltip.container.height() + 30, 10));
                break;
            case 'top-right':
                Tooltip.container.css('left', (settings.offset.left + $this.width()) - Tooltip.container.width() - 10);
                Tooltip.container.css('top', parseInt(settings.offset.top + 17, 10));
                break;
            case 'top-left':
                Tooltip.container.css('top', parseInt(settings.offset.top + 17, 10));
                Tooltip.container.css('left', settings.offset.left - 10);
                break;
            case 'bottom-right':
                Tooltip.container.css('top', parseInt(settings.offset.top - Tooltip.container.height() - 14, 10));
                Tooltip.container.css('left', parseInt(settings.offset.left + $this.width() - Tooltip.container.width() - 10, 10));
                break;
            case 'bottom-left':
                Tooltip.container.css('top', parseInt(settings.offset.top - Tooltip.container.height() - 14, 10));
                Tooltip.container.css('left', parseInt(settings.offset.left - 10, 10));
                break;
        }
    };
    this.hide = function () {
        var $this = Tooltip.activeInitiator;
        if (!$this) {
            return;
        }
        Tooltip.container.removeClass(function (index, classes) {
            var allClasses = classes.split(' ');
            var classesToRemove = [];
            var i = 0;
            while (i < allClasses.length) {
                if (allClasses[i].match(/tooltip-name-/i)) {
                    classesToRemove.push(allClasses[i]);
                }
                i++;
            }
            if (classesToRemove.length > 0) {
                return classesToRemove.join(' ');
            }
        });
        Tooltip.container.removeClass('tooltip-bottom-left tooltip-bottom-right tooltip-left-bottom tooltip-left-top tooltip-top-left tooltip-top-right tooltip-right-top tooltip-right-bottom');
        var contentTarget;
        if ($this.data('tooltip-query')) {
            contentTarget = $this.find($this.data('tooltip-query'));
        } else if ($this.data('tooltip-query-global')) {
            contentTarget = $($this.data('tooltip-query-global'));
        }
        if (contentTarget) {
            contentTarget.append(Tooltip.container.find('.txt').contents());
        } else {
            Tooltip.container.find('.txt').empty();
        }
        Tooltip.container.hide();
        $this.removeClass('tooltip-active');
        Tooltip.activeInitiator = undefined;
        LayerConflict.removeLayer(Tooltip.container);
        Tooltip.container.remove('body');
        Tooltip.container.find('.tooltip-closer').remove();
        Tooltip.container.find('.tooltip-blocker').remove();
        $('body').removeAttr('data-tooltip-active');
    };
    this._block = function ($initiator) {
        if ($initiator.data('tooltip-id')) {
            var id = $initiator.data('tooltip-id');
            if (Storage.supportLocalStorage) {
                Storage.save('tooltip-' + id, 'block');
            }
        }
    };
    this._isBlocked = function (id) {
        if (Storage.supportLocalStorage && Storage.get('tooltip-' + id) === 'block') {
            return true;
        }
        return false;
    };
};
BodyStarted.add(function () {
    Tooltip.init();
});
var PageState = {
    'list': {},
    'data': {},
    'changed': function (state, value) {
        var current = PageState._get(state);
        if (!PageState._equals(current[0], value)) {
            var previous = current[0];
            PageState.list[state] = [value, previous];
            return true;
        }
        return false;
    },
    '_get': function (state) {
        if (PageState.list[state] === undefined) {
            PageState.list[state] = [];
        }
        return PageState.list[state];
    },
    '_equals': function (a, b) {
        if (a === undefined || b === undefined) {
            return false;
        }
        if (a instanceof Array && b instanceof Array) {
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) {
                    return false;
                }
            }
            return true;
        }
        return a === b;
    },
    'get': function (state) {
        return PageState._get(state)[0];
    },
    'previous': function (state) {
        return PageState._get(state)[1];
    }
};
var PageLayout = new function () {
    this.adType = 'default';
    this.adVariant = 'default';
    var self = this;
    var layoutWatcherRunning = false;
    this.config = {
        adVariant: 'default',
        adType: 'default',
        layout: 'default',
        align: 'center',
        htmlId: false,
        htmlClass: [],
        htmlData: {},
        columns: {
            '2': {
                active: false,
                blocked: false,
                border: [30]
            },
            '3': {
                active: true,
                blocked: false,
                border: [0, 30]
            },
            '4': {
                active: true,
                blocked: false,
                border: [0, 30]
            }
        },
        narrow: {
            top: 0,
            left: 0,
            right: 0
        },
        minContentWidth: 0,
        minFitsAllBrowserWidth: 942,
        topper: true,
        reducenarrowinsteadbleed: false
    };
    this.supportTouch = (function () {
        return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
    })();
    this._isSmallScreen = (function () {
        return /(ipad|iphone|ios|android|windows rt|windows nt 6\.[2,3]; arm)/i.test(navigator.userAgent) || (($.ua.os.name === 'linux' || $.ua.os.name === 'mac os') && self.supportTouch);
    })();
    var isiPad = (function () {
        return /(ipad)/i.test(navigator.userAgent);
    })();
    this.isiPad = isiPad;
    this.isiPadPro = (function () {
        return isiPad && (Math.max(screen.width, screen.height) === 1366);
    })();
    this.init = function () {
        this.LayoutChange = new FunctionHook();
        $('html').attr({
            'data-ua-browser': $.ua.browser.name,
            'data-ua-browser-version': $.ua.browser.version.major,
            'data-ua-os': $.ua.os.name,
            'data-device-type': PageLayout._isSmallScreen ? 'mobile' : 'desktop'
        });
        this.checkBrowserSupport();
        this.initAnimationsWatcher();
    };
    this.initAnimationsWatcher = function () {
        function whichAnimationEvent() {
            var t;
            var el = document.createElement('fakeelement');
            var animations = {
                'animation': 'animationstart',
                'OAnimation': 'oAnimationStart',
                'MozAnimation': 'animationstart',
                'WebkitAnimation': 'webkitAnimationStart'
            };
            for (t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        }
        var animationEvent = whichAnimationEvent();
        animationEvent && document.addEventListener(animationEvent, function (e) {
            if (['col4', 'col4border', 'col3', 'col3border', 'col2'].indexOf(e.animationName) !== -1) {
                PageLayout.forceRefresh();
            }
        });
    };
    this.adInit = function (layoutConfig) {
        if (typeof layoutConfig != 'undefined') {
            this.config = layoutConfig;
        }
        this.adType = this.adType === 'default' ? this.config.adType : this.adType + '_' + this.config.adType;
        this.adVariant = this.config.adVariant;
        this.calcBreakpoints();
        if (this.config.htmlClass.length) {
            $('html').addClass(this.config.htmlClass.join(' '));
        }
        $.each(this.config.htmlData, function (key, value) {
            $('html').attr('data-' + key, value);
        });
        if (this.config.narrow.left || this.config.narrow.right) {
            this.setNarrow();
        }
        if (this.config.narrow.top) {
            $('.wrapper-center.first').css({
                top: this.config.narrow.top,
                marginBottom: this.config.narrow.top
            });
        }
        if (typeof StickyLogin !== 'undefined') {
            StickyLogin.setYOffset('pagelayout', this.config.narrow.top, true);
        }
        this.prepareLayout(this.config.layout);
        this.adInitMQBrowsers();
        this.check(true);
    };
    this.removeNarrow = function () {
        $('body').css({
            paddingLeft: 0,
            paddingRight: 0
        });
    };
    this.setNarrow = function () {
        $('body').css({
            paddingLeft: this.config.narrow.left,
            paddingRight: this.config.narrow.right
        });
    };
    this.layoutHooks = [];
    this.addLayoutHook = function (layoutName, hook) {
        PageLayout.layoutHooks[layoutName] = hook;
    };
    this.prepareLayout = function (layout) {
        if (typeof PageLayout.layoutHooks[layout] !== 'undefined') {
            PageLayout.layoutHooks[layout]();
        }
    };
    this.checkBrowserSupport = function () {
        if (this._isSmallScreen) {
            $.each(this.config.columns, function (column, columnData) {
                if ($.isArray(columnData.border) && columnData.border.indexOf(0) != -1) {
                    columnData.border.splice(columnData.border.indexOf(0), 1);
                }
            });
        }
        this.doPreCheck = ($.ua.browser.name === 'msie' && $.ua.browser.msie <= 8);
    };
    this.calcBreakpoints = function () {
        this.config.breakpoints = [];
        for (var column in this.config.columns) {
            if (!this.config.columns.hasOwnProperty(column)) {
                continue;
            }
            var columnData = this.config.columns[column];
            if (columnData.active && typeof columnData.border !== 'undefined') {
                for (var index in columnData.border) {
                    if (!this.config.columns.hasOwnProperty(column)) {
                        continue;
                    }
                    var borderWidth = columnData.border[index];
                    var columnInt = parseInt(column, 10);
                    var contentWidth = (columnInt * 300) + ((columnInt - 1) * 20) + (2 * borderWidth) + 2;
                    if (PageLayout.config.minContentWidth <= contentWidth) {
                        PageLayout.config.breakpoints.push({
                            name: column + 'col' + (borderWidth === 0 ? 'border' : ''),
                            contentWidth: contentWidth
                        });
                    }
                }
            }
        }
        this.config.breakpoints.sort(function (a, b) {
            return parseInt(b.contentWidth, 10) - parseInt(a.contentWidth, 10);
        });
        var scrollbarWidth = this.getScrollbarWidth();
        var smallestWidth;
        var narrowTotal = this.config.narrow.left + this.config.narrow.right;
        for (var i = 0; i < this.config.breakpoints.length; i++) {
            if (this.config.breakpoints.length === 1) {
                this.config.breakpoints[i].all = true;
            } else {
                if (i === 0) {
                    this.config.breakpoints[i].min = this.config.breakpoints[i].contentWidth + scrollbarWidth + narrowTotal;
                } else if (i === this.config.breakpoints.length - 1) {
                    this.config.breakpoints[i].max = this.config.breakpoints[i - 1].contentWidth + scrollbarWidth + narrowTotal - 1;
                } else {
                    this.config.breakpoints[i].max = this.config.breakpoints[i - 1].contentWidth + scrollbarWidth + narrowTotal - 1;
                    this.config.breakpoints[i].min = this.config.breakpoints[i].contentWidth + scrollbarWidth + narrowTotal;
                }
            }
            smallestWidth = this.config.breakpoints[i].contentWidth;
        }
        this.config.minFitsAllBrowserWidth = smallestWidth + 1 + (this.config.reducenarrowinsteadbleed ? 0 : narrowTotal);
    };
    this.getSmallestContentWidth = function () {
        try {
            return this.config.breakpoints.filter(function (a, b) {
                return typeof a.contentWidth !== 'undefined';
            }).sort(function (a, b) {
                return (b.contentWidth < a.contentWidth) ? 1 : (b.contentWidth > a.contentWidth) ? -1 : 0;
            })[0].contentWidth;
        } catch (e) {
        }
    };
    this.adInitMQBrowsers = function () {
        var cssMedias = [];
        for (var i = 0; i < this.config.breakpoints.length; i++) {
            var medias = [];
            if (this.config.breakpoints[i].min) {
                medias.push('(min-width: ' + this.config.breakpoints[i].min + 'px)');
            }
            if (this.config.breakpoints[i].max) {
                medias.push('(max-width: ' + this.config.breakpoints[i].max + 'px)');
            }
            if (this.config.breakpoints[i].all) {
                medias.push('all');
            }
            if (medias.length > 0) {
                if (medias.indexOf('all') === -1) {
                    medias.unshift('screen');
                }
                cssMedias.push({ name: this.config.breakpoints[i].name, media: medias.join(' and ') });
            }
        }
        this.viewHandler(this.renderMediaQuery(cssMedias));
        this.setAlign(this.config.align);
        this.observeLayoutChange();
    };
    this.setAlign = function (align) {
        var isLeft = align === 'left';
        if (document.getElementsByTagName('html')[0].getAttribute('data-col-left') !== isLeft + '') {
            document.getElementsByTagName('html')[0].setAttribute('data-col-left', isLeft);
        }
    };
    this.getScrollbarWidth = function () {
        if (document.body) {
            var inner = document.createElement('p');
            inner.style.width = "100%";
            inner.style.height = "200px";
            var outer = document.createElement('div');
            outer.style.position = "absolute";
            outer.style.top = "0px";
            outer.style.left = "0px";
            outer.style.visibility = "hidden";
            outer.style.width = "200px";
            outer.style.height = "150px";
            outer.style.overflow = "hidden";
            outer.appendChild(inner);
            document.body.appendChild(outer);
            var w1 = inner.offsetWidth;
            outer.style.overflow = 'scroll';
            var w2 = inner.offsetWidth;
            if (w1 == w2) w2 = outer.clientWidth;
            document.body.removeChild(outer);
            return w1 - w2;
        } else {
            return 0;
        }
    };
    this.check = function (forceRefresh) {
        if (this._isSmallScreen && this.config) {
            var smallestContentWidth = this.getSmallestContentWidth();
            if (PageLayout.isiPad) {
                if (!$('head meta[name="viewport"]').length) {
                    $('head').append($('<meta name="viewport" content="width=device-width" />'));
                }
                $('body').css({
                    minWidth: smallestContentWidth
                });
                if (PageLayout.isiPadPro) {
                    $('body').css({
                        minHeight: [90, -90].indexOf(window.orientation) === -1 ? 1366 / 1024 * smallestContentWidth : ''
                    });
                }
            } else {
                var viewport = $('head meta[name=viewport]');
                var oldWidth = null;
                if (viewport.length) {
                    var viewportValue = viewport.attr('content');
                    viewportValue = viewportValue.split('=');
                    oldWidth = viewportValue[1];
                }
                if (oldWidth === null) {
                    if (smallestContentWidth > window.outerWidth) {
                        changeMetaContentWidth(smallestContentWidth);
                    } else {
                        changeMetaContentWidth('device-width');
                    }
                } else if (oldWidth !== smallestContentWidth
                    && smallestContentWidth > window.outerWidth) {
                    changeMetaContentWidth(smallestContentWidth, true);
                } else if (oldWidth !== 'device-width') {
                    changeMetaContentWidth('device-width', true);
                }
            }
        }
        if (this.doPreCheck) {
            this.preCheck();
        }
    };
    this.observeLayoutChange = function () {
        if (!layoutWatcherRunning) {
            if ('animationName' in document.body.style) {
                layoutWatcherRunning = true;
                document.addEventListener('animationstart', animationEvent);
                document.addEventListener('oanimationstart', animationEvent);
                document.addEventListener('MSAnimationStart', animationEvent);
                document.addEventListener('webkitAnimationStart', animationEvent);
                function animationEvent(ev) {
                    var layoutType = (ev.animationName || '').split('layout-type-')[1];
                    if (layoutType) {
                        document.querySelector('html').setAttribute('data-col-case', layoutType);
                        PageConfig.lastColCase = PageConfig.currentColCase;
                        PageConfig.currentColCase = layoutType;
                        var contentWidth = PageLayout.getCurrentContentWidth();
                        var windowInnerWidth = getWindowInnerWidth();
                        var alignment = windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth ? 'left' : 'center';
                        var cols = layoutType.charAt(0);
                        var bleeding = PageLayout.config.reducenarrowinsteadbleed ? (windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth + PageLayout.config.narrow.left + PageLayout.config.narrow.right) : false;
                        var size = contentWidth;
                        var mini = contentWidth - cols * 300 - (cols - 1) * 20 < 60;
                        PageState.changed('cols', cols);
                        PageState.changed('border', mini);
                        PageState.changed('bleeding', bleeding);
                        PageState.changed('alignment', alignment);
                        PageState.changed('layoutConfig', [alignment, cols, mini, size, bleeding]);
                        PageLayout.toggleDisableSticky(alignment, cols);
                        PageLayout.LayoutChange.run(alignment, cols, mini, size, bleeding);
                    }
                }
            } else {
                var colCase = '1col';
                $(window).on('resize orientationchange', function (e) {
                    var currentWidth = window.innerWidth;
                    for (var i = 0; i < this.config.breakpoints.length; i++) {
                        if (this.config.breakpoints[i].min && this.config.breakpoints[i].max) {
                            if (currentWidth >= this.config.breakpoints[i].min && currentWidth <= this.config.breakpoints[i].max) {
                                colCase = this.config.breakpoints[i].name;
                            }
                        } else if (this.config.breakpoints[i].min) {
                            if (currentWidth >= this.config.breakpoints[i].min) {
                                colCase = this.config.breakpoints[i].name;
                            }
                        } else if (this.config.breakpoints[i].max) {
                            if (currentWidth <= this.config.breakpoints[i].max) {
                                colCase = this.config.breakpoints[i].name;
                            }
                        } else {
                        }
                    }
                });
                document.getElementsByTagName('html')[0].setAttribute('data-col-case', colCase);
                var contentWidth = PageLayout.getCurrentContentWidth();
                var windowInnerWidth = getWindowInnerWidth();
                var alignment = windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth ? 'left' : 'center';
                var cols = colCase.charAt(0);
                var bleeding = PageLayout.config.reducenarrowinsteadbleed ? (windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth + PageLayout.config.narrow.left + PageLayout.config.narrow.right) : false;
                var size = contentWidth;
                var mini = contentWidth - cols * 300 - (cols - 1) * 20 < 60;
                PageState.changed('cols', cols);
                PageState.changed('border', mini);
                PageState.changed('bleeding', bleeding);
                PageState.changed('alignment', alignment);
                PageState.changed('layoutConfig', [alignment, cols, mini, size, bleeding]);
                PageLayout.toggleDisableSticky(alignment, cols);
                PageLayout.LayoutChange.run(alignment, cols, mini, size, bleeding);
            }
        }
    };
    $(window).on('resize orientationchange', function () {
        var dataColCase = document.querySelector('html').getAttribute('data-col-case') || '4';
        var contentWidth = PageLayout.getCurrentContentWidth();
        var windowInnerWidth = getWindowInnerWidth();
        var alignment = windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth ? 'left' : 'center';
        var cols = parseInt(dataColCase.charAt(0)) || 4;
        var bleeding = PageLayout.config.reducenarrowinsteadbleed ? (windowInnerWidth < PageLayout.config.minFitsAllBrowserWidth + PageLayout.config.narrow.left + PageLayout.config.narrow.right) : false;
        var size = contentWidth;
        var mini = contentWidth - cols * 300 - (cols - 1) * 20 < 60;
        PageState.changed('cols', cols);
        PageState.changed('border', mini);
        PageState.changed('bleeding', bleeding);
        PageState.changed('alignment', alignment);
        PageState.changed('layoutConfig', [alignment, cols, mini, size, bleeding]);
        PageLayout.toggleDisableSticky(alignment, cols);
        PageLayout.LayoutChange.run(alignment, cols, mini, size, bleeding);
    });
    this.toggleDisableSticky = function (align, cols) {
        var hasSticky = $('html').hasClass('disableSticky');
        if (cols <= 2 && align === 'left') {
            if (!hasSticky) {
                document.querySelector('html').setAttribute('data-col-left', 'true');
                $('html').addClass('disableSticky');
            }
        } else {
            if (hasSticky) {
                var isSitebar = document.querySelector('html').getAttribute('data-prioad-type') === 'sitebar';
                if (!isSitebar) {
                    document.querySelector('html').setAttribute('data-col-left', 'false');
                }
                $('html').removeClass('disableSticky');
            }
        }
    };
    this.renderMediaQuery = function (medias) {
        var template = document.querySelector('#cssLayoutChangeTriggerTemplate').innerHTML;
        Mustache.parse(template);
        var rendered = Mustache.render(template, { layouts: medias });
        return rendered;
    };
    this.viewHandler = function (css) {
        if (document.querySelector('#cssLayoutChangeTrigger')) {
            var elem = document.querySelector('#cssLayoutChangeTrigger');
            elem.parentNode.removeChild(elem);
        }
        var head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');
        style.type = 'text/css';
        style.id = 'cssLayoutChangeTrigger';
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
    };
    var changeMetaContentWidth = function (width, removeOld) {
        if (removeOld) {
            $('head meta[name=viewport]').remove();
        }
        $('head').append($('<meta name="viewport" content="width=' + width + '"/>'));
    };
    this.preCheck = function () {
        var windowWidth = $(window).width();
        var contentWidth = $('.wrapper-center.first').width();
        for (var i = 0; i < this.config.breakpoints.length; i++) {
            if (windowWidth > (this.config.breakpoints[i].min || 0) && windowWidth <= (this.config.breakpoints.max || 999999)) {
                break;
            }
        }
        this.setAlign(this.config.align);
    };
    this.getContainerWidth = function () {
        var windowWidth = getWindowInnerWidth();
        var containerWidth = 0;
        $.each(PageLayout.config.breakpoints, function (key, value) {
            if (typeof value.min !== 'undefined' && typeof value.max !== 'undefined') {
                if (windowWidth >= value.min && windowWidth <= value.max) {
                    containerWidth = value.contentWidth;
                }
            } else if (typeof value.min !== 'undefined') {
                if (windowWidth >= value.min) {
                    containerWidth = value.contentWidth;
                }
            } else if (typeof value.max !== 'undefined') {
                if (windowWidth <= value.max) {
                    containerWidth = value.contentWidth;
                }
            }
        });
        return containerWidth;
    };
    this.getCurrentContentWidth = function () {
        return $('.wrapper-center.first').width();
    };
    this.getContentMinWidth = function () {
        for (var key in this.config.columns) {
            if (this.config.columns.hasOwnProperty(key)) {
                if (this.config.columns[key].active) {
                    var minColumn = parseInt(key, 10);
                    return minColumn * 300 + ((minColumn - 1) * 20) + (Math.min(this.config.columns[key].border) * 2);
                }
            }
        }
    };
    this.getContentWidth = function () {
        var cols = parseInt(PageState.get('cols'));
        var alignment = PageState.get('alignment');
        var gapReduced = PageState.get('border');
        var gapWidth = 0;
        try {
            var gapWidth = Math.max(this.config.columns['' + cols].border);
        } catch (e) {
        }
        if (gapReduced && gapWidth === 30) {
            gapWidth = 0;
        }
        var borderWidth = 2;
        return cols * 300 + ((cols - 1) * 20) + (gapWidth * 2) + borderWidth;
    };
    this.getContentInnerWidth = function () {
        var padding = 22;
        if (SiteInfo.brand === 'webde') {
            padding = 60;
        }
        return $('.wrapper-center.first .wrapper-indent').width() - padding;
    };
    this.forceRefresh = function () {
        var layoutConfig = PageState.get('layoutConfig');
        if (layoutConfig) {
            PageLayout.toggleDisableSticky(layoutConfig[0], layoutConfig[1]);
            this.LayoutChange.run(layoutConfig[0], layoutConfig[1], layoutConfig[2], layoutConfig[3], layoutConfig[4]);
        }
    };
    this.onchange = function (func) {
        this.LayoutChange.add(func);
    };
    this.extendLayoutConfig = function (layoutConfig, extensionKey, extensionValue) {
        extensionKey = extensionKey.toLowerCase();
        switch (extensionKey) {
            case 'narrowright':
                layoutConfig.narrow.right = layoutConfig.narrow.right + parseFloat(extensionValue);
                break;
            case 'narrowleft':
                layoutConfig.narrow.left = layoutConfig.narrow.left + parseFloat(extensionValue);
                break;
            case 'narrowtop':
                layoutConfig.narrow.top = layoutConfig.narrow.top + parseFloat(extensionValue);
                break;
            case 'align':
                if (layoutConfig.align === 'center') {
                    layoutConfig.align = extensionValue;
                }
                break;
            case 'zerowidthborder':
                if (extensionValue) {
                    $.each(layoutConfig.columns, function (k, columnData) {
                        if (layoutConfig.columns[k].border.indexOf(0) === -1) {
                            layoutConfig.columns[k].border.unshift(0);
                        }
                    });
                } else {
                    $.each(layoutConfig.columns, function (k, columnData) {
                        if (layoutConfig.columns[k].border.indexOf(0) !== -1) {
                            var indexOfNull = layoutConfig.columns[k].border.indexOf(0);
                            layoutConfig.columns[k].border.splice(indexOfNull, 1);
                        }
                    });
                }
                break;
            case 'borderwidth':
                $.each(layoutConfig.columns, function (k, columnData) {
                    if (layoutConfig.columns[k].border.indexOf(0) !== -1) {
                        layoutConfig.columns[k].border = [0, extensionValue];
                    } else {
                        layoutConfig.columns[k].border = [extensionValue];
                    }
                });
                break;
            case 'mincontentwidth':
                layoutConfig.minContentWidth = layoutConfig.minContentWidth < extensionValue ? extensionValue : layoutConfig.minContentWidth;
                break;
            case '2col':
                layoutConfig = PageLayout.setColumn(layoutConfig, '2', extensionValue);
                break;
            case '3col':
                layoutConfig = PageLayout.setColumn(layoutConfig, '3', extensionValue);
                break;
            case '4col':
                layoutConfig = PageLayout.setColumn(layoutConfig, '4', extensionValue);
                break;
            case 'outsidecomponent':
                if (extensionValue) {
                    if (layoutConfig.htmlClass.indexOf('adWithOutsideComponent') === -1) {
                        layoutConfig.htmlClass.push('adWithOutsideComponent');
                    }
                }
                break;
            case 'exclusive-ad':
                if (extensionValue) {
                    layoutConfig.htmlData['exclusive-ad'] = true;
                }
                break;
            default:
                layoutConfig[extensionKey] = extensionValue;
                break;
        }
        return layoutConfig;
    };
    this.setColumn = function (layoutConfig, col, value) {
        if (value === 'blocked') {
            layoutConfig.columns[col].blocked = true;
            layoutConfig.columns[col].active = false;
        } else {
            if (!layoutConfig.columns[col].blocked) {
                layoutConfig.columns[col].active = value;
            }
        }
        return layoutConfig;
    };
    this.getSetPositionSelector = function (position) {
        switch ('' + position) {
            case '2':
                return '.wrapper-center.first ~ .wrapper-center:eq(5)';
                break;
            case '3':
                return '.wrapper-center.first ~ .wrapper-center:eq(8)';
                break;
            case '4':
                return 'body > .wrapper-center:eq(-2)';
                break;
            case '1':
            default:
                return '.wrapper-center.first ~ .wrapper-center:eq(1)';
                break;
        }
    }
};
PageLayout.init();
BodyStarted.add(function () {
    PageLayout.adInit();
});
PageLayout.onchange(function (alignment, cols) {
    var adType = PageLayout.adType;
    if (PageLayout.adType === 'sitebar' && PageLayout.adVariant === 'billboard') {
        adType = 'flagship';
    }
    AdService.setParam('categorytype', '' + adType + '_' + cols);
    AdService.setParam('column', '' + cols);
});
PageLayout.onchange(function (alignment, cols) {
    window.SiteInfo.columns = cols;
});
$(window).on('resize orientationchange', function (e) {
    PageLayout.check();
});
ContentService.FinishedHook.add(function () {
    PageLayout.check();
});
if ($.ua.browser.msie === 11) {
    $(window).on('load', function () {
        $(window).trigger('resize');
    });
}

var StickyLogin = new FunctionHook();
StickyLogin.add(function (nextState) {
        if (nextState === 'fixed') {
            $('body').addClass('loginFixed');
        } else {
            $('body').removeClass('loginFixed');
        }
    if (typeof Suggest !== 'undefined' && typeof Suggest.closeSuggest === 'function') {
        Suggest.closeSuggest();
    }
});
StickyLogin.yOffsetFirst = 0;
StickyLogin.yOffsetSecond = 0;
StickyLogin.yOffsets = {names: {}, values: [], halfpage: []};
StickyLogin.setYOffset = function (name, offset, halfpageAlso) {
    if (!StickyLogin.yOffsets.names.hasOwnProperty(name)) {
        StickyLogin.yOffsets.names[name] = StickyLogin.yOffsets.values.length;
        StickyLogin.yOffsets.values.push(0);
        StickyLogin.yOffsets.halfpage.push(0);
    }
    StickyLogin.yOffsets.values[StickyLogin.yOffsets.names[name]] = offset;
    StickyLogin.yOffsets.halfpage[StickyLogin.yOffsets.names[name]] = halfpageAlso ? offset : 0;
    StickyLogin.yOffsetFirst = StickyLogin.yOffsetSecond = 0;
    for (var i = 0, l = StickyLogin.yOffsets.values.length; i < l; i++) {
        StickyLogin.yOffsetFirst += StickyLogin.yOffsets.values[i];
        StickyLogin.yOffsetSecond += StickyLogin.yOffsets.halfpage[i];
    }
};
StickyLogin.supported = function () {
    return (!PageLayout._isSmallScreen && $.ua.browser.name !== 'safari') ? true : false;
}

StickyLogin.push = function (distance, expandExpander) {
    if (typeof StickyLogin.$sepLoginExpander === 'undefined') {
        StickyLogin.$sepLoginExpander = $('.sepLoginExpander');
    }
    if (typeof StickyLogin.$loginsearch === 'undefined') {
        StickyLogin.$loginsearch = $('.hint-wrapper');
    }
    var actualDistance = (distance === 0) ? '' : distance;
    StickyLogin.$loginsearch.css('top', actualDistance);
    $('#promoline').css('marginTop', actualDistance);
    StickyLogin.setYOffset('push', distance, true);
    if (expandExpander) {
        StickyLogin.$sepLoginExpander.css('paddingTop', actualDistance);
    }
}

if ($.ua.browser.name == 'msie' && $.ua.browser.msie == 8) {
    BodyEnded.add(function () {
        $('#loginsearch').parent().prepend($('<div id="ie8before" />'));
    });
}

var $html = $('html');
if ($html.hasClass('hasMessage')) {
    StickyLogin.setYOffset('message', 109, false);
}

var ImageChanger = new function () {
    var _this = this;
    _this.init = function (options) {
        var settings = $.extend({
            container: '.multi-news.hero',
            image: '.teaser-img img',
            colsMatrix: {
                '2': 'small',
                '3': 'medium',
                '4': 'big'
            },
            callback: false
        }, options);
        $(settings.container).each(function () {
            settings.container = this;
            ImageChanger.initImage(settings);
        });
    };
    _this.initImage = function (settings) {
        var $container, $images;
        $container = $(settings.container);
        $images = $(settings.image, $container);
        var pageState = PageState.get('layoutConfig');
        $images.each(function () {
            var src = $(this).attr('src');
            $(this).attr('data-imgsrc-big', src);
        });
        if (pageState && pageState[1]) {
            ImageChanger.checkCols($container, $images, settings, pageState[1]);
        }
        PageLayout.onchange(function (alignment, cols) {
            ImageChanger.checkCols($container, $images, settings, cols);
        });
    };
    _this.checkCols = function ($container, $images, settings, cols) {
        var imgSize = settings.colsMatrix[cols];
        $images.not('.' + imgSize + '-img').each(function () {
            var $this = $(this);
            var newSrc = $this.attr('data-imgsrc-' + imgSize);
            $this.attr('src', newSrc).removeClass().addClass(imgSize + '-img')
        });
        if (settings.callback && typeof settings.callback === 'function') {
            settings.callback($container);
        }
    }
};
LoginReady.add(function () {
    ImageChanger.init({
        container: '.layer-list-and-image',
        image: '.image-fullwidth img',
        colsMatrix: {
            '2': 'small',
            '3': 'medium',
            '4': 'big'
        }
    });
});
HeroReady.add(function () {
    ImageChanger.init({
        container: '.multi-news.hero',
        image: '.teaser-img img',
        colsMatrix: {
            '2': 'small',
            '3': 'big',
            '4': 'big'
        }
    });
});
TopEditorialReady.add(function () {
    ImageChanger.init({
        container: '.top-editorial',
        image: '.teaser-img img',
        colsMatrix: {
            '2': 'small',
            '3': 'medium',
            '4': 'big'
        }
    });
});
Metronome = {};
Metronome.storage = {};
Metronome.add = function (func, ms) {
    if (!Metronome.storage[ms]) {
        Metronome.storage[ms] = new FunctionHook();
        Metronome.storage[ms].onclear = Metronome.onclear(ms);
        Metronome.storage[ms].interval = window.setInterval(function () {
            Metronome.storage[ms].run();
        }, ms);
    }
    Metronome.storage[ms].add(func);
};
Metronome.onclear = function (ms) {
    return function () {
        window.clearInterval(Metronome.storage[ms].interval);
    }
};
Metronome.clear = function () {
    for (var ms in Metronome.storage) {
        if (!Metronome.storage.hasOwnProperty(ms)) {
            continue;
        }
        Metronome.storage[ms].clear();
    }
};
Metronome.stop = function () {
    for (var ms in Metronome.storage) {
        if (!Metronome.storage.hasOwnProperty(ms)) {
            continue;
        }
        window.clearInterval(Metronome.storage[ms].interval);
    }
};
Metronome.go = function () {
    for (var ms in Metronome.storage) {
        if (!Metronome.storage.hasOwnProperty(ms)) {
            continue;
        }
        Metronome.storage[ms].interval = window.setInterval(function () {
            Metronome.storage[ms].run();
        }, ms);
    }
};
BodyEnded.add(function () {
    $('span[data-tolink-href]').each(function () {
        var $this = $(this);
        var link = atob($this.data('tolink-href'));
        $this.replaceWith($('<a>').append($this.contents()).addClass($this.attr('class')).attr({href: link}));
    });
});
HeroReady.add(function () {
    $('.breaking-news').each(function () {
        var $this = $(this);
        var $basicSpan = $('span', $this);
        if (!$basicSpan.length) {
            return;
        }
        var outerWidth = $basicSpan.outerWidth() || 0;
        var childItems = Math.ceil(1260 / outerWidth);
        if (childItems > 1) {
            for (var i = 1; i <= childItems; i++) {
                $basicSpan.after($basicSpan.clone());
            }
        }
        var $basicLink = $('a', $this);
        var $linkClone = $basicLink.clone();
        $basicLink.after($linkClone);
        var resetOffset = $linkClone.offset().left;
        var animationId = null;
        var curPos = 10;
        var startAnimation = function () {
            if (SiteInfo.animationEnabled) {
                var self = this;
                var newPos = null;
                var amount = 10 / -10;
                var now;
                var then = Date.now();
                var interval = 1000 / 30;
                var delta;
                var $breakingNewsInner = $('.breaking-news-inner', $this);
                cancelAnimation();
                function moveLeft() {
                    now = Date.now();
                    delta = now - then;
                    if (delta > interval) {
                        then = now - (delta % interval);
                        if (curPos <= -resetOffset) {
                            curPos = 0;
                        }
                        curPos = curPos + amount;
                        $breakingNewsInner.css('left', curPos);
                    }
                    animationId = requestAnimationFrame(moveLeft);
                }
                moveLeft();
            }
        };
        var cancelAnimation = function () {
            if (animationId) {
                window.cancelAnimationFrame(animationId);
            }
        };
        if (!PageLayout._isSmallScreen) {
            $this.on({
                mouseenter: startAnimation,
                mouseleave: cancelAnimation
            });
        }
    });
});
(function (global, factory) {
    if (typeof exports === "object" && exports) {
        factory(exports);
    } else if (typeof define === "function" && define.amd) {
        define(factory({}));
    } else {
        global.Mustache = factory({});
    }
}(this, function (mustache) {
    var Object_toString = Object.prototype.toString;
    var isArray = Array.isArray || function (object) {
        return Object_toString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    var RegExp_test = RegExp.prototype.test;
    function testRegExp(re, string) {
        return RegExp_test.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': '&quot;',
        "'": '&#39;',
        "/": '&#x2F;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    function parseTemplate(template, tags) {
        if (!template)
            return [];
        var sections = [];
        var tokens = [];
        var spaces = [];
        var hasTag = false;
        var nonSpace = false;
        function stripSpace() {
            if (hasTag && !nonSpace) {
                while (spaces.length)
                    delete tokens[spaces.pop()];
            } else {
                spaces = [];
            }
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tags) {
            if (typeof tags === 'string')
                tags = tags.split(spaceRe, 2);
            if (!isArray(tags) || tags.length !== 2)
                throw new Error('Invalid tags: ' + tags);
            openingTagRe = new RegExp(escapeRegExp(tags[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tags[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tags[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while (!scanner.eos()) {
            start = scanner.pos;
            value = scanner.scanUntil(openingTagRe);
            if (value) {
                for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
                    chr = value.charAt(i);
                    if (isWhitespace(chr)) {
                        spaces.push(tokens.length);
                    } else {
                        nonSpace = true;
                    }
                    tokens.push(['text', chr, start, start + 1]);
                    start += 1;
                    if (chr === '\n')
                        stripSpace();
                }
            }
            if (!scanner.scan(openingTagRe))
                break;
            hasTag = true;
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else {
                value = scanner.scanUntil(closingTagRe);
            }
            if (!scanner.scan(closingTagRe))
                throw new Error('Unclosed tag at ' + scanner.pos);
            token = [type, value, start, scanner.pos];
            tokens.push(token);
            if (type === '#' || type === '^') {
                sections.push(token);
            } else if (type === '/') {
                openSection = sections.pop();
                if (!openSection)
                    throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value)
                    throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') {
                nonSpace = true;
            } else if (type === '=') {
                compileTags(value);
            }
        }
        openSection = sections.pop();
        if (openSection)
            throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            token = tokens[i];
            switch (token[0]) {
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    Scanner.prototype.eos = function () {
        return this.tail === "";
    };
    Scanner.prototype.scan = function (re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0)
            return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    Scanner.prototype.scanUntil = function (re) {
        var index = this.tail.search(re), match;
        switch (index) {
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    function Context(view, parentContext) {
        this.view = view == null ? {} : view;
        this.cache = {'.': this.view};
        this.parent = parentContext;
    }
    Context.prototype.push = function (view) {
        return new Context(view, this);
    };
    Context.prototype.lookup = function (name) {
        var cache = this.cache;
        var value;
        if (name in cache) {
            value = cache[name];
        } else {
            var context = this, names, index;
            while (context) {
                if (name.indexOf('.') > 0) {
                    value = context.view;
                    names = name.split('.');
                    index = 0;
                    while (value != null && index < names.length)
                        value = value[names[index++]];
                } else {
                    value = context.view[name];
                }
                if (value != null)
                    break;
                context = context.parent;
            }
            cache[name] = value;
        }
        if (isFunction(value))
            value = value.call(this.view);
        return value;
    };
    function Writer() {
        this.cache = {};
    }
    Writer.prototype.clearCache = function () {
        this.cache = {};
    };
    Writer.prototype.parse = function (template, tags) {
        var cache = this.cache;
        var tokens = cache[template];
        if (tokens == null)
            tokens = cache[template] = parseTemplate(template, tags);
        return tokens;
    };
    Writer.prototype.render = function (template, view, partials) {
        var tokens = this.parse(template);
        var context = (view instanceof Context) ? view : new Context(view);
        return this.renderTokens(tokens, context, partials, template);
    };
    Writer.prototype.renderTokens = function (tokens, context, partials, originalTemplate) {
        var buffer = '';
        var self = this;
        function subRender(template) {
            return self.render(template, context, partials);
        }
        var token, value;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            token = tokens[i];
            switch (token[0]) {
                case '#':
                    value = context.lookup(token[1]);
                    if (!value)
                        continue;
                    if (isArray(value)) {
                        for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
                            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
                        }
                    } else if (typeof value === 'object' || typeof value === 'string') {
                        buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
                    } else if (isFunction(value)) {
                        if (typeof originalTemplate !== 'string')
                            throw new Error('Cannot use higher-order sections without the original template');
                        value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
                        if (value != null)
                            buffer += value;
                    } else {
                        buffer += this.renderTokens(token[4], context, partials, originalTemplate);
                    }
                    break;
                case '^':
                    value = context.lookup(token[1]);
                    if (!value || (isArray(value) && value.length === 0))
                        buffer += this.renderTokens(token[4], context, partials, originalTemplate);
                    break;
                case '>':
                    if (!partials)
                        continue;
                    value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
                    if (value != null)
                        buffer += this.renderTokens(this.parse(value), context, partials, value);
                    break;
                case '&':
                    value = context.lookup(token[1]);
                    if (value != null)
                        buffer += value;
                    break;
                case 'name':
                    value = context.lookup(token[1]);
                    if (value != null)
                        buffer += mustache.escape(value);
                    break;
                case 'text':
                    buffer += token[1];
                    break;
            }
        }
        return buffer;
    };
    mustache.name = "mustache.js";
    mustache.version = "0.8.1";
    mustache.tags = ["{{", "}}"];
    var defaultWriter = new Writer();
    mustache.clearCache = function () {
        return defaultWriter.clearCache();
    };
    mustache.parse = function (template, tags) {
        return defaultWriter.parse(template, tags);
    };
    mustache.render = function (template, view, partials) {
        return defaultWriter.render(template, view, partials);
    };
    mustache.to_html = function (template, view, partials, send) {
        var result = mustache.render(template, view, partials);
        if (isFunction(send)) {
            send(result);
        } else {
            return result;
        }
    };
    mustache.escape = escapeHtml;
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
}));
var PostMessageHelper = new function () {
    this.allowedOrigins = [
        'https://ad11.adfarm1.adition.com',
        'https://united.uimserv.net',
        'https://adimg.uimserv.net',
        'https://advideo.uimserv.net',
        'https://dl.web.de',
        'https://dl.gmx.net',
        'https://dl.gmx.at',
        'https://dl.gmx.ch',
        'https://dl.1und1.de',
        'https://dl-preview.web.de',
        'https://origin-adimg.uimserv.net',
        'https://origin-advideo.uimserv.net',
        'https://img.ui-portal.de'
    ];
    this.init = function () {
        var self = this;
        $(window).on('message', function (e) {
            self.run(e.originalEvent);
        });
    };
    this.storage = [];
    this.listener = [];
    this.unknowMessages = [];
    this.add = function (name, callback, options) {
        options = $.extend(true, {
            allowedOrigins: PostMessageHelper.allowedOrigins,
            onlyOnce: false
        }, options);
        if (this.isInUnkownMessages(name)) {
            var message = this.getMessageFromUnknownMessages(name);
            var messageData = message.messageData;
            var event = message.event;
            this.handleMessage(messageData, event, {
                name: name,
                callback: callback,
                options: options
            });
            if (options.onlyOnce) {
                return true;
            }
        }
        this.listener.push({
            name: name,
            callback: callback,
            options: options
        });
    };
    this.remove = function (name, callCallback) {
        for (var i = 0; i < this.listener.length; i++) {
            if (this.listener[i].name === name) {
                if (callCallback) {
                    if (typeof this.listener[i].callback === 'function') {
                        this.listener[i].callback(null, {});
                    }
                }
                this.listener.splice(i, 1);
            }
        }
    };
    this.isInStorage = function (name) {
        for (var i = 0; i < this.storage.length; i++) {
            if (this.nameIsMatching(name, this.storage[i].messageData.name)) {
                return true;
            }
        }
        return false;
    };
    this.getMessageFromStorage = function (name) {
        for (var i = 0; i < this.storage.length; i++) {
            if (this.nameIsMatching(name, this.storage[i].messageData.name)) {
                return this.storage[i];
            }
        }
        return null;
    };
    this.isInUnkownMessages = function (name) {
        for (var i = 0; i < this.unknowMessages.length; i++) {
            if (this.nameIsMatching(name, this.unknowMessages[i].messageData.name)) {
                return true;
            }
        }
        return false;
    };
    this.getMessageFromUnknownMessages = function (name) {
        for (var i = 0; i < this.unknowMessages.length; i++) {
            if (this.nameIsMatching(name, this.unknowMessages[i].messageData.name)) {
                var messageObject = this.unknowMessages.splice(i, 1)[0];
                this.storage.push(messageObject);
                return messageObject;
            }
        }
        return null;
    };
    this.getIframe = function (iframeWindow) {
        var iframes = document.getElementsByTagName('iframe');
        for (var i = 0; i < iframes.length; i++) {
            if (iframes[i].contentWindow === iframeWindow) {
                return iframes[i];
            }
        }
        return null;
    };
    this.getWindowFromPostMessageName = function (name) {
        var messageObject = null;
        if (this.isInStorage(name)) {
            messageObject = this.getMessageFromStorage(name);
        } else if (this.isInUnkownMessages(name)) {
            messageObject = this.getMessageFromUnknownMessages(name);
        }
        if (messageObject) {
            try {
                return messageObject.event.source;
            } catch (e) {
            }
        }
        return null;
    };
    this.nameIsMatching = function (name, messageName) {
        return (typeof name === 'string' && name === messageName) || (name instanceof RegExp && messageName.match(name));
    };
    this.originAllowed = function (allowedOrigins, origin) {
        if (allowedOrigins === '*') {
            return true;
        }
        if (allowedOrigins instanceof Array) {
            if (allowedOrigins.indexOf(origin) !== -1) {
                return true;
            }
        }
        return false;
    };
    this.handleMessage = function (messageData, event, listenerItem) {
        if (!this.originAllowed(listenerItem.options.allowedOrigins, event.origin)) {
            return false;
        }
        if (typeof listenerItem.callback === 'function') {
            listenerItem.callback(event.source, messageData.name, messageData.data);
        }
    };
    this.run = function (e) {
        var messageData = e.data;
        if (typeof messageData === 'string' && messageData[0] === '{') {
            try {
                messageData = JSON.parse(messageData);
            } catch (e) {
            }
        }
        if (typeof messageData === 'string') {
            messageData = {
                name: messageData
            }
        }
        if (messageData && messageData.name) {
            var matches = 0;
            for (var i = 0; i < this.listener.length; i++) {
                if (this.nameIsMatching(this.listener[i].name, messageData.name)) {
                    this.storage.push({
                        messageData: messageData,
                        event: e
                    });
                    this.handleMessage(messageData, e, this.listener[i]);
                    matches++;
                }
            }
            if (!matches) {
                this.unknowMessages.push({
                    messageData: messageData,
                    event: e
                });
            }
        }
    };
    this.send = function (targetIframe, message, targetOrigin) {
        if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
            console.log('[POST MESSAGE HELPER]', '[SEND]', '[MESSAGE]', '[(see below)]');
            console.info('[POST MESSAGE HELPER]', '[SEND]', '[MESSAGE]','targetIframe', targetIframe);
            console.info('[POST MESSAGE HELPER]', '[SEND]', '[MESSAGE]','message', message);
            console.info('[POST MESSAGE HELPER]', '[SEND]', '[MESSAGE]','targetOrigin', targetOrigin);
        }
        if (typeof message === 'string') {
            message = {name: message};
        }
        targetIframe.contentWindow.postMessage(JSON.stringify(message), targetOrigin ? targetOrigin : '*');
    };
    this.init();
};
(function($) {
    var params = {
        names: [],
        values: {},
        get: function(name, defValue) {
            return params.values[name] || defValue || '';
        }
    };
    var temp = (location.search||'?').substr(1).split('&');
    for (var i=0; i<temp.length; i++) {
        var parts = temp[i].split('=');
        var name  = unescape(parts[0]);
        var value = unescape(parts.slice(1).join('='));
        if (params.values.hasOwnProperty(name)) {
            if (params.values[name] instanceof Array) {
                params.values[name].push(value);
            } else {
                params.values[name] = [params.values[name], value];
            }
        } else {
            params.names.push(name);
            params.values[name] = value;
        }
    }
    window.AdService = new function() {
        this.versionToken  = 'adservice-template';
        this.startTime     = new Date();
        this.positions     = {};
        this.params        = {};
        this.paramOverride = {};
        this.metaData      = {};
        this.eventHandler  = {};
        this.createAdHook  = {};
        this.serverConf    = {};
        this.adserverAllowed       = true;
        this.googleadsAllowed      = true;
        this.googleParams          = {ad_output:'js', ad_type:'text', ad_client:'ca-gmx', adtest:'off'};
        this.lastRequestedType     = null;
        this.lastRequestedPosition = null;
        this.lastAdMoveToPosition  = null;
        this.currentIndex          = 0;
        this.advContainerId        = 'adv-current-container';
        this.advContainerClass     = 'adv-generic-container';
        this.advPromotionContent   = '<p class="adv-promotion-headline"><span>Promotion</span></p>';
        this.isBlocked             = null;
        this.checkBlocked          = true;
        this.templateEngine        = {templates:[]};
        this.requestedTemplateUrls = {};
        this.adplayerJsUrl         = '//js.ui-portal.de/c/ads/adlib/res/js/adplayer.min.js';
        this.adplayerCssUrl        = '//js.ui-portal.de/c/ads/adlib/res/css/adplayer.min.css';
        this.advContainerAlreadyClosed = false;
        this.NO_AD_HOOK = null;
        this.init = function(portal, category, section, layoutclass, params) {
            this.fireEvent('beforeinit');
            this.params = {
                ac:           0,
                os:           this._getOs(),
                browser:      this._getBrowser(),
                ref:          this._getReferer(),
                iframe:       this._getIframe(),
                screen_res:   this._getResolution(),
                portal:       portal,
                category:     category,
                section:      section,
                layoutclass:  layoutclass,
                deviceclient: 'browser',
                nw:           42,
                external_uid: '',
                uid_stable:   0,
                wi:           (Math.random().toString().substr(2, 9))
            };
            this.setServer(
                'adition-asp',
                {
                    'baseAdserverUrl': '//ad11.adfarm1.adition.com/lt?wpt=j&',
                    'baseRefreshUrl':  '//ad11.adfarm1.adition.com/lt?wpt=h&',
                    'paramOrder':      {
                        begin:  [
                            'nw', 'lt', 'portal', 'category', 'section', 'tagid', 'layoutclass',
                            'posIndex', 'posCount', 'wi', 'ref',
                            'os', 'browser', 'screen_res', 'iframe',
                            'external_uid', 'uid_stable', 'optout', 'consentLevel',
                            'prf[portal]', 'prf[category]', 'prf[section]', 'prf[tagid]', 'prf[layoutclass]',
                            'prf[deviceclass]', 'prf[deviceclient]',
                            'prf[sectionlong]', 'prf[categorytype]',
                            'prf[os]', 'prf[browser]', 'prf[screen_res]', 'prf[iframe]', 'prf[fvers]',
                            'prf[sys]', 'prf[sysv]', 'prf[cl]', 'prf[clv]', 'prf[vpw]', 'prf[net]',
                            'prf[external_uid]', 'prf[hid]', 'prf[nguserid]', 'prf[uids]', 'prf[optout]',
                            'prf[pp]', 'prf[pa]', 'prf[pg]'
                        ],
                        end:    ['prf[pageview]', 'debug'],
                        ignore: ['posName', 'ff']
                    },
                    'paramNames':      {'posIndex':'ac', 'posCount':'pos'},
                    'paramSeparator':  '&',
                    'evenIfEmpty':     {'ref':true, 'iframe':true, 'fvers':true, 'prf[fvers]':true, 'external_uid':true, 'uid_stable':true, 'nguserid':true, 'prf[hid]':true, 'prf[nguserid]':true, 'prf[uids]':true, 'prf[external_uid]': true, 'prf[tcf_pub]': true, 'prf[tcf_pur]': true, 'prf[tcf_spe]': true},
                    'replacements':    {'tagid':['posCount', '{tagid}', function(params) { return (''+params.tagid).indexOf('_x')>=0 ? '{tagid}' : '{tagid}_x'; }]},
                    'paramTypes':      {
                        'lt': ['portal', 'category', 'section', 'tagid', 'layoutclass'],
                        'direct': ['lt', 'ac', 'nw', 'uid_stable', 'sid', 'bid', 'kid', 'ref', 'debug', 'userid', 'gdpr', 'gdpr_consent'],
                        'directprf': ['os', 'browser', 'wi', 'iframe', 'screen_res', 'fvers', 'optout', 'external_uid'],
                        'ignore': ['posIndex', 'posName', 'ff']
                    },
                    'callbackInit':    function(server) {
                        var info = this._getMailcheck();
                        this.params.toolbar = info.hasToolbar ? '1' : '0';
                        this.params.brandedbrowser = !!info.bbrowser ? '1' : '0';
                        this._handleCookies();
                        if (server.callbackSetparam) {
                            this.params = server.callbackSetparam(this.params);
                        }
                        return server;
                    },
                    'callbackSetparam': function(params) {
                        if (params.hid) {
                            params.external_uid = params.hid;
                            params.uid_stable   = '1';
                            params.uids         = '1';
                        }
                        return params;
                    },
                    'paramType_lt': function(data, list, keys) {
                        data.lt = '';
                        $.each(list, function(i, name) {
                            var effectiveName = AdService._getEffectiveParamName(name),
                                effectiveValue = AdService._getEffectiveParamValue(name, data),
                            _;
                            data.lt += effectiveName + '(' + effectiveValue + ')';
                            data['prf['+effectiveName+']'] = effectiveValue;
                            delete data[name];
                        });
                    },
                    'paramType_direct': function(data, list, keys) {
                    },
                    'paramType_directprf': function(data, list) {
                        $.each(list, function(i, name) {
                            var effectiveName = AdService._getEffectiveParamName(name),
                                effectiveValue = AdService._getEffectiveParamValue(name, data),
                            _;
                            if (!data.hasOwnProperty('prf['+effectiveName+']')) {
                                data['prf['+effectiveName+']'] = effectiveValue;
                            }
                        });
                    },
                    'paramType__default': function(data, list, keys) {
                        $.each(list, function(i, name) {
                            if (name.indexOf('prf[') === 0) { return; }
                            var effectiveName = AdService._getEffectiveParamName(name),
                                effectiveValue = AdService._getEffectiveParamValue(name, data),
                            _;
                            data['prf['+effectiveName+']'] = effectiveValue;
                            delete data[name];
                        });
                    }
                }
            );
            this.serverConf._default = 'adition-asp';
            this._analyzeMobile();
            this.newPageContext();
            params = params || {};
            for (var param in params) {
                if (!params.hasOwnProperty(param)) { continue; }
                this.params[param] = params[param];
            }
            this._initPositions();
            this._initServer(this.serverConf[this.serverConf._default]);
            document.write('<style type="text/css">#'+this.advContainerId+' { display: none; }<\/style>');
            this.fireEvent('init');
            return this;
        };
        this.setPositions = function(positions) {
            this.positions = positions;
            this._appendUrlParams();
        };
        this._initPositions = function() {
            this.setPositions({
                content:{tagid:'contentad', _isPromotion:true}
            });
        };
        this._initServer = function(server) {
            if (server.initialized) { return; }
            if (server.callbackInit) {
                try {
                    server.callbackInit.apply(this, [server]);
                } catch(e) {
                }
            }
            server.initialized = true;
        };
        this.setTemplateEngine = function(conf) {
            var defaults = {
                'mustache': {
                    'engineUrl': '//js.ui-portal.de/c/ads/adservice/te/mustache.js',
                    'objectName': 'Mustache'
                }
            };
            if (typeof(conf) !== 'object' && conf) {
                conf = {
                    'name': conf,
                    'templateUrl': arguments[1]
                };
            }
            this.templateEngine = $.extend(
                {templates:{}},
                defaults[conf.name] || {},
                conf
            );
            if (!window[this.templateEngine.objectName]) {
                var self = this;
                $.ajax({
                    url: this.templateEngine.engineUrl,
                    async: false,
                    dataType: 'script',
                    success: function(data, status, xhr) {
                        self.templateEngine.engine = window[self.templateEngine.objectName];
                    }
                });
            } else {
                this.templateEngine.engine = window[this.templateEngine.objectName];
            }
            return this;
        };
        this.setTemplates = function(data) {
            $.extend(this.templateEngine.templates, data);
            this.fireEvent('templateloaded');
        };
        this._loadTemplates = function(tpl, url) {
            if (this.requestedTemplateUrls[url]) { return; }
            $.ajax({
                url: url,
                async: false,
                dataType: 'script'
            });
            this.requestedTemplateUrls[url] = true;
        };
        this._getTemplate = function(tpl) {
            var parts = tpl.split('-');
            for (var i=parts.length; i>0; i--) {
                tpl = parts.slice(0, i).join('-');
                if (this.templateEngine.templates[tpl]) {
                    return this.templateEngine.templates[tpl];
                }
            }
            return '';
        };
        this.render = function(data, target) {
            this.fireEvent('beforerender', {'render':data});
            this.fireEvent('render:preparedata', {'render':data});
            if (target === undefined) {
                target = $('#'+this.advContainerId).css({position:'relative'});
            } else if (target !== false) {
                target = $(target);
            }
            var self = this;
            if (data._type === 'cart-products') {
                for (var indexProducts = 0; indexProducts < data.products.length; indexProducts++) {
                    if (data.products[indexProducts]['_oba']) {
                        data['_oba'] = data.products[indexProducts]['_oba'];
                        break;
                    }
                }
            }
            function executeRender(e) {
                var engine = self.templateEngine.engine;
                var template = self._getTemplate(data._type);
                engine.parse(template);
                if(data.retargeting_forced) {
                    data.retargeting = true;
                    data.usualText = false;
                }
                var html = engine.render(template, data);
                var obaId, domId;
                if (!data._oba_direct && data['_oba'] && data['_oba'].length && window.$ADP) {
                    obaId = $ADP.Registry.generateId(),
                        domId = 'adp_container_'+obaId;
                    html = '<div id="' + domId + '"></div>' + html;
                    for (var i = 0, l = data['_oba'].length; i < l; i++) {
                        $ADP.Registry.register(obaId, data._oba[i]);
                    }
                } else if (data._oba_direct) {
                    var obaIcon = '<a target="_blank" class="obaDirectClickout" href="' + data._oba_direct + '"><span>Datenschutzinfo</span></a>';
                    html = obaIcon + html;
                }
                if (target === false && html) {
                    document.write(html);
                } else {
                    var $ad = $(html);
                    target.append($ad).parent().show();
                    if (data._type === 'cart-products') {
                        $('.cart .spinner').remove();
                    }
                }
                if (typeof obaId !== 'undefined' && typeof domId !== 'undefined') {
                    $ADP.Registry.createPlayer(obaId, {domId: domId});
                }
                self.fireEvent('render', {render:data, ad:$ad});
            }
            if (data['_oba'] && !window.$ADP) {
                $.ajax({
                url: self.adplayerJsUrl,
                    async: false,
                    dataType: 'script',
                    success: function() {
                        if(self._render && data._type === 'cart-products') {
                            data.retargeting_forced = true;
                        }
                        (self._render||self.render).call(self, data, target);
                    }
                });
                $('head').append($('<link rel="stylesheet" href="'+this.adplayerCssUrl+'"/>'));
                this.fireEvent('breakrender', {render:data});
                return false;
            }
            if (!this._getTemplate(data._type)) {
                this.on('templateloaded', data._type, executeRender);
                this._loadTemplates(data._type, this.templateEngine.templateUrl);
            } else {
                executeRender();
            }
        };
        this.setAdplayerUrls = function(js, css) {
            this.adplayerJsUrl  = js;
            this.adplayerCssUrl = css;
        };
        this.newPageContext = function() {
            this.params.wi = this._createPageId();
        };
        this._createPageId = function() {
            return (''+Math.random()).substr(2, 9);
        };
        this._handleCookies = function() {
            var cookie = (document.cookie.match(/(?:^|; )NGUserID=([^;]*)/) || [0, ''])[1];
            this.params.uid_stable = this.params.uids = cookie ? '0' : '';
            this.params['prf[external_uid]'] = this.params.external_uid = this.params.nguserid = cookie;
			this.params.optout = window.consent.full === false ? '1' : '0';
            var consentLevelCookie = (document.cookie.match(/(?:^|; )consentLevel=([^;]*)/) || [0, ''])[1];
            this.params.consentLevel = consentLevelCookie || '0';
            this._applyConsent();
        };
        this._applyConsent = function(changeParams) {
            var setAll = function(optin) {
                var consents = {publisher: {}, purpose: {}, specialFeature: {}};
                consents.publisher.consents = {1: optin, 2: optin, 3: optin, 4: optin, 5: optin, 6: optin, 7: optin, 8: optin, 9: optin, 10: optin};
                consents.purpose.consents = {1: optin, 2: optin, 3: optin, 4: optin, 5: optin, 6: optin, 7: optin, 8: optin, 9: optin, 10: optin};
                consents.specialFeature.consents = {1: optin, 2: optin};
                return consents;
            }
            var writeConsentsToWindow = function(consents) {
                window.consent.purposes = {};
                window.consent.purposes.publisher = consents.publisher;
                window.consent.purposes.purpose = consents.purpose;
                window.consent.purposes.special = consents.specialFeature;
            }
            AdService.setParam('tcf_version', window.consent.tcStringVersion);
            var euCookieValue = PrebidConnector.getCookie('euconsent-v2');
            if (euCookieValue) {
                AdService.setParam('gdpr', 1);
                AdService.setParam('gdpr_consent', euCookieValue);
                if (typeof window.optout === 'undefined') {
                    window.optout = this.params.optout;
                }
                AdService.setParam('optout', undefined);
                AdService.setParam('prf[optout]', window.optout);
                AdService.setParam('prf[consentLevel]', undefined);
                if (changeParams) {
                    changeParams.optout = undefined;
                    changeParams['prf[optout]'] = window.optout;
                    changeParams['prf[consentLevel]'] = undefined;
                }
            } else {
                window.consent.full = window.PageConfig.optin;
                var consents = setAll(window.PageConfig.optin);
                writeConsentsToWindow(consents);
                if (changeParams) {
                    changeParams.consentLevel = this.params.consentLevel;
                    changeParams['prf[consentLevel]'] = this.params.consentLevel;
                    changeParams.external_uid = this.params.external_uid;
                    changeParams['prf[external_uid]'] = this.params['prf[external_uid]'];
                }
            }
            if (window.consent.acString === '1~' || window.consent.acString === null || window.consent.acString === undefined || window.consent.acString.trim().length === 0) {
                AdService.setParam('google_ac', 0);
            } else {
                AdService.setParam('google_ac', 1);
            }
            var pub = window.consent.purposes.publisher.consents || {};
            var pur = window.consent.purposes.purpose.consents || {};
            var spe = window.consent.purposes.special.consents || {};
            window.consent.purposes.publisher.consents = pub;
            window.consent.purposes.purpose.consents = pur;
            window.consent.purposes.special = {consents: spe};
            var fillParams = function(optObject) {
                var params = {};
                var keys = Object.keys(optObject);
                for (var objectIndex = 0; objectIndex < keys.length; objectIndex++) {
                    var paramString = ',';
                    for (var param in optObject[keys[objectIndex]]) {
                        if (optObject[keys[objectIndex]][param]) {
                            paramString += param + ',';
                        }
                    }
                    if (paramString.length === 1) {
                        paramString += ',';
                    }
                    params[keys[objectIndex]] = paramString;
                }
                return params;
            }
            var fillPub, fillPur, fillSpe;
            if (euCookieValue) {
                fillPub = pub;
                fillPur = pur;
                fillSpe = spe;
            } else {
                if (parseInt(this.params.optout) === 1) {
                    fillPub = {};
                    fillPur = {};
                    fillSpe = {};
                } else {
                    if (parseInt(this.params.consentLevel) === 2 || parseInt(this.params.consentLevel) === 3) {
                        var allTrue = setAll(true);
                        fillPub = allTrue.publisher.consents;
                        fillPur = allTrue.purpose.consents;
                        fillSpe = allTrue.specialFeature.consents;
                    } else {
                        fillPub = {};
                        fillPur = {};
                        fillSpe = {};
                    }
                }
            }
            var params = fillParams({'tcf_pub': fillPub, 'tcf_pur': fillPur, 'tcf_spe': fillSpe});
            var paramKeys = Object.keys(params);
            for (var i = 0; i < paramKeys.length; i++) {
                AdService.setParam(paramKeys[i], params[paramKeys[i]]);
            }
            if (!window.consent.full) {
                var pubEmpty = Object.keys(pub).length === 0;
                this._setBooleanToChangeServerForConsent();
                var removeParams = {
                    'userid': pubEmpty || !Boolean(pub[1]),
                    'deviceclass': pubEmpty || !Boolean(pub[2]),
                    'prf[deviceclass]': pubEmpty || !Boolean(pub[2]),
                    'cl': pubEmpty || !Boolean(pub[2]),
                    'prf[cl]': pubEmpty || !Boolean(pub[2]),
                    'clv': pubEmpty || !Boolean(pub[2]),
                    'prf[clv]': pubEmpty || !Boolean(pub[2]),
                    'sys': pubEmpty || !Boolean(pub[2]),
                    'prf[sys]': pubEmpty || !Boolean(pub[2]),
                    'sysv': pubEmpty || !Boolean(pub[2]),
                    'prf[sysv]': pubEmpty || !Boolean(pub[2]),
                    'os': pubEmpty || !Boolean(pub[2]),
                    'prf[os]': pubEmpty || !Boolean(pub[2]),
                    'browser': pubEmpty || !Boolean(pub[2]),
                    'prf[browser]': pubEmpty || !Boolean(pub[2]),
                    'screen_res': pubEmpty || !Boolean(pub[2]),
                    'prf[screen_res]': pubEmpty || !Boolean(pub[2]),
                    'vpw': pubEmpty || !Boolean(pub[2]),
                    'prf[vpw]': pubEmpty || !Boolean(pub[2]),
                    'toolbar': pubEmpty || !Boolean(pub[2]),
                    'prf[toolbar]': pubEmpty || !Boolean(pub[2]),
                    'brandedbrowser': pubEmpty || !Boolean(pub[2]),
                    'prf[brandedbrowser]': pubEmpty || !Boolean(pub[2]),
                    'weather_temp': pubEmpty || !Boolean(pub[2]),
                    'prf[weather_temp]': pubEmpty || !Boolean(pub[2]),
                    'weather_condition': pubEmpty || !Boolean(pub[2]),
                    'prf[weather_condition]': pubEmpty || !Boolean(pub[2]),
                    'clk_type': pubEmpty || !Boolean(pub[2]),
                    'prf[clk_type]': pubEmpty || !Boolean(pub[2]),
                    'view': pubEmpty || !Boolean(pub[2]),
                    'prf[view]': pubEmpty || !Boolean(pub[2]),
                    'camera': pubEmpty || !Boolean(pub[2]),
                    'prf[camera]': pubEmpty || !Boolean(pub[2]),
                    'hw': pubEmpty || !Boolean(pub[2]),
                    'prf[hw]': pubEmpty || !Boolean(pub[2]),
                    'hwversion': pubEmpty || !Boolean(pub[2]),
                    'prf[hwversion]': pubEmpty || !Boolean(pub[2]),
                    'appvers': pubEmpty || !Boolean(pub[2]),
                    'prf[appvers]': pubEmpty || !Boolean(pub[2]),
                    'd': pubEmpty || !Boolean(pub[2]),
                    'prf[d]': pubEmpty || !Boolean(pub[2]),
                    'retina': pubEmpty || !Boolean(pub[2]),
                    'prf[retina]': pubEmpty || !Boolean(pub[2]),
                    'orient': pubEmpty || !Boolean(pub[2]),
                    'prf[orient]': pubEmpty || !Boolean(pub[2]),
                    'net': pubEmpty || !Boolean(pub[2]),
                    'prf[net]': pubEmpty || !Boolean(pub[2]),
                    'apilevel': pubEmpty || !Boolean(pub[2]),
                    'prf[apilevel]': pubEmpty || !Boolean(pub[2]),
                    'interstitial': pubEmpty || !Boolean(pub[2]),
                    'prf[interstitial]': pubEmpty || !Boolean(pub[2]),
                    'screensizewidth': pubEmpty || !Boolean(pub[2]),
                    'prf[screensizewidth]': pubEmpty || !Boolean(pub[2]),
                    'screensizeheight': pubEmpty || !Boolean(pub[2]),
                    'prf[screensizeheight]': pubEmpty || !Boolean(pub[2]),
                    'maxsize': pubEmpty || !Boolean(pub[2]),
                    'prf[maxsize]': pubEmpty || !Boolean(pub[2]),
                    'sectionlong': pubEmpty || !Boolean(pub[2]),
                    'prf[sectionlong]': pubEmpty || !Boolean(pub[2]),
                    'sectionshort': pubEmpty || !Boolean(pub[2]),
                    'prf[sectionshort]': pubEmpty || !Boolean(pub[2]),
                    'column': pubEmpty || !Boolean(pub[2]),
                    'prf[column]': pubEmpty || !Boolean(pub[2]),
                    'clean': pubEmpty || !Boolean(pub[2]),
                    'prf[clean]': pubEmpty || !Boolean(pub[2]),
                    'fvers': pubEmpty || !Boolean(pub[2]),
                    'prf[fvers]': pubEmpty || !Boolean(pub[2]),
                    'tpc': pubEmpty || !Boolean(pub[2]),
                    'prf[tpc]': pubEmpty || !Boolean(pub[2]),
                    'prf[external_uid]': pubEmpty || !Boolean(pub[1]) || !Boolean(pub[3]),
                    'prf[hid]': pubEmpty || !Boolean(pub[1]) || !Boolean(pub[3]),
                    'prf[nguserid]': pubEmpty || !Boolean(pub[1]) || !Boolean(pub[3]),
                    'external_uid': pubEmpty || !Boolean(pub[1]) || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'pp': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'prf[pp]': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'pa': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'prf[pa]': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'pg': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'prf[pg]': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'userlevel': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4]),
                    'prf[userlevel]': pubEmpty || !Boolean(pub[3]) || !Boolean(pub[4])
                };
                var paramRemoveKeys = Object.keys(removeParams);
                var checkParams = changeParams ? Object.keys(changeParams) : Object.keys(AdService.params);
                for (var paramIndex = 0; paramIndex < paramRemoveKeys.length; paramIndex++) {
                    var param = paramRemoveKeys[paramIndex];
                    if (removeParams[param] && checkParams.indexOf(param) >= 0) {
                        if (changeParams) {
                            changeParams[param] = undefined;
                        } else {
                            AdService.setParam(param, undefined);
                        }
                    }
                }
            }
        };
        this._setBooleanToChangeServerForConsent = function() {
            var pub = window.consent.purposes.publisher.consents;
            var pubEmpty = Object.keys(pub).length === 0;
            if (!window.consent.full && (pubEmpty || !Boolean(pub[1]) || !Boolean(pub[2]))) {
                if (!AdService.abd().isBlocked) {
                    window.useConsentServer = true;
                }
            }
        };
        this._analyzeMobile = function() {
            var o = {ua: navigator.userAgent.toLowerCase(), info: {}},
                x = 'browser',
                v = 'version',
                w = window,
                i;
            o.ua.replace(/[\(\)]/g, ';')
                .replace(/\s*(\w*?\ ?\w+[\:\s]?[^\d\s;]*?)[\/\ ;](\d[.\w]*|)/g, function(f, k, v) { o.info[k] = o.info[k] || v || !0; });
            'edge1msie1opr1firefox1seamonkey1aurora1iron1chrome1mobile safari1safari1opera1windows0windows nt0windows phone0windows rt0mac os0os x0android0iphone0ipad0ipod0blackberry0rim0linux0'.replace(/(\D+)(\d)/g, function(n, c, d) { n = +d ? x : 'os'; o.info[c] && (o[n] = o[n] || { name: c == 'opr' ? 'opera' : (c == 'safari' && o.info.android || c == 'chrome' && +o.info[v] == 1) || (o.info.android && c == 'mobile safari') ? 'native' : c == 'os x' ? 'mac os' : c, version: (+d ? o.info[v] : 0) || o.info[c] }, o[n][o[n].name] = parseFloat(o[n][v]) || o[n][v]) });
            (i = +o.info.trident + 4) && (o[x] = {name: 'msie', msie: i, version: i});
            o[x] = o[x] || {name: '', version: ''};
            o.os = o.os || {name: '', version: ''};
            o.retina = 'matchMedia' in w && (w.matchMedia('(-webkit-min-device-pixel-ratio: 2)') || 0).matches;
            o.connection = ['unknown', 'eth', 'wifi', '2g', '3g', '4g'][(navigator.connection || 0).type || 0] || 'unknown';
            o.format = /android(?!.*mobile)|ipad|kindle|playbook|\btab|surface/.test(o.ua) ? 'tab' : /mobi|windows phone|iphone|blackberry/.test(o.ua) ? 'mobile' : 'desktop';
            this.params.cl   = o.browser.name.slice(0, 3);
            this.params.clv  = 0 | parseFloat(o.browser.version);
            this.params.sys  = (o.os.name).slice(0, 3);
            this.params.sysv = o.os.version || '?';
            this.params.vpw  = document.documentElement.offsetWidth;
            this.params.r    = o.retina ? '1' : undefined;
            this.params.net  = o.connection;
            this.params.ff   = (({'tab':'m', 'mobile':'s'})[o.format] || 'b');
            this.params.deviceclass = this.params.ff;
        };
        this._getOs = function() {
            var n = navigator.userAgent.toLowerCase();
                 if (n.search(/windows\sphone\s10\.0/) !== -1) { return 25; }
            else if (n.search(/symbian/) !== -1) { return 13; }
            else if (n.search(/xbox/) !== -1) { return 22; }
            else if (n.search(/android/) !== -1) { return 12; }
            else if (n.search(/windows\snt\s6\.2;\sarm/) !== -1) { return 18; }
            else if (n.search(/iphone|ipad/) !== -1) { return 14; }
            else if (n.search(/windows\snt\s6\.2/) !== -1) { return 15; }
            else if (n.search(/windows\snt\s10\.0/) !== -1) { return 17; }
            else if (n.search(/windows\sce/) !== -1) { return 11; }
            else if (n.search(/cros/) !== -1) { return 19; }
            else if (n.search(/playstation/) !== -1) { return 20; }
            else if (n.search(/nintendo/) !== -1) { return 21; }
            else if (n.search(/windows\sphone\s8\.0/) !== -1) { return 23; }
            else if (n.search(/windows\sphone\s8\.1/) !== -1) { return 24; }
            else if (n.search(/blackberry/) !== -1) { return 26; }
            else if (n.search(/windows\snt\s6\.3/) !== -1) { return 16; }
            else if (n.search(/nokia/) !== -1) { return 27; }
            else if (n.search(/mac\sos\sx|macintosh|mac\x5fpowerpc/) !== -1) { return 5; }
            else if (n.search(/linux/) !== -1) { return 6; }
            else if (n.search(/unix/) !== -1) { return 7; }
            else if (n.search(/windows\snt\s6\.1/) !== -1) { return 10; }
            else if (n.search(/windows\snt\s6\.0/) !== -1) { return 9; }
            else if (n.search(/windows\snt\s5\.2/) !== -1) { return 8; }
            else if (n.search(/windows\snt\s5\.1/) !== -1) { return 3; }
            else if (n.search(/windows\snt\s5\.0/) !== -1) { return 2; }
            else if (n.search(/windows\snt\s4\.0/) !== -1) { return 4; }
            else if (n.search(/windows\s95|windows\sme|win98|windows\s98/) !== -1) { return 1; }
            return -1;
        };
        this._getBrowser = function() {
            var n = navigator.userAgent.toLowerCase();
                 if (n.search(/fban|fb_iab/) !== -1) { return 30; }
            else if (n.search(/ucbrowser|ucweb/) !== -1) { return 16; }
            else if (n.search(/chromium/) !== -1) { return 17; }
            else if (n.search(/qqbrowser/) !== -1) { return 26; }
            else if (n.search(/yabrowser/) !== -1) { return 20; }
            else if (n.search(/vivaldi/) !== -1) { return 23; }
            else if (n.search(/silk/) !== -1) { return 28; }
            else if (n.search(/edge/) !== -1) { return 15; }
            else if (n.search(/palemoon/) !== -1) { return 22; }
            else if (n.search(/iron/) !== -1) { return 21; }
            else if (n.search(/iceweasel/) !== -1) { return 19; }
            else if (n.search(/seamonkey/) !== -1) { return 18; }
            else if (n.search(/maxthon|myie/) !== -1) { return 24; }
            else if (n.search(/metasr/) !== -1) { return 27; }
            else if (n.search(/trident\/(7\.0)/) !== -1) { return 14; }
            else if (n.search(/360se|360ee/) !== -1) { return 25; }
            else if (n.search(/msie\s10/) !== -1) { return 13; }
            else if (n.search(/nokia/) !== -1) { return 29; }
            else if (n.search(/msie\s9/) !== -1) { return 12; }
            else if (n.search(/chrome\//) !== -1) { return 11; }
            else if (n.search(/msie\s8/) !== -1) { return 10; }
            else if (n.search(/opera/) !== -1) { return 7; }
            else if (n.search(/gecko\//) !== -1) { return 6; }
            else if (n.search(/konqueror|safari/) !== -1) { return 8; }
            else if (n.search(/msie\s7/) !== -1) { return 9; }
            else if (n.search(/msie\s6/) !== -1) { return 3; }
            else if (n.search(/msie\s5/) !== -1) { return 2; }
            else if (n.search(/netscape6|netscape\/(7\.\d*)/) !== -1) { return 5; }
            else if (n.search(/netscape4/) !== -1) { return 4; }
            else if (n.search(/msie\s4/) !== -1) { return 1; }
            return -1;
        };
        this._getReferer = function() {
            return location.href || '';
        };
        this._getIframe = function() {
            var iframe = 0;
            try {
                if (top.location.href !== window.location.href) { iframe = 1; }
            } catch (e) {
                iframe = 1;
            }
            return ''+iframe;
        };
        this._getMailcheck = function() {
            var ua = navigator.userAgent,
                info = {};
            if (/Edge\/|Trident\/|MSIE /.test(ua)) {
                var data = ua.match(/tb-([a-z]+)\/([0-9\.]+)(; \([a-z]+\/[0-9\.]+\))?/i);
                if (data) {
                    info.brand = data[1];
                    info.version = data[2];
                    info.bbrowser = data[3] ? true : false;
                }
            } else {
                var $html = $('html');
                info.kid = $html.attr('united-toolbar-campaignid');
                info.mode = $html.attr('united-toolbar-mode');
                info.variant = $html.attr('united-toolbar-variant');
                info.brand = $html.attr('united-toolbar-brand');
                info.bbrowser = $html.attr('united-toolbar-branded-browser');
                info.version = $html.attr('united-toolbar-version');
            }
            info.hasToolbar = !!info.version;
            return info;
        };
        this._getResolution = function() {
            var size = screen.width+'x'+screen.height;
            switch (size) {
                case '1024x576':  return 164;
                case '1024x600':  return 165;
                case '1024x768':  return   3;
                case '1072x600':  return 166;
                case '1152x768':  return 167;
                case '1152x864':  return   4;
                case '1152x870':  return 168;
                case '1152x900':  return 169;
                case '1200x800':  return 170;
                case '1200x900':  return 171;
                case '1280x1024': return   5;
                case '1280x720':  return 172;
                case '1280x768':  return   9;
                case '1280x800':  return  10;
                case '1280x854':  return 173;
                case '1280x960':  return   7;
                case '1360x1024': return 179;
                case '1360x768':  return 174;
                case '1366x1024': return 180;
                case '1366x768':  return 175;
                case '1376x768':  return 176;
                case '1400x1050': return   8;
                case '1400x900':  return 177;
                case '1440x900':  return  11;
                case '1440x960':  return 178;
                case '1600x1024': return 183;
                case '1600x1200': return   6;
                case '1600x768':  return 181;
                case '1600x900':  return 182;
                case '1680x1050': return  12;
                case '1920x1080': return 184;
                case '1920x1200': return  13;
                case '1920x1400': return 185;
                case '1920x1440': return 186;
                case '2048x1152': return 187;
                case '2048x1536': return 188;
                case '2560x1440': return 190;
                case '2560x1600': return 191;
                case '2560x2048': return 192;
                case '2800x2100': return 193;
                case  '640x480':  return   1;
                case  '720x400':  return 153;
                case  '800x480':  return 154;
                case  '800x600':  return   2;
                case  '832x624':  return 159;
                case  '848x480':  return 155;
                case  '852x480':  return 156;
                case  '858x484':  return 158;
                case  '864x480':  return 157;
                case  '960x540':  return 160;
                case  '960x640':  return 162;
                case  '960x720':  return 163;
                case  '964x544':  return 161;
                case 'Sonstige':  return 0;
                case    '0x0':    return 18;
                case  '100x130':  return 98;
                case  '101x54':   return 139;
                case  '101x56':   return 106;
                case  '101x64':   return 76;
                case  '101x65':   return 75;
                case  '101x67':   return 97;
                case  '101x80':   return 44;
                case  '1024x600': return 36;
                case  '1024x768': return 151;
                case  '102x80':   return 58;
                case  '104x208':  return 66;
                case  '106x56':   return 111;
                case  '110x96':   return 78;
                case  '112x112':  return 104;
                case  '112x64':   return 67;
                case '1136x640':  return 194;
                case  '120x100':  return 121;
                case  '120x120':  return 119;
                case  '120x160':  return 85;
                case  '124x124':  return 88;
                case  '126x160':  return 54;
                case  '128x112':  return 134;
                case  '128x120':  return 99;
                case  '128x127':  return 142;
                case  '128x128':  return 23;
                case  '128x141':  return 95;
                case  '128x143':  return 65;
                case  '128x144':  return 96;
                case  '128x160':  return 17;
                case  '128x168':  return 69;
                case  '128x220':  return 31;
                case  '128x40':   return 135;
                case  '128x64':   return 37;
                case  '128x92':   return 115;
                case  '128x96':   return 84;
                case  '130x130':  return 51;
                case  '132x160':  return 133;
                case  '132x162':  return 89;
                case  '132x176':  return 55;
                case  '140x160':  return 144;
                case  '150x170':  return 147;
                case  '160x100':  return 94;
                case  '160x120':  return 68;
                case  '160x128':  return 52;
                case  '160x160':  return 83;
                case  '160x220':  return 73;
                case  '160x240':  return 82;
                case  '162x216':  return 101;
                case  '167x220':  return 25;
                case  '176x132':  return 74;
                case  '176x144':  return 57;
                case  '176x192':  return 80;
                case  '176x200':  return 60;
                case  '176x208':  return 41;
                case  '176x220':  return 21;
                case  '176x240':  return 72;
                case  '176x320':  return 137;
                case  '176x92':   return 145;
                case  '177x220':  return 53;
                case  '193x196':  return 143;
                case  '200x176':  return 61;
                case  '208x104':  return 81;
                case  '208x208':  return 43;
                case  '208x320':  return 71;
                case  '220x176':  return 38;
                case  '220x220':  return 45;
                case  '220x267':  return 90;
                case  '240x160':  return 39;
                case  '240x176':  return 92;
                case  '240x240':  return 35;
                case  '240x260':  return 28;
                case  '240x270':  return 146;
                case  '240x320':  return 16;
                case  '240x330':  return 33;
                case  '240x400':  return 22;
                case  '240x427':  return 130;
                case  '240x432':  return 24;
                case  '240x440':  return 126;
                case  '240x480':  return 26;
                case  '240x60':   return 93;
                case  '256x128':  return 109;
                case  '256x384':  return 118;
                case  '260x240':  return 42;
                case  '262x144':  return 50;
                case  '320x194':  return 124;
                case  '320x204':  return 141;
                case  '320x240':  return 19;
                case  '320x320':  return 20;
                case  '320x400':  return 127;
                case  '320x448':  return 120;
                case  '320x480':  return 49;
                case  '352x416':  return 40;
                case  '360x400':  return 150;
                case  '360x480':  return 116;
                case  '360x640':  return 114;
                case  '384x288':  return 138;
                case  '400x194':  return 148;
                case  '400x240':  return 34;
                case  '432x240':  return 123;
                case  '448x320':  return 122;
                case  '480x240':  return 129;
                case  '480x272':  return 46;
                case  '480x320':  return 14;
                case  '480x360':  return 117;
                case  '480x640':  return 15;
                case  '480x800':  return 32;
                case  '480x854':  return 140;
                case  '490x165':  return 132;
                case  '640x200':  return 64;
                case  '640x240':  return 59;
                case  '640x320':  return 79;
                case  '640x480':  return 152;
                case   '64x101':  return 107;
                case  '770x300':  return 113;
                case  '800x345':  return 149;
                case  '800x352':  return 47;
                case  '800x480':  return 27;
                case   '80x101':  return 105;
                case   '80x40':   return 103;
                case   '84x48':   return 87;
                case   '84x84':   return 102;
                case  '854x480':  return 125;
                case   '86x64':   return 110;
                case   '90x40':   return 128;
                case   '94x64':   return 100;
                case   '94x94':   return 70;
                case   '96x39':   return 29;
                case   '96x44':   return 131;
                case   '96x48':   return 91;
                case   '96x55':   return 63;
                case   '96x56':   return 108;
                case   '96x60':   return 86;
                case   '96x64':   return 48;
                case   '96x65':   return 62;
                case   '96x68':   return 30;
                case   '96x72':   return 112;
                case   '96x86':   return 56;
                case   '97x56':   return 136;
                case   '98x67':   return 77;
            }
            return -1;
        };
        this._getTimezone = function() {
            return -parseInt(new Date().getTimezoneOffset()/6)/10;
        };
        this._appendUrlParams = function(additionalParams) {
            for (var i=0; i<params.names.length; i++) {
                var name = params.names[i];
                if (name.substring(0, 4) != '_ad.') { continue; }
                if (this['_appendUrlParam_'+name.substr(4)]) {
                    this['_appendUrlParam_'+name.substr(4)](params.get(name));
                } else {
                    this.params[name.substr(4)] = params.get(name).split('|');
                }
            }
            if (additionalParams) {
                var self = this;
                Object.keys(additionalParams).forEach(function(key) {
                    self.params[key] = additionalParams[key];
                  });
            }
        };
        this._appendUrlParam_bannerid = function(value) {
            var positions = value.split(';');
            for (var i=0, l=positions.length; i<l; i++) {
                var parts = positions[i].split(',');
                for (var j=1, m=parts.length; j<m; j++) {
                    this.setPositionParam(parts[j], 'posIndex', -1);
                    this.setPositionParam(parts[j], 'bid', parts[0]);
                }
            }
        };
        this.setServer = function(name, conf) {
            this.serverConf[name] = conf;
            this.serverConf[name].name = name;
            if (!this.serverConf[name].paramNames)       { this.serverConf[name].paramNames       = {}; }
            if (!this.serverConf[name].paramSeparator)   { this.serverConf[name].paramSeparator   = '&'; }
            if (!this.serverConf[name].valueSeparator)   { this.serverConf[name].valueSeparator   = '='; }
            if (!this.serverConf[name].evenIfEmpty)      { this.serverConf[name].evenIfEmpty      = {}; }
            if (!this.serverConf[name].replacements)     { this.serverConf[name].replacements     = {}; }
            if (!this.serverConf[name].baseRefreshUrl)   { this.serverConf[name].baseRefreshUrl   = this.serverConf[name].baseAdserverUrl; }
            if (!this.serverConf[name].baseIframeUrl)    { this.serverConf[name].baseIframeUrl    = this.serverConf[name].baseRefreshUrl; }
            if (!this.serverConf[name].baseExtIframeUrl) {
                    this.serverConf[name].baseExtIframeUrl = '//dl.gmx.' + (SiteInfo.country !== 'de' ? SiteInfo.country : 'net') + '/uim/container/service-connector/service-connector.html';
            }
            if (!this.serverConf[name].posCount)         { this.serverConf[name].posCount         = 0; }
        };
        this.addPosition = function(pos, tagid, params) {
            params = params || {};
            params.tagid = tagid;
            this._initPosition(pos, params._disabled);
            params._disabled = this.positions[pos]._disabled;
            params.posCount  = this.positions[pos].posCount;
            this.positions[pos] = params;
        };
        this.disablePosition = function(pos) {
            this._initPosition(pos, true);
        };
        this.enablePosition = function(pos) {
            this._initPosition(pos, false);
        };
        this.moveAdToPosition = function(pos) {
            this.lastAdMoveToPosition = pos;
        };
        this._initPosition = function(pos, isDisabled) {
            if (!this.positions[pos])          { this.positions[pos]           = {}; }
            if (!this.positions[pos].posCount) { this.positions[pos].posCount  = 0; }
            if (!this.positions[pos]._pos)     { this.positions[pos]._pos      = pos; }
            if (!this.positions[pos].hasOwnProperty('_disabled') || isDisabled !== undefined) { this.positions[pos]._disabled = !!isDisabled; }
            return this.positions[pos];
        };
        this.setBlockedCheck = function(check) {
            this.checkBlocked = check;
        };
        this.stopAdserverAds = function() {
            this.adserverAllowed = false;
        };
        this.stopGoogleAds = function() {
            this.googleadsAllowed = false;
        };
        this.param = function(obj, sepParam, sepValue, escFunc) {
            var param = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) { continue; }
                param.push((escFunc||encodeURIComponent)(''+i) + (sepValue||'=') + (escFunc||encodeURIComponent)(''+obj[i]));
            }
            return param.join(sepParam||'&');
        };
        this.getParam = function(name) {
            return this.params[name];
        };
        this.setParam = function(name, value) {
            this.setPositionParam(null, name, value);
        };
        this.getPositionParam = function(pos, name, alsoGlobal) {
            this._initPosition(pos);
            return this.positions[pos][name] || (alsoGlobal===false ? undefined : this.params[name]);
        };
        this.setPositionParam = function(pos, name, value) {
            if (pos) {
                this._initPosition(pos);
            }
            var params = {};
            if (typeof(name) === 'object') {
                params = name;
            } else {
                params[name] = value;
            }
            var server = this.serverConf[pos ? (this.positions[pos]._server||this.serverConf._default) : (this.currentServer ? this.currentServer.name : this.serverConf._default)];
            if (server.callbackSetparam) {
                try {
                    params = server.callbackSetparam(params);
                } catch(e) {
                }
            }
            for (var i in params) {
                if (!params.hasOwnProperty(i)) { continue; }
                if (pos) {
                    this.positions[pos][i] = params[i];
                } else {
                    this.params[i] = params[i];
                }
            }
        };
        this.getDeviceClass = function() {
            return this.getParam('deviceclass');
        };
        this.setSticky = function() {
            this.metaData[this.lastRequestedPosition].sticky = true;
        };
        this.setAdCallback = function(callback) {
            var ad = this.positions[this.lastRequestedPosition];
            if (!ad) { return; }
            if (!ad._callbacks) { ad._callbacks = []; }
            ad._callbacks.push(callback);
        };
        this.setCurrentServer = function(ad) {
            this.currentServer = this.serverConf[ad._server||this.serverConf._default];
            this._initServer(this.currentServer);
        };
        this._getEffectiveParamName = function(paramName) {
            return typeof this.currentServer.paramNames[paramName] !== 'undefined' ? this.currentServer.paramNames[paramName] : paramName;
        };
        this._getEffectiveParamValue = function(paramName, params, simulateNextRequest) {
            if (this.currentServer.replacements[paramName]) {
                var rule = this.currentServer.replacements[paramName];
                var value = (params[rule[0]] + (simulateNextRequest ? 1 : 0) <= 1) ? rule[1] : rule[2];
                if (typeof value === 'function') {
                    try { value = value(params); }
                    catch (e) { }
                }
                return value.replace(/\{(.+?)\}/g, function(x, $1) { return params[$1]; });
            }
            return params[paramName]===undefined ? '' : ''+params[paramName];
        };
        this.getParamString = function(ad) {
            this.setCurrentServer(ad);
            var result = [];
            var params = {};
            var paramOrder = [];
            for (var param in this.params) {
                if (!this.params.hasOwnProperty(param) || param.substr(0, 1)==='_' || this.params[param]===null) { continue; }
                var ignore = false;
                for (var i=0; i<this.currentServer.paramOrder.ignore.length; i++) {
                    if (this.currentServer.paramOrder.ignore[i] == param) {
                        ignore = true;
                        break;
                    }
                }
                if (ignore) { continue; }
                params[param] = this.params[param];
            }
            for (var param in ad) {
                if (!ad.hasOwnProperty(param) || param.substr(0, 1)=='_') { continue; }
                var ignore = false;
                for (var i=0; i<this.currentServer.paramOrder.ignore.length; i++) {
                    if (this.currentServer.paramOrder.ignore[i] == param) {
                        ignore = true;
                        break;
                    }
                }
                if (ignore) { continue; }
                params[param] = ad[param];
            }
            for (var param in this.currentServer.evenIfEmpty) {
                if (!this.currentServer.evenIfEmpty.hasOwnProperty(param) || !this.currentServer.evenIfEmpty[param]) { continue; }
                if (!params.hasOwnProperty(param)) { params[param] = undefined; }
            }
            for (var param in this.paramOverride) {
                if (!this.paramOverride.hasOwnProperty(param)) { continue; }
                params[param] = this.paramOverride[param];
            }
            if (this.currentServer.paramTypes) {
                var keys = [],
                    server = this.currentServer,
                _;
                $.each(params, function(key) { keys.push(key); });
                $.each(this.currentServer.paramTypes, function(type, list) {
                    $.each(list, function(i, key) {
                        var index = $.inArray(key, keys);
                        if (index >= 0) {
                            keys.splice(index, 1);
                        }
                    });
                    if (server['paramType_'+type]) {
                        server['paramType_'+type](params, list, keys);
                    }
                });
                if (server['paramType__default']) {
                    server['paramType__default'](params, keys, keys);
                }
            }
            AdService._applyConsent(params);
            for (var i=0; i<this.currentServer.paramOrder.begin.length; i++) {
                var param = this.currentServer.paramOrder.begin[i];
                paramOrder.push(param);
            }
            var beginEnd = [].concat(this.currentServer.paramOrder.begin, this.currentServer.paramOrder.end);
            middleParams: for (var param in params) {
                if (!params.hasOwnProperty(param)) { continue middleParams; }
                for (var j=0; j<beginEnd.length; j++) {
                    if (param == beginEnd[j]) { continue middleParams; }
                }
                paramOrder.push(param);
            }
            for (var i=0; i<this.currentServer.paramOrder.end.length; i++) {
                var param = this.currentServer.paramOrder.end[i];
                paramOrder.push(param);
            }
            if (this.currentServer.remodelParamOrder) {
                try {
                    paramOrder = this.currentServer.remodelParamOrder(paramOrder);
                } catch (e) {
                }
            }
            var p = 0;
            for (var i=0; i<paramOrder.length; i++) {
                if (!params[paramOrder[i]] && !this.currentServer.evenIfEmpty[paramOrder[i]]) { continue; }
                result[p] = [paramOrder[i], params[paramOrder[i]]];
                var paramName = result[p][0];
                result[p][1] = this._getEffectiveParamValue(paramName, params);
                paramName = this._getEffectiveParamName(paramName);
                if (result[p][1] instanceof Array) {
                    var value = [];
                    for (var j=0; j<result[p][1].length; j++) {
                        value.push(paramName ? this._escapeValue(paramName) + this.currentServer.valueSeparator + this._escapeValue(result[p][1][j]) : this._escapeValue(result[p][1][j]));
                    }
                    result[p] = value.join(this.currentServer.paramSeparator);
                } else {
                    result[p] = paramName
                              ? this._escapeValue(paramName) + this.currentServer.valueSeparator + this._escapeValue(result[p][1])
                              : this._escapeValue(result[p][1]);
                }
                p++;
            }
            var result = result.join(this.currentServer.paramSeparator);
            if (ad._urlFragment) {
                result += '#' + ad._urlFragment;
            }
            if (this.currentServer.remodelParamString) {
                try {
                    result = this.currentServer.remodelParamString(result, ad);
                } catch (e) {
                }
            }
            return result;
        };
        this._escapeValue = function(val) {
            return encodeURIComponent(val).replace(/%2F/gi, '/');
        };
        this.getAdUrl = function(pos, baseUrl, params) {
            var ad = this._initPosition(pos);
            var self = this;
            if (params) {
                for (var i in params) {
                    if (params[i]===false || !params.hasOwnProperty(i)) { continue; }
                    ad[i] = params[i];
                }
            }
            this.positions[pos].posCount++;
            if (                  pos.substr(0, 1)!='_') { this.params.posIndex = ++this.currentIndex; }
            if (!ad.tagid      && pos.substr(0, 1)!='_') { ad.tagid   = pos; }
            if (pos!==ad.tagid && pos.substr(0, 1)!='_') { ad.posName = pos; }
            if (this.currentServer.callbackSetparam) {
                try {
                    ad = this.currentServer.callbackSetparam(ad);
                } catch(e) {
                }
            }
            baseUrl = baseUrl.replace(/\$\{([^}]+)\}/g, function() {
                return ad[RegExp.$1] || AdService.params[RegExp.$1];
            });
            return baseUrl+this.getParamString(ad);
        };
        this.getTagid = function (pos) {
            var ad = this._initPosition(pos);
            this.setCurrentServer(ad);
            if (ad.tagid) {
                return this._getEffectiveParamValue('tagid', ad, true);
            } else {
                return pos;
            }
        };
        this.getPositionNameFromTagid = function (tagid) {
            var allKeys = Object.keys(AdService.positions);
            var adjustedTagid = tagid.replace(/\_x$/, '');
            for (var i = 0; i < allKeys.length; i++) {
                var position = this._initPosition(allKeys[i]);
                if (!position._disabled && (position.tagid || allKeys[i]) === adjustedTagid) {
                    return allKeys[i];
                }
            }
            return null;
        };
        this.abd = function() {
            if (!(this instanceof AdService.abd)) { return new this.abd(); }
            if (this.isBlocked === undefined) {
                var d = document,
                    n = d.createElement('div'),
                    b = d.getElementsByTagName('body')[0];
                n.id             = 'abd-container';
                n.className      = 'advertorial adv ad ad-container ad-contain promoad pub_300x250 plainAd photoad ad-body ad-content adContent ad300x250 adBox adCreative adModule adboxcontent sponsorad';
                n.style.height   = '200px';
                n.style.width    = '200px';
                n.style.position = 'absolute';
                n.style.top      = '-1000px';
                n.style.left     = '-1000px';
                b.appendChild(n);
                var height = n.clientHeight || n.offsetHeight;
                this.isBlocked = (height>0) ? undefined : true;
                AdService.isBlocked = this.isBlocked;
                if (this.isBlocked) {
                    AdService.fireEvent('adblockdetected');
                }
                b.removeChild(n);
            }
            return this;
        };
        this.createPosition = function(pos, target, func, opts, additionalParams) {
            if(!AdService.firstAdLoaded) {
                AdService.firstAdLoaded = true;
            } else if(!AdService.logoutAdDetectionDone) {
                AdService.logoutAdDetectionDone = true;
                var event = new CustomEvent ('abDetectionDone', { bubbles: true, cancelable: true });
                document.querySelector('body').dispatchEvent(event);
            }
            if (!opts) { opts = func; func = target; }
            if (typeof func !== 'function') { func = window.postscribe; }
            try {
                var additionalParamsAsString = JSON.stringify(additionalParams);
                if (target && target !== func) {
                    func(target, '<script>AdService.ad("' + pos + '", undefined, ' + additionalParamsAsString + ');</script><script>AdService.cleanup();</script>', opts);
                } else {
                    func('<script>AdService.ad("' + pos + '", undefined, ' + additionalParamsAsString + ');</script><script>AdService.cleanup();</script>', opts);
                }
            } catch (e) {
            }
        };
        this.ad = function(pos, target, additionalParams) {
            this._appendUrlParams(additionalParams);
            if (this.checkBlocked && AdService.isBlocked===null) { AdService.isBlocked = this.abd().isBlocked; }
            this._setBooleanToChangeServerForConsent();
            if (AdService.isBlocked && !this.blockingActivated) {
                this.switchToInfoAdServer();
                this.blockingActivated = true;
            }
            if (window.useConsentServer) {
                this.switchToUnitedUimservAdServer(true);
            }
            var ad = this._initPosition(pos);
            this.setCurrentServer(ad);
            this.lastRequestedPosition = pos;
            this.fireEvent('position');
            ad = this.positions[pos];
            this.setCurrentServer(ad);
            if (!ad)                   { return; }
            if (ad._type !== 'iframe' && !target) {
                document.writeln('<div id="'+this.advContainerId+'">');
            }
            if (ad._disabled)          { return; }
            if (!this.adserverAllowed) { return; }
            this.lastRequestedType = 'ad';
            if (ad._content) {
                this.fireEvent('beforeinsert', {ad:ad._content});
                $('script').last().before(ad._content).parent().show();
                this.fireEvent('insert', {ad:ad._content});
                ad._content = null;
                return;
            }
            var html = '';
            var callback = undefined;
            if (ad._type === 'iframe' || target || ad._type === 'nfi') {
                html = this.getIframe(pos, ad);
            } else {
                var url = this.getAdUrl(pos, this.currentServer.baseAdserverUrl);
                html = '<script type="text/javascript" src="'+(url.replace(/&/g, '&amp;'))+'"><\/script>';
            }
            this.fireEvent('beforerequest', {url:url});
            if (target) {
                ad._container = $(target);
                ad._container.html(html);
            } else {
                document.writeln(html);
            }
            if (typeof callback === 'function') {
                callback();
            }
            this.fireEvent('request');
        };
        this.fly = function(tagid, params, target) {
            this.positions['_fly'] = {};
            this.addPosition('_fly', tagid, params);
            this.ad('_fly', target);
        };
        this.refresh = function(pos, width, height, params) {
            var ad = this.positions[pos];
            if (!ad)                   { return; }
            if (!ad._container)        { return; }
            if (ad._disabled)          { return; }
            if (!this.adserverAllowed) { return; }
            this.fireEvent('beforerefresh');
            this.setCurrentServer(ad);
            var fragment = '',
                orgIframe = null;
            if (isNaN(width)) {
                orgIframe = $(width);
                params = height;
                width = orgIframe.width();
                height = orgIframe.height();
                var orgUrl = orgIframe.attr('src');
                if (orgUrl.indexOf('#') >= 0) {
                    fragment = orgUrl.substr(orgUrl.indexOf('#') + 1);
                }
            }
            params = params || {};
            params.richmedia = 'false';
            if (!params._urlFragment) {
                params._urlFragment = fragment;
            }
            var url = this.getAdUrl(pos, this.currentServer.baseRefreshUrl, params);
            $('#advBanderole').hide();
            this.fireEvent('beforerequest');
            if (orgIframe) {
                orgIframe.attr('src', url);
            } else {
                var $iframe = $(this.getIframe(pos, ad));
                $iframe.css({width: width, height: height});
                insertIntoList: if (params._iframeList && params._iframeList.push) {
                    var oldIframe = $('iframe:first', ad._container).get(0),
                        newIframe = $iframe.get(0);
                    for (var i=0, l=params._iframeList.length; oldIframe && i<l; i++) {
                        if (params._iframeList[i] === oldIframe) {
                            params._iframeList[i] = newIframe;
                            break insertIntoList;
                        }
                    }
                    params._iframeList.push(newIframe);
                }
                ad._container.html($iframe);
            }
            this.fireEvent('request');
            this.fireEvent('refresh');
            return;
        };
        this.getIframe = function(pos, ad) {
            var url;
            ad._width = ad._width || '100%';
            ad._height = ad._height || '100%';
            if (ad._type === 'nfi') {
                url = this.getAdUrl(pos, this.currentServer.baseAdserverUrl, {richmedia: 'false', wpt: 'j'});
                return '<iframe src="' + this.currentServer.baseExtIframeUrl + '?param-deviceclass=' + encodeURIComponent(this.getDeviceClass()) + '" name="' + (url.replace(/&/g, '&amp;')) + '" width="' + ad._width + '" height="' + ad._height + '" frameborder="0" border="0" scrolling="no" marginwidth="0" marginheight="0"><\/iframe>';
            } else {
                url = this.getAdUrl(pos, this.currentServer.baseIframeUrl, {richmedia: 'false'});
                return '<iframe src="' + (url.replace(/&/g, '&amp;')) + '" width="' + ad._width + '" height="' + ad._height + '" frameborder="0" border="0" scrolling="no" marginwidth="0" marginheight="0"><\/iframe>';
            }
        };
        this.createUimTag = function(attributes) {
            var tag = $('<uim:ad></uim:ad>')[0];
            var keys = Object.keys(attributes);
            for (var i = 0; i < keys.length; i++) {
                tag.setAttribute(keys[i], attributes[keys[i]]);
            }
            var div = document.createElement('div');
            div.innerHTML = tag.outerHTML.trim();
            return div.firstChild;
        };
        this.adMeta = function(meta) {
            var position = this.getPositionNameFromTagid(meta.tagid);
            this.metaData[position] = meta;
            this.fireEvent('meta');
        };
        this.on = function(evt) {
            if (!this.eventHandler[evt]) { this.eventHandler[evt] = []; }
            this.eventHandler[evt].push(this._prepareEvent(evt, Array.prototype.slice.call(arguments, 1)));
            this.fireEvent('eventHandlerAdded', {event: evt});
        };
        this.onAdsize = function(adsize, func) {
            return this.on('meta', {adsize:adsize}, func);
        };
        this.onSticky = function(tagid, func) {
            var comp = typeof(tagid)==='string' ? {sticky:true, tagid:tagid} : {sticky:true},
                func = func ? func : tagid;
            return this.on('cleanup', comp, func);
        };
        this._prepareEvent = function(evt, args) {
            if (typeof(args[0]) === 'function') {
                return args;
            }
            if (this['_prepareEvent_'+evt]) {
                return this['_prepareEvent_'+evt](args);
            }
            if (typeof(args[0]) === 'string') {
                return this._prepareEvent_position(args);
            }
        };
        this._prepareEvent_objCompare = function(args, obj) {
            args[0] = (function(data, comp) { return function(e) {
                var obj = typeof(comp)==='string' ? e[comp] : (comp ? comp : e.meta);
                if (!obj) { return !data; }
                for (var i in data) {
                    if (!data.hasOwnProperty(i)) { continue; }
                    if (!(data[i] instanceof Array)) {
                        data[i] = [data[i]];
                    }
                    var result = false;
                    arrayrun: for (var j=0, l=data[i].length; j<l; j++) {
                        if (data[i][j] instanceof RegExp) {
                            if (data[i][j].test(obj[i])) {
                                result = true;
                                break arrayrun;
                            }
                        } else {
                            if (data[i][j] == obj[i]) {
                                result = true;
                                break arrayrun;
                            }
                        }
                    }
                    if (!result) {
                        return false;
                    }
                }
                return true;
            }})(args[0], obj);
            return args;
        };
        this._prepareEvent_position = function(args) {
            args[0] = (function(data) { return function(e) {
                return e.position === data;
            }})(args[0]);
            return args;
        };
        this._prepareEvent_meta = function(args) {
            return this._prepareEvent_objCompare(args, 'meta');
        };
        this._prepareEvent_cleanup = function(args) {
            return (typeof args[0]==='string') ? this._prepareEvent_position(args) : this._prepareEvent_objCompare(args, 'meta');
        };
        this._prepareEvent_beforecleanup = function(args) {
            return (typeof args[0]==='string') ? this._prepareEvent_position(args) : this._prepareEvent_objCompare(args, 'meta');
        };
        this._prepareEvent_templateloaded = function(args) {
            var self = this;
            args[0] = (function(data) { return function(e) {
                var parts = data.split('-');
                for (var i=parts.length; i>0; i--) {
                    tpl = parts.slice(0, i).join('-');
                    if (self.templateEngine.templates[tpl]) {
                        return self.templateEngine.templates[tpl];
                    }
                }
                return false;
            }})(args[0]);
            return args;
        };
        this._prepareEvent_eventHandlerAdded = function(args) {
            args[0] = (function(data) { return function(e) {
                return data == e.event;
            }})(args[0]);
            return args;
        };
        this.fireEvent = function(evt, data) {
            if (!this.eventHandler[evt]) { return; }
            var e = {
                type: evt,
                meta: AdService.getLastMeta(),
                position: this.lastRequestedPosition,
                pos: this.positions[this.lastRequestedPosition],
                ad: ((this.positions[this.lastRequestedPosition]||{})._container||{get:function() {}}).get(0)
            };
            for (var i in data) {
                if (!data.hasOwnProperty(i)) { continue; }
                e[i] = data[i];
            }
            for (var i=0, l=this.eventHandler[evt].length; i<l; i++) {
                try {
                    var item = this.eventHandler[evt][i],
                        comp = item[0],
                        func = item[item.length-1];
                    if (item.length>1) {
                        e.compare = comp;
                        if (!comp(e)) { continue; }
                    } else {
                        delete e.compare;
                    }
                    func(e);
                } catch(error) {
                }
            }
        };
        this.autoResizeContainer = function(evt) {
            if (evt.ad && evt.meta && evt.meta.width && evt.meta.height) {
                $(evt.ad).css({width:evt.meta.width, height:evt.meta.height});
            }
        };
        this.getLastMeta = function() {
            return this.metaData[this.lastRequestedPosition] ? this.metaData[this.lastRequestedPosition] : {};
        };
        this.createAd = function(data) {
            if (typeof(data)==='string') { data = {'type':data}; }
            this.fireEvent('beforeadhook', {data:data});
            if (typeof(data.components)==='object') {
                for (var i in data.components) {
                    if (!data.components.hasOwnProperty(i)) { continue; }
                    data[i] = data.components[i];
                }
            }
            var isSpecialAd;
            switch(data.type) {
                case 'halfpage':
                case 'billboard':
                case 'bridge':
                case 'sitebar':
                case 'flagship':
                case 'double-sitebar':
                case 'maxiframe':
                case 'maxiad':
                case 'maxiadcontent':
                case 'skyright':
                case 'cinematic':
                    isSpecialAd = true;
                    break;
                default:
                    isSpecialAd = false;
            }
            var metaOf = data.type;
            if (isSpecialAd) {
                metaOf = 'rectangle';
            } else if (data.type === 'content-slider') {
                metaOf = 'slider_1';
            }
            var lastMeta = this.metaData[metaOf];
            if (typeof(this.createAdHook['_global:prepare'])==='function') {
                data = this.createAdHook['_global:prepare'](data, lastMeta);
                this.fireEvent('adhook:global:prepare', {data:data});
            }
            if (typeof(this.createAdHook[data.type + ':prepare'])==='function') {
                data = this.createAdHook[data.type + ':prepare'](data, lastMeta);
                this.fireEvent('adhook:prepare', {data:data});
            }
            if (typeof(this.createAdHook['_global'])==='function') {
                var result = this.createAdHook['_global'](data, lastMeta);
                this.fireEvent('adhook:global', {data:data});
                return result;
            }
            if (typeof(this.createAdHook[data.type])==='function') {
                var result = this.createAdHook[data.type](data, lastMeta);
                this.fireEvent('adhook', {data:data});
                return result;
            } else if (typeof(this.createAdHook['_default'])==='function') {
                var result = this.createAdHook['_default'](data, lastMeta);
                this.fireEvent('adhook:default', {data:data});
                return result;
            }
            this.fireEvent('noadhook', {data:data});
            return this.NO_AD_HOOK;
        };
        this.setAdHook = function(type, func) {
            this.createAdHook[type] = func;
        };
        this.setAdserverFallback = function(func) {
            if (typeof(func)!=='function' && typeof(this.adserverFallbackCallback)==='function') {
                return this.adserverFallbackCallback();
            }
            this.adserverFallbackCallback = func;
        };
        this.cleanup = function() {
            var el = $('#'+this.advContainerId);
            if (!el.length) {
                this.fireEvent('breakcleanup');
                return;
            }
            this.fireEvent('beforecleanup', {ad:el.get(0)});
            if (!AdService.advContainerAlreadyClosed) {
                document.writeln('<\/div>');
            }
            AdService.advContainerAlreadyClosed = false;
            if (this.lastRequestedPosition) {
                if (!this.positions[this.lastRequestedPosition]._container) {
                    this.positions[this.lastRequestedPosition]._container = el;
                }
                if (this.positions[this.lastRequestedPosition]._callbacks) {
                    var callbacks = this.positions[this.lastRequestedPosition]._callbacks;
                    for (var i=0; i<callbacks.length; i++) {
                        try {
                            callbacks[i](el, this.lastRequestedPosition, this.positions[this.lastRequestedPosition]);
                        } catch(e) {
                        }
                    }
                }
            }
            if (el.length) {
                el.removeAttr('id');
                el.addClass(this.advContainerClass);
                var p = el.parent();
                if (this.lastAdMoveToPosition) {
                    $('script', el).remove();
                    this.fireEvent('movead', {target:this.lastAdMoveToPosition, ad:el.get(0)});
                    this._initPosition(this.lastAdMoveToPosition);
                    this.positions[this.lastAdMoveToPosition]._content = el;
                    el.remove();
                }
                var isempty = false;
                if (!$('>div.'+this.advContainerClass+'>*:not(script)', p).length) {
                    isempty = true;
                    if ($('>*:not(script)', p).length<=1) {
                        p.hide();
                    }
                } else {
                    p.show();
                }
                if ((this.positions[this.lastRequestedPosition]||{})._isPromotion && !isempty) {
                    el.before(this.advPromotionContent);
                }
            }
            this.fireEvent('cleanup');
            this.fireEvent('aftercleanup');
            this.lastRequestedType = null;
            this.lastRequestedPosition = null;
            this.lastAdMoveToPosition = null;
        };
        this.googleAd = function(conf) {
            if (!this.googleadsAllowed) { return; }
            for (var i in this.googleParams) {
                if (!this.googleParams.hasOwnProperty(i)) { continue; }
                if (conf[i]) { continue; }
                conf[i] = this.googleParams[i];
            }
            for (var i in conf) {
                if (!conf.hasOwnProperty(i)) { continue; }
                window['google_'+i] = conf[i];
            }
            this.lastRequestedType = 'google';
            document.writeln('<script type="text/javascript" src="//pagead2.googlesyndication.com/pagead/show_ads.js"><\/script>');
        };
        this.on('render:preparedata', function(data) {
            var render = data.render;
            $.each(render._splitlines, function(i, property) {
                var lineProperty = property + '_lines';
                render[lineProperty] = render[property].split(/\r\n|\r|\n|##br##/);
                for (var i=0, l=render[lineProperty].length; i<l; i++) {
                    render[lineProperty][i] = {
                        line:     render[lineProperty][i],
                        isLast:   render[lineProperty].length === i+1,
                        notLast:  render[lineProperty].length !== i+1,
                        isFirst:  i === 0,
                        notFirst: i !== 0
                    };
                }
            });
        });
        this.handleMessage = function(iframeWindow, adservice, data) {
            try {
                var method = (typeof this['_from_iframe_' + data.method] === 'function') ? '_from_iframe_' + data.method : data.method;
                if (typeof this[method] !== 'function') { return console.log('[AD SERVICE]', '[POST MESSAGE]', '[UNKNOWN METHOD]', method, data.arguments); }
                switch (method) {
                    case 'render':
                        var iframe = PostMessageHelper.getIframe(iframeWindow);
                        this[AdService._render ? '_render' : 'render'](data.arguments[0], $(iframe).parent());
                        $(iframe).hide();
                        break;
                    case 'createAd':
                    case 'setParam':
                    case 'setPositionParam':
                    case 'getParam':
                    case 'getPositionParam':
                    case 'disablePosition':
                    case 'adMeta':
                        AdService[method].apply(this, data.arguments);
                        break;
                    default:
                        console.log('[AD SERVICE]', '[POST MESSAGE]', '[METHOD NOT SUPPORTED]', method, data.arguments);
                }
            } catch(e) {
                console.error('[AD SERVICE]', '[ERROR]', '[HANDLE MESSAGE]', e, iframeWindow, adservice, data);
            }
        };
        PostMessageHelper.add('adservice', function() { AdService.handleMessage.apply(AdService, arguments); });
        PostMessageHelper.add('uimtag', function(sourceWindow, name, data) {
            var attributes = data.attributes;
            var pos = AdService.getPositionNameFromTagid(attributes.tagid);
            var uimTag  = AdService.createUimTag(attributes);
            var iframeContainer = document.querySelectorAll('[data-adservice-slot=' + pos + '] .adv-generic-container iframe');
            if (iframeContainer) {
                for (var i = 0; i < iframeContainer.length; i++) {
                    if (iframeContainer[i].before) {
                        iframeContainer[i].before(uimTag);
                    }
                }
            }
        });
        this.testCommunication = function(pos, name, value) {
            console.log('[AD SERVICE]', '[POST MESSAGE]', '[TEST COMMUNICATION]', pos + '/' + name + '/' + value);
        };
    };
})(jQuery);
AdService.on('init', function () {
    AdService.setPositions({
        available: {_disabled: true},
        rectangle: {tagid: 'prioad', _fallbackTagid: 'rectangle_info', _child: '> div', _width: 300, _height: 250, _adRefresh: true, _prebid: true, _pauseContentService: true},
        uniteaser: {tagid: 'rectangle_1', _fallbackTagid: 'rectangle_info', _disabled: true},
        rectangleEvent: {tagid: 'rectangle_1', wpt: 'h', 'iframe': '1', _disabled: true, _child: '> div', _prebid: true, _type: 'nfi'},
        rectangle_2: {'wpt': 'h', _prebid: true, _type: 'nfi', _adRefresh: true, 'sandbox': 'allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts'},
        rectangle_3: {'wpt': 'h', _prebid: true, _type: 'nfi', _adRefresh: true},
        sky_right: {_disabled: true, _prebid: true, _adRefresh: true},
        multiad:   { tagid: 'tam', pagevers: '1', _lazyLoad: true },
        box_1_1: {wpt: 'h', _type: 'nfi', _prebid: true},
        box_2_1: {wpt: 'h', _type: 'nfi', _prebid: true},
        box_3_1: {wpt: 'h', _type: 'nfi'},
        box_4_1: {wpt: 'h', _type: 'nfi'},
        box_5_1: {wpt: 'h', _type: 'nfi'},
        box_6_1: {wpt: 'h', _type: 'nfi'},
        box_7_1: {wpt: 'h', _type: 'nfi'},
        box_8_1: {wpt: 'h', _type: 'nfi'},
        box_9_1: {wpt: 'h', _type: 'nfi'},
        rectangle_layer: {_prebid: true, _child: '> div', _type: 'nfi'},
        bubble: { tagid: 'notification', _lazyLoad: true },
        notification: {}
    });
    AdService.setParam('dnt', (navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack) == 1 ? '1' : '0');
    if (window.PageConfig.sitespect) {
      AdService.setParam('special', window.PageConfig.sitespect.special);
    }
    AdService.on('beforerender', function (data) {
        data.render._splitlines = ['headline', 'subline'];
        if (data.render.count && typeof data.render.count === 'string') {
            data.render.count = [data.render.count];
        }
        if (data.render.clickcount && typeof data.render.clickcount === 'string') {
            data.render.clickcount = [data.render.clickcount];
        }
    });
        AdService.on('render', function(data) {
            if (data.render.clickcount && data.render.clickcount.length) {
                if (data.ad && data.ad.length) {
                    $('a', data.ad).click(function() {
                        for (var i = 0; i < data.render.clickcount.length; i++) {
                            try {
                                new Image(1, 1).src = data.render.clickcount[i];
                            } catch (e) { }
                        }
                    });
                } else {
                }
            }
        if (data.render.count && data.render.count.length) {
            for (var i = 0; i < data.render.count.length; i++) {
                try {
                    new Image(1, 1).src = data.render.count[i];
                } catch (e) {
                }
            }
        }
    });
    AdService.setServer(
        'info',
        $.extend({}, AdService.serverConf['adition-asp'], {
            baseAdserverUrl: '//info.gmx.net/lt?wpt=j&',
            baseRefreshUrl: '//info.gmx.net/lt?wpt=h&',
            baseIframeUrl: '//info.gmx.net/lt?wpt=h&',
            callbackSetparam: function (params) {
                if (params.tagid && params.tagid.indexOf('_info') < 0) {
                    params.tagid = params._fallbackTagid ? params._fallbackTagid : params.tagid + '_info';
                }
                if (params.hid) {
                    params.external_uid = params.hid;
                    params.uid_stable = '1';
                    params.uids = '1';
                }
                return params;
            }
        })
    );
    AdService.setServer(
        'united-infos',
        $.extend({}, AdService.serverConf['adition-asp'], {
            baseAdserverUrl: '//united-infos.net/lt?wpt=j&',
            baseRefreshUrl: '//united-infos.net/lt?wpt=h&',
            baseIframeUrl: '//united-infos.net/lt?wpt=h&',
            callbackSetparam: function (params) {
                if (params.tagid && params.tagid.indexOf('_united') < 0) {
                    params.tagid = params._fallbackTagid ? params._fallbackTagid.replace('_info', '_united') : params.tagid + '_united';
                }
                if (params.hid) {
                    params.external_uid = params.hid;
                    params.uid_stable = '1';
                    params.uids = '1';
                }
                return params;
            }
        })
    );
    AdService.setServer(
        'united-uimserv',
        $.extend({}, AdService.serverConf['adition-asp'], {
            baseAdserverUrl: '//united.uimserv.net/lt?wpt=j&',
            baseRefreshUrl: '//united.uimserv.net/lt?wpt=h&',
            baseIframeUrl: '//united.uimserv.net/lt?wpt=h&'
        })
    );
    AdService.setServer(
        'united-consent',
        $.extend({}, AdService.serverConf['adition-asp'], {
            baseAdserverUrl: '//united.uimserv.net/lt?wpt=j&',
            baseRefreshUrl: '//united.uimserv.net/lt?wpt=h&',
            baseIframeUrl: '//united.uimserv.net/lt?wpt=h&'
        })
    );
});
AdService.setTemplateEngine('mustache');
AdService.switchToInfoAdServer = function () {
    var unitedFallbackPercent = parseInt(window.PageConfig.unitedFallback, 10);
    unitedFallbackPercent = Number.isInteger(unitedFallbackPercent) && unitedFallbackPercent >= 0 && unitedFallbackPercent <= 100 ? unitedFallbackPercent : 0;
    var useUnitedInfos = (Math.random() * (100 - 0)) < unitedFallbackPercent || (getUrlParam('_useUnitedFallback') && getUrlParam('_useUnitedFallback') != 'false');
    if (useUnitedInfos) {
        AdService.serverConf._default = 'united-infos';
    } else {
        AdService.serverConf._default = 'info';
    }
    AdService.setParam('deviceclient', 'browser');
    AdService.setParam('wpt', 'j');
    AdService.setPositionParam('rectangleEvent', '_type', 'iframe');
    AdService.setPositionParam('rectangleEvent', '_disabled', false);
    AdService.setPositionParam('rectangle_layer', '_type', undefined);
    AdService.disablePosition('multiad');
    $('html').addClass('abd');
};
AdService.switchToUnitedUimservAdServer = function (fromConsentCheck) {
    if (fromConsentCheck) {
        AdService.serverConf._default = 'united-consent';
        return;
    }
    AdService.serverConf._default = 'united-uimserv';
    AdService.setPositionParam('rectangle_2', '_type', 'iframe');
    AdService.setPositionParam('rectangle_3', '_type', 'iframe');
    AdService.setPositionParam('rectangle_layer', '_type', undefined);
};
    AdService.addParamToAllPositions = function(keyValuePairs, exclude) {
        if (!(keyValuePairs instanceof Object)) { return; }
        var excludeUs = [];
        if (exclude !== undefined) {
            excludeUs = exclude instanceof Array ? exclude : [exclude];
        }
        var positionKeys = Object.keys(AdService.positions);
        var keys = Object.keys(keyValuePairs);
        for (var positionKeysIndex = 0; positionKeysIndex < positionKeys.length; positionKeysIndex++) {
            var positionKey = positionKeys[positionKeysIndex];
            if (excludeUs.indexOf(positionKey) === -1) {
                for (var keysIndex = 0; keysIndex < keys.length; keysIndex++) {
                    var key = keys[keysIndex];
                    AdService.setPositionParam(positionKey, key, keyValuePairs[key]);
                }
            }
        }
    };
    document.addEventListener('abDetectionDone', function () {
        var pub = window.consent.purposes.publisher.consents;
        var pubEmpty = Object.keys(pub).length === 0;
        if (parseInt(AdService.params.optout) !== 1) {
            var userID = PrebidConnector.getCookie('_autuserid2');
            if (!userID) {
                var aditionUserID = PrebidConnector.getAditionUserID();
                if (aditionUserID.length) {
                    PrebidConnector.setCookie('_autuserid2', aditionUserID);
                    if (!pubEmpty  && pub[1]) {
                        AdService.addParamToAllPositions({'userid': aditionUserID});
                    }
                }
            } else {
                if (!pubEmpty  && pub[1]) {
                    AdService.addParamToAllPositions({'userid': userID});
                }
            }
        } else {
            PrebidConnector.delete_cookie('_autuserid2');
        }
    }, false);
    $(document).ready(function () {
        var multiadTarget = document.getElementById('multiadContainer');
        AdService.createPosition('multiad', multiadTarget);
    });
BodyStarted.add(function () {
    if (!window.indexedDB) {
        return;
    }
    function handleDBError(status, errorName) {
        if (errorName === "InvalidStateError") {
            SiteInfo.prvMode = true;
            AdService.setParam('clean', '1');
            AdConstructor.createHiddenIframe('//adimg.uimserv.net/tam/cookie_dp.html');
        } else {
            SiteInfo.prvMode = false;
            AdService.setParam('clean', '0');
        }
    }
    if ($.ua.browser.name === 'firefox' && $.ua.browser.version >= 42) {
        try {
            var test = window.indexedDB.open('test');
            test.onerror = function (e) {
                var errorName = '';
                try {
                    errorName = e.target.error.name;
                } catch (e2) {
                }
                handleDBError(false, errorName);
                e.preventDefault && e.preventDefault();
                return false;
            };
            test.onsuccess = function (e) {
                handleDBError(true, '');
            };
        } catch (e) {
        }
    }
});
var escapeIframe = function (str) {
    return str.replace(escapeIframe.regexp.replace, "$1 data-iframe-url=$2$3$2");
};
escapeIframe.regexp = {
    check: /<iframe/i,
    replace: /(<iframe[^\uFFFF]*?)\s(?:src|data-iframe-url)\s*=\s*(['"]?)([^\s>]*?)\2/ig
};
var escapeIframeElement = function ($element) {
    $('iframe', $element).removeAttr('src');
};
var unescapeIframe = function (DOMElement, sandbox) {
    DOMElement = DOMElement ? DOMElement : 'body';
    $dataIframe = $('iframe[data-iframe-url]', DOMElement);
    if ($dataIframe.length) {
        $dataIframe.each(function () {
            var $this = $(this);
            if (!$this.is('[data-iframe-blocked]')) {
                var url = $this.attr('data-iframe-url');
                if ($this.attr('src') !== url) {
                    $this.attr('src', url);
                }
                if(sandbox) {
                    $this.attr('sandbox', sandbox);
                }
            }
        });
    }
};
$(window).on('contentloaded', function () {
    unescapeIframe();
});
document.write = function (str) {
    if (escapeIframe.regexp.check.test(str)) {
        try {
            str = escapeIframe(str);
        } catch (e) {
        }
    }
    document._write(str);
};
document.writeln = function (str) {
    if (escapeIframe.regexp.check.test(str)) {
        try {
            str = escapeIframe(str);
        } catch (e) {
        }
    }
    document._writeln(str);
};
var PrebidConnector = new function () {
    var self = this;
    this.version = 4;
    this.isInitialized = false;
    this.timeoutId = null;
    this.timeout = parseInt(getUrlParam('_prebidTimeout'), 10) || (window.PageConfig.prebid || {}).timeout || 1200;
    this.layerTimeout = parseInt(getUrlParam('_prebidLayerTimeout'), 10) || (window.PageConfig.prebid || {}).layerTimeout || 2000;
    this.iframeTimeout = parseInt(getUrlParam('_prebidIframeTimeout'), 10) || (window.PageConfig.prebid || {}).iframeTimeout || 700;
    this.isPrebidMeasurement = false;
    this.prebidMeasurementPixelTemplate = '//t.uimserv.net/drp_p/?evtid=925&mediaID=1022&site=%PORTAL%&region=de&sc=%TAGID%&att1=%TIME%&att2=%DEVICECLASS%&att3=%TYPE%&d=%TIMESTAMP%';
    document.addEventListener('afterInitialCleanup', function () {
        AdService.setPositionParam('rectangle', 'pb_timeout', PrebidConnector.iframeTimeout);
        var group = Math.floor(Math.random() * 100) <= 5;
        if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
            group = group || getUrlParam('prebidGroup') === 'true';
        }
        if (group
            && !document.querySelector('html').hasAttribute('data-abd')
            && !parseInt(AdService.params.optout)
            && AdService.params.consentLevel >= 2) {
            PrebidConnector.isPrebidMeasurement = true;
        }
    }, false);
    this.isAllowed = function () {
        var deviceclient = AdService.getParam('deviceclient');
        return !(AdService.isBlocked || AdService.isBlocked) && !((deviceclient === 'browser_clean') || (Array.isArray(deviceclient) && deviceclient.indexOf('browser_clean') >= 0));
    };
    this.basicParams = {
        portal: function () {
            return AdService.params.portal;
        },
        category: function () {
            return AdService.params.category;
        },
        section: function () {
            return AdService.params.section;
        },
        layoutclass: function () {
            return AdService.params.layoutclass;
        },
        external_uid: function () {
            return AdService.params.external_uid;
        },
        optout: function () {
            return AdService.params.optout;
        },
        consentlevel: function () {
            return AdService.params.consentLevel;
        },
        prioad: function () {
            return PageLayout.adType;
        },
        wi: function () {
            return AdService.params.wi;
        },
        timeout: function () {
            return PrebidConnector.iframeTimeout;
        },
        ts: function () {
            return (new Date()).getTime();
        }
    };
    this.addParam = function (key, value) {
        this.basicParams[key] = value;
    };
    this.createBiddingIframe = function (tagIds) {
        var iframe = document.createElement('iframe');
        var amazonDebug = getUrlParams('amzn_debug_mode');
        var prebidDebug = getUrlParams('_prebid_debug');
        var additionalParams = {
            tagids: tagIds.join(','),
            deviceclass: AdService.getParam('deviceclass'),
            deviceclient: AdService.getParam('deviceclient')
        };
        if (amazonDebug === '1') {
            additionalParams.amzn_debug_mode = '1';
        }
        if (PrebidConnector.isPrebidMeasurement) {
            additionalParams.prebidmessung = '1';
        }
        if (!(prebidDebug === undefined || prebidDebug === 'off')) {
            if (prebidDebug === 'on' || prebidDebug === 'uim') {
                additionalParams.debug = prebidDebug;
                if (prebidDebug === 'uim') {
                    additionalParams.pbjs_debug = true;
                }
            }
        }
        iframe.src = this.getIframeUrl(additionalParams);
        var target = document.querySelector('.statistics');
        target.appendChild(iframe);
        this.biddingIframe = iframe;
    };
    this.getIframeUrl = function (additionalParams) {
        var iframeUrl;
        var prebidDebug = getUrlParams('_prebid_debug');
        var useDevIframe = ['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1 && (prebidDebug === undefined || prebidDebug !== 'off');
        useDevIframe = useDevIframe || additionalParams.debug;
        if (useDevIframe) {
            iframeUrl = '//dl-preview.web.de/uim/bidding/pbjs_iframe_dev.html?';
        } else {
            iframeUrl = '//dl.gmx.' + (SiteInfo.country !== 'de' ? SiteInfo.country : 'net') + '/uim/bidding/pbjs_iframe_' + this.version + '.html?';
        }
        if (AdService.getPositionParam('rectangle', 'busterid')) {
            this.addParam('hpeventid', AdService.getPositionParam('rectangle', 'busterid'));
        }
        var params = $.extend({
            loadprioad: 1
        }, this.basicParams, additionalParams || {});
        return iframeUrl + this.getParamsString(params);
    };
    this.getParamsString = function (params) {
        var paramsArray = [];
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                if (typeof params[key] === 'function') {
                    paramsArray.push(key + '=' + params[key]());
                } else {
                    paramsArray.push(key + '=' + params[key]);
                }
            }
        }
        return paramsArray.join('&');
    };
    this.stopTimeoutIfNotNecessary = function () {
        if (Object.keys(PrebidConnector.slotsInProgress).length === 0) {
            window.clearTimeout(this.timeoutId);
        }
    };
    this.biddingIframe = null;
    this.biddingCallback = null;
    this.firstBiddingStarted = null;
    this.firstBiddingFirstResponse = null;
    this.whenFirstResponseSaveDate = function () {
        if (!this.firstBiddingFirstResponse) {
            this.firstBiddingFirstResponse = new Date();
        }
    };
    this.slotsInProgress = {};
    this.startBidding = function (positions, timeout, callback) {
        timeout = timeout || this.timeout;
        if (!PrebidConnector.isAllowed()) {
            return;
        }
        var tagids = [];
        for (var i = 0; i < positions.length; i++) {
            var isDisabled = AdService.getPositionParam(positions[i], '_disabled');
            var biddingAllreadyStarted = AdService.getPositionParam(positions[i], '_prebidBiddingStarted');
            if (typeof this.slotsInProgress[positions[i]] === 'undefined') {
                this.slotsInProgress[positions[i]] = callback;
            }
            if (!isDisabled && !biddingAllreadyStarted) {
                tagids.push(AdService.getTagid(positions[i]));
                AdService.setPositionParam(positions[i], '_prebidBiddingStarted', true);
            }
        }
        if (!tagids.length) {
            return;
        }
        if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
            console.log('[PREBID]', '[START]', '[TAG IDS / POSITIONS]', JSON.stringify(tagids) + ' / ' + JSON.stringify(positions));
        }
        if (!this.biddingIframe) {
            this.createBiddingIframe(tagids);
            this.firstBiddingStarted = new Date();
        } else {
            PostMessageHelper.send(this.biddingIframe, {
                name: 'startBidding',
                data: {
                    tagids: tagids,
                    prioad: PageLayout.adType
                }
            });
        }
        if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
            console.log('[PREBID]', '[TIMEOUT]', '[START]', JSON.stringify(tagids) + ' / Timeout: ' + this.timeout + 'ms');
        }
        this.timeoutId = window.setTimeout(function () {
            if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
                console.log('[PREBID]', '[TIMEOUT]', '[END]', JSON.stringify(tagids) + ' / ' + JSON.stringify(Object.keys(PrebidConnector.slotsInProgress)));
            }
            PrebidConnector.whenFirstResponseSaveDate();
            PrebidConnector.finishSlots();
            if (typeof PrebidConnector.biddingCallback === 'function') {
                PrebidConnector.biddingCallback();
                PrebidConnector.biddingCallback = null;
            }
        }, timeout);
    };
    this.fireMeasurementPixel = function (position, portal, start) {
        var time = new Date().getTime() - htmlStart;
        var replacements = {
            '%PORTAL%': portal,
            '%TAGID%': AdService.getTagid(position),
            '%TIME%': time + '',
            '%DEVICECLASS%': AdService.getParam('deviceclass'),
            '%TYPE%': start ? 'init' : 'render',
            '%TIMESTAMP%': new Date().getTime() + ''
        };
        var pixelSrc = PrebidConnector.prebidMeasurementPixelTemplate.replace(/%\w+%/g, function (all) {
            return replacements[all] || all;
        });
        var pixel = new Image();
        pixel.src = pixelSrc;
        if (start) {
            AdService.positions[position].startMeasurePixelFired = true;
        } else {
            AdService.positions[position].endMeasurePixelFired = true;
        }
    };
    this.finishSlots = function () {
        var slots = Object.keys(this.slotsInProgress);
        for (var i = 0; i < slots.length; i++) {
            this.finishSlot(slots[i]);
        }
    };
    this.finishSlot = function (positionName) {
        if (this.slotsInProgress.hasOwnProperty(positionName)) {
            AdService.setPositionParam(positionName, '_prebidBiddingEnded', true);
            if (typeof this.slotsInProgress[positionName] === 'function') {
                this.slotsInProgress[positionName](positionName);
            } else {
                if (typeof ContentService.ads[positionName] !== 'undefined') {
                    ContentService.createPosition(positionName, ContentService.ads[positionName], { _highPriority: true });
                } else {
                }
            }
            delete this.slotsInProgress[positionName];
            var componentCreatedEvent = new CustomEvent (positionName + ':created', { bubbles: true, cancelable: true });
            document.querySelector('body').dispatchEvent(componentCreatedEvent);
        }
    };
    function getUrlParams(param) {
        var results = new RegExp('[\?&]' + param + '=([^]*)').exec(window.location.href);
        if (results === null) {
            return null;
        } else {
            return results[1] || 0;
        }
    }
    this.resetPosition = function (positionName) {
        try {
            if (AdService.positions[positionName]) {
                for (var key in AdService.positions[positionName]) {
                    if (AdService.positions[positionName].hasOwnProperty(key)) {
                        if (key.indexOf('pb_') === 0) {
                            delete AdService.positions[positionName][key];
                        }
                    }
                }
            }
            AdService.setPositionParam(positionName, '_biddingHtml', null);
            AdService.setPositionParam(positionName, '_prebidBiddingStarted', null);
            AdService.setPositionParam(positionName, '_prebidBiddingEnded', null);
        } catch (e) {
        }
    };
    this.initPostMessages = function () {
        PostMessageHelper.add('gotOffer', function (sourceWindow, name, data) {
            if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
                console.log('[PREBID]', '[OFFER]', '[RECEIVED]', data.tagid);
            }
            if (data.tagid) {
                PrebidConnector.whenFirstResponseSaveDate();
                var position = AdService.getPositionNameFromTagid(data.tagid);
                AdService.setPositionParam(position, 'pb_vers', PrebidConnector.version);
                if (data.params) {
                    for (var key in data.params) {
                        if (data.params.hasOwnProperty(key)) {
                            AdService.setPositionParam(position, key, data.params[key]);
                        }
                    }
                }
                if (data.html) {
                    AdService.setPositionParam(position, '_biddingHtml', data.html);
                }
                PrebidConnector.finishSlot(position);
                PrebidConnector.stopTimeoutIfNotNecessary();
            }
        });
        PostMessageHelper.add('noOffer', function (sourceWindow, name, data) {
            if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
                console.log('[PREBID]', '[OFFER]', '[MISSING]', data.tagid);
            }
            if (data.tagid) {
                PrebidConnector.whenFirstResponseSaveDate();
                var position = AdService.getPositionNameFromTagid(data.tagid);
                PrebidConnector.finishSlot(position);
                PrebidConnector.stopTimeoutIfNotNecessary();
            }
        });
        PostMessageHelper.add('getHtml', function (sourceWindow, name, data) {
            if (['qa-ba', 'qa-bs', 'dev'].indexOf(SiteInfo.stage) !== -1) {
                console.log('[PREBID]', '[POST MESSAGE]', '[HTML]', data.tagid);
            }
            if (data.tagid) {
                var html = AdService.getPositionParam(AdService.getPositionNameFromTagid(data.tagid), '_biddingHtml');
                if (html) {
                    sourceWindow.postMessage(JSON.stringify({
                        name: 'renderHtml',
                        data: {
                            tagid: data.tagid,
                            html: html
                        }
                    }), '*');
                    PostMessageHelper.send(PrebidConnector.biddingIframe, {
                        name: 'successBidding',
                        tagid: data.tagid
                    });
                }
            }
        });
    };
    this.setCookie = function (name, value) {
        if (typeof value !== undefined) {
            var expires = new Date((new Date()).getTime() + 10950 * 1000 * 60 * 60 * 24);
            var domain = '';
                    domain = '.gmx.' + SiteInfo.tld;
            document.cookie = name + "=" + (value || "") + '; expires=' + expires + "; domain=" + domain + "; path=/";
        }
    };
    this.delete_cookie = function (name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    this.getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };
    this.getAditionUserID = function () {
        var pub = window.consent.purposes.publisher.consents;
        var pubEmpty = Object.keys(pub).length === 0;
        if (!pubEmpty  && pub[1]) {
            var request = new XMLHttpRequest();
            var adURL = '';
            switch (document.querySelector('html').getAttribute('data-abd')) {
                case 'indirect':
                    adURL = 'united.uimserv.net';
                    break;
                case 'direct':
                    if (AdService.serverConf._default === 'info') {
                        adURL = 'info.gmx.' + SiteInfo.tld;
                    } else {
                        adURL = 'united-infos.net'
                    }
                    break;
                default:
                    adURL = 'ad11.adfarm1.adition.com';
                    break;
            }
            var url = 'https://' + adURL + '/i?raw=1&ts=' + (new Date()).getTime();
            request.open('GET', url, false);
            request.withCredentials = true;
            request.send(null);
            if (request.status === 200) {
                return request.responseText;
            }
        }
        return false;
    }
};
PrebidConnector.initPostMessages();
window.AdConstructor = new function () {
    this.globalDefaults = {
        target: '_blank',
        offsetXAllowed: [0, 0],
        offsetYAllowed: [0, 0],
        rtbLoading: false,
        rtbTimeout: 2000,
        rtbTimeoutCallback: undefined,
        callbacks: {},
        postMessage: false,
        postMessageEvents: {}
    };
    this.Components = this.Components || {};
    this.postMessageOrigins = [];
    this.createdComponents = {};
    this.createdComponentsData = {};
    this.currentCount = 0;
    this.counter = 0;
    this.initAd = function (data, meta) {
        this.createComponents(data, meta);
    };
    this.stickyAllowed = function () {
        return !PageLayout._isSmallScreen;
    };
    this._getValueList = function (list) {
        list = $.makeArray(list);
        list.push($.extend({}, this.globalDefaults));
        var items = $.extend.apply($, list.reverse());
        if (!(items.offsetXAllowed instanceof Array)) {
            items.offsetXAllowed = [-items.offsetXAllowed, items.offsetXAllowed];
        }
        if (!(items.offsetYAllowed instanceof Array)) {
            items.offsetYAllowed = [-items.offsetYAllowed, items.offsetYAllowed];
        }
        var urlItems = ['clickUrl', 'iframeUrl', 'bgUrl'];
        for (var i = 0; i < urlItems.length; i++) {
            if (items[urlItems[i]]) {
                if (typeof(items[urlItems[i]]) === 'object') {
                    items[urlItems[i]] = $.param(items[urlItems[i]]);
                }
                items[urlItems[i]] = items[urlItems[i]].replace(
                    /(?:\{|%7[bB])(\w+)(?:\}|%7[dD])/g,
                    function (all, item) {
                        return items[item] ? escape(items[item]) : '';
                    }
                );
            }
        }
        return items;
    };
    this.registerComponent = function (keys, callback) {
        if (!(keys instanceof Array)) {
            keys = [keys];
        }
        for (var i = 0; i < keys.length; i++) {
            AdConstructor.Components[keys[i]] = callback;
        }
    };
    this.createComponents = function (data, meta) {
        AdConstructor.counter++;
        data = data ? data : {};
        meta = meta ? meta : {};
        if (typeof data.components !== 'undefined') {
            var layoutConfig = $.extend({}, PageLayout.config);
            layoutConfig.adType = data.type ? data.type : layoutConfig.adType;
            layoutConfig.adVariant = data.variant ? data.variant : layoutConfig.adVariant;
            data = $.extend(true, {
                refreshLayout: true
            }, AdConstructor.globalDefaults, data);
            if (data.rtbLoading) {
                $('body').addClass('rtb-loading');
                this.rtbTimeout = window.setTimeout(function () {
                    AdConstructor.stopRtbTimeout();
                    if (typeof data.rtbTimeoutCallback === 'function') {
                        data.rtbTimeoutCallback();
                    }
                }, data.rtbTimeout);
            }
            AdConstructor.countComponentType = 'richmedia';
            $.each(data.components, function (key, componentData) {
                componentData = AdConstructor._getValueList([componentData, data]);
                componentData._key = key;
                if (PageLayout._isSmallScreen) {
                    componentData.sticky = false;
                }
                if (typeof AdConstructor.Components[key] === 'function') {
                    AdConstructor.Components[key](key, componentData, layoutConfig, data);
                }
            });
            if (data.refreshLayout) {
				PageLayout.adInit(layoutConfig);
				if(layoutConfig.adType === 'sky_right') {
					var refreshTimes = 40;
					var i = 0;
					var refresher = setInterval( function () {
						if(i >= refreshTimes) {
							clearInterval(refresher);
						}
						PageLayout.forceRefresh();
						i++;
					}, 50);
				}
            }
            if ($('.ad-component img[data-image-src]').length) {
                PageLayout.onchange(function (alignment, cols, border) {
                    AdConstructor.requestMultipleFallback(cols, border);
                });
                window.requestAnimationFrame(function () {
                    AdConstructor.requestMultipleFallback(parseInt(PageState.get('cols')), PageState.get('border'));
                });
            }
            if (typeof data.components.bg !== 'undefined') {
                if (layoutConfig.htmlClass.indexOf('adWithOutsideComponent') !== -1 || ['billboard', 'cinematic'].indexOf(data.type) !== -1) {
                    var backgroundData = AdConstructor._getValueList([data.components.bg, data]);
                    if ((typeof data.components.skyright !== 'undefined'
                        || typeof data.components.sitebar !== 'undefined')
                        && (typeof data.components.skyleft === 'undefined'
                            && typeof data.components.superbanner === 'undefined')) {
                        AdConstructor.createPageBackground(backgroundData, 'right');
                    } else {
                        AdConstructor.createPageBackground(backgroundData, 'fullsize');
                    }
                    if (data.type === 'sitebar' && typeof data.components.billboard !== 'undefined') {
                        AdConstructor.createComponentBackground(data.components.bg, AdConstructor.createdComponents['billboard']);
                    }
                    if (typeof data.components.skyleft !== 'undefined' && data.components.skyleft.widthVariant === 'dynamic') {
                        var backgroundData = AdConstructor._getValueList([data.components.bg, data]);
                        AdConstructor.createComponentBackground(backgroundData, AdConstructor.createdComponents['skyleft']);
                    }
                    if (typeof data.components.skyright !== 'undefined' && data.components.skyright.widthVariant === 'dynamic') {
                        var backgroundData = AdConstructor._getValueList([data.components.bg, data]);
                        AdConstructor.createComponentBackground(backgroundData, AdConstructor.createdComponents['skyright']);
                    }
                    if (typeof data.components.sitebar !== 'undefined') {
                        var backgroundData = AdConstructor._getValueList([data.components.bg, data]);
                        AdConstructor.createComponentBackground(backgroundData, AdConstructor.createdComponents['sitebar']);
                    }
                } else if (typeof AdConstructor.createdComponents['maxiad'] !== 'undefined') {
                    AdConstructor.createComponentBackground(data.components.bg, AdConstructor.createdComponents['maxiad']);
                }
            }
            if (data.count) {
                AdConstructor.count(data.count);
            }
            if (data.trackingIframeUrl) {
                AdConstructor.count(data.trackingIframeUrl, 'iframe');
            }
            if (data.postMessage) {
                $(window).on('message', function (e) {
                    if (AdConstructor.postMessageOrigins.indexOf(e.originalEvent.origin) === -1) {
                        return;
                    }
                    var eventName = e.originalEvent.data;
                    if (data.postMessageEvents && typeof data.postMessageEvents[eventName] !== 'undefined') {
                        if (typeof data.postMessageEvents[eventName].callback === 'function') {
                            data.postMessageEvents[eventName].callback(data);
                        } else if (typeof data.postMessageEvents[eventName].callback === 'string' && typeof data.callbacks[data.postMessageEvents[eventName].callback] === 'function') {
                            data.callbacks[data.postMessageEvents[eventName].callback](data);
                        } else {
                        }
                        if (data.postMessageEvents[eventName].onlyOnce) {
                            delete data.postMessageEvents[eventName];
                        }
                    } else if (['uimBillboardOpen',
                        'uimBillboardClose',
                        'uimHalfpageOpen',
                        'uimHalfpageClose',
                        'uimSuperbannerOpen',
                        'uimSuperbannerClose',
                        'uimSkyrightOpen',
                        'uimSkyrightClose'].indexOf(eventName) !== -1) {
                        switch (eventName) {
                            case 'uimBillboardOpen':
                                AdConstructor.expandComponent('billboard');
                                break;
                            case 'uimBillboardClose':
                                AdConstructor.collapseComponent('billboard');
                                break;
                            case 'uimHalfpageOpen':
                                AdConstructor.expandComponent('halfpage');
                                break;
                            case 'uimHalfpageClose':
                                AdConstructor.collapseComponent('halfpage');
                                break;
                            case 'uimSuperbannerOpen':
                                AdConstructor.expandComponent('superbanner');
                                break;
                            case 'uimSuperbannerClose':
                                AdConstructor.collapseComponent('superbanner');
                                break;
                            case 'uimSkyrightOpen':
                                AdConstructor.expandComponent('skyright');
                                break;
                            case 'uimSkyrightClose':
                                AdConstructor.collapseComponent('skyright');
                                break;
                        }
                    } else if (data.postMessageData && typeof data.postMessageData[eventName] !== 'undefined') {
                        e.originalEvent.source.postMessage(eventName + '=' + JSON.stringify(data.postMessageData[eventName]), '*');
                    } else {
                    }
                });
            }
            if ((AdService.lastRequestedPosition === null || AdService.lastRequestedPosition === 'rectangle') && AdConstructor.counter === 1) {
                $('#adRectangle').removeClass('empty');
                AdService.fireEvent('adconstructor:prioad_created', data);
                var createBubble = new CustomEvent ('create_bubble', { bubbles: true, cancelable: true });
                document.querySelector('body').dispatchEvent(createBubble);
                if (data.type !== 'rectangle') {
                    if (!$('html').attr('id')) {
                        $('html').attr('id', 'prioad');
                    }
                }
                $('html').attr('data-prioad-type', data.type);
            }
        }
    };
    this.stopRtbTimeout = function () {
        if (AdConstructor.rtbTimeout) {
            window.clearTimeout(AdConstructor.rtbTimeout);
        }
        $('body').removeClass('rtb-loading');
    }
    this.requestMultipleFallback = function (cols, border) {
        var $multipleFallbackImages = $('.ad-component img[data-image-src]');
        var currentClass = 'col' + cols + (border ? 'border' : '');
        $multipleFallbackImages.filter('.' + currentClass).each(function () {
            var $this = $(this);
            $this.attr('src', $this.attr('data-image-src')).removeAttr('data-image-src');
        });
    };
    this.createHiddenIframe = function (iframeUrl, target) {
        var $div = $('<div />').css({
            width: 0,
            height: 0,
            position: 'absolute',
            left: '-999em',
            overflow: 'hidden'
        });
        $(target ? target : '.statistics').prepend($div);
        $div.append(AdConstructor.createComponentIframe({iframeUrl: iframeUrl, height: '1', width: '1'}));
    };
    this.repositionDynamicSky = function (key) {
        if (key === 'skyleft') {
            AdConstructor.createdComponents[key].css('marginRight', '50%');
            AdConstructor.createdComponents[key].css('right', PageLayout.getContentWidth() / 2);
        } else {
            var pageAlignment = document.querySelector('html').getAttribute('data-col-left');
            if (pageAlignment === 'true') {
                AdConstructor.createdComponents[key].css({
                    marginLeft: 0,
                    left: PageLayout.getContentWidth() + PageLayout.config.narrow.left
                });
            } else {
                AdConstructor.createdComponents[key].css({
                    marginLeft: '50%',
                    left: PageLayout.getContentWidth() / 2
                });
            }
        }
    };
    this.repositionStickySky = function (key, pageAlignment) {
        var htmlMismatch = parseInt($('body').css('marginRight'), 10) - parseInt($('body').css('marginLeft'), 10);
        var bodyMismatch = parseInt($('body').css('paddingRight'), 10) - parseInt($('body').css('paddingLeft'), 10);
        if (key === 'skyleft') {
            var realMarginRight = $('.wrapper-center.first').innerWidth() / 2 - 0.4;
            var marginRight = realMarginRight - bodyMismatch / 2 + htmlMismatch / 2;
            AdConstructor.createdComponents[key].css('marginRight', marginRight);
            $('> .ad-component-inner', AdConstructor.createdComponents[key]).css('marginRight', marginRight);
        } else {
            var containerWidth = $('.wrapper-center.first').innerWidth();
            var marginLeft = Math.floor(containerWidth / 2 + 0.4 - bodyMismatch / 2 - htmlMismatch / 2);
            AdConstructor.createdComponents[key].css('marginLeft', marginLeft);
            $('> .ad-component-inner', AdConstructor.createdComponents[key]).css('marginLeft', marginLeft);
        }
    };
    this.calcStickySkyWidth = function (key, componentData) {
        var width = 0;
        if (typeof componentData.width !== 'undefined' && componentData.width !== '100%' && componentData.width !== 'auto') {
            width = componentData.width;
        } else {
            var windowWidth = $(window).innerWidth();
            var containerWidth = $('.wrapper-center.first').innerWidth();
            var maxSkyWidth = (windowWidth - containerWidth) / 2;
            if (maxSkyWidth > componentData.maxWidth) {
                width = componentData.maxWidth;
            } else if (maxSkyWidth < componentData.minWidth) {
                width = componentData.minWidth;
            } else {
                width = maxSkyWidth;
            }
        }
        $('> .ad-component-inner', AdConstructor.createdComponents[key]).css('width', width);
    };
    this.createPageBackgroundContainer = function (data) {
        data = $.extend({
            target: '_blank'
        }, data);
        var backgroundRepeat = {'-': 'no-repeat', x: 'repeat-x', y: 'repeat-y', xy: 'repeat'};
        var $background = $('<div class="ad-background"></div>');
        if (data.globalColor) {
            $('body').css('background-color', data.globalColor);
        }
        if (data.color) {
            $background.css('background-color', data.color);
        }
        if (data.image) {
            $background.css('background-image', 'url(' + data.image + ')');
        }
        if (data.repeat) {
            $background.css('background-repeat', backgroundRepeat[data.repeat] ? backgroundRepeat[data.repeat] : 'no-repeat');
        }
        if (data.offsetX || data.offsetY) {
            $background.css('background-position', (data.offsetX || 0) + 'px ' + (data.offsetY || 0) + 'px');
        }
        if (data.size) {
            $background.css('background-size', data.size);
        }
        if (data.attachment) {
            $background.css('background-attachment', data.attachment);
        }
        if (data.clickUrl) {
            $background.append(Mustache.render('<a href="{{clickUrl}}" target="{{target}}"></a>', data));
        }
        if (data.height) {
            $background.css('height', data.height);
        }
        if (data.image2col || data.image3col || data.image4col) {
            PageLayout.onchange(function (alignment, cols) {
                if (data['image' + cols + 'col']) {
                    $background.css('background-image', 'url(' + data['image' + cols + 'col'] + ')');
                } else if (data.image) {
                    $background.css('background-image', 'url(' + data.image + ')');
                } else {
                    $background.css('background-image', 'none');
                }
            });
        }
        return $background;
    };
    this.createComponentBackgroundContainer = function (data) {
        data = $.extend({
            target: '_blank'
        }, data);
        var $background = $('<div class="ad-background"></div>');
        if (data.clickUrl) {
            $background.append(Mustache.render('<a href="{{clickUrl}}" target="{{target}}"></a>', data));
        }
        if (data.height) {
            $background.css('height', data.height);
        }
        return $background;
    }
    this.createPageBackground = function (data, position) {
        var $background = this.createPageBackgroundContainer(data);
        switch (position) {
            case 'right':
                $background.css({
                    top: 0,
                    right: 0,
                    left: '50%',
                    marginLeft: $('.wrapper-center.first').width() / 2 + ($('body').css('paddingRight') / 2)
                });
                PageLayout.onchange(function () {
                    $background.css('marginLeft', $('.wrapper-center.first').width() / 2 + ($('body').css('paddingRight') / 2));
                });
                break;
            case 'fullsize':
            default:
                $background.css({
                    top: 0,
                    right: 0,
                    left: 0
                });
                break;
        }
        $('body').prepend($background);
    };
    this.createComponentBackground = function (data, $component) {
        var $background = this.createComponentBackgroundContainer(data);
        $background.css({
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
        });
        $('.ad-component-inner', $component).prepend($background);
    };
    this.addComponent = function ($container, type, data) {
        var containerCss = {};
        switch (type) {
            case 'fallback':
                $container.append(this.createComponentFallback(data));
                containerCss.width = data.fallbackWidth ? data.fallbackWidth : data.width;
                containerCss.height = data.fallbackHeight ? data.fallbackHeight : data.height;
                break;
            case 'iframe':
                $container.append(this.createComponentIframe(data));
                containerCss.width = data.width;
                containerCss.height = data.height;
                if (data.postMessage) {
                    var urlComponents = data.iframeUrl.match(/^(https?:)?(\/\/[^/]+)/);
                    if (!urlComponents) {
                        urlComponents = ['', location.protocol, '//' + location.host];
                    }
                    if (!urlComponents[1]) {
                        urlComponents[1] = window.location.protocol;
                    }
                    var url = urlComponents[1] + urlComponents[2];
                    if (AdConstructor.postMessageOrigins.indexOf(url) === -1) {
                        AdConstructor.postMessageOrigins.push(url);
                    }
                }
                break;
            case 'script':
                break;
        }
        if (data.maxWidth) {
            containerCss.maxWidth = data.maxWidth;
        }
        if (data.minWidth) {
            containerCss.minWidth = data.minWidth;
        }
        if (data.maxHeight) {
            containerCss.maxHeight = data.maxHeight;
        }
        if (data.minHeight) {
            containerCss.minHeight = data.minHeight;
        }
        $container.css(containerCss);
        return $container;
    };
    this.createComponentFallback = function (data) {
        if (typeof data.fallback !== 'undefined') {
            if (typeof data.fallback === 'string') {
                data.fallbackWidth = data.fallbackWidth ? data.fallbackWidth : data.width;
                data.fallbackHeight = data.fallbackHeight ? data.fallbackHeight : data.height;
                return Mustache.render('<a href="{{clickUrl}}" target="{{target}}"><img src="{{fallback}}" alt="{{alt}}" width="{{fallbackWidth}}" height="{{fallbackHeight}}"/></a>', data);
            } else if (data.fallback.crop) {
                return Mustache.render('<a href="{{clickUrl}}" target="{{target}}" class="cropping-fallback" style="background-image: url({{fallback.crop}})"></a>', data);
            } else {
                if (!(data.type === 'billboard' && data.variant === 'default')) {
                    data.fallbackWidth = '100%';
                }
                data = $.extend({id: 'fallback-' + data._key}, data);
                var html = '';
                var additionalClasses = [];
                var fallbackOrder = ['col4', 'col4border', 'col3', 'col3border', 'col2'];
                for (var i = 0; i < fallbackOrder.length; i++) {
                    additionalClasses.push(fallbackOrder[i]);
                    var currentImage = data.fallback[fallbackOrder[i]];
                    if (currentImage) {
                        var imageData = $.extend({
                            alt: data.alt,
                            height: data.fallbackHeight || data.height,
                            classes: additionalClasses.join(' ')
                        }, currentImage);
                        html += Mustache.render('<img data-image-src="{{url}}" alt="{{alt}}" width="{{width}}" height="{{height}}" class="{{classes}}"/>\n', imageData);
                        additionalClasses = [];
                    }
                }
                html = Mustache.render('<a id="{{id}}" href="{{clickUrl}}" target="{{target}}" class="ad-multiple-fallback">', data) + html + '</a>';
                return html;
            }
        }
    };
    this.createComponentIframe = function (data) {
        if (data.escapeIframe) {
            return Mustache.render('<iframe data-iframe-url="{{iframeUrl}}" width="{{width}}" height="{{height}}"{{#name}} name="{{name}}"{{/name}} border="0" background="transparent" allowtransparency="true" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" noresize="noresize"></iframe>', data);
        } else {
            return Mustache.render('<iframe src="{{iframeUrl}}" width="{{width}}" height="{{height}}"{{#name}} name="{{name}}"{{/name}} border="0" background="transparent" allowtransparency="true" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" noresize="noresize"></iframe>', data);
        }
    };
    this.createComponentScript = function (data) {
        var el = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(el);
        postscribe(el, '<script src="' + data.script + '"><\/script>');
        return el;
    };
    this.createComponent = function (key, data) {
        var data = $.extend(true, {
            showFallback: false,
            escapeIframe: false,
            blockIframe: false,
            initialVisible: true,
            innerMinWidth: false,
            innerMaxWidth: false,
            innerHeight: false,
            insideContent: false,
            position: {
                translate: {
                    x: 0,
                    y: 0
                }
            },
            zIndex: false,
            sticky: false,
            expandable: false,
            offsetTarget: 'componentInner',
            onInit: false,
            closer: false,
            closeCallback: false,
            autoclose: false,
            closeOnClick: false,
            name: 'iframe_' + key,
            noGap: false
        }, data);
        if (data.virtual) {
            AdConstructor.createdComponentsData[key] = data;
            AdConstructor.createdComponents[key] = $('<div class="dummy"></div>');
        }
        var actualWidth = data.componentWidth;
        var $component = $(Mustache.render('<div class="ad-component{{#_key}} ad-component-{{_key}}{{/_key}}{{#type}} ad-type-{{type}}{{#variant}} ad-variant-{{variant}}{{/variant}}{{/type}}{{#insideContent}} inside-content{{/insideContent}}{{#sticky}} ad-component-sticky{{/sticky}}{{#expandable}} ad-component-expandable{{/expandable}}"><div class="ad-component-inner"></div></div>', data)).css({
            width: actualWidth ? actualWidth : (data.width ? data.width : '100%'),
            height: data.componentHeight ? data.componentHeight : (data.height ? data.height : '100%')
        });
        if (data.minHeight) {
            $component.css({
                minHeight: data.minHeight
            });
        }
        if (data.componentWidth === '100%' && ['dynamic', 'inner'].indexOf(data.widthVariant) === -1) {
            $component.addClass('ad-component-width-fullwidth');
        } else if (data.widthVariant == 'dynamic') {
            $component.addClass('ad-component-width-dynamic');
        } else if (data.widthVariant == 'inner') {
            $component.addClass('ad-component-width-inner');
        }
        if (PageLayout._isSmallScreen) {
            data.sticky = false;
        }
        var $componentInner = $('.ad-component-inner', $component);
        if (data.innerMaxWidth) {
            AdConstructor.setWidth($componentInner, 'maxWidth', data.innerMaxWidth);
        }
        if (data.innerMinWidth) {
            AdConstructor.setWidth($componentInner, 'minWidth', data.innerMinWidth);
        }
        if (data.innerHeight) {
            AdConstructor.setWidth($componentInner, 'height', data.innerHeight);
        }
        if (data.innerWidth) {
            AdConstructor.setWidth($componentInner, 'width', data.innerWidth);
        }
        if (data.backgroundLink) {
            if (data.bgClickUrl) {
                $componentInner.append(Mustache.render('<a href="{{bgClickUrl}}{{^bgClickUrl}}{{clickUrl}}{{/bgClickUrl}}" target="_blank" class="background-color" style="{{#bgColor}}background-color: {{bgColor}};{{/bgColor}}"></a>', data));
            } else {
                $componentInner.append(Mustache.render('<span class="background-color" style="{{#bgColor}}background-color: {{bgColor}};{{/bgColor}}"></span>', data));
            }
        }
        if (data.align) {
            $componentInner.addClass('align-' + data.align);
        }
        var noPremiumLounge = !(data.type === 'maxiframe' && data.variant === 'premiumlounge');
        var deviceclient = AdService.getParam('deviceclient');
        if (data.script) {
        } else if (data.dom) {
            $('script', data.dom).remove();
            $componentInner.append(data.dom);
        } else if (
            ((((SiteInfo.prvMode || ((deviceclient === 'browser_clean') || (Array.isArray(deviceclient) && deviceclient.indexOf('browser_clean') >= 0))) && !AdConstructor.isUimIframe(data))
            || (typeof data.showFallback === 'function' && data.showFallback(data))
            || !data.iframeUrl
            || ($.ua.browser.msie <= 10 || ($.ua.os.name === 'ios' && $.ua.os.version.major <= 10) || ($.ua.os.name === 'android' && $.ua.os.version.major <= 5)))
            && noPremiumLounge)
        ) {
            AdConstructor.countComponentType = 'fallback';
            var $fallback = $('<div class="fallback"/>').appendTo($componentInner);
            $fallback.on('click', function() {
                AdConstructor.count(data.count.fallbackClick);
            });
            if (Array.isArray(data.polite) && data.polite.length >= 2) {
                var fallbackPoliteType = data.polite[1];
                var politeSettings = $.extend(
                    {},
                    typeof fallbackPoliteType === 'string' && typeof this.politeDefaults[fallbackPoliteType] === 'object' ? this.politeDefaults[fallbackPoliteType] : this.politeDefaults.animation,
                    data.polite === true ? {} : data.polite
                );
                var $loading, loadingTimeout;
                if (politeSettings.loading) {
                    if (politeSettings.loading === true && data._key !== 'layer') {
                        politeSettings.loading = this.politeDefaults.loadingImage;
                    }
                    var loaderTemplate = '<span class="loading"></span>';
                    $loading = $(Mustache.render(loaderTemplate, data)).css('background-image', 'url(' + politeSettings.loading + ')');
                    $componentInner.prepend($loading);
                    var fallbackPixel = '';
                    if (data.count.politeClick) {
                        fallbackPixel = Array.isArray(data.count.politeClick) ? data.count.politeClick : data.count.politeClick.fallback;
                    }
                    if (fallbackPixel) {
                        $loading.on('click', function() {
                            AdConstructor.count(fallbackPixel);
                        });
                    }
                }
                var finished = (function ($componentInner, data) {
                    return function () {
                        AdConstructor.addComponent($('.main', $componentInner), 'iframe', data);
                        $('.loading', $componentInner).remove();
                        $componentInner.removeClass('politeFallback');
                        window.clearTimeout(loadingTimeout);
                    }
                })($componentInner, data);
                var timeout = window.setTimeout(function () {
                    finished();
                    $(window).off('load', finished);
                }, politeSettings.delay);
                $(window).on('load', finished);
                $(window).on('load', function () {
                    window.clearTimeout(timeout);
                });
            }
            $componentInner = this.addComponent($fallback, 'fallback', data);
        } else if (data.polite && (data.polite === 'string' && !data.polite.inactive && noPremiumLounge || (data.polite.length && data.polite[0].trim().length > 0))) {
            var $main = $('<div class="main" />').appendTo($componentInner);
            var $fallback = $('<div class="polite-fallback" />').appendTo($componentInner);
            var richmediaPoliteType = Array.isArray(data.polite) ? data.polite[0] : data.polite;
            var richmediaPixel = '';
            if (data.count.politeClick) {
                richmediaPixel = Array.isArray(data.count.politeClick) ? data.count.politeClick : data.count.politeClick.richmedia;
            }
            var politeSettings = $.extend(
                {},
                typeof richmediaPoliteType === 'string' && typeof this.politeDefaults[richmediaPoliteType] === 'object' ? this.politeDefaults[richmediaPoliteType] : this.politeDefaults.animation,
                data.polite === true ? {} : data.polite
            );
            var $loading, loadingTimeout;
            if (typeof data.fallback !== 'undefined' && politeSettings.fallback) {
                $fallback.append(this.createComponentFallback(data));
                $fallback.on('click', function() {
                    AdConstructor.count(richmediaPixel);
                    AdConstructor.count(data.count.fallbackClick);
                });
            }
            if (politeSettings.loading) {
                if (politeSettings.loading === true && data._key !== 'layer') {
                    politeSettings.loading = this.politeDefaults.loadingImage;
                }
                var loaderTemplate = '<span class="loading"></span>';
                if (politeSettings.fallback) {
                    loaderTemplate = '<a href="{{clickUrl}}" target="{{target}}" class="loading"></a>';
                }
                $loading = $(Mustache.render(loaderTemplate, data)).css('background-image', 'url(' + politeSettings.loading + ')');
                if (politeSettings.waitForLoading) {
                    loadingTimeout = window.setTimeout(function () {
                        $componentInner.prepend($loading);
                        if (richmediaPixel) {
                            $loading.on('click', function() {
                                AdConstructor.count(richmediaPixel);
                            });
                        }
                    }, politeSettings.waitForLoading);
                } else {
                    $componentInner.prepend($loading);
                    if (richmediaPixel) {
                        $loading.on('click', function() {
                            AdConstructor.count(richmediaPixel);
                        });
                    }
                }
            }
            if (politeSettings.fallback) {
                $componentInner.addClass('politeFallback');
            }
            if (data.fallbackWidth || data.fallbackHeight) {
                $componentInner.attr({
                    "data-fallback-width": data.fallbackWidth ? data.fallbackWidth : 0,
                    "data-fallback-height": data.fallbackHeight ? data.fallbackHeight : 0
                });
            }
            var finished = (function ($componentInner, data) {
                return function () {
                    AdConstructor.addComponent($('.main', $componentInner), 'iframe', data);
                    $('.loading', $componentInner).remove();
                    $componentInner.removeClass('politeFallback');
                    window.clearTimeout(loadingTimeout);
                }
            })($componentInner, data);
            if (!politeSettings.delay) {
                if (politeSettings.onload === 'ignore') {
                    AdConstructor.addComponent($('.main', $componentInner), 'iframe', data);
                } else {
                    $(window).on('load', finished);
                }
            } else {
                if (politeSettings.onload === 'ignore') {
                    window.setTimeout(finished, politeSettings.delay);
                } else if (politeSettings.onload === 'delay') {
                    $(window).on('load', function () {
                        window.setTimeout(finished, politeSettings.delay);
                    });
                } else {
                    var timeout = window.setTimeout(function () {
                        finished();
                        $(window).off('load', finished);
                    }, politeSettings.delay);
                    $(window).on('load', finished);
                    $(window).on('load', function () {
                        window.clearTimeout(timeout);
                    });
                }
            }
        } else if (data.iframeUrl) {
            var $iframe = $('<div class="iframe"/>').appendTo($componentInner);
            $componentInner = this.addComponent($iframe, 'iframe', data);
        } else {
            var $main = $('<div class="main" />').appendTo($componentInner);
            $main = this.addComponent($main, 'iframe', data);
            if (data._key !== 'layer' && data.fallback !== false) {
                var $fallback = $('<div class="fallback" />').appendTo($componentInner);
                $fallback = this.addComponent($fallback, 'fallback', data);
            }
        }
        if (data.outerZIndex) {
            $component.css('zIndex', data.outerZIndex);
        }
        if (data.zIndex) {
            $componentInner.css('zIndex', data.zIndex);
        }
        if (data.offsetX || data.offsetY) {
            AdConstructor.setOffset($component, data);
        }
            if (data.addition) {
                if (!(data.addition instanceof Array)) {
                    data.addition = [data.addition];
                }
                for (var i = 0, l = data.addition.length; i < l; i++) {
                    if (!data.addition[i]) {
                        continue;
                    }
                    if (typeof data.addition[i] === 'string') {
                        data.addition[i] = {_type: 'script', url: data.addition[i]};
                    }
                    switch (data.addition[i]._type) {
                        case 'iframe':
                            data.addition[i] = $.extend(true, {
                                _invisible: true,
                                width: 1,
                                height: 1
                            }, data.addition[i]);
                            if (data.addition[i]._invisible) {
                                data.addition[i].style = 'position:absolute !important; left:-999em !important; top:-999em !important; width:0 !important; height:0 !important;';
                            }
                            $componentInner.append(Mustache.render('<iframe src="{{url}}" width="{{width}}" height="{{height}}"{{#style}} style="{{style}}"{{/style}} frameborder="0" border="0"></iframe>', data.addition[i]));
                            break;
                        case 'script':
                        default:
                            data.addition[i] = $.extend(true, {async: false}, data.addition[i]);
                            $componentInner.append(Mustache.render('<script src="{{url}}"{{#async}} async="async"{{/async}}></script>', data.addition[i]));
                            break;
                    }
                }
            }
        if (data['3col'] || data['4col']) {
            PageLayout.onchange(function (alignment, cols) {
                var key = cols + 'col';
                if (data[key]) {
                    var colData = $.extend({}, data, data[key]);
                    if (colData.offsetX || colData.offsetY) {
                        AdConstructor.setOffset($component, colData);
                    }
                }
            });
        }
        if (data.initialVisible === false) {
            $component.hide();
        }
        if (data.parent) {
            var $componentParent;
            if (data.parent.jQueryObject) {
                $componentParent = data.parent.jQueryObject;
            } else if (data.parent.component && AdConstructor.createdComponents[data.parent.component]) {
                $componentParent = AdConstructor.createdComponents[data.parent.component];
            } else if (data.parent.selector) {
                $componentParent = $(data.parent.selector);
            }
            if (typeof $componentParent != 'undefined') {
                if (data.position && data.position.parentAnchor && data.position.anchor) {
                    $component = AdConstructor.alignElementAtParent($componentParent, data.position.parentAnchor, $component, data.position.anchor, data.position.translate);
                } else if (data.position && data.position.translate) {
                    if (data.position.translate.x) {
                        $component.css({
                            left: data.position.translate.x
                        });
                    }
                    if (data.position.translate.y) {
                        $component.css({
                            top: data.position.translate.y
                        });
                    }
                }
                $componentParent[data.parent.insertPosition ? data.parent.insertPosition : 'append']($component);
                if (data.script) {
                    $(function () {
                        postscribe($component.get(0), '<script src="' + data.script + '"><\/script>');
                    });
                }
                if (data.appendLoginSeperator) {
                    $component.after('<div id="sepRespBillboard" class="sepLoginExpander"></div>');
                    $('html').attr('data-seperator', 'billboard');
                }
            } else {
            }
        }
        if (typeof data.onInit === 'function') {
            data.onInit.call($component, data);
        }
        if (data.closer) {
            var $closer = $('<a href="#" class="ad-component-closer" title="Schließen" />');
            $closer.on('click', function (e) {
                e.preventDefault();
                if (typeof data.closeCallback === 'function') {
                    data.closeCallback(data, $component);
                } else if (typeof data.callbacks[data.closeCallback] === 'function') {
                    data.callbacks[data.closeCallback](data, $component);
                }
            });
            $component.append($closer);
        }
        if (data.autoclose) {
            window.setTimeout(function () {
                $component.remove();
            }, parseInt(data.autoclose, 10));
        }
        if (data.closeOnClick) {
            $component.on('click', function () {
                $component.remove();
            });
        }
        if (data.blockIframe) {
            $('iframe', $component).attr('data-iframe-blocked', '1');
        }
        if (data.hideIfBleed) {
            PageLayout.onchange(function (alignment, cols, border, pixel, bleeding) {
                if (bleeding) {
                    $component.hide();
                    PageLayout.removeNarrow();
                } else {
                    $component.show();
                    PageLayout.setNarrow();
                }
            });
        }
        AdConstructor.createdComponentsData[key] = data;
        AdConstructor.createdComponents[key] = $component;
    };
    this.uimUrls = [
        'https://united.uimserv.net',
        'https://adimg.uimserv.net',
        'https://advideo.uimserv.net',
        'https://dl.web.de',
        'https://dl.gmx.net',
        'https://dl.gmx.at',
        'https://dl.gmx.ch',
        'https://dl.1und1.de',
        'https://dl-preview.web.de',
        'https://origin-adimg.uimserv.net',
        'https://origin-advideo.uimserv.net',
        'https://img.ui-portal.de'
    ]
    this.isUimIframe = function (data) {
        if (typeof data.iframeUrl === 'string') {
            for (var i = 0; i < this.uimUrls.length; i++) {
                if (data.iframeUrl.indexOf(this.uimUrls[i]) === 0) {
                    return true;
                }
            }
        }
        return false;
    };
    this.setOffset = function ($component, data) {
        var css = {
            left: data.offsetX < 0 ? Math.max(data.offsetXAllowed[0], data.offsetX) : Math.min(data.offsetXAllowed[1], data.offsetX),
            top: data.offsetY < 0 ? Math.max(data.offsetYAllowed[0], data.offsetY) : Math.min(data.offsetYAllowed[1], data.offsetY)
        }
        var $target;
        switch (data.offsetTarget) {
            case 'component':
                $target = $component;
                break;
            case 'componentInner':
                $target = $('.ad-component-inner', $component);
                break;
            case 'componentItems':
                $target = $('> .ad-component-inner > div:not(.ad-background)', $component);
                break;
        }
        if ($target) {
            $target.css(css);
        }
    };
    this.showLayer = function (data, userInteraction) {
        if (typeof AdConstructor.createdComponents['layer'] !== 'undefined') {
            if (userInteraction) {
                LayerConflict.closeAllLayer();
            }
            AdConstructor.createdComponents['layer'].show();
            if (typeof data.count !== 'undefined') {
                AdConstructor.count(data.count);
            }
        }
    };
    this.hideLayer = function (data) {
        if (typeof AdConstructor.createdComponents['layer'] !== 'undefined') {
            AdConstructor.createdComponents['layer'].hide();
        }
    };
    this.expandComponent = function (componentName) {
        var newSize = {};
        var data = this.createdComponentsData[componentName] || {};
        if (data.expandHeight) {
            newSize.height = data.expandHeight;
        }
        if (data.expandWidth) {
            newSize.width = data.expandWidth;
        }
        this.resizeComponent(componentName, newSize);
    };
    this.collapseComponent = function (componentName) {
        var newSize = {};
        var data = this.createdComponentsData[componentName] || {};
        if (data.height) {
            newSize.height = data.height;
        }
        if (data.width) {
            newSize.width = data.width;
        }
        this.resizeComponent(componentName, newSize);
    };
    this.resizeComponent = function (componentName, size) {
        if (typeof AdConstructor.createdComponents[componentName] !== 'undefined') {
            $('> .ad-component-inner > .iframe, > .ad-component-inner > .iframe > iframe', AdConstructor.createdComponents[componentName]).css(size);
        }
    };
    this.setWidth = function ($container, widthProperty, width) {
        var widthValue = AdConstructor.getWidthValue(width);
        if (typeof widthValue === 'function') {
            PageLayout.onchange(function () {
                $container.css(widthProperty, widthValue);
            });
        } else {
            $container.css(widthProperty, widthValue);
        }
    };
    this.getWidthValue = function (value) {
        switch (value) {
            case 'adMinWidth':
                return AdConstructor.getCurrentMinWidth;
                break;
            case 'adMaxWidth':
                return AdConstructor.getCurrentMaxWidth;
                break;
            case 'contentInnerWidth':
                return PageLayout.getContentInnerWidth;
                break;
            default:
                return value;
        }
    }
    this.getCurrentMinWidth = function () {
        var $leftSkyMain = $('.ad-component-skyleft > .ad-component-inner > .main');
        var $rightSkyMain = $('.ad-component-skyright > .ad-component-inner > .main');
        var leftSkyMinWidth = 0;
        var rightSkyMinWidth = 0;
        if ($leftSkyMain.length) {
            leftSkyMinWidth = $leftSkyMain.css('minWidth') !== '0px' ? parseInt($leftSkyMain.css('minWidth'), 10) : parseInt($leftSkyMain.css('width'), 10);
        }
        if ($rightSkyMain.length) {
            rightSkyMinWidth = $rightSkyMain.css('minWidth') !== '0px' ? parseInt($rightSkyMain.css('minWidth'), 10) : parseInt($rightSkyMain.css('width'), 10);
        }
        return $('.wrapper-center.first').innerWidth() + leftSkyMinWidth + rightSkyMinWidth;
    };
    this.getCurrentMaxWidth = function () {
        var $leftSkyMain = $('.ad-component-skyleft > .ad-component-inner > .main');
        var $rightSkyMain = $('.ad-component-skyright > .ad-component-inner > .main');
        var leftSkyMaxWidth = 0;
        var rightSkyMaxWidth = 0;
        if ($leftSkyMain.length) {
            leftSkyMaxWidth = $leftSkyMain.css('maxWidth') !== 'none' ? parseInt($leftSkyMain.css('maxWidth'), 10) : parseInt($leftSkyMain.css('width'), 10);
        }
        if ($rightSkyMain.length) {
            rightSkyMaxWidth = $rightSkyMain.css('maxWidth') !== 'none' ? parseInt($rightSkyMain.css('maxWidth'), 10) : parseInt($rightSkyMain.css('width'), 10);
        }
        return $('.wrapper-center.first').innerWidth() + leftSkyMaxWidth + rightSkyMaxWidth;
    };
    this.alignElementAtParent = function ($parent, parentAnchor, $element, elementAnchor, translate) {
        var offset = {};
        var xAttributLeft = ['nw', 'w', 'sw'];
        var xAttributRight = ['ne', 'e', 'se'];
        switch (parentAnchor) {
            case 'ne':
            case 'se':
            case 'e':
                if (xAttributLeft.indexOf(elementAnchor) != -1) {
                    offset.left = '100%';
                } else if (xAttributRight.indexOf(elementAnchor) != -1) {
                    offset.right = 0;
                } else {
                    offset.right = ($element.innerWidth() / 2 * -1);
                }
                break;
            case 'sw':
            case 'nw':
            case 'w':
                if (xAttributLeft.indexOf(elementAnchor) != -1) {
                    offset.left = 0;
                } else if (xAttributRight.indexOf(elementAnchor) != -1) {
                    offset.right = '100%';
                } else {
                    offset.left = $element.innerWidth() / 2 * -1;
                }
                break;
            case 'n':
            case 's':
                if (xAttributLeft.indexOf(elementAnchor) != -1) {
                    offset.left = '50%';
                } else if (xAttributRight.indexOf(elementAnchor) != -1) {
                    offset.right = '50%';
                } else {
                    offset.left = '50%';
                    offset.marginLeft = $element.innerWidth() / 2 * -1;
                }
                break;
        }
        var yAttributTop = ['nw', 'n', 'ne'];
        var yAttributBottom = ['sw', 's', 'se'];
        switch (parentAnchor) {
            case 'ne':
            case 'nw':
            case 'n':
                if (yAttributTop.indexOf(elementAnchor) != -1) {
                    offset.top = 0;
                } else if (yAttributBottom.indexOf(elementAnchor) != -1) {
                    offset.top = $element.innerHeight() * -1;
                } else {
                    offset.top = $element.innerHeight() / 2 * -1;
                }
                break;
            case 'se':
            case 'sw':
            case 's':
                if (yAttributTop.indexOf(elementAnchor) != -1) {
                    offset.top = $parent.innerHeight();
                } else if (yAttributBottom.indexOf(elementAnchor) != -1) {
                    offset.bottom = 0;
                } else {
                    offset.top = $parent.innerHeight() - $element.innerHeight() / 2;
                }
                break;
            case 'e':
            case 'w':
                if (yAttributTop.indexOf(elementAnchor) != -1) {
                    offset.top = $parent.innerHeight() / 2;
                } else if (yAttributBottom.indexOf(elementAnchor) != -1) {
                    offset.bottom = $parent.innerHeight() / 2;
                } else {
                    offset.top = '50%';
                    offset.marginTop = $element.innerHeight() / 2 * -1;
                }
                break;
        }
        if (translate && translate.x !== 0) {
            if (typeof offset.marginLeft != 'undefined') {
                offset.marginLeft = offset.marginLeft + translate.x;
            } else if (typeof offset.left != 'undefined') {
                offset.left = offset.left + translate.x;
            }
            if (typeof offset.marginRight != 'undefined') {
                offset.marginRight = offset.marginRight - translate.x;
            } else if (typeof offset.right != 'undefined') {
                offset.right = offset.right - translate.x;
            }
        }
        if (translate && translate.y !== 0) {
            if (typeof offset.marginTop != 'undefined') {
                offset.marginTop = offset.marginTop + translate.y;
            } else if (typeof offset.top != 'undefined') {
                offset.top = offset.top + translate.y;
            }
            if (typeof offset.marginBottom != 'undefined') {
                offset.marginBottom = offset.marginBottom - translate.x;
            } else if (typeof offset.bottom != 'undefined') {
                offset.bottom = offset.bottom - translate.x;
            }
        }
        return $element.css(offset);
    };
    this.count = function (pix, type) {
        if (typeof pix === 'object' && !(pix instanceof Array)) {
            pix = pix[AdConstructor.countComponentType] || [];
        }
        if (!(pix instanceof Array)) {
            pix = [pix];
        }
        for (var i = 0; i < pix.length; i++) {
            if (pix[i]) {
                if (type === 'return' && pix[i].length > 0) {
                    pix[i] = pix[i].replace('{ts}', +new Date());
                } else if (type === 'iframe') {
                    AdConstructor.createHiddenIframe(pix[i].replace('{ts}', +new Date()));
                } else {
                    (new Image(1, 1)).src = pix[i].replace('{ts}', +new Date());
                }
            }
        }
        if (type === 'return') {
            return pix;
        }
    };
    this.politeDefaults = {
        loadingImage: '//img.ui-portal.de/homepage/img/webde/spinner.svg',
        blank: {
            delay: 5000,
            onload: 'run',
            fallback: false,
            loading: false
        },
        fallback: {
            delay: 5000,
            onload: 'run',
            fallback: true,
            loading: false
        },
        animation: {
            delay: 5000,
            onload: 'run',
            fallback: false,
            loading: true,
            waitForLoading: 250
        },
        'fallback-animation': {
            delay: 5000,
            onload: 'run',
            fallback: true,
            loading: true,
            waitForLoading: 250
        }
    };
};
AdConstructor.registerComponent('halfpage', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        width: 300,
        height: 600,
        parent: {
            selector: '#adRectangle > div'
        }
    }, componentData);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'layout', 'halfpage');
    $('html').attr('id', 'halfpage');
    AdConstructor.createComponent(key, componentData);
});
AdConstructor.registerComponent('billboard', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        componentWidth: '100%',
        width: 970,
        fallbackWidth: 970,
        minWidth: 970,
        height: 250,
        insideContent: true,
        parent: true || key === 'billboard' ? {
            selector: '#adRectangle',
            insertPosition: 'before'
        } : {
            selector: '#sepRespBillboard',
            insertPosition: 'after'
        },
        appendLoginSeperator: key === 'billboard',
        widthVariant: 'static',
        align: 'center',
        backgroundLink: false
    }, componentData);
    componentData.offsetXAllowed = [-10, 10];
    componentData.offsetYAllowed = [-1, 1];
    if (componentData.width === '100%' && typeof [].indexOf(componentData.widthVariant) === -1) {
        componentData.widthVariant = 'dynamic';
    }
    switch (componentData.widthVariant) {
        case 'fullwidth':
            if (typeof componentData.skyleft !== 'undefined' || typeof componentData.skyright !== 'undefined') {
                layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
                layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'border', 30);
            }
            componentData.width = '100%';
            break;
        case 'inner':
            layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
            layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'border', 30);
            componentData.innerWidth = 'contentInnerWidth';
            componentData.componentWidth = 'auto';
            componentData.width = '100%';
            componentData.minWidth = 620;
            break;
        case 'dynamic':
            componentData.maxWidth = 1260;
            break;
        case 'static':
        default:
            componentData.minWidth = componentData.width;
            componentData.fallbackWidth = componentData.width;
            break;
    }
    if (componentData.noGap) {
        $('html').addClass('noGap');
        $('html').attr('data-promoline-position', 'belowlogin');
        StickyLogin.setYOffset('gap', -28, true);
        StickyLogin.push(componentData.height - 250 - 48);
    } else {
        StickyLogin.push(componentData.height - 250);
    }
    if ((typeof componentData.bgColor !== 'undefined' && componentData.bgColor)
        || (typeof componentData.bgClickUrl !== 'undefined' && componentData.bgClickUrl)) {
        componentData.backgroundLink = true;
    }
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'mincontentwidth', componentData.minWidth);
    if (typeof componentData.components.bg !== 'undefined') {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'outsidecomponent', true);
    }
    AdConstructor.createComponent(key, componentData);
    AdConstructor.createdComponents[key].addClass('ad-component-billboard');
});
AdService.on('cleanup', function() {
    var genericContainers = $('#adRectangle .adv-generic-container');
    if (genericContainers.length && genericContainers.length > 1) {
        var firstElement = $(genericContainers[0]);
        var div = $('> div', firstElement);
        var width = div.offsetWidth;
        div.css('max-width', width + 'px');
        div.css('width', '');
    }
});
AdConstructor.registerComponent('rectangle', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        width: 300,
        height: 250,
        parent: {
            selector: '#adRectangle > div'
        }
    }, componentData);
    componentData.offsetXAllowed = [0, 1];
    if (componentData.width === 321 || componentData.width === 501) {
        $('html').addClass('rect321');
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'borderwidth', 20);
    }
    AdConstructor.createComponent(key, componentData);
    enableRectangleEvent = false;
});
AdConstructor.registerComponent('sitebar', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        componentWidth: 'auto',
        minWidth: 220,
        fallbackWidth: 220,
        width: '100%',
        height: '100%',
        sticky: AdConstructor.stickyAllowed(),
        parent: {
            selector: 'body',
            insertPosition: 'prepend'
        },
        position: {
            parentAnchor: 'ne',
            anchor: 'ne'
        }
    }, componentData);
    componentData.height = getWindowInnerHeight();
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'align', 'left');
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'narrowright', (componentData.minWidth ? componentData.minWidth : componentData.width));
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, '2col', true);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'outsidecomponent', true);
    PageLayout.extendLayoutConfig(layoutConfig, 'topper', false);
    AdConstructor.createComponent(key, componentData);
    $(window).on('resize', function () {
        AdConstructor.createdComponents[key].add($('.main, .iframe, iframe', AdConstructor.createdComponents[key])).css('height', getWindowInnerHeight());
    });
});
AdConstructor.registerComponent(['skyleft', 'skyright'], function (key, componentData, layoutConfig, data) {
    var variantProperties = {};
    if (componentData.widthVariant == 'dynamic') {
        variantProperties = {
            componentWidth: 'auto',
            width: '100%',
            minWidth: 130,
            maxWidth: 220,
            parent: {
                selector: 'body',
                insertPosition: 'prepend'
            }
        }
    } else {
        variantProperties = {
            width: 160,
            parent: {
                selector: '.wrapper-center.first',
                insertPosition: 'prepend'
            }
        }
    }
    componentData = $.extend(true, {
        height: 600,
        align: key === 'skyright' ? 'left' : 'right',
        stickyBehavior: 'scrollToBottom',
        position: {
            parentAnchor: key === 'skyright' ? 'ne' : 'nw',
            anchor: key === 'skyright' ? 'ne' : 'nw',
            translate: {
                x: 0,
                y: 0
            }
        },
        collocation: undefined,
        sticky: data.type === 'skyright' || data.type === 'sky_right'
    }, variantProperties, componentData);
    if (componentData.sticky && componentData.sticky !== 'false') {
        componentData.parent = {
            selector: 'body',
            component: false,
            insertPosition: 'prepend'
        };
        if (typeof componentData.components.superbanner !== 'undefined') {
            if (componentData.collocation === 'side-by-side') {
                componentData.position.translate = {
                    y: 0
                }
            } else {
                var offsetTop = componentData.components.superbanner.height ? componentData.components.superbanner.height : 90;
                componentData.position.translate = {
                    y: offsetTop
                }
            }
        }
    }
    if (key == 'skyleft') {
        componentData.offsetXAllowed = [-10, 10];
        componentData.offsetYAllowed = [-5, 50];
    } else {
        componentData.offsetXAllowed = [-1, 10];
        componentData.offsetYAllowed = [-5, 50];
    }
    if (componentData.hideIfBleed) {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'narrow' + (key === 'skyleft' ? 'left' : 'right'), (componentData.minWidth ? componentData.minWidth : componentData.width));
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'reducenarrowinsteadbleed', true);
    } else {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'narrow' + (key === 'skyleft' ? 'left' : 'right'), (componentData.minWidth ? componentData.minWidth : componentData.width));
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, '2col', true);
    }
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'outsidecomponent', true);
    if (key === 'skyleft') {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'topper', false);
    }
    if (typeof componentData.parent.jQueryObject === 'undefined'
        && typeof componentData.parent.component === 'undefined'
        && componentData.parent.selector === '.wrapper-center.first') {
        if (typeof componentData.position.translate === 'undefined') {
            componentData.position.translate = {};
        }
        var brandOffset = 0;
        if (componentData.position.parentAnchor === componentData.position.anchor) {
            componentData.position.translate.x = ((componentData.position.translate.x ? componentData.position.translate.x : 0) + componentData.width * (key === 'skyright' ? 1 : -1)) + brandOffset;
        }
    }
    if (componentData.sticky) {
        if (componentData.width !== '100%') {
            componentData.innerWidth = componentData.width;
        }
        if (componentData.height !== '100%') {
            componentData.innerHeight = componentData.height;
        }
    }
    AdConstructor.createComponent(key, componentData);
    if (componentData.sticky) {
        AdConstructor.calcStickySkyWidth(key, componentData);
        if (componentData.widthVariant === 'dynamic') {
            $(window).on('resize', function () {
                AdConstructor.calcStickySkyWidth(key, componentData);
            });
        }
        PageLayout.onchange(function () {
            AdConstructor.calcStickySkyWidth(key, componentData);
            AdConstructor.repositionStickySky(key);
        });
        $(window).on('layer-closed layer-opened', function () {
            var alignment = PageState.get('alignment');
            AdConstructor.repositionStickySky(key, alignment);
        });
        if (componentData.stickyBehavior === "scrollToBottom") {
            $(window).on('scroll resize', function () {
                var positionTop = $('> .ad-component-inner', AdConstructor.createdComponents[key]).position().top;
                var windowInnerHeight = getWindowInnerHeight();
                var componentHeight = componentData.height;
                var scrollTop = $(window).scrollTop();
                var moveTop = 0;
                if (positionTop === 0 && windowInnerHeight >= componentHeight) {
                } else {
                    if (positionTop > 0 && windowInnerHeight >= componentHeight) {
                        moveTop = scrollTop < positionTop ? scrollTop : positionTop;
                    } else {
                        var maxMoveTop = (windowInnerHeight - (componentHeight + positionTop)) * -1;
                        moveTop = scrollTop < maxMoveTop ? scrollTop : maxMoveTop;
                    }
                }
                $('> .ad-component-inner', AdConstructor.createdComponents[key]).css({
                    marginTop: moveTop * -1
                });
            });
        }
    } else {
        if (componentData.widthVariant == 'dynamic') {
            PageLayout.onchange(function () {
                AdConstructor.repositionDynamicSky(key);
            });
        }
    }
    if (data.type === 'double-sitebar' || (data.type === 'bridge' && data.variant === 'sitebar') && key === 'skyleft') {
        $(window).on('resize', function () {
            AdConstructor.createdComponents['skyleft']
                .add(AdConstructor.createdComponents['skyright'])
                .add($('.main, .iframe, iframe', AdConstructor.createdComponents['skyleft']))
                .add($('.main, .iframe, iframe', AdConstructor.createdComponents['skyright']))
                .css('height', getWindowInnerHeight())
                ;
        });
    }
});
AdConstructor.registerComponent('superbanner', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        width: 728,
        height: 90,
        parent: {
            selector: '.wrapper-center.first',
            insertPosition: 'prepend'
        },
        position: {
            parentAnchor: 'n',
            anchor: 's'
        }
    }, componentData);
    componentData.offsetXAllowed = [-10, 10];
    componentData.offsetYAllowed = [-1, 1];
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'outsidecomponent', true);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'topper', false);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'narrowtop', componentData.height);
    if (componentData.width > 682) {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, '2col', 'blocked');
    }
    AdConstructor.createComponent(key, componentData);
});
AdConstructor.registerComponent('cinematic', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        componentWidth: '100%',
        width: '100%',
        height: 380,
        parent: {
            selector: '.wrapper-center:eq(1)',
            insertPosition: 'before'
        }
    }, componentData);
    AdConstructor.createComponent(key, componentData);
    StickyLogin.push(componentData.height - 250);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
    $('.hasBreakingNews #promoline').css({
        marginTop: componentData.height - 250
    });
    AdConstructor.createdComponents[key].next().find('.wrapper-indent').prepend('<div id="sepRespBillboard" class="sepLoginExpander"></div>');
    $('html').attr('data-seperator', 'billboard');
});
    AdConstructor.registerComponent('maxiad', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        componentWidth: '100%',
        insideContent: true,
        align: 'center',
        width: 640,
        height: 480,
        parent: {
            selector: '#adRectangle',
            insertPosition: 'before'
        },
        widthVariant: 'fullwidth',
        color: '#EFEFEF'
    }, componentData);
    componentData.minWidth = componentData.minWidth ? componentData.minWidth : componentData.width
    componentData.offsetYAllowed = [-620, 620];
    componentData.offsetXAllowed = [-500, 500];
    if (typeof componentData.components.bg != 'undefined') {
        componentData.componentHeight = componentData.components.bg.height;
    }
    ContentService.settings.disabled = true;
    AdService.disablePosition('multiad');
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'topper', false);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'exclusive-ad', true);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'mincontentwidth', componentData.minWidth);
    AdConstructor.createComponent(key, componentData);
});
    AdConstructor.registerComponent('maxiadcontent', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        escapeIframe: true,
        blockIframe: true,
        insideContent: true,
        componentWidth: 620,
        width: 640,
        height: 480,
        parent: {
            selector: '#adRectangle',
            insertPosition: 'after'
        }
    }, componentData);
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, '2col', 'blocked');
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'layout', 'maxiadcontent');
    layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
    $('html').attr('id', 'maxiadcontent');
    AdConstructor.createComponent(key, componentData);
});
    AdConstructor.registerComponent('maxiframe', function (key, componentData, layoutConfig) {
    componentData = $.extend({
        align: 'center',
        insideContent: true,
        width: 940,
        height: 2200,
        parent: {
            selector: '#adRectangle',
            insertPosition: 'before'
        }
    }, componentData);
    ContentService.settings.disabled = true;
    AdService.disablePosition('multiad');
    if (componentData.width !== '100%') {
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'zerowidthborder', false);
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, '4col', false);
        layoutConfig = PageLayout.extendLayoutConfig(layoutConfig, 'exclusive-ad', true);
    }
    AdConstructor.createComponent(key, componentData);
});
AdService.on('adconstructor:prioad_created', function (data) {
    var enableRectangleEvent = true;
    var enableSkyRight = true;
    $.each(data.components, function (key, componentData) {
        switch (key) {
            case 'bg':
                break;
            case 'skyleft':
            case 'skyright':
                enableSkyRight = false;
                break;
            case 'sitebar':
                enableSkyRight = false;
                break;
            case 'rectangle':
                enableRectangleEvent = false;
                break;
            case 'halfpage':
                enableRectangleEvent = false;
                enableSkyRight = false;
                break;
            case 'superbanner':
                enableSkyRight = false;
                break;
            case 'billboard':
                if (PageLayout._isSmallScreen || AdService.isBlocked) {
                    enableSkyRight = false;
                }
                break;
            case 'cinematic':
                enableSkyRight = false;
                break;
            case 'maxiad':
                enableRectangleEvent = false;
                enableSkyRight = false;
                break;
            case 'maxiadcontent':
                enableRectangleEvent = false;
                $('#adRectangle').hide();
                break;
            case 'maxiframe':
                enableRectangleEvent = false;
                enableSkyRight = false;
                break;
        }
    });
    if (enableRectangleEvent) {
        if (AdService.isBlocked) {
            AdService.setPositionParam('rectangleEvent', 'tagid', 'rectangle_' + data.type);
        }
        AdService.enablePosition('rectangleEvent');
    }
    if (enableSkyRight) {
        AdService.enablePosition('sky_right');
    }
});
AdService.setAdHook('_global:prepare', function (data, meta) {
    if (typeof data.components === 'undefined') {
        var itemsToCopyInComponents = ['sky', 'top', 'topbanner', 'panorama', 'skyleft', 'skyright', 'sitebar', 'rectangle', 'halfpage', 'superbanner', 'billboard', 'maxiad', 'maxiadcontent', 'maxiframe', 'layer', 'bg'];
        data.components = {};
        for (var i = 0; itemsToCopyInComponents.length > i; i++) {
            if (typeof data[itemsToCopyInComponents[i]] !== 'undefined') {
                data.components[itemsToCopyInComponents[i]] = data[itemsToCopyInComponents[i]];
            }
        }
        if (isEmptyObject(data.components)) {
            delete data.components;
        }
    }
    if (typeof meta !== 'undefined') {
        var dataToExtract = ['sticky'];
        var metaExtract = {};
        for (var i = 0; i < dataToExtract.length; i++) {
            if (meta[dataToExtract[i]]) {
                metaExtract[dataToExtract[i]] = meta[dataToExtract[i]];
            }
        }
        data = $.extend(true, {}, metaExtract, data);
    }
    if (typeof data.components !== 'undefined') {
        var namingMatrix = {
            sky: 'skyright',
            top: 'superbanner',
            topbanner: 'superbanner',
            panorama: 'billboard'
        }
        $.each(data.components, function (key, value) {
            if (typeof namingMatrix[key] !== 'undefined') {
                data.components[namingMatrix[key]] = value;
                delete data.components[key];
            }
        });
    }
    for (var key in data.components) {
        if (!data.components.hasOwnProperty(key)) {
            continue;
        }
        if (data.components[key].variant === 'expand') {
            data.components[key].expandable = true;
            delete data.components[key].variant;
        }
    }
    switch (data.variant) {
        case 'verticalCollision':
            if (typeof data.components.skyright !== 'undefined') {
                data.components.skyright.collocation = 'side-by-side';
            }
            if (typeof data.components.skyleft !== 'undefined') {
                data.components.skyleft.collocation = 'side-by-side';
            }
            break;
        case 'horizontalCollision':
            if (typeof data.components.skyright !== 'undefined') {
                data.components.skyright.collocation = 'stacked';
            }
            if (typeof data.components.skyleft !== 'undefined') {
                data.components.skyleft.collocation = 'stacked';
            }
            break;
        case 'sticky':
            if (typeof data.components.skyright !== 'undefined') {
                data.components.skyright.sticky = true;
            }
            if (typeof data.components.skyleft !== 'undefined') {
                data.components.skyleft.sticky = true;
            }
            break;
    }
    if (typeof data.skyVariant !== 'undefined') {
        if (typeof data.components.skyright !== 'undefined') {
            data.components.skyright.widthVariant = data.skyVariant;
        }
        if (typeof data.components.skyleft !== 'undefined') {
            data.components.skyleft.widthVariant = data.skyVariant;
        }
        delete data.skyVariant;
    }
    if (!AdConstructor.stickyAllowed()) {
        try {
            for (var key in data.components) {
                if (!data.components.hasOwnProperty(key)) {
                    continue;
                }
                if (data.components[key].sticky) {
                    data.components[key].sticky = false;
                }
            }
        } catch (e) {
        }
    }
    return data;
});
AdService.on('aftercleanup', function (e) {
    unescapeIframe(e.ad);
});
AdService.on('position', 'rectangle', function (e) {
    AdService.___adhook_requested = false;
    var deviceclient = AdService.getParam('deviceclient');
    if ((deviceclient === 'browser_clean') || (Array.isArray(deviceclient) && deviceclient.indexOf('browser_clean') >= 0)) {
        AdService.switchToUnitedUimservAdServer();
    } else {
        if (AdService.isBlocked) {
            AdService.setPositionParam('rectangle', 'pagestate', SiteInfo.status);
            AdService.setPositionParam('rectangle', 'bn', SiteInfo.breakingNews ? '1' : '0');
        }
    }
    try {
        var tpcLocalStorage = localStorage.getItem('tpc');
        if (tpcLocalStorage === '1') {
            AdService.setParam('tpc', '1');
        } else {
            AdService.setParam('tpc', '0');
        }
    } catch (e) {
    }
});
AdService.on('beforeadhook', function (e) {
    return e.position === 'rectangle' && e.data.type !== 'rectangle';
}, function (e) {
    if (!AdService.isBlocked) {
        $('#adRectangle').addClass('ad');
    }
    AdService.___adhook_requested = true;
});
AdService.on('cleanup', function (data) {
    return data.position === 'rectangle';
}, function () {
    AdService.createAd('rectangle');
    var deviceclient = AdService.getParam('deviceclient');
    if (!((deviceclient === 'browser_clean') || (Array.isArray(deviceclient) && deviceclient.indexOf('browser_clean') >= 0)) && !AdService.isBlocked && !ContentService.settings.disabled) {
        PrebidConnector.startBidding(['rectangleEvent', 'rectangle_2', 'rectangle_3', 'box_1_1', 'box_2_1', 'sky_right']);
    }
    var $uniteaserAndRectangleEventTarget = $('[data-adservice-slot="rectangle"]');
    if (ContentService.checkAdSlot('uniteaser', $uniteaserAndRectangleEventTarget)) {
        ContentService.createPosition('uniteaser', $uniteaserAndRectangleEventTarget);
    }
    if (ContentService.checkAdSlot('rectangleEvent', $uniteaserAndRectangleEventTarget)) {
        ContentService.createPosition('rectangleEvent', $uniteaserAndRectangleEventTarget);
    }
});
AdService.on('cleanup', function (data) {
    return data.position === 'rectangle';
}, function () {
    AdService.setParam('prioad', PageLayout.adType);
});
AdService.on('cleanup', function (data) {
    return data.position === 'uniteaser';
}, function () {
    $('[data-adservice-slot="rectangle"] > div').show();
});
AdService.setAdHook('rectangle', function (data, meta) {
    if (!AdService.___adhook_requested) {
        if (PageLayout.adType === 'default' && $('#adRectangle>div>div').children(':not(script)').length === 0) {
            var $originalAdRectangle = $('#adRectangle');
            $('#adRectangle script').remove();
            $originalAdRectangle.after($('<section>').attr('id', 'rectangle-fallbackContent').attr('data-adservice-slot', 'rectangle').append($('> div', $originalAdRectangle)));
            $originalAdRectangle.remove();
            AdService.isBlocked = true;
            AdService.enablePosition('uniteaser');
        }
        if (AdService.isBlocked) {
            PageLayout.check();
            return;
        } else {
            $('#adRectangle').addClass('ad');
        }
        var sizetable = {
            '450x300': ['maxiad'],
            '640x360': ['maxiad'],
            '640x480': ['maxiad'],
            '640x481': ['maxiadcontent'],
            '800x450': ['maxiad'],
            '800x600': ['maxiad'],
            '1260x690': ['maxiad'],
            '300x250': true,
            '300x115': true,
            '728x90': ['superbanner'],
            '120x600': ['skyright'],
            '160x600': ['skyright'],
            '200x600': ['skyright'],
            '320x600': ['skyright'],
            '800x250': ['billboard'],
            '970x250': ['billboard'],
            '994x250': ['billboard'],
            '220x600': ['sitebar'],
            '300x600': ['halfpage'],
            '750x200': ['floor'],
            '300x250_630x350': ['content'],
            '600x250': ['widecontent'],
            '770x250': ['banderole'],
            '1x1': ['ambient']
        };
        var copyAdSize = ['skyright', 'maxiad'];
        var adsize = meta.adsize;
        var adtype = sizetable[adsize] ? sizetable[adsize] : ['skyright'];
        if (adtype && adtype !== true && $('[data-adservice-slot="rectangle"] div.adv-generic-container:first').children.length) {
            if ($.ua.browser.msie === 8) {
                document.write('</div>');
                AdService.advContainerAlreadyClosed = true;
            }
            var components = {};
            components[adtype[0]] = { dom: $('[data-adservice-slot="rectangle"] div.adv-generic-container:first').get(0) };
            if (copyAdSize.indexOf(adtype[0]) !== -1) {
                if (meta.width) {
                    components[adtype[0]].width = parseInt(meta.width, 10);
                }
                if (meta.height) {
                    components[adtype[0]].height = parseInt(meta.height, 10);
                }
            }
            AdService.positions['rectangle'].tagid = adtype[0];
            AdService.createAd({
                type: adtype[0],
                components: components
            }, meta);
            AdService.fireEvent('cleanup', { meta: { tagid: adtype[0] } });
        } else {
            PageLayout.check();
            AdService.enablePosition('sky_right');
        }
    }
    var event = new CustomEvent ('afterInitialCleanup', { bubbles: true, cancelable: true });
    document.querySelector('body').dispatchEvent(event);
});
AdService.setAdHook('billboard:prepare', function (data, meta) {
    if (data.rtbLoading) {
        data = $.extend({
            postMessage: true,
            postMessageEvents: {
                showRectangle: {
                    callback: function () {
                        AdConstructor.stopRtbTimeout();
                        $('.ad-component-billboard').remove();
                        $('html').removeAttr('data-seperator');
                        track('rtb-reply.false', 'event');
                    }
                },
                showBillboard: {
                    callback: function () {
                        AdConstructor.stopRtbTimeout();
                        track('rtb-reply.true', 'event');
                    }
                }
            },
            rtbTimeoutCallback: function () {
                $('.ad-component-billboard').remove();
                $('html').removeAttr('data-seperator');
                $('body').removeClass('rtb-loading');
                track('rtb-reply.timeout', 'event');
            }
        }, data);
    }
    return data;
});
var BridgeAdHook = new function() {
  this.created = false;
  this.cleanupCalled = false;
};
AdService.setAdHook('bridge:prepare', function (data, meta) {
    var variantProperties = {};
    if (data.components.skyright.widthVariant === 'static') {
        variantProperties = $.extend(true, {
            components: {
                skyright: {
                    width: 130
                }
            }
        }, variantProperties);
    } else {
        variantProperties = $.extend(true, {
            components: {
                skyright: {
                    widthVariant: 'dynamic',
                    fallbackWidth: 130
                }
            }
        }, variantProperties);
    }
    if (data.components.skyleft.widthVariant === 'static') {
        variantProperties = $.extend(true, {
            components: {
                skyleft: {
                    width: 130
                }
            }
        }, variantProperties);
    } else {
        variantProperties = $.extend(true, {
            components: {
                skyleft: {
                    widthVariant: 'dynamic',
                    fallbackWidth: 130
                }
            }
        }, variantProperties);
    }
    if (data.variant === 'sitebar') {
        variantProperties = $.extend(true, {
            components: {
                skyleft: {
                    fallbackWidth: 220,
                    fallbackHeight: 600,
                    sticky: AdConstructor.stickyAllowed(),
                    minWidth: 220,
                    maxWidth: '100%',
                    height: '100%',
                    innerHeight: '100%'
                },
                skyright: {
                    fallbackWidth: 220,
                    fallbackHeight: 600,
                    sticky: AdConstructor.stickyAllowed(),
                    minWidth: 220,
                    maxWidth: '100%',
                    height: '100%',
                    innerHeight: '100%'
                }
            }
        }, variantProperties);
    }
    data = $.extend(true, {
        components: {
            billboard: {
                widthVariant: 'fullwidth',
                minWidth: 682,
                fallbackWidth: 682
            },
            skyright: {
                height: 850
            },
            skyleft: {
                height: 850
            }
        }
    }, variantProperties, data);
    BridgeAdHook.created = true;
    return data;
});
AdService.on('cleanup', function() {
    if (BridgeAdHook.created && !BridgeAdHook.cleanupCalled) {
        PageLayout.forceRefresh();
        BridgeAdHook.cleanupCalled = true;
    }
});
AdService.setAdHook('sitebar:prepare', function (data, meta) {
    var variantProperties = {};
    if (typeof data.components.billboard !== 'undefined') {
        $.extend(variantProperties, {
            components: {
                billboard: {
                    widthVariant: 'fullwidth',
                    minWidth: 682,
                    fallbackWidth: 682,
                    align: 'right'
                }
            }
        });
    }
    data = $.extend(true, {}, variantProperties, data);
    return data;
});
var DoubleSitebarAdHook = new function() {
    this.created = false;
    this.cleanupCalled = false;
};
AdService.setAdHook('double-sitebar:prepare', function (data, meta) {
    var variantProperties = {};
    data = $.extend(true, {
        components: {
            skyright: {
                sticky: AdConstructor.stickyAllowed(),
                widthVariant: 'dynamic',
                minWidth: 220,
                fallbackWidth: 220,
                fallbackHeight: 600,
                maxWidth: '100%',
                height: '100%',
                innerHeight: '100%'
            },
            skyleft: {
                sticky: AdConstructor.stickyAllowed(),
                widthVariant: 'dynamic',
                minWidth: 220,
                fallbackWidth: 220,
                fallbackHeight: 600,
                maxWidth: '100%',
                height: '100%',
                innerHeight: '100%'
            }
        }
    }, variantProperties, data);
    DoubleSitebarAdHook.created = true;
    return data;
});
AdService.on('cleanup', function() {
    if (DoubleSitebarAdHook.created && !DoubleSitebarAdHook.cleanupCalled) {
        PageLayout.forceRefresh();
        DoubleSitebarAdHook.cleanupCalled = true;
    }
});
AdService.setAdHook('notification', function (data, meta) {
    if (!PageLayout.config.topper) {
        return;
    }
    if (data.variant === 'topper') {
        if (AdService.positions.notification._disabled) {
            return;
        }
        $(document).on('notification-show', function () {
            var $adBGRight = $('#adBgRight');
            if ($adBGRight.length > 0) {
                $adBGRight.css('height', $('body').outerHeight(true));
            }
            if (typeof StickyLogin != "undefined") {
                var topperHeight = $('#topper, .notification-alert').outerHeight();
                StickyLogin.setYOffset('topper', topperHeight, true);
            }
        });
        $(document).on('notification-hide', function () {
            $('body').css('margin-top', 0);
            var $adBGRight = $('#adBgRight');
            if ($adBGRight.length > 0) {
                $adBGRight.css('height', $('body').outerHeight());
            }
            if (typeof StickyLogin != "undefined") {
                StickyLogin.setYOffset('topper', 0, true);
            }
        });
        var topScript = document.createElement('script');
        topScript.type = 'text/javascript';
        topScript.src = data.notification.url;
        var headID = document.getElementsByTagName('head')[0];
        headID.appendChild(topScript);
    }
});
AdService.setAdHook('cinematic:prepare', function (data, meta) {
    var variantProperties = {};
    data = $.extend(true, {
        components: {
            cinematic: {
                'height': 380,
                'width': '100%',
                fallbackWidth: '100%'
            }
        }
    }, variantProperties, data);
    if (typeof data.components.cinematic.fallback !== 'string') {
        if (typeof data.components.cinematic.fallback['col2'] !== 'undefined' && typeof data.components.cinematic.fallback['col2'].width === 'undefined') {
            data.components.cinematic.fallback['col2'].width = 682;
        }
        if (typeof data.components.cinematic.fallback['col3'] !== 'undefined' && typeof data.components.cinematic.fallback['col3'].width === 'undefined') {
            data.components.cinematic.fallback['col3'].width = 1002;
        }
        if (typeof data.components.cinematic.fallback['col4'] !== 'undefined' && typeof data.components.cinematic.fallback['col4'].width === 'undefined') {
            data.components.cinematic.fallback['col4'].width = 1322;
        }
    }
    return data;
});
AdService.on('render:preparedata', function (data, meta) {
    if (data.render._type && data.render._type.indexOf('teaser-') === 0) {
        data.render._type = 'teaser-fs';
    }
});
AdService.setAdHook('_default', function (data, meta) {
    AdConstructor.createComponents(data, meta);
});
AdService.setTemplates({
    "teaser-fs": "<div class=\"uim-ad uim-fullsize-imageteaser\">\n <a href=\"{{clickurl}}\" target=\"{{target}}{{^target}}_blank{{/target}}\">\n <div class=\"uim-content\">\n <div class=\"teaser-img\">\n <div class=\"teaser-image-scaled\" style=\"background-image: url(\'{{imageurl}}\')\"></div>\n </div>\n <div class=\"details teaser-text\">\n <header>\n {{#partner}}<span class=\"partner\">{{partner}}</span>{{/partner}}\n {{#headline}}<span class=\"headline\">{{headline}}</span>{{/headline}}\n </header>\n <p>\n {{#subline}}<span class=\"subline\">\n {{#subline_lines}}{{line}}{{#notLast}}<br/>{{/notLast}}{{/subline_lines}}\n {{^subline_lines}}{{subline}}{{/subline_lines}}\n </span>{{/subline}}\n <span class=\"more\"></span>\n </p>\n <span class=\"consumerinfo\"><span><span>Anzeige</span></span></span>\n </div>\n {{#privacyicon}}\n <div class=\"privacy-icon\">\n {{#privacyurl}}<a href=\"{{privacyurl}}\" target=\"_blank\">{{/privacyurl}}\n <img src=\"{{privacyicon}}\" />\n {{#privacyurl}}</a>{{/privacyurl}}\n </div>\n {{/privacyicon}}\n </div>\n </a>\n</div>\r\n",
    "bubble": "<div id=\"bubble\">\n <a href=\"{{clickUrl}}\" target=\"_blank\" style=\"color: {{dynamic.textColor}}\">\n {{#showImage}}\n <div class=\"container\" style=\"background-image: url(\'{{imageUrl}}\')\">\n <span class=\"close\" onclick=\"Bubble.closeBubble(event)\"></span>\n {{/showImage}}\n {{^showImage}}\n <div class=\"container\" style=\"background-color: {{dynamic.backgroundColor}}\">\n <span class=\"close\" onclick=\"Bubble.closeBubble(event)\">\n <span class=\"times\">&times;</span>\n </span>\n <div class=\"content\">\n <div class=\"icon\">\n <img src=\"{{dynamic.iconUrl}}\" alt=\"Icon\">\n </div>\n <div class=\"text\">\n {{dynamic.text}}\n </div>\n </div>\n {{/showImage}}\n </div>\n </a>\n</div>\r\n",
    "cart-products": "<div class=\"cart-inner\">\n <div class=\"cart-title\">Zuletzt angesehen</div>\n {{#retargeting}}\n {{#products}}\n {{#show}}\n <div class=\"cart-product\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <img class=\"product-icon\" src=\"{{icon}}\"/>\n </a>\n <div class=\"product-description\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <div class=\"product-description-head\">{{headline}}</div>\n </a>\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <div class=\"product-description-body\">{{subline}}</div>\n </a>\n <div class=\"product-description-footer\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">Zum Produkt</a>\n <span data-index=\"{{index}}\" onclick=\"CartLayerProduct.removeProduct(event, this)\">Löschen</span>\n </div>\n </div>\n </div>\n {{/show}}\n {{/products}}\n {{/retargeting}}\n {{#allDeleted}}\n <div class=\"no-products\">Ihr Warenkorb ist leer.</div>\n {{/allDeleted}}\n {{#usualText}}\n <div class=\"no-products\">Sie haben keine {{site}} Produkte besucht.</div>\n {{/usualText}}\n</div>\n{{^retargeting}}\n <div class=\"cart-inner bottom\">\n <div class=\"cart-title\">Unsere Empfehlungen für Sie</div>\n {{#products}}\n {{#show}}\n <div class=\"cart-product\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <img class=\"product-icon\" src=\"{{icon}}\"/>\n </a>\n <div class=\"product-description\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <div class=\"product-description-head\">{{headline}}</div>\n </a>\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">\n <div class=\"product-description-body\">{{subline}}</div>\n </a>\n <div class=\"product-description-footer\">\n <a href=\"{{link}}\" onclick=\"CartLayerProduct.goToPage(event, this)\">Zum Produkt</a>\n </div>\n </div>\n </div>\n {{/show}}\n {{/products}}\n </div>\n{{/retargeting}}\r\n",
    "cart-count": "<span></span>\r\n",
    "content-slider-news": "<article class=\"slider-item\"{{#lastitem}} data-slider-lastitem=\"1\"{{/lastitem}}>\r\n <section class=\"news news-fullsize-item\">\r\n <div class=\"r1\">\r\n <div class=\"news-content\">\r\n <div class=\"teaser-content\">\r\n <a href=\"{{clickurl}}\" target=\"{{target}}{{^target}}_blank{{/target}}\">\r\n <div class=\"teaser-img\">\r\n <img width=\"300\" height=\"250\" src=\"{{imageurl}}\">\r\n </div>\r\n {{#headline}}\r\n <div class=\"details teaser-text\">\r\n <header> {{headline}}</header>\r\n {{#subline}}\r\n <p>\r\n <span class=\"subline\">{{subline}}</span>\r\n <span class=\"more\"></span>\r\n </p>\r\n {{/subline}}\r\n </div>\r\n {{/headline}}\r\n </a>\r\n </div>\r\n </div>\r\n </div>\r\n </section>\r\n</article>\r\n",
    '': ''
});
var AdRefresh = new function() {
    AdService.on('adblockdetected', function() {
        AdRefresh.stop();
    });
};
AdRefresh.checkPositionAndRegister = function(data) {
    if (!AdService.getPositionParam(data.position, '_adRefresh')) {
        return;
    }
    var $container = null;
    switch (data.position) {
        case 'rectangle':
            if (!data.meta) { return; }
            if (data.meta.adsize !== '300x250' && data.meta.adsize !== '300x115') { return; }
            $container = ContentService.ads[data.position] || $('[data-adservice-slot="' + data.position + '"]');
            break;
        case 'sky_right':
            $container = AdConstructor.createdComponents['skyright'];
            break;
        default:
            $container = ContentService.ads[data.position] || $('[data-adservice-slot="' + data.position + '"]');
            break;
    }
    if ($container && $container.length) {
        AdService.setPositionParam(data.position, '_container', $container);
        var timer = AdService.getPositionParam(data.position, '_refreshInterval');
        if (timer !== 'disabled') {
            AdRefresh.register(data.position, $container, timer);
        }
    } else {
    }
};
AdRefresh.register = function(pos, el, config) {
    if (config && typeof config !== 'object') { config = {interval:config}; }
    if (!el) { return; }
    var $el = $(el);
    var basicData = AdRefresh.storage[pos] ? AdRefresh.storage[pos] : {};
    AdRefresh.storage[pos] = $.extend({}, AdRefresh.defaults, {
        pos: pos,
        $element: $el,
        offset: $el.offset() || {left:0, top:0},
        size: {width:$el.width(), height:$el.height()||$el.children(':visible').height()},
        maxPendingDuration: AdRefresh.defaults.maxPendingDuration,
        seconds: 0,
        enabled: true
    }, basicData, config);
    $el.attr('data-refresh-position', pos);
    AdService.on('refresh', pos, function() {
        AdRefresh.refreshDone(AdRefresh.storage[pos]);
    });
    if (!AdRefresh.started) {
        AdRefresh.startTime = new Date();
        AdRefresh.start();
    }
};
AdRefresh.start = function() {
    if (AdRefresh.stopOnAdblock && AdService.isBlocked) { return AdRefresh.stop(); }
    AdRefresh.interval = window.setInterval(function() { AdRefresh.check(); }, 1000);
    AdRefresh.started = true;
};
AdRefresh.stop = function(position) {
    if (typeof position !== 'undefined') {
        if (typeof AdRefresh.storage[position] === 'undefined') { AdRefresh.storage[position] = {}; }
        AdRefresh.storage[position].enabled = false;
    } else {
        window.clearInterval(AdRefresh.interval);
        AdRefresh.started = false;
    }
};
AdRefresh.stopThisPosition = function() {
    AdRefresh.stop(AdService.lastRequestedPosition);
};
AdRefresh.check = function() {
    if (SiteInfo.isVisible()) {
        AdRefresh.checks++;
        for (var i in AdRefresh.storage) {
            if (!AdRefresh.storage.hasOwnProperty(i)) { continue; }
            var item = AdRefresh.storage[i];
            if (item.enabled && AdRefresh.getVisibleFraction(item) >= item.fraction) {
                if (item.interval && ++item.seconds >= item.interval && !item.refreshStarted) {
                    AdRefresh.refresh(item);
                }
            }
        }
    }
};
AdRefresh.getVisibleFraction = function(item) {
    var $win = $(window),
        dimension = {x:item.offset.left, y:item.offset.top, width:item.size.width, height:item.size.height, top:$win.scrollTop(), left:$win.scrollLeft()};
    dimension.scrolledLeft = dimension.left + window.innerWidth;
    dimension.scrolledTop = dimension.top + window.innerHeight;
    dimension.size = dimension.width * dimension.height;
    var visibleSize = (
        Math.min(dimension.scrolledLeft, dimension.x + dimension.width) - Math.max(dimension.left, dimension.x)
    ) * (
        Math.min(dimension.scrolledTop, dimension.y + dimension.height) - Math.max(dimension.top, dimension.y)
    );
    return visibleSize / dimension.size;
};
AdRefresh.refresh = function(item) {
    PrebidConnector.resetPosition(item.pos);
    item.refreshStarted = true;
    var doRefresh = function() {
        AdService.newPageContext();
        AdService.refresh(item.pos, item.size.width, item.size.height);
        item.seconds = 0;
        item.refreshStarted = false;
    };
    if (AdService.getPositionParam(item.pos, '_prebid') && PrebidConnector.isAllowed()) {
        PrebidConnector.startBidding([item.pos], PrebidConnector.timeout, doRefresh);
    } else {
        doRefresh();
    }
};
AdRefresh.refreshDone = function(item) {
};
AdRefresh.stopOnAdblock = true;
AdRefresh.started = false;
AdRefresh.checks = 0;
AdRefresh.storage = {};
AdRefresh.defaults = {
    interval: 0,
    fraction: 0.5,
    maxPendingDuration: 0
};
$(window).on('message', function(e) {
if (e.originalEvent.data === 'stopAdRefresh') {
    $('iframe').each(function() {
        if (this.contentWindow === e.originalEvent.source) {
            var position = $(this).closest('[data-refresh-position]').attr('data-refresh-position')
            if (typeof position !== 'undefined') {
                AdRefresh.stop(position);
            }
        }
    });
}

});
function adRefreshIntervalConfig(config) {
config = (''+config).split(' ');
for (var i=0, l=config.length; i<l; i++) {
    var item = config[i];
    if (!item) { continue; }
    if ((''+parseInt(item, 10)) === item) {
        var timer = parseInt(item, 10);
        if (timer) {
            AdService.setParam('_refreshInterval', timer);
            continue;
        }
        AdService.setParam('_refreshInterval', 'disabled');
        break;
    }
    var parts = item.split(':');
    if (parseInt(parts[1], 10) > 0) {
        AdService.setPositionParam(parts[0], '_refreshInterval', parseInt(parts[1], 10));
    } else {
        AdService.setPositionParam(parts[0], '_refreshInterval', 'disabled');
    }
}

}

AdService.on('cleanup', function(e) { return true; }, function(data) {
AdRefresh.checkPositionAndRegister({
    position: data.position,
    meta: data.meta
});
});
var InstantAds = new function () {
    this.debug = true;
    this.init = function () {
        this.originalDocumentWrite = document.write;
        this.preloadImages();
    };
    this.clearStorage = function () {
        localStorage.clear();
    };
    this.documentWriteStorage = '';
    this.captureDocumentWrite = function () {
        document.write = function (str) {
            InstantAds.documentWriteStorage += str;
        }
    };
    this.resetDocumentWrite = function () {
        document.write = this.originalDocumentWrite;
        this.documentWriteStorage = '';
    };
    this.hasAd = function (position) {
        var storage = this.getStorage();
        if (storage && typeof storage[position] === 'object' && storage[position].length > 0) {
            return true;
        }
        return false;
    };
    this.getAd = function (position) {
        var storage = this.getStorage();
        if (storage && typeof storage[position] === 'object' && storage[position].length > 0) {
            var ad = storage[position].shift();
            this.saveStorage(storage);
            return ad.source;
        }
        return false;
    };
    this.hasBanner = function (busterid) {
        var storage = this.getStorage();
        if (storage && typeof storage.banner === 'object' && typeof storage.banner[busterid] !== 'undefined') {
            return true;
        }
        return false;
    };
    this.getBanner = function (busterid) {
        var storage = this.getStorage();
        if (storage && typeof storage.banner === 'object' && typeof storage.banner[busterid] !== 'undefined') {
            return storage.banner[busterid].source;
        }
        return false;
    };
    this.getStorage = function () {
        var data = {};
        if (localStorage) {
            var rawData = localStorage.getItem('instant-ads');
            if (rawData) {
                try {
                    data = JSON.parse(rawData);
                } catch (e) {
                }
            }
        }
        return data;
    };
    this.saveStorage = function (ads) {
        if (localStorage) {
            localStorage.setItem('instant-ads', JSON.stringify(ads));
        }
    };
    this.preloadAd = function (position) {
        this.captureDocumentWrite();
        $.ajax(AdService.getAdUrl(position, AdService.currentServer.baseAdserverUrl), {
            dataType: 'script',
            position: position,
            success: function (data, textStatus) {
                InstantAds.saveAd(this.position, InstantAds.documentWriteStorage);
                InstantAds.resetDocumentWrite();
            }
        });
    };
    this.preloadBanner = function (busterid, position) {
        if (!this.hasBanner(busterid)) {
            position = position || 'rectangle';
            AdService.setPositionParam(position, 'busterid', busterid);
            this.captureDocumentWrite();
            $.ajax(AdService.getAdUrl(position, AdService.currentServer.baseAdserverUrl), {
                dataType: 'script',
                busterid: busterid,
                success: function (data, textStatus) {
                    InstantAds.saveBanner(this.busterid, InstantAds.documentWriteStorage);
                    InstantAds.resetDocumentWrite();
                }
            });
            delete AdService.positions[position].busterid;
        }
    };
    this.saveAd = function (position, source) {
        if (this.isRealBanner(source)) {
            var currentStorage = this.getStorage();
            if (typeof currentStorage[position] === 'undefined') {
                currentStorage[position] = [];
            }
            currentStorage[position].push({
                source: source,
                images: this.getImagesFromSource(source)
            });
            this.saveStorage(currentStorage);
        }
    };
    this.saveBanner = function (busterid, source) {
        if (this.isRealBanner(source)) {
            var currentStorage = this.getStorage();
            if (typeof currentStorage.banner === 'undefined') {
                currentStorage.banner = {};
            }
            currentStorage.banner[busterid] = {
                source: source,
                images: this.getImagesFromSource(source)
            };
            this.saveStorage(currentStorage);
        }
    };
    this.isRealBanner = function (source) {
        if (source.indexOf('NOADPROXYDEFAULT') !== -1) {
            return false;
        }
        return true;
    };
    this.getImagesFromSource = function (source) {
        var images = [];
        var imgTags = source.match(/<img.+?>/ig);
        if (imgTags !== null && imgTags.length > 0) {
            for (var i = 0, l = imgTags.length; i < l; i++) {
                var imgMatch = imgTags[i].match(/src="(.+?)"/i);
                if (imgMatch !== null && imgMatch.length >= 1) {
                    if (this.isValidUrl(imgMatch[1])) {
                        images.push(imgMatch[1]);
                        this.preloadImage(imgMatch[1]);
                    }
                }
            }
        }
        var createAdObject = source.match(/AdService\.createAd\(([\n\w\W]+?)\)/);
        if (createAdObject !== null && createAdObject.length === 2) {
            try {
                eval('InstantAds.tmp = ' + createAdObject[1]);
                var fallbackImages = this.getAllFallbackImages(InstantAds.tmp);
                if (fallbackImages.length > 0) {
                    Array.prototype.push.apply(images, fallbackImages);
                }
            } catch (e) {
            }
        }
        return images;
    };
    this.getAllFallbackImages = function (data) {
        var fallbacks = [];
        for (var key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            if (key === 'fallback') {
                fallbacks.push(data[key]);
            } else if (typeof data[key] === 'object' && !(data[key] instanceof Array)) {
                var subObjectFallbacks = this.getAllFallbackImages(data[key]);
                if (subObjectFallbacks.length > 0) {
                    Array.prototype.push.apply(fallbacks, subObjectFallbacks);
                }
            }
        }
        return fallbacks;
    };
    this.isValidUrl = function (url) {
        var re_weburl = new RegExp(
            "^" +
            "(?:(?:https?|ftp)://)" +
            "(?:\\S+(?::\\S*)?@)?" +
            "(?:" +
            "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
            "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
            "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
            "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
            "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
            "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
            "|" +
            "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
            "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
            "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
            "\\.?" +
            ")" +
            "(?::\\d{2,5})?" +
            "(?:[/?#]\\S*)?" +
            "$", "i"
        );
        return re_weburl.test(url);
    }
    this.preloadImages = function () {
        var storage = this.getStorage();
        for (var position in storage) {
            if (!storage.hasOwnProperty(position)) {
                continue;
            }
            for (var i = 0; i < storage[position].length; i++) {
                for (var j = 0; j < storage[position][i].images.length; j++) {
                    this.preloadImage(storage[position][i].images[j]);
                }
            }
        }
    };
    this.preloadImage = function (src) {
        try {
            (new Image(1, 1)).src = src;
        } catch (e) {
        }
    };
};
PostMessageHelper.add('iframe_json', function (sourceWindow, name, data) {
    var sourceIframe = PostMessageHelper.getIframe(sourceWindow);
    var $iframe = $(sourceIframe);
    var $container = $iframe.parent();
    AdService[AdService._render ? '_render' : 'render'](data, $container);
    $iframe.hide();
}, {
    allowedOrigins: '*'
});
var Layer = (function () {
    var _initializedLayers = [];
    var _init = function (options) {
        var settings = $.extend({
            name: undefined,
            layerContainer: false,
            layerOpener: false,
            layer: false,
            layerCloser: false,
            closerException: false,
            closeOnMouseLeave: false,
            closeOnOutsideClick: false,
            closeCallback: false,
            on: {},
            openInteraction: 'click'
        }, options);
        if (!settings.layerContainer || !settings.layer) {
            return;
        }
        $(settings.layerContainer).has(settings.layer).each(function () {
            var $container = $(this);
            var $layer = $(settings.layer, $container);
            if (settings.layerOpener) {
                if (settings.openInteraction === 'click') {
                    var $layerOpener = $(settings.layerOpener, $container);
                    if ($layerOpener.is('label') && _getCheckbox($layerOpener)) {
                        var $checkbox = _getCheckbox($layerOpener);
                        $checkbox.on('change', function (event) {
                            $(this).blur();
                            if ($(this).is(':checked')) {
                                _showLayer($layer, settings);
                            } else {
                                _hideLayer($layer, settings);
                            }
                        }).trigger('change');
                    } else {
                        $layerOpener.on(PageLayout._isSmallScreen ? 'touchend' : 'click', function (event) {
                            event.preventDefault();
                            $(this).blur();
                            _toggleLayer($layer, settings);
                        });
                    }
                } else {
                    $(settings.layerOpener, $container).on('mouseenter', function (event) {
                        event.preventDefault();
                        $(this).blur();
                        _showLayer($layer, settings);
                    });
                }
            }
            if (settings.layerCloser) {
                if (typeof settings.layerCloser === 'string') {
                    _initCloser(settings.layerCloser, $container, $layer, settings);
                } else if (typeof settings.layerCloser === 'object') {
                    for (var key in settings.layerCloser) {
                        if (typeof settings.layerCloser[key] === 'string') {
                            _initCloser(settings.layerCloser[key], $container, $layer, settings);
                        } else if (typeof settings.layerCloser[key] === 'object') {
                            _initCloser(settings.layerCloser[key].selector, $container, $layer, settings, settings.layerCloser[key].callback);
                        }
                    }
                }
            }
            if (settings.closeOnOutsideClick) {
                var closeContainer = document;
                if (typeof settings.closeOnOutsideClick === 'string' && $(settings.closeOnOutsideClick).length > 0) {
                    closeContainer = settings.closeOnOutsideClick;
                }
                $(closeContainer).on(PageLayout._isSmallScreen ? 'touchend' : 'click', function (event) {
                    if (Layer.openLayers > 0
                        && $(event.target).closest($container).length === 0
                        && (!settings.closerException || $(event.target).closest(settings.closerException).length === 0)
                    ) {
                        _hideLayer($layer, settings, true);
                    }
                });
            }
            if (settings.closeOnMouseLeave) {
                $(settings.layerContainer).on('mouseleave', function () {
                    _hideLayer($layer, settings, true);
                });
            }
            $layer.on({
                open: function (e) {
                    _showLayer($(this), settings, true);
                },
                close: function (e) {
                    _hideLayer($(this), settings, true);
                },
                toggle: function (e) {
                    _toggleLayer($(this), settings, true);
                }
            })
        });
        _initializedLayers.push(options);
    };
    var _getOpener = function ($layer, settings) {
        var $container = $layer.closest(settings.layerContainer);
        return $(settings.layerOpener, $container);
    }
    var _getCheckbox = function ($layerOpener) {
        var $checkbox = $('input[type="checkbox"]#' + $layerOpener.attr('for'));
        if ($checkbox.length) {
            return $checkbox;
        } else {
            return null;
        }
    }
    var _initCloser = function (closer, $container, $layer, settings, callback) {
        $(closer, $container).on('click', function (event) {
            event.preventDefault();
            $(this).blur();
            if (Layer.openLayers > 0) {
                _hideLayer($layer, settings, true);
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        });
    };
    var _toggleLayer = function ($layer, options, syncCheckbox) {
        if ($layer.closest(options.layerContainer).hasClass('open')) {
            _hideLayer($layer, options, syncCheckbox);
        } else {
            _showLayer($layer, options, syncCheckbox);
        }
    };
    var _syncCheckbox = function ($layer, options, isOpened) {
        var $opener = _getOpener($layer, options);
        if ($opener.is('label') && _getCheckbox($opener)) {
            $checkbox = _getCheckbox($opener);
            $checkbox.prop('checked', isOpened);
        }
    };
    var _showLayer = function ($layer, options, syncCheckbox) {
        if (!$layer.closest(options.layerContainer).hasClass('open')) {
            if (typeof options.name !== 'undefined') {
                $('body').attr('data-layer-' + options.name, 'open');
            }
            $layer.closest(options.layerContainer).addClass('open');
            Layer.openLayers++;
            LayerConflict.addLayer($layer, function () {
                $layer.trigger('close');
                if (typeof options.closeCallback === 'function') {
                    options.closeCallback();
                }
            });
            Layer.toggleFunctions.run('open');
            Layer.checkBodyClass();
            if (typeof options.on.open === 'function') {
                try {
                    options.on.open();
                } catch (e) {
                }
            }
        }
        if (syncCheckbox) {
            _syncCheckbox($layer, options, true);
        }
    };
    var _hideLayer = function ($layer, options, syncCheckbox) {
        if ($layer.closest(options.layerContainer).hasClass('open')) {
            $layer.closest(options.layerContainer).removeClass('open');
            Layer.openLayers--;
            LayerConflict.removeLayer($layer);
            if (typeof options.name !== 'undefined') {
                $('body').removeAttr('data-layer-' + options.name);
            }
            Layer.toggleFunctions.run('close');
            Layer.checkBodyClass();
            if (typeof options.on.close === 'function') {
                try {
                    options.on.close();
                } catch (e) {
                }
            }
        }
        if (syncCheckbox) {
            _syncCheckbox($layer, options, false);
        }
    };
    return {
        openLayers: 0,
        openLayersHidingAds: 0,
        toggleFunctions: new FunctionHook(),
        init: function (options) {
            _init(options);
        },
        checkBodyClass: function () {
            if (Layer.openLayers === 1) {
                $('html').addClass('layer-open');
            } else if (Layer.openLayers === 0) {
                $('html').removeClass('layer-open');
            }
        },
        initializedLayers: _initializedLayers
    }
})();
LoginReady.add(function () {
    Layer.init({
        name: 'loggedin',
        layerContainer: '.loggedin-layer',
        layerOpener: '.opener',
        layer: '.layer-content',
        closeOnOutsideClick: true
    });
});
var LayerConflict = {
    settings: {
        criticalElements: [
            {
                selector: '#adRectangle',
                bodyClass: 'hideMedRecTop',
                jsHide: false,
                contentCheck: function ($container) {
                    $('.ad-component-rectangle.ad-component-content-html', $container).length > 0 ? false : true
                }
            },
            {
                selector: '.ad-component.ad-component-content-flash:not(.ad-component-maxiframe)',
                bodyClass: 'hideSpecialAd',
                jsHide: false,
                isGroup: true
            },
        ]
    },
    layerStack: [],
    criticalElements: [],
    groups: [],
    addLayer: function ($layer, closeCallback) {
        if (!LayerConflict.isLayerInStack($layer)) {
            LayerConflict.layerStack.push({
                layer: $layer,
                closeCallback: closeCallback
            });
            LayerConflict.check();
        }
    },
    closeAllLayer: function () {
        var callbacks = [];
        for (var i = 0; i < LayerConflict.layerStack.length; i++) {
            if (typeof LayerConflict.layerStack[i].closeCallback === 'function') {
                callbacks.push(LayerConflict.layerStack[i].closeCallback);
            }
        }
        for (var i = 0; i < callbacks.length; i++) {
            callbacks[i]();
        }
    },
    isLayerInStack: function ($layer) {
        var check = false;
        $.each(LayerConflict.layerStack, function () {
            if ($layer.is(this.layer)) {
                check = true;
                return true;
            }
        });
        return check;
    },
    removeLayer: function ($layer) {
        for (var i in LayerConflict.layerStack) {
            if ($layer.is(LayerConflict.layerStack[i].layer)) {
                LayerConflict.layerStack.splice(i, 1);
            }
        }
        LayerConflict.check();
    },
    check: function () {
        LayerConflict.updateCriticalElements();
        if (LayerConflict.layerStack.length === 0) {
            LayerConflict.showElements(LayerConflict.criticalElements);
            return;
        }
        if (LayerConflict.criticalElements.length === 0) {
            return;
        }
        var elementsToHide = [];
        $.each(LayerConflict.layerStack, function () {
            var $layer = this.layer;
            var layerSize = LayerConflict.getSize($layer);
            $.each(LayerConflict.criticalElements, function () {
                var $element = this;
                if (LayerConflict.isOverlapping(layerSize, $element)) {
                    elementsToHide = LayerConflict.addElement($element, elementsToHide);
                }
            });
        });
        var elementsToShow = $.merge([], LayerConflict.criticalElements);
        if (elementsToHide.length > 0) {
            LayerConflict.hideElements(elementsToHide);
            $.each(elementsToHide, function () {
                var index = $.inArray(this, elementsToShow);
                if (index !== -1) {
                    elementsToShow.splice(index, 1);
                }
            });
        }
        LayerConflict.showElements(elementsToShow);
    },
    addElement: function ($element, targetArray) {
        for (var i = 0; i < LayerConflict.groups.length; i++) {
            if ($.inArray($element, LayerConflict.groups[i]) !== -1) {
                targetArray = LayerConflict.addGroup(LayerConflict.groups[i], targetArray);
            }
        }
        targetArray.push($element);
        return targetArray;
    },
    addGroup: function (group, targetArray) {
        for (var i = 0; i < group.length; i++) {
            if ($.inArray(group[i], targetArray) === -1) {
                targetArray.push(group[i]);
            }
        }
        return targetArray;
    },
    isOverlapping: function (as, bs) {
        var a = (typeof as.left !== 'undefined' && typeof as.top !== 'undefined' && typeof as.right !== 'undefined' && typeof as.bottom !== 'undefined') ? as : LayerConflict.getSize(as);
        var b = (typeof bs.left !== 'undefined' && typeof bs.top !== 'undefined' && typeof bs.right !== 'undefined' && typeof bs.bottom !== 'undefined') ? bs : LayerConflict.getSize(bs);
        return (a.right > b.left && a.left < b.right && a.bottom > b.top && a.top < b.bottom);
    },
    getSize: function ($element) {
        if ($element.is(':visible')) {
            var offset = $element.offset();
            return {
                top: offset.top,
                right: offset.left + $element.outerWidth(),
                bottom: offset.top + $element.outerHeight(),
                left: offset.left
            }
        } else {
            return {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    },
    hideElements: function (array) {
        $.each(array, function () {
            LayerConflict.hideElement($(this));
        });
    },
    hideElement: function ($element) {
        if ($element.is(':visible')) {
            var elementData = $element.data();
            if (elementData) {
                if (elementData.bodyClass) {
                    $('body').addClass(elementData.bodyClass);
                }
                if (elementData.jsHide) {
                    $element.hide();
                }
            } else {
                $element.hide();
            }
        }
    },
    showElements: function (array) {
        $.each(array, function () {
            LayerConflict.showElement($(this));
        });
    },
    showElement: function ($element) {
        var elementData = $element.data();
        if (elementData) {
            if (elementData.bodyClass) {
                $('body').removeClass(elementData.bodyClass);
            }
            if (elementData.jsHide) {
                $element.css('display', '');
            }
        } else {
            $element.show();
        }
    },
    getSelector: function (selector) {
        return typeof selector === 'string' ? selector : selector.selector;
    },
    getElementData: function (element) {
        element = typeof element === 'string' ? {selector: element} : element;
        var data = $.extend({
            layerConflict: true,
            selector: undefined,
            isGroup: false,
            bodyClass: false,
            jsHide: true
        }, element);
        if (data.isGroup) {
            data.groupIndex = LayerConflict.createNewGroup();
        }
        return data;
    },
    createNewGroup: function () {
        return LayerConflict.groups.push([]) - 1;
    },
    updateCriticalElements: function () {
        window.requestAnimationFrame(function () {
            for (var i = 0; i < LayerConflict.settings.criticalElements.length; i++) {
                var elementData = LayerConflict.getElementData(LayerConflict.settings.criticalElements[i]);
                $(elementData.selector).each(function () {
                    var $element = $(this);
                    if ($element.is(':visible') && !$element.data().layerConflict && (typeof elementData.contentCheck !== 'function' || elementData.contentCheck($element))) {
                        $element.data(elementData);
                        LayerConflict.criticalElements.push($element);
                        if (elementData.isGroup) {
                            LayerConflict.groups[elementData.groupIndex].push($element);
                        }
                    }
                });
            }
        });
    }
}

    ContentService.FinishedHook.add(function () {
        LayerConflict.updateCriticalElements();
    });
var track = function(name, type, additionalParams, options) {
    additionalParams = additionalParams || {};
    options = options || {};
    if (!options.nct) {
        track.counter++;
    }
    if (options.nct) {
        additionalParams['_c'] = '0';
    }
    if ((type === 'event' || type === 'pi') && PageConfig.reco) {
        additionalParams['reco'] = PageConfig.reco;
    }
    if (typeof name === 'undefined' && typeof type === 'undefined') {
        return;
    }
    var url = track.getUrl(name, type, additionalParams, options);
    if (track.blocked && !options.nct) {
        track.stack.push(url);
    } else {
        if (track.counter === 1 && !options.nct) {
            track.blocked = true;
            track.createImage(url, function() {
                track.blocked = false;
                for (var i = 0; i < track.stack.length; i++) {
                    track.createImage(track.stack[i]);
                }
            });
        } else {
            track.createImage(url);
        }
    }
};
track.piData = {};
track.htmlStart = htmlStart;
track.counter = 0;
track.blocked = false;
track.stack = [];
track.createImage = function(url, callback) {
    if (url) {
        url += '&ts=' + (new Date()).getTime();
        var image = new Image(1, 1);
        if (typeof callback === 'function') {
            image.onload = callback;
        }
        image.src = url;
    }
};
track.getUrl = function(name, type, additionalParams, options) {
    additionalParams = $.extend({
        type: type === 'pi' ? 'view' : 'hidden'
    }, additionalParams);
    options = options || {};
    var params = $.extend({}, track.basicParams, additionalParams || {});
    return (options.nct ? this.pathNct : this.path) + this.brand + '/' + this.brand + '/s?name=' + track.page + '.startseite.' + type + '.' + name + track._getParamString(params);
};
track._getParamString = function(data) {
    var paramString = '';
    var dontEncodeValue = ['teaser'];
    for (var key in data) {
        if (!data.hasOwnProperty(key)) { return }
        var value = typeof data[key] === 'function' ? data[key]() : data[key];
        if (value) {
            if (dontEncodeValue.indexOf(key) === -1) {
                paramString += '&' + key + '=' + encodeURIComponent(value);
            } else {
                paramString += '&' + key + '=' + value;
            }
        }
    }
    return paramString;
};
    track.path = (['qa', 'qa-bs', 'qa-ba', 'dev'].indexOf(SiteInfo.stage) !== -1) ? '//wa-qa.gmx.' + SiteInfo.tld + '/' : '//wa.gmx.' + SiteInfo.tld + '/';
track.pathNct = '//nct.ui-portal.de/';
if (['qa', 'qa-bs', 'qa-ba', 'dev'].indexOf(SiteInfo.stage) !== -1 && getUrlParam('_brainSimulator')) {
    track.path = '//brain-simulator-bs-qa.server.lan/';
    track.pathNct = '//brain-simulator-bs-qa.server.lan/';
}

track.brand = SiteInfo.brand;
track.getCategory = function() {
    return (AdService.params.section != 'homepage' && AdService.params.section.indexOf('/') > -1) ? AdService.params.section.split('/')[1] : AdService.params.section;
};
track.page = SiteInfo.portal;
track.sessionid = $.cookie.get('ui_cid', false);
track.sspVariant = 'default';
BodyStarted.add(function() {
    try {
        track.sspContent = (typeof window.SS !== 'undefined' && typeof window.SS.EventTrack !== 'undefined');
    } catch (e) { }
    try {
        track.sspVariant = window.SiteInfo.sitespect ? window.SiteInfo.sitespect : 'default';
    } catch (e) { }
});
track.screenres = (screen.width || 0) + 'x' + (screen.height || 0);
track.viewres = ($(window).width()||'?')+'x'+($(window).height()||'?');
track.basicParams = {
    portal: SiteInfo.brand,
    country: SiteInfo.country,
    'var': function() {
        return window.consent.features.brainTracking ? track.sspVariant : '';
    },
    pvid: (function() {
        if (!window.consent.features.brainTracking) {
            return '';
        }
        var result = '';
        charSet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for (var i = 20; i > 0; --i) result += charSet[Math.floor(Math.random() * charSet.length)];
        return result;
    })(),
    login: SiteInfo.loggedIn ? "1" : "0"
};
track.getPeriod = function() {
    return (new Date()).getTime() - track.htmlStart;
}

track.getCoremediaIdFromUrl = function(url) {
    var cID = parseInt(url.split('-').pop());
    return (isNaN(cID)) ? 0 : cID;
};
track.getLinkIdentifier = function($link, moduleName, index) {
    return moduleName + ',' + index + ',' + track.getCoremediaIdFromUrl($link.attr('href'));
};
track.prepareTextForTracking = function(text) {
    return $.trim((''+text).replace(/\./g, ''));
};
track.addHash = function($link, moduleName, params, options) {
    options = options || {};
    if (options.sitespect && !$link.data('ss-tracked') && typeof SS !== 'undefined') {
        if (typeof track.sspMetrics !== 'undefined' && typeof track.sspMetrics[moduleName] !== 'undefined') {
            if (typeof track.sspMetrics[moduleName] === 'function') {
                if (track.sspMetrics[moduleName]($link)) {
                    SS.EventTrack.rp(track.sspMetrics[moduleName]($link), 1);
                }
            } else {
                SS.EventTrack.rp(track.sspMetrics[moduleName], 1);
            }
            $link.data('ss-tracked', true);
        } else if (track.sspContent) {
            SS.EventTrack.rp('content', 1);
            $link.data('ss-tracked', true);
        } else {
        }
    } else {
    }
    if ($link.attr('href').indexOf('#') !== -1) { return; }
    params = params.length ? params : [params];
    var recoModules = ['pointOfViewTeaser', 'inactivityLayer'];
    recoModules.push('heroBreakingNews', 'hero');
    var moduleNameToTrack = moduleName;
    if (PageConfig.reco && PageConfig.reco === 'treatment' && recoModules.indexOf(moduleName) !== -1) {
            moduleNameToTrack += '_treatSimple';
    }
    params.unshift(moduleNameToTrack);
    params.unshift($link.is('[target="_blank"]') ? SiteInfo.brand + '-' + track.page : track.page);
    if ($link.is('[data-ab-testid]') && $link.is('[data-ab-name]')) {
        params[params.length - 1] = params[params.length - 1] + '-' + $link.attr('data-ab-testid') + '-' + $link.attr('data-ab-name');
    }
    for (var i = 0, l = params.length; i < l; i++) {
        params[i] = encodeURIComponent(track.prepareTextForTracking(params[i]));
    }
    $link.attr('href', $link.attr('href') + '#.' + params.join('.'));
};
track.hashLinkStorage = {};
track.registerHashLink = function(selector, handler) {
    if (typeof track.hashLinkStorage[selector] !== 'undefined') {
        console.error('Für den Selector (' + selector + ') ist bereits ein Handler registriert.')
    } else {
        track.hashLinkStorage[selector] = handler;
        $(document).on('mousedown touch', selector, handler);
    }
};
track.unregisterHashLink = function(selector) {
    if (typeof track.hashLinkStorage[selector] !== 'undefined') {
        $(document).off('mousedown touch', selector, track.hashLinkStorage[selector]);
    } else {
        console.error('Für den Selector (' + selector + ') wurde kein Handler gefunden.');
    }
};
track.moduleNames = {
    '.hero': 'hero',
    '.news-spotlight': 'pointOfViewTeaser',
    '.news-fullsize': function($module) {
        if ($module.closest('.content-slider').length) {
            return 'single';
        } else if ($module.index('.wrapper-indent > .news-fullsize') < 3) {
            return 'pointOfViewTeaser';
        } else {
            return 'single';
        }
    },
    '.liveticker': 'topevent',
    '.multi-news:not(.hero)': function($module) {
        if ($module.is('[data-module-name="slideshows"]')) {
            return 'topSlideshowsTeaser';
        } else {
            return $module.is('[data-module-name="topViewedVideos"]') ? 'topVideosTeaser' : 'channel_small';
        }
    },
    '.icons': 'service_icon',
    '.service:not(.top-search):not(.icon)': function($module) {
        return $module.attr('class').split(' ')[1].replace(/-/,'_');
    },
    '.channel': function($module) {
        var newsInChannel = $('.news', $module).length;
        return 'channel' + newsInChannel;
    },
    '.horoscope': 'horoscope',
    '.top-article': 'top_article',
    '.content-slider.games': 'gamesslider',
    '.top-editorial': 'topnews',
    '.breaking-news': 'breakingNewsLine',
    '.iframe-widget': 'olympia2018widget'
};
track.getModuleName = function($module) {
    var name;
    for (var key in track.moduleNames) {
        if (track.moduleNames.hasOwnProperty(key)) {
            if ($module.is(key)) {
                if (typeof track.moduleNames[key] === 'function') {
                    name = track.moduleNames[key]($module);
                } else {
                    name = track.moduleNames[key];
                }
                break;
            }
        }
    }
    return name;
};
track.getText = function($element, headlineSelector) {
    if (typeof headlineSelector !== 'undefined' && $(headlineSelector, $element).length) {
        return track.getText($(headlineSelector, $element));
    }
    var headlineData = $element.data();
    return $.trim((headlineData && typeof headlineData.ellipsisOrigText !== 'undefined') ? headlineData.ellipsisOrigText : $element.text());
};
track.getStoryIndex = function(heroIndex, linkIndex) {
    return '' + heroIndex + '0' + (linkIndex + 1);
};
track.heroCountOffset = 0;
track.abd = function(data) {
    track('ovk', 'event', {
        adb: ''+data
    }, {
        nct: true
    });
};
$(document).ready(function () {
    var ScrollTracking = {
        pointsToTrack: [25, 50, 75, 100],
        nextMarker: false,
        init: function () {
            ScrollTracking.calcNextMarker();
            PageLayout.onchange(function () {
                ScrollTracking.calcNextMarker();
            });
            $(window).on('scroll', function () {
                var $window = $(this);
                if (($window.scrollTop() + $window.innerHeight()) >= ScrollTracking.nextMarker) {
                    ScrollTracking.reachedNextMarker();
                }
            });
        },
        calcNextMarker: function () {
            var documentHeight = $(document).height();
            var nextPoint = ScrollTracking.pointsToTrack[0];
            ScrollTracking.nextMarker = parseInt(documentHeight * (nextPoint / 100), 10);
            if (nextPoint === 100) {
                ScrollTracking.nextMarker = ScrollTracking.nextMarker - 5;
            }
        },
        reachedNextMarker: function () {
            var marker = ScrollTracking.pointsToTrack.shift();
            track('scroll_' + marker, 'event');
            ScrollTracking.calcNextMarker();
        }
    }
    ScrollTracking.init();
});
HeroReady.add(function () {
    var hp_formular = '';
    $('.tab-container form').submit(function (ev) {
        var form = this;
        ev.preventDefault();
        if (ev.originalEvent !== undefined) {
            var identifier = $(form).attr('id');
            switch (identifier) {
                case 'promailLoginForm':
                    hp_formular = 'promail';
                    break;
                case 'topmailLoginForm':
                    hp_formular = 'topmail';
                    break;
                case 'freemailLoginForm':
                    hp_formular = 'freemail';
                    break;
                case 'demailLoginForm':
                    hp_formular = 'demail';
                    break;
                case 'domainLoginForm':
                    hp_formular = 'domain';
                    break;
                default:
                    hp_formular = 'search';
                    break;
            }
            if (PageState.get('loginState') === 'fixed') {
                hp_formular += '_sticky';
            }
            track('formular.' + hp_formular, 'event');
        }
        form.submit();
    });
});
BodyStartedAfter.add(function() {
    var toolbarInfo = {};
    if ($.ua.browser.name === 'msie') {
        try {
            var ieInfo = navigator.userAgent.match(/tb-([a-z]+)\/([0-9\.]+)(; \([a-z]+\/[0-9\.]+\))?/i);
            if (ieInfo) {
                toolbarInfo.brand = ieInfo[1];
                toolbarInfo.version = ieInfo[2];
                toolbarInfo.bbrowser = ieInfo[3] ? true : false;
            }
        } catch (e) { }
    } else {
        toolbarInfo.kid = $('html[united-toolbar-campaignid]').attr('united-toolbar-campaignid');
        toolbarInfo.mode = $('html[united-toolbar-mode]').attr('united-toolbar-mode');
        toolbarInfo.variant = $('html[united-toolbar-variant]').attr('united-toolbar-variant');
        toolbarInfo.brand = $('html[united-toolbar-brand]').attr('united-toolbar-brand');
        toolbarInfo.bbrowser = $('html[united-toolbar-branded-browser]').attr('united-toolbar-branded-browser');
        toolbarInfo.version = $('html[united-toolbar-version]').attr('united-toolbar-version');
        toolbarInfo.accc = $('html[united-toolbar-accountconfigured]').attr('united-toolbar-accountconfigured');
    }
    track.piData = {
        category: track.getCategory(),
        error: $('.hint-error').attr('data-hint') || 'none',
        screenres: window.consent.features.brainTracking ? track.screenres : '',
        viewres: window.consent.features.brainTracking ? track.viewres : '',
        session: window.consent.features.brainTracking ? track.sessionid : '',
        title: document.title,
        pageurl: location.href,
        referrer: document.referrer,
        prv_mode: '' + SiteInfo.prvMode,
        tb_kid: '' + toolbarInfo.kid,
        tb_mode: '' + toolbarInfo.mode,
        tb_var: '' + toolbarInfo.variant,
        tb_brand: '' + toolbarInfo.brand,
        tb_bbrowser: '' + toolbarInfo.bbrowser,
        tb_version: '' + toolbarInfo.version,
        tb_accc: '' + toolbarInfo.accc,
        lvts: '' + (window.consent.features.brainTracking ? (window.PageConfig.brain || {}).lvts : ''),
        segment: '' + (window.consent.features.brainTracking ? ((window.PageConfig.brain || {}).segment) : ''),
        consentLevel: $.cookie.get('consentLevel', typeof CookieLasche !== 'undefined' && CookieLasche.isRequired() ? '0' : 'undefined'),
        ngu: function() { return window.consent.features.brainTracking ? (window.x || AdService.params.nguserid || 'undefined') : ''; }
    };
    track('default', 'pi', track.piData);
        if (SiteInfo.country === 'de') {
            var intervals = [2000, 5000, 10000, 20000, 30000, 60000, 120000];
            for (var i = 0, l = intervals.length; i < l; i++) {
                (function() {
                    var counter = i + 1;
                    window.setTimeout(function() {
                        track('duration.' + counter, 'event');
                    }, intervals[i]);
                })();
            }
        }
});
var getUpdateEventParams = function() {
    var params = {
        size: 'col' + PageState.get('cols') + (PageState.get('border') ? '' : 'border'),
        av: PageLayout.adVariant,
        at: PageLayout.adType
    };
    params['pageloadtime'] = SiteInfo.prebidDuration;
    return params;
};
ContentService.FinishedHook.add(function() {
    track('update', 'event', $.extend({}, track.piData, getUpdateEventParams()));
    track(PageLayout.adType, 'event', {
        teaser: function() {
            var returns = [];
            var $modules = $('.wrapper-indent > .top-editorial, .wrapper-indent > .news, .wrapper-indent > .news-spotlight, .wrapper-indent > .news-fullsize').filter(':lt(5)');
            var pointOfViewTeaserCounter = 0;
            $modules.each(function() {
                var $this = $(this);
                var moduleName = track.getModuleName($this);
                if (moduleName === 'hero') {
                    $('.teaser-content .teaser-text a', $this).filter( function() {
                        return ($(this).parents('.link-list').length === 0);
                    }).each(function(id) {
                        returns.push(track.getLinkIdentifier($(this), moduleName, id + track.heroCountOffset));
                    });
                    $('.hero .teaser-content').each(function(teaserIndex) {
                        $('.link-list a', this).each(function(linkIndex) {
                            returns.push(track.getLinkIdentifier($(this), moduleName, track.getStoryIndex(teaserIndex, linkIndex)));
                        });
                    });
                } else {
                    var linkSelector = '';
                    if (moduleName === 'top-editorial' || moduleName === 'pointOfViewTeaser') {
                        linkSelector = '.teaser-text a';
                    } else {
                        linkSelector = '.news-list a';
                    }
                    $(linkSelector, $this).each(function(id) {
                        var $this = $(this);
                        var index;
                        if (moduleName === 'pointOfViewTeaser' || moduleName === 'focus') {
                            index = pointOfViewTeaserCounter;
                            pointOfViewTeaserCounter++;
                        } else {
                            index = id;
                            if ((moduleName === 'topVideosTeaser' || moduleName === 'channel_small' || moduleName === 'topSlideshowsTeaser') && index > 3) {
                                return;
                            }
                        }
                        var recoModules = ['pointOfViewTeaser'];
                        recoModules.push('heroBreakingNews', 'hero');
                        var moduleNameToTrack = moduleName;
                        if (PageConfig.reco && PageConfig.reco === 'treatment' && recoModules.indexOf(moduleName) !== -1) {
                                moduleNameToTrack += '_treatSimple';
                        }
                        returns.push(track.getLinkIdentifier($(this), moduleNameToTrack, index));
                    });
                }
            });
            return returns.join('|');
        }
    });
    StickyLogin.add(function(nextState) {
        if (PageState.get('loginState') === 'fixed') {
            track('show_sticky', 'event');
        }
    });
});
if (Math.floor(Math.random() * 20) === 1 || getUrlParam('_performance') === '1') {
    BodyStarted.add(function() {
        track('performance.bodyStarted.1', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
    LoginReady.add(function() {
        track('performance.loginReady.2', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
    AdService.on('cleanup', function(e) { return e.position === 'rectangle'; }, function(e) {
        track('performance.afterPrioad.3', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
    AdService.on('position', 'rectangleBottom', function() {
        track('performance.beforeRectangleBottom.4', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
    $(document).on('ready', function() {
        track('performance.documentReady.5', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
    $(window).on('load', function() {
        track('performance.windowLoad.6', 'event', {
            period: track.getPeriod()
        }, {
            nct: true
        });
    });
}

track.registerHashLink('html #adRectangle .news-fullsize a', function() {
    var $this = $(this);
    var moduleName = 'topRightTeaser';
    var text = track.getText($this, 'header');
    var index = 1;
    track.addHash($this, moduleName, [text, index], { sitespect: true });
});
track.registerHashLink('html #mainnav .layer a', function() {
    var $this = $(this);
    if ($this.closest('.user').length || $this.closest('.help').length) {
        return;
    }
    if ($this.closest('.slider-pagination').length) { return; }
    var $layer = $this.closest('.layer');
    var position;
    try {
        if ($layer.is('.layer-more')) {
            position = $('#mainnav > ul > li:visible').index($this.closest('#mainnav > ul > li')) + $this.closest('li.active').index();
        } else {
            position = $('#mainnav > ul > li:visible').index($this.closest('#mainnav > ul > li'));
        }
    } catch (e) { }
    var layerType;
    try {
        layerType = $layer.attr('class').split(' ')[1].replace('layer-', '');
    } catch (e) { }
    var layerText;
    try {
        if ($layer.is('.layer-more')) {
            var $liWithHeadline = $this.closest('ul').parents('ul').eq(0).closest('li');
            if ($liWithHeadline.closest('ul').is('#more-content-list')) {
                layerText = $liWithHeadline.find('label').text() || undefined;
            };
        } else {
            layerText = $.trim($layer.closest('li').find('> label figcaption').text());
        }
    } catch (e) { }
    var layerHeading;
    try {
        var $header = $layer.closest('li').find('> label header');
        if ($header.length && $header.text()) {
            layerHeading = $header.text();
        }
    } catch (e) { }
    var linkIndex;
    try {
        linkIndex = $('*:not(.slider-pagination) a', $layer).index($this);
    } catch (e) { }
    var linkType = $this.closest('.slider-box').length ? 'teaser' : 'text';
    var linkText = $.trim($this.text());
    linkText = linkText || undefined;
    track.addHash($this, 'header', [position + '_' + layerType + '_' + layerText + '_' + layerHeading, linkIndex + '_' + linkType + '_' + linkText]);
});
track.registerHashLink('html #header .help a', function() {
    track.addHash($(this), 'header', ['hilfe', 0]);
});
track.registerHashLink('html #header .user a', function() {
    var $this = $(this);
    var linkIndex = $('html #header .user a').index($this);
    track.addHash($(this), 'header', ['account', linkIndex + '_' + $this.text()]);
});
track.registerHashLink('html #header .weather a', function() {
    track.addHash($(this), 'weather', [undefined, 1]);
});
track.registerHashLink('.hero .teaser-content a', function() {
    var $this = $(this);
    var $module = $this.parents('.hero');
    var moduleName = track.getModuleName($module);
    if ($this.closest('.teaser-content').is('.breaking')) {
        moduleName = 'heroBreakingNews';
    }
    var $teaser = $this.parents('.teaser-content');
    var teaserIndex = $teaser.index();
    if ($this.closest('.link-list').length === 0) {
        var text = track.getText($teaser, 'header');
        track.addHash($this, moduleName, [text, teaserIndex + track.heroCountOffset], { sitespect: true });
    } else {
        var linkIndex = $this.parent('li').index();
        track.addHash($this, moduleName, [track.getText($this), track.getStoryIndex(teaserIndex, linkIndex)], { sitespect: true });
    }
});
track.registerHashLink('.hero .news-list a', function() {
    var $this = $(this);
    var $module = $this.parents('.hero');
    var moduleName = track.getModuleName($module);
    if ($('.breaking', $this.closest('li')).length) {
        moduleName = 'heroBreakingNews';
    }
    var text = track.getText($this, 'span:not(.placeholder)');
    var index = $this.closest('li').index();
    track.addHash($this, moduleName, [text, index + track.heroCountOffset], { sitespect: true });
});
track.registerHashLink('.wrapper-indent > .news-fullsize a', function() {
    var $this = $(this);
    var $module = $this.parents('.news-fullsize');
    var moduleName = track.getModuleName($module);
    var text = track.getText($this, 'header');
    var index = $module.index('.wrapper-indent > .news-fullsize');
    if (moduleName === 'single') {
        index = index - 3;
    }
    track.addHash($this, moduleName, [text, index], { sitespect: true });
});
track.registerHashLink('.top-editorial a', function() {
    var $this = $(this);
    var $module = $this.parents('.top-editorial');
    var moduleName = track.getModuleName($module);
    var text, index;
    if ($this.parent('li').length) {
        text = track.getText($this);
        index = $this.parent('li').index() + 1;
    } else {
        text = track.getText($module, 'header');
        index = 0;
    }
    track.addHash($this, moduleName, [text, index], { sitespect: true });
});
track.registerHashLink('.breaking-news a', function() {
    var $this = $(this);
    var $module = $this.parents('.breaking-news');
    var moduleName = track.getModuleName($module);
    var text = track.getText($('span:first-child', $this));
    track.addHash($this, moduleName, [text, 0], { sitespect: true });
});
track.registerHashLink('#footer-socialmarks a', function() {
    var $this = $(this);
    var moduleName = 'socialmarks';
    track.addHash($this, moduleName, [track.getText($this, 'header'), $this.index('#footer-socialmarks a')]);
});
track.registerHashLink('.liveticker *:not(.partner) > a', function() {
    var $this = $(this);
    var $module = $this.parents('.liveticker');
    var moduleName = track.getModuleName($module);
    var params = [this.textContent, $this.index('.liveticker *:not(.partner) > a')];
    if ($module.is('.champions-league')) {
        params.unshift('champions-league');
    } else if ($module.is('.bundesliga')) {
        params.unshift('bundesliga');
    }
    track.addHash($this, moduleName, params, { sitespect: true })
});
track.registerHashLink('.multi-news:not(.hero) a', function() {
    var $this = $(this);
    var $module = $(this).parents('.multi-news');
    var moduleName = track.getModuleName($module);
    var index, text;
    if ($this.parent('.news-list-teaser').length > 0) {
        index = $(this).parents('li').index();
        var $teaser = $($module.find('.teaser-content').get(index));
        text = track.getText($('a', $teaser), 'header');
    } else {
        text = track.getText($this, 'header');
        index = $this.parents('.teaser-content').index();
    }
    track.addHash($this, moduleName, [text, index], { sitespect: true });
});
track.registerHashLink('.service.icons a', function() {
    var $this = $(this);
    var $module = $this.parents('.icons');
    var moduleName = track.getModuleName($module);
    track.addHash($this, moduleName, [track.getText($this, 'header').toLowerCase(), $this.parents('.icon-wrapper').index()], { sitespect: true });
});
track.registerHashLink('.service.horoscope a', function() {
    var $this = $(this);
    var $module = $this.parents('.service');
    var moduleName = track.getModuleName($module);
    track.addHash($this, moduleName, [track.getText($this), $this.index('.service.horoscope a')], { sitespect: true });
});
track.registerHashLink('.service.top-article a', function() {
    var $this = $(this);
    var $module = $this.parents('.service');
    var moduleName = track.getModuleName($module);
    track.addHash($this, moduleName, [track.getText($this).replace(/mehr$/, ''), $this.index('.service.top-article a')], { sitespect: true });
});
track.registerHashLink('.service.product-list a', function() {
    var $this = $(this);
    var $module = $this.parents('.service');
    var moduleName = track.getModuleName($module);
    track.addHash($this, moduleName, [track.getText($this), $this.index('.service.product-list a')], { sitespect: true });
});
track.registerHashLink('.service.lotto a', function() {
    var $this = $(this);
    var $module = $this.parents('.service');
    var moduleName = track.getModuleName($module);
    track.addHash($this, moduleName, ['', $this.index('.service.lotto a')], { sitespect: true });
});
track.registerHashLink('.info-layer-inactive .news-content a', function() {
    var $this = $(this);
    var $module = $this.parents('.news-content');
    var moduleName = 'inactivityLayer';
    var text = track.getText($('header', $this));
    var index = $('.info-layer-inactive .news-content').index($module);
    track.addHash($this, moduleName, [text, index], { sitespect: true });
});
track.registerHashLink('.info-layer-inactive .btn-wrapper a', function() {
    var $this = $(this);
    track.addHash($this, 'inactivityLayer', ['back']);
});
track.registerHashLink('#header-image-link', function() {
    var $this = $(this);
    track.addHash($this, 'header_emotion', [0]);
});
track.registerHashLink('.content-slider.games a', function() {
    var $this = $(this);
    var $module = $this.parents('.content-slider');
    var moduleName = track.getModuleName($module);
    var text, submodul, linkIndex;
    if ($this.closest('.slider').length) {
        text = track.getText($this, 'header');
        submodul = 'teaser';
        linkIndex = $('a', $this.closest('.slider')).index($this);
    } else {
        text = track.getText($this);
        submodul = 'channel';
        linkIndex = $('a', $this.closest('.channel-list')).index($this);
    }
    track.addHash($this, moduleName, [text, submodul + '_' + linkIndex], { sitespect: true });
});
track.registerHashLink('#helplinks-neukunden a', function() {
    track.addHash($(this), 'header_1', ['9', 'mail']);
});
track.registerHashLink('#formLoginFreemail .login-username a', function() {
    track.addHash($(this), 'loginbox_1', ['1', 'registrierung']);
});
track.registerHashLink('.slider-headnav *:not(.logo) a', function() {
    var $this = $(this);
    var $module = $this.parents('.slider-headnav');
    var moduleName = 'channel_header';
    var $contentSlider = $module.closest('.content-slider');
    var text = track.getText($this);
    var sliderIndex = $('.wrapper-center:not(.first) .content-slider:not(.vorteilswelt):not(.games)').index($contentSlider);
    var channelName = track.getText($('.slider-headnav header', $contentSlider));
    var index;
    if ($this.closest('header').length) {
        index = 0;
    } else {
        index = $this.closest('li').index() + 1;
    }
    track.addHash($this, 'channelheader_' + sliderIndex + '_' + channelName , [text, index], { sitespect: true });
});
track.registerHashLink('.slider-headnav .logo a', function() {
    track.addHash($(this), 'channel_logo', [0], { sitespect: true });
});
track.registerHashLink('.wrapper-indent .slider > .news-fullsize a', function() {
    var $this = $(this);
    var $module = $this.parents('.news-fullsize');
    var moduleName = track.getModuleName($module);
    var text = track.getText($this, 'header');
    var $contentSlider = $this.closest('.content-slider');
    var sliderIndex = $('.wrapper-center:not(.first) .content-slider:not(.vorteilswelt):not(.games)').index($contentSlider);
    var channelName = track.getText($contentSlider.find('.slider-headnav header'));
    var index = $('.slider > .news-fullsize', $contentSlider).index($module);
    track.addHash($this, moduleName + '_' + sliderIndex + '_' + channelName, [text, index], { sitespect: true });
});
track.registerHashLink('.wrapper-indent .slider .iframe-widget a', function() {
    var $this = $(this);
    var $module = $this.parents('.iframe-widget');
    var moduleName = track.getModuleName($module);
    var $contentSlider = $this.closest('.content-slider');
    var sliderIndex = $('.wrapper-center:not(.first) .content-slider:not(.vorteilswelt):not(.games)').index($contentSlider);
    var channelName = track.getText($contentSlider.find('.slider-headnav header'));
    var index = $('.slider > .news-fullsize', $contentSlider).index($module);
    track.addHash($this, moduleName + '_' + sliderIndex + '_' + channelName, ['undefined', 0], { sitespect: !$module.is('[data-module-name="productsBoxImages"]') });
});
$(document).on('click', '.linked-image a', function() {
    track('unicef', 'click', {
        'click1': 'homepage',
        'click2': 'mr_teaser',
        'click3': 'unicef',
        'click4': $(this).data('resource-id')
    });
});
var Search = new function() {
    this.addOriginToSearchForm = function(suffix) {
        if (suffix === null) { return; }
        var $origin = $('.search-wrapper input[name=origin]');
        $origin.each(function() {
            var $this = $(this);
            $this.val($this.val() + ',' + suffix);
        });
    };
    this.addOriginToTopSearch = function(suffix) {
        if (suffix === null) { return; }
        $('.service.top-search a').each(function() {
            var $this = $(this);
            $this.attr('href', ($this.attr('href')||'').replace(/([?&]origin=[^&]+)/, function(m, b) { return b + ',' + suffix; }));
        });
    };
    this.addOriginToAll = function(suffix) {
        this.addOriginToSearchForm(suffix);
        this.addOriginToTopSearch(suffix);
    };
};
SearchCreated.add(function() {
    $('.search form').submit(function(ev) {
        var $form = $(this);
        if ($('.search-field', $form).val() == 0) {
            var action = $form.attr('action');
            action = action.replace('/web', '/webhp');
            $form.attr('action', action);
            $('input[name="q"]').prop('disabled', true);
            $('input[name="origin"]', $form).attr('name', 'src').attr('value', 'hp_start');
        }
    });
});
var doTif = function() {
    if (typeof NSfTIF !== 'undefined' ) {
        NSfTIF.track({
            pageidentifier: track.getCategory() === 'loginfailed' ? 'mail/logout/fail_login' : 'mail/logout/ad_dynamisch',
            cc:             AdService.params.region,
            region:         SiteInfo.country,
            brand:          SiteInfo.brand,
            deviceclass:    'desktop',
            frabo:          true        });
    }
}

var tifId = '2740';
if ((SiteInfo.stage === 'prelive' || SiteInfo.stage === 'qa' || SiteInfo.stage === 'qa-bs' || SiteInfo.stage === 'qa-ba') && getUrlParam('_tifId')) {
    tifId = getUrlParam('_tifId');
}

var tifUrl = '/\/uim.tifbs.net/js/' + tifId + '.js';
    BodyStarted.add(function() {
        document.write('\x3Cscript type="text/javascript" src="' + tifUrl + '">\x3C/script>');
    });
    BodyStartedAfter.add(function() {
        doTif();
    });
            if (SiteInfo.country === 'at' || SiteInfo.country === 'ch') {
            ContentService.FinishedHook.add(function() {
                postscribe($('.statistics:last'), '<script>if (typeof NSfTIF !== "undefined" ) { NSfTIF.callSurvey(); }</script>');
            });
        }
var Pagination = function (options) {
    if (!(this instanceof Pagination)) {
        return new Pagination(options);
    }
    var self = this;
    var init = function (options) {
        self.settings = $.extend({
            container: false,
            paginationContainer: false,
            paginationTemplate: undefined,
            prevCallback: false,
            nextCallback: false,
            checkCallback: false,
            prevItem: false,
            nextItem: false,
            disableOnClick: false,
            tracking: {
                prev: false,
                next: false
            }
        }, options);
        self.createContainer();
        self.initPagination();
    };
    this.checkPagination = function () {
        if (typeof self.settings.checkCallback === 'function') {
            self.settings.checkCallback(self);
        }
    };
    this.disablePrev = function () {
        self.$prevItem.closest('li').addClass('disabled');
    };
    this.disableNext = function () {
        self.$nextItem.closest('li').addClass('disabled');
    };
    this.enablePrev = function () {
        self.$prevItem.closest('li').removeClass('disabled');
    };
    this.enableNext = function () {
        self.$nextItem.closest('li').removeClass('disabled');
    };
    this.prevEnabled = function () {
        return !self.$prevItem.closest('li').hasClass('disabled');
    };
    this.nextEnabled = function () {
        return !self.$nextItem.closest('li').hasClass('disabled');
    };
    this.createContainer = function () {
        self.$container = $(self.settings.container);
        if (self.settings.prevItem && self.settings.nextItem) {
            self.$prevItem = $(self.settings.prevItem, self.$container);
            self.$nextItem = $(self.settings.nextItem, self.$container);
        } else {
            var $pagination = $(Mustache.render(ContentService.templates[self.settings.paginationTemplate ? self.settings.paginationTemplate : 'pagination-default']));
            self.$prevItem = $('.prev > a', $pagination);
            self.$nextItem = $('.next > a', $pagination);
            if (self.settings.paginationContainer) {
                $(self.settings.paginationContainer).append($pagination);
            } else {
                self.$container.append($pagination);
            }
        }
    };
    this.prev = function () {
        if (self.prevEnabled()) {
            if (self.settings.disableOnClick) {
                self.disablePrev();
            }
            if (self.settings.tracking && self.settings.tracking.prev) {
                self.track(self.settings.tracking.prev);
            }
            if (typeof self.settings.prevCallback === 'function') {
                self.settings.prevCallback();
            }
            self.checkPagination();
        }
    };
    this.next = function () {
        if (self.nextEnabled()) {
            if (self.settings.disableOnClick) {
                self.disableNext();
            }
            if (self.settings.tracking && self.settings.tracking.next) {
                self.track(self.settings.tracking.next);
            }
            if (typeof self.settings.nextCallback === 'function') {
                self.settings.nextCallback();
            }
            self.checkPagination();
        }
    };
    this.initPagination = function () {
        var self = this;
        self.$prevItem.on('click', function (e) {
            e.preventDefault();
            $(this).blur();
            self.prev();
        });
        self.$nextItem.on('click', function (e) {
            e.preventDefault();
            $(this).blur();
            self.next();
        });
        self.checkPagination();
    };
    this.track = function (pixel) {
        if (pixel) {
            if (typeof pixel === 'function') {
                pixel();
            } else {
                track.createImage(pixel);
            }
        }
    };
    init(options);
};
(function () {
    var Diashow = function (container, options) {
        var self = this;
        self.browserSupportsEffect = function (effect) {
            if ($.ua.os.name === 'android' && $.ua.browser.name === 'safari') {
                return false;
            } else {
                return true;
            }
        };
        self.activeSlide = 1;
        var init = function (container, options) {
            self.settings = $.extend({
                interval: 4000,
                transitionDuration: 250,
                sliderContainer: '.slider-container',
                slider: '.slider',
                effect: false,
                autostart: false,
                autostartDelay: 'direct',
                autoShowHide: false,
                animated: false,
                checkBeforeSwitch: undefined,
                navigationList: '.news-list',
                slideItem: '.teaser-content',
                defaultEffectDisabled: false,
                activateCallback: false,
                pagination: false,
                showState: false,
                switchOn: 'mouseenter',
                switchTracking: false,
                mobileDoubleClick: false
            }, options);
            self.$container = $(container);
            self.items = $(self.settings.slideItem, self.$container).length;
            if (self.settings.effect && !self.browserSupportsEffect(self.settings.effect)) {
                self.settings.effect = false;
                self.settings.defaultEffectDisabled = true;
            }
            self.$container.on('mouseover', function (event) {
                self.$container.data('blocker', true);
            });
            self.$container.on('mouseleave', function (event) {
                self.$container.data('blocker', false);
            });
            $('a', self.settings.slider).attr('tabIndex', '-1');
            $navigationListItems = $(self.settings.navigationList + ' li', self.$container);
            if (self.settings.mobileDoubleClick && PageLayout._isSmallScreen) {
                $navigationListItems.on('click', function (event) {
                    var $this = $(this);
                    if (!$this.data('clicked')) {
                        event.preventDefault();
                        event.stopPropagation();
                        $this.data('clicked', true).siblings().data('clicked', false);
                    }
                });
            }
            $navigationListItems.on(self.settings.switchOn, function (event) {
                if (typeof self.settings.checkBeforeSwitch != 'function' || self.settings.checkBeforeSwitch()) {
                    var $this = $(this);
                    var next = $this.index() + 1;
                    if (typeof self.settings.switchTracking === 'function') {
                        self.settings.switchTracking($this.index(), $this);
                    }
                    self.slideTo(next, event.type);
                }
            });
            $navigationListItems.on('focusin', function (event) {
                if (typeof self.settings.checkBeforeSwitch != 'function' || self.settings.checkBeforeSwitch()) {
                    var next = $(this).index() + 1;
                    self.slideTo(next, 'focusin');
                }
            });
            if (self.settings.pagination) {
                self.pagination = Pagination($.extend({
                    prevCallback: self.slidePrev,
                    nextCallback: self.slideNext
                }, self.settings.pagination));
            }
            if (self.settings.showState) {
                $(self.settings.sliderContainer, self.$container).append($('<span class="diashow-state">' + self.activeSlide + '/' + self.items + '</span>'));
            }
            if (typeof self.settings.onPageLayoutChange === 'function') {
                PageLayout.onchange(function () {
                    self.settings.onPageLayoutChange();
                });
            }
            self.slide();
            if (self.settings.activateCallback && typeof self.settings.activateCallback === 'function') {
                self.settings.activateCallback($(self.settings.slider + ' > :nth-child(' + self.activeSlide + ')', self.$container), 'initial');
            }
        };
        self.slide = function (next) {
            if (!$(self.settings.slideItem, self.$container).length) {
                return;
            }
            if (self.settings.effect) {
                $(self.settings.sliderContainer, self.$container).attr('data-slide-effect', self.settings.effect);
            }
            if (self.settings.autostart) {
                switch (true) {
                    case self.settings.autostartDelay == 'windowload' && !$.isReady:
                        $(window).on('load', function() {
                           self.startSliding();
                        });
                        break;
                    case self.settings.autostartDelay == 'windowload' && $.isReady:
                    case self.settings.autostartDelay == 'direct':
                    default:
                        self.startSliding();
                        break;
                }
            }
        };
        self.startSliding = function () {
            Metronome.add(function () {
                if (!self.$container.data('blocker') && (typeof self.settings.checkBeforeSwitch !== 'function' || self.settings.checkBeforeSwitch())) {
                    self.slideNext('metronome');
                }
            }, self.settings.interval);
        };
        self.slideTo = function (next, trigger) {
            if (self.activeSlide !== next) {
                if (next > self.items) {
                    next = 1;
                } else if (next < 1) {
                    next = self.items;
                }
                var $item = $(self.settings.slider + ' > :nth-child(' + next + ')', self.$container);
                if ($item.data('slide-id') == 'clone') {
                    next = 1;
                }
                if (self.settings.jsShowAndHide) {
                    $item.show().siblings().hide();
                }
                self.setActiveSlide(next);
                if (self.settings.defaultEffectDisabled) {
                    $(self.settings.sliderContainer, self.$container).toggleClass('dummyClassForRerendering');
                }
                $(self.settings.navigationList + ' li:nth-child(' + next + ')', self.$container).addClass('active').siblings().removeClass('active');
                if (self.settings.activateCallback && typeof self.settings.activateCallback === 'function') {
                    self.settings.activateCallback($item, trigger);
                }
                if (self.settings.showState) {
                    $('.diashow-state', self.$container).text(self.activeSlide + '/' + self.items);
                }
            }
        };
        self.setActiveSlide = function (index) {
            $(self.settings.sliderContainer, self.$container).attr('data-active-slide', index);
            self.activeSlide = index;
        };
        self.slideNext = function (trigger) {
            self.slideTo(self.activeSlide + 1, trigger);
        };
        self.slidePrev = function (trigger) {
            self.slideTo(self.activeSlide - 1, trigger);
        };
        init(container, options);
    };
    $.fn.diashow = function (method) {
        var _arguments = arguments;
        return $(this).each(function () {
            if (typeof method === 'string') {
                if (this.diashow instanceof Diashow) {
                    if (typeof this.diashow[method] === 'function') {
                        var args = Array.prototype.slice.call(_arguments, 1);
                        this.diashow[method].apply(this.diashow, args);
                    } else {
                    }
                } else {
                }
            } else {
                this.diashow = new Diashow(this, method);
            }
        });
    };
})(jQuery);
$('html').on('isVisibleInViewport', '.multi-news.hero', function () {
    var $hero = $(this);
    var $newsList = $('.news-list', $hero);
    $('.teaser-content', $hero).wrapLink({
        wrapLinkTo: ['.teaser-img', {
            selector: '.teaser-text',
            exclude: '.link-list'
        }]
    });
    $('.news-list li', $hero).wrapLink({
        linkSelector: 'figcaption a',
        exclude: 'header'
    });
    $hero.diashow({
        autostart: $hero.attr('data-diashow-autostart') == 0 ? false : true,
        autostartDelay: 'windowload',
        effect: 'fade',
        activateCallback: function ($item, trigger) {
            if (trigger !== 'mouseenter' && parseInt(PageState.get('cols')) !== 2) {
                var index = $item.index();
                var itemsAmount = $item.siblings().length + 1;
                var newMarginTop = 0;
                if (index > 1 && itemsAmount > 3) {
                    if (index <= itemsAmount - 2) {
                        newMarginTop = -75 * (index - 1);
                    } else {
                        newMarginTop = -75 * (itemsAmount - 3);
                    }
                }
                if (checkCssTransition()) {
                    $newsList.css({
                        'transform': 'translateY(' + newMarginTop + 'px)'
                    });
                } else {
                    $newsList.animate({
                        marginTop: newMarginTop + 'px'
                    });
                }
            }
        },
        pagination: {
            container: '.multi-news.hero .r2',
            tracking: {
                prev: function () {
                    track('hero_left', 'event');
                },
                next: function () {
                    track('hero_right', 'event');
                }
            }
        }
    });
});
$('html').on('isVisibleInViewport', '.multi-news:not(.hero)', function () {
    $(this).diashow();
});
$('html').on('isVisibleInViewport', '.service.lotto', function () {
    $(this).diashow({
        navigationList: '.slide-navigation',
        slideItem: '.service-content',
        autostart: true
    });
});
var Ellipsis = {
    functions: {},
    push: function (name, func) {
        Ellipsis.functions[name] = func;
    },
    get: function (name) {
        return Ellipsis.functions[name];
    },
    run: function (alignment, cols) {
        for (var i in Ellipsis.functions) {
            if (!Ellipsis.functions.hasOwnProperty(i)) {
                continue;
            }
            try {
                Ellipsis.functions[i](alignment, cols);
            } catch (e) {
            }
        }
    }
};
BodyEnded.add(function () {
    PageLayout.onchange(function (alignment, cols) {
        Ellipsis.run(alignment, cols);
    });
});
HeroReady.add(function () {
    $('.hero .teaser-text p .subline').ellipsis({
        row: function ($this) {
            return 2;
        },
        select: function () {
            return $(this).parent();
        }
    });
});
SpotlightReady.add(function () {
    $('.news-fullsize-item .teaser-text p .subline').ellipsis({
        row: 2,
        select: function () {
            return $(this).parent();
        }
    });
});
(function () {
    $(document).on('click', '[data-popup-name] a:not([data-popup-disabled]), [data-popup-style] a:not([data-popup-disabled]), a[data-popup-name], a[data-popup-style]', function () {
        if ($(this).attr('data-popup-disabled') !== undefined) {
            return;
        }
        var root = $(this).parents().andSelf().filter('[data-popup-name], [data-popup-style]');
        return portalPopup(this.href, root.attr('data-popup-name') || 'win', root.attr('data-popup-style') || null, false);
    });
    function portalPopup(url, windowname, windowstyle, returncode) {
        windowname = ('' + windowname).replace(/[^a-z0-9_]/gi, '');
        if (!/^[a-z_]/i.test(windowname)) {
            windowname = 'win' + windowname;
        }
        var cwin = window.open(url, windowname, windowstyle);
        if (!cwin || cwin.closed) {
            return !returncode;
        }
        if (cwin.focus) {
            cwin.focus();
        }
        return returncode;
    }
})();
(function() {
    var ValueChecker = {
        init: function () {
            var $this = $(this);
            ValueChecker.checkValue($this);
            $this.on('focus focusout keyup click', function(e) {
                ValueChecker.checkValue($(this));
                if(e.type == 'click' || e.type == 'keyup') {
                    $(this).addClass('clickSelected');
                }
                if(e.type == 'focusout') {
                    $(this).removeClass('clickSelected');
                }
            });
        },
        checkValue: function($field) {
            if($field.val() === '') {
                $field.removeClass('filled');
            } else {
                $field.addClass('filled');
            }
        }
    }
    $.fn.valueChecker = function(method) {
        if (typeof method === 'object' || !method) {
            return ValueChecker.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.valueChecker');
        }
    };
})();
function initSearch() {
    if (!PageLayout._isSmallScreen) {
        $('#header .search-field, #loginsearch .search-field, .info-layer .search-field').focus();
    }
}

SearchCreated.add(function() {
    $('#header .search-field, #loginsearch .search-field, .info-layer .search-field').valueChecker();
});
if ($.ua.browser.msie === 11) {
    $(window).on('load', function() {
        initSearch();
    });
} else {
    SearchCreated.add(function() {
        initSearch();
    });
}

SearchTabletSupport = new function () {
    this.init = function () {
        this.setPlaceholder();
    };
    this.setPlaceholder = function () {
        if (PageLayout._isSmallScreen) {
            $('.search-field').attr('placeholder', 'Im Web suchen');
        }
    };
    SearchCreated.add(function () {
        SearchTabletSupport.init();
    });
};
var _$ = function(selector, context) {
    if (!(this instanceof _$))  return new _$(selector, context);
    this.readyList     = [];
    this.isReady       = false;
    this.eventbindings = [];
    this.elem          = false;
    if ( typeof ( selector ) == 'function' ) { this.ready(selector); }
    else if ( typeof selector == 'object' )  { this.elem = selector; }
    else {
        var c = context || document,
            e = [],
            i,
            elms,
            initial;
        if      ( selector === window || selector === document )  { this.elem = selector; }
        else if ( selector === 'body' )                           { this.elem = c.body; }
        else {
            initial = selector.substr(0,1);
            if ( initial === '#' )    { this.elem = c.getElementById(selector.slice(1)); }
            else if ( initial === '.' ) {
                elms = (!!c.getElementsByClassName) ? c.getElementsByClassName(selector.slice(1)) : (!!c.querySelectorAll) ? c.querySelectorAll(selector) : 0;
                for(i=0; i<elms.length; i++) {
                    e.push(elms[i]);
                }
                this.elem = e;
            }
            else {
                elms = c.getElementsByTagName(selector);
                for(i=0; i<elms.length; i++) {
                    e.push(elms[i]);
                }
                this.elem = e;
            }
        }
        return (this.elem === null) ? false : this;
    }
};
SearchReset = function(input, title) {
    if (typeof input == 'string') { input = document.getElementById(input); }
    if (!input || !input.parentNode) { return; }
    var reset = document.createElement('input');
    var found = false;
    for(var i=0,len=input.parentNode.children.length; i<len; i++) {
        if (input.parentNode.children[i].getAttribute('type') === 'reset') {
            reset = input.parentNode.children[i];
            found = true;
        }
    }
    if (!found) {
        reset.setAttribute('type', 'reset');
        input.parentNode.insertBefore(reset, input.nextSibling);
    }
    reset.className = 'searchFormReset';
    reset.title = title || reset.value || '';
    reset.check = function() {
        reset.form.className =
            reset.form.className.replace(/\bfilled\b/g, '')
            + ((input.value == '' || input.value == input.defaultValue && (input.parentNode.parentNode.id != 'formSearchTop' && input.parentNode.parentNode.id != 'formSearchBottom')) ? ''
                : ' filled');
    };
    reset.onclick = function() {
        input.value = '';
        reset.check();
        if (typeof input.onkeyup == 'function') { input.onkeyup({ which: 0 }); }
        input.focus();
        Suggest.setHasSuggest(false);
        return false;
    };
    input.form.onkeyup = function() { window.setTimeout(reset.check, 95); };
    reset.check();
};
function SuggestHandler (data) {
    this._searchField = false;
    this._suggestContainer = false;
    this._messageContainer = document.createElement('p');
    this._suggestList = document.createElement('ul');
    this._suggestUrl = false;
    this._SuggestSelection = false;
    this._mediaCode = false;
    this._message = false;
    this._allowSuggest = false;
    this._hasFocus = false;
    this._hasSuggest = false;
    this._jsonScriptNode = false;
    this._initData = data;
    this._pendingTimeout = false;
    this._variants = {
        control: 'exp_adlh_control',
        variant_1: 'exp_maps_control',
        variant_2: 'exp_colorbg_control',
        variant_3: 'exp_tbserp_control',
        variant_4: 'exp_nafs_control'
    };
    if(document.querySelector('html').hasAttribute('data-variant-name') && document.querySelector('html').getAttribute('data-variant-name') === '2831_control') {
        this._variants = {
            control: 'exp_adlh_control',
            variant_1: 'exp_hp_05',
            variant_2: 'exp_hp_07',
            variant_3: 'exp_hp_06',
            variant_4: 'exp_hp_08'
        };
    }
    this.getVariants = function() {
        return this._variants;
    }
    this.init();
}

SuggestHandler.prototype.setAllowed = function(value) {
    this._allowSuggest = value;
};
SuggestHandler.prototype.getAllowed = function() {
    return this._allowSuggest;
};
SuggestHandler.prototype.setHasSuggest = function(value) {
    this._hasSuggest = value;
    if (this._hasSuggest) {
        this.openSuggest();
    } else {
        this.closeSuggest();
    }
};
SuggestHandler.prototype.openSuggest = function() {
    if (!$(this._suggestContainer.elem).hasClass('active')) {
        $(this._suggestContainer.elem).addClass('active');
    }
    if(!this.$searchField.hasClass('hasSuggest')) {
        this.$searchField.addClass('hasSuggest');
    }
};
SuggestHandler.prototype.closeSuggest = function() {
    if ($(this._suggestContainer.elem).is('.active')) {
        $(this._suggestContainer.elem).removeClass('active');
        this.$searchField.removeClass('hasSuggest');
        $(this._suggestContainer.elem).trigger('close');
    }
};
SuggestHandler.prototype.getHasSuggest = function() {
    return this._hasSuggest;
};
SuggestHandler.prototype.setUmlautPressed = function(value) {
    this._umlautPressed = value;
};
SuggestHandler.prototype.getUmlautPressed = function() {
    return this._umlautPressed;
};
SuggestHandler.prototype.setHasFocus = function(value) {
    this._hasFocus = value;
};
SuggestHandler.prototype.getHasFocus = function() {
    return this._hasFocus;
};
SuggestHandler.prototype.setSuggestSelection = function(value) {
    this._SuggestSelection = value;
};
SuggestHandler.prototype.getSuggestSelection = function() {
    return this._SuggestSelection;
};
SuggestHandler.prototype.getActiveIndex = function() {
    for (var i=0, len=this._suggestList.childNodes.length; i<len; i++) {
        var listItem = this._suggestList.childNodes[i];
        if (listItem && /active/i.test(listItem.className)) {
            return i;
        }
    }
};
SuggestHandler.prototype.getItem = function(index) {
    return this._suggestList.childNodes.length >= index && index >= 0 ? this._suggestList.childNodes[index] : 0;
};
SuggestHandler.prototype.setActiveIndex = function(index) {
    for (var i=0, len=this._suggestList.childNodes.length; i<len; i++) {
        $(this._suggestList.childNodes[i]).removeClass('active');
    }
    if (this._suggestList.childNodes.length > index && index >= 0) {
        $(this._suggestList.childNodes[index]).addClass('active');
    } else if (this._suggestList.childNodes.length > 0) {
        $(this._suggestList.childNodes[0]).addClass('active');
    }
};
SuggestHandler.prototype.getSearchField = function() {
    return this._searchField;
};
SuggestHandler.prototype.init = function() {
    var self = this;
    this._searchField = this._initData['field'] ? this._initData['field'] : _$('#searchText');
    this.$searchField = $(this._searchField.elem);
    this._suggestUrl = this._initData['url'] ? this._initData['url'] : suggestUrl;
    this._message = this._initData['msg'] ? this._initData['msg'] : 'Suchvorschl&auml;ge bereitgestellt durch WEB.DE';
    this._mediaCode = this._initData['mc'] ? this._initData['mc'] : 'suche@web@suggesthp.suche@web';
    this._umlautPressed = false;
    if (/firefox|msie|trident/i.test(navigator.userAgent)) {
        this.$searchField.removeAttr('target');
    }
    this._suggestContainer = _$('#suggestions');
    if (this._suggestContainer.elem === null) {
        this._suggestContainer = document.createElement('div');
        this._suggestContainer.id = 'suggestions';
        this._searchField.elem.parentNode.appendChild(this._suggestContainer);
        this._suggestContainer = _$('#suggestions');
    }
    Layer.init({
        name: 'searchsuggest',
        layerContainer: '.search-field-wrapper',
        layer: '#suggestions',
        closeCallback: function() {
            Suggest.closeSuggest();
        }
    });
    var submitButtons = [],
        elems = this._searchField.elem.form.elements || [],
        e = elems.length;
    for (;e--;) {
        if (elems[e].type === 'submit') {
            $(elems[e]).on('click', function(evt) {
                if (typeof evt.preventDefault === 'function') {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
                return Suggest.submit();
            })
        }
    }
    if (/firefox/i.test(navigator.userAgent)) {
        document.addEventListener('keypress', function(evt) {
            var umlauts = [228,246,252,196,214,220];
            if (umlauts.indexOf(evt.charCode) >= 0) {
                self.setUmlautPressed(true);
            }
        });
    }
    var keydownCode = -1;
    $(this._searchField.elem).on('keydown', function(evt) {
        var key = (evt.which || evt.keyCode || evt.charCode);
        keydownCode = key;
        if (key !== 13) {
            Suggest.setSuggestSelection(false);
        } else {
            if (typeof evt.preventDefault === 'function') {
                evt.preventDefault();
                evt.stopPropagation();
            } else {
                return false;
            }
        }
        if (key !== 27) {
            Suggest.setAllowed(true);
            Suggest.setHasFocus(true);
        } else {
            Suggest.setAllowed(false);
            Suggest.setHasFocus(false);
        }
    });
   $(this._searchField.elem).on('keyup', function(evt) {
            SearchReset(this, $(this).attr('data-reset-message'));
        var key = (evt.which || evt.keyCode || evt.charCode);
        if (key === 0 && keydownCode > -1) {
            key = keydownCode;
        }
        if (key === 16) {
            return;
        }
        if (this._pendingTimeout !== false) {
            window.clearTimeout(this._pendingTimeout);
        }
        if (Suggest.getSearchField().elem.value && (Suggest.getSearchField().elem.value.length > 2 && (key == 8 || key == 32 || key == 46 || key >= 48) || (Suggest.getUmlautPressed() && key != 16 && Suggest.getSearchField().elem.value.length > 2))) {
            Suggest.setUmlautPressed(false);
            var timeout = 0;
            if (Suggest.getSearchField().elem.value.length >= 4) {
                timeout = 200;
            }
            this._pendingTimeout = window.setTimeout(function() {
                Suggest.fill();
            }, timeout);
        } else if (Suggest.getSearchField().elem.value === '') {
            Suggest.setHasSuggest(false);
        } else if (key == 38) {
            if (!Suggest.getHasSuggest()) { return; }
            if (typeof Suggest.getActiveIndex() !== 'undefined') {
                Suggest.setActiveIndex(Suggest.getActiveIndex() - 1);
            } else {
                Suggest.setActiveIndex(0);
            }
            Suggest.setSuggestSelection(true);
            Suggest.getSearchField().elem.value = Suggest.getItem(Suggest.getActiveIndex()).title;
        } else if (key == 40) {
            if (!Suggest.getHasSuggest()) { return; }
            if (typeof Suggest.getActiveIndex() !== 'undefined') {
                Suggest.setActiveIndex(Suggest.getActiveIndex() + 1);
            } else {
                Suggest.setActiveIndex(0);
            }
            Suggest.setSuggestSelection(true);
            Suggest.getSearchField().elem.value = Suggest.getItem(Suggest.getActiveIndex()).title;
        } else if (key == 13) {
            Suggest.submit();
        } else if (key == 27) {
            Suggest.getSearchField().elem.value = '';
            Suggest.getSearchField().elem.focus();
            Suggest.setHasSuggest(false);
        }
        if (typeof evt.preventDefault === 'function') {
            evt.preventDefault();
            evt.stopPropagation();
        } else {
            return false;
        }
        try {
            $(evt.target).trigger('suggest-keyup');
        } catch (e) { }
    });
    $(this._searchField.elem).on('blur', function(evt) {
        setTimeout(function() {
            Suggest.setHasSuggest(false);
        }, 300);
        Suggest.setHasFocus(false);
    });
    $(this._searchField.elem).on('focus', function(evt) {
        Suggest.setHasFocus(true);
    });
    $(this._searchField.elem).on('mousedown', function(evt) {
        Suggest.setAllowed(true);
    });
};
SuggestHandler.prototype.fill = function() {
    this._jsonScriptNode = _$('#suggest-script');
    if (this._jsonScriptNode.elem !== null) {
        this._jsonScriptNode.elem.parentNode.removeChild(this._jsonScriptNode.elem);
    }
    this._jsonScriptNode = document.createElement('script');
    this._jsonScriptNode.type = 'text/javascript';
    this._jsonScriptNode.id = 'suggest-script';
    this._jsonScriptNode.src = this._suggestUrl + encodeURIComponent(this._searchField.elem.value.replace(/\s+/, ' ')) + '&_=' + (+new Date()) + '&jsonp=suggest';
    if (!(this._hasFocus && this._allowSuggest)) {
        this.setHasSuggest(false);
    }
    this.setAllowed(true);
    document.getElementsByTagName('head')[0].appendChild(this._jsonScriptNode);
};
SuggestHandler.prototype.highlightSuggest = function(suggestion, searchString) {
    return suggestion.replace(new RegExp('(' + searchString.replace(/\s+$/, '') + ')', 'i'), '<strong>' + searchString.toLowerCase() + '</strong>');
};
SuggestHandler.prototype.doSuggest = function(data, keyword) {
    var numDataItems = data.length;
    if (numDataItems > 0 && this._searchField.elem.value !=='') {
        this.setHasSuggest(true);
    } else {
        this.setHasSuggest(false);
    }
    while(this._suggestList.lastChild) {
        this._suggestList.removeChild(this._suggestList.lastChild);
    }
    for (var i=0; i<numDataItems; i++) {
        if (this._suggestList.childNodes.length >= 5) {
            break;
        }
        var suggestion = data[i]['v'];
        var suggestionItem = document.createElement('li');
        suggestionItem.setAttribute('title', suggestion);
        if (data[i]['t'] === 'sc' && i>0) {
            continue;
        }
        var suggestionSpan = document.createElement('span');
        suggestionSpan.setAttribute('class', 'itemName');
        var compiledSuggestion = '';
        if (this._searchField.elem.value !== '' && suggestion !== '') {
            compiledSuggestion = this.highlightSuggest(suggestion, this._searchField.elem.value.replace(/\s+/, ' '));
        }
        suggestionSpan.innerHTML = compiledSuggestion.replace(/&/g, '&amp;');
        if (data[i]['t'] === 'sc') {
            $suggestionItem = $(suggestionItem);
            if (!$suggestionItem.hasClass('spell-correct')) {
                $suggestionItem.addClass('spell-correct')
            }
            suggestionSpan.innerHTML += '?';
        }
        suggestionItem.appendChild(suggestionSpan);
        this._suggestList.appendChild(suggestionItem);
        $(suggestionItem).on('click', function() {
            Suggest.getSearchField().elem.value = this.title;
            ((document.getElementsByName('mc')||[])[0]||{}).value = this._mediaCode;
            Suggest.setSuggestSelection(true);
            return Suggest.submit();
        });
        $(suggestionItem).on('mouseover', function() {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            }
        });
        $(suggestionItem).on('mouseout', function() {
            $(this).removeClass('active');
        });
    }
    this._suggestContainer.elem.appendChild(this._suggestList);
    this._messageContainer.innerHTML = this._message;
    this._suggestContainer.elem.appendChild(this._messageContainer);
    $(this._suggestContainer.elem).trigger('open');
};
SuggestHandler.prototype.submit = function() {
    if (this._searchField.elem.value.length <= 0 && /search-amazon/i.test(document.body.className)) {
        return false;
    }
    if (this._suggestContainer.elem.children.length > 0) {
        this.setHasSuggest(false);
    }
    this.setHasSuggest(false);
    var fields = this._searchField.elem.form.getElementsByTagName('input');
    for (var i = 0, len = fields.length; i < len; i++) {
        if (fields[i].value !== '') {
            if (fields[i].name === 'origin') {
                var value = fields[i].value;
                var bodyClasses = document.querySelector('body').getAttribute('class');
                var isSticky = false;
                if (bodyClasses) {
                  isSticky = bodyClasses.indexOf('loginFixed') !== -1;
                }
                if (Suggest.getSuggestSelection()) {
                  fields[i].value = fields[i].value.replace('_atf','').replace('_sg','').replace(/(,|$)/, function(m, b) { return '_sg' + b; });
                  value = fields[i].value;
                  if (!PageLayout._isSmallScreen) {
                    if (!isSticky) {
                      value += ',' + Suggest.getVariants().variant_2;
                    } else {
                      value += ',' + Suggest.getVariants().variant_4;
                    }
                  }
                } else {
                  if (!PageLayout._isSmallScreen) {
                    if (!isSticky) {
                      value += ',' + Suggest.getVariants().variant_1;
                    } else {
                      value += ',' + Suggest.getVariants().variant_3;
                    }
                  }
                }
                fields[i].value = value;
            }
        }
    }
    Suggest.setSuggestSelection(false);
    $(this._searchField.elem.form).submit();
    return false;
};
var Suggest;
SearchCreated.add(function() {
    $('input[data-suggest-url][data-suggest-enabled="true"]').each(function() {
        var $this = $(this);
        $this.attr('autocomplete', 'off')
        var suggestUrl = $this.attr('data-suggest-url');
        var suggestMessage = ($this.attr('data-suggest-powered') || '').replace(/&/g, '&amp;');
        var mediaCode = $this.attr('data-suggest-mc');
        Suggest = new SuggestHandler ({'field' : _$($this.get(0)), 'url': suggestUrl, 'msg' : suggestMessage, 'mc' : mediaCode});
    });
});
function suggest(data, query) {
    if (typeof query === 'undefined') {
        query = Suggest.getSearchField().elem.value;
    } else {
        query = decodeURIComponent(escape(atob(query)));
    }
    if (Suggest.getSearchField().elem.value.toLowerCase() === query.toLowerCase()) {
        Suggest.doSuggest(data);
    }
}

PageLayout.onchange(function() {
    if (typeof Suggest !== 'undefined' && typeof Suggest.closeSuggest === 'function') {
        Suggest.closeSuggest();
    }
});
(function ($) {
    var Slider = function (container, options) {
        this.settings = $.extend({
            recalcOnLayerOpen: false,
            listParent: 'ul',
            listItem: 'li',
            visibleArea: 'nav',
            fillLastPage: false,
            touchGestures: false,
            slideItems: 'auto',
            slideCallback: false,
            cssTransitions: true,
            lazyLoad: false,
            tracking: {
                prevPage: false,
                nextPage: false
            },
            paginationContainer: '.slider-container',
            paginationContainer: undefined,
            paginationPrev: false,
            paginationNext: false,
            disablePaginationOnClick: false,
            direction: 'horizontal',
            spacer: false,
        }, options);
        this.$container;
        this.sectors = [];
        this.currentSector = 0;
        this._init = function (container, options) {
            $.extend(this.settings, options);
            var self = this;
            this.$container = $(container);
            this.pagination = Pagination({
                container: self.$container,
                paginationContainer: self.settings.paginationContainer,
                paginationTemplate: self.settings.paginationTemplate,
                prevItem: self.settings.paginationPrev,
                nextItem: self.settings.paginationNext,
                nextCallback: function () {
                    self.slideNext();
                },
                prevCallback: function () {
                    self.slidePrev();
                },
                tracking: {
                    prev: self.settings.tracking.prevPage,
                    next: self.settings.tracking.nextPage
                },
                disableOnClick: self.settings.disablePaginationOnClick,
                checkCallback: function (pagination) {
                    if (self.currentSector > 0) {
                        pagination.enablePrev();
                    } else {
                        pagination.disablePrev();
                    }
                    if (self.currentSector < self.sectors.length - 1) {
                        pagination.enableNext();
                    } else {
                        pagination.disableNext();
                    }
                }
            });
            if (this.settings.touchGestures && $.ua.support.touch) {
                Swipe.registerSlider({
                    parentContainer: this.$container,
                    slideContainer: $(this.settings.listParent + ':first', this.$container),
                    nextCallback: function () {
                        self.handleSwipe('right');
                    },
                    prevCallback: function () {
                        self.handleSwipe('left');
                    }
                });
            }
            if (
                this.settings.lazyLoad === true ||
                (typeof this.settings.lazyLoad === 'function' && this.settings.lazyLoad(this.$container))
            ) {
                $(this.settings.listParent + ':first', this.$container).append('<article class="slider-item loader" />');
            }
            this.$container.on('slider-update', function () {
                self._calcSectors();
                self.pagination.checkPagination();
                self._triggerEvents();
            });
            if (this.settings.direction === 'horizontal') {
                PageLayout.onchange(function () {
                    self._calcSectors();
                    self.pagination.checkPagination();
                    self._triggerEvents();
                });
            }
            if (this.settings.recalcOnLayerOpen) {
                Layer.toggleFunctions.add(function (state) {
                    if (state === 'open') {
                        self._calcSectors();
                        self.pagination.checkPagination();
                        self._triggerEvents();
                    }
                });
            } else {
                window.requestAnimationFrame(function () {
                    self._calcSectors();
                    self.pagination.checkPagination();
                    self._triggerEvents();
                });
            }
        };
        this.handleSwipe = function (direction) {
            var nextSector;
            if (direction === 'left' && this.currentSector > 0) {
                nextSector = this.currentSector - 1;
            } else if (direction === 'right' && this.currentSector < this.sectors.length - 1) {
                nextSector = this.currentSector + 1;
            } else {
                nextSector = this.currentSector;
            }
            this.slideTo(nextSector);
        }
        this._getVisibleArea = function (options) {
            if (typeof this.settings.visibleArea === 'number') {
                return this.settings.visibleArea;
            } else if (options.direction === 'vertical') {
                return $(this.settings.visibleArea, this.$container).height();
            } else {
                return $(this.settings.visibleArea, this.$container).width();
            }
        };
        this._calcSectors = function () {
            var self = this;
            var oldSectors = this.sectors;
            this.sectors = [0];
            var visibleArea = this._getVisibleArea(this.settings);
            var amount = 0;
            $(this.settings.listParent + ':first ' + this.settings.listItem, this.$container).each(function (index) {
                var $this = $(this);
                var itemHeight = $('> .r1', $this).length ? $('> .r1', $this).height() : $this.height();
                var itemWidth = $('> .r1', $this).length ? $('> .r1', $this).width() : $this.width();
                var value = self.settings.direction === 'vertical' ? itemHeight : itemWidth;
                var margin = parseInt($this.css(self.settings.direction === 'vertical' ? 'marginTop' : 'marginLeft'), 10);
                if (self.settings.slideItems === 'auto') {
                    if (amount + margin + value > self.sectors[self.sectors.length - 1] + visibleArea && (!self.settings.spacer || !$(this).is(self.settings.spacer))) {
                        self.sectors.push(amount + margin);
                    }
                } else if (self.settings.slideItems === 1 && index !== 0) {
                    self.sectors.push(amount + margin);
                } else {
                }
                $this.attr('data-slider-sector', self.sectors.length - 1);
                amount = amount + margin + value;
            });
            if (this.settings.slideItems === 'auto') {
                if (this.settings.fillLastPage) {
                    if (this.sectors.length > 1 && this.sectors[this.sectors.length - 1] > amount - visibleArea) {
                        this.sectors.pop();
                        this.sectors.push(amount - visibleArea);
                    }
                }
            } else if (this.settings.slideItems === 1) {
                while (this.sectors[this.sectors.length - 1] > amount - visibleArea) {
                    this.sectors.pop();
                }
            } else {
            }
            if (oldSectors !== undefined) {
                if (this.currentSector > this.sectors.length - 1) {
                    this.slideTo(this.sectors.length - 1);
                } else {
                    this.slideTo(this.currentSector);
                }
            }
        };
        this._triggerEvents = function () {
            $('[data-slider-sector="' + this.currentSector + '"]', this.$container).trigger('isVisibleOutOfViewport');
            $('[data-slider-sector!="' + this.currentSector + '"]', this.$container).trigger('isInvisibleOutOfViewport');
        }
        this.getItemsSector = function ($item) {
            return parseInt($item.attr('data-slider-sector'), 10);
        };
        this.showItem = function ($item) {
            this.slideTo(this.getItemsSector($item));
        };
        this.slidePrev = function () {
            this.slideTo(this.currentSector - 1);
        };
        this.slideNext = function () {
            this.slideTo(this.currentSector + 1);
        };
        this.slideTo = function (sector, direction) {
            var self = this;
            var direction;
            if (typeof direction === 'undefined') {
                if (this.currentSector < sector) {
                    direction = 'next';
                } else if (this.currentSector > sector) {
                    direction = 'prev';
                } else {
                    direction = 'reposition';
                }
            }
            var margin;
            if (self.currentSector < self.sectors.length) {
                margin = self.sectors[sector] * -1;
            } else {
                margin = self.sectors[self.sectors.length - 1] * -1;
            }
            self.currentSector = sector;
            self.pagination.checkPagination();
            var $el = $(self.settings.listParent + ':first', self.$container);
            if (direction === 'reposition' || (self.settings.cssTransitions && $.ua.support.transitions)) {
                $el.stop(true, true).css(self.settings.direction === 'vertical' ? 'marginTop' : 'marginLeft', margin + 'px');
                self._triggerEvents();
                if (typeof self.settings.slideCallback === 'function') {
                    self.settings.slideCallback(self.$container, direction, self.currentSector);
                }
            } else {
                var animation = {};
                if (self.settings.direction === 'vertical') {
                    animation.marginTop = margin + 'px';
                } else {
                    animation.marginLeft = margin + 'px';
                }
                $el.stop(true, true).animate(animation, 600, function () {
                    self._triggerEvents();
                    if (typeof self.settings.slideCallback === 'function') {
                        self.settings.slideCallback(self.$container, direction, self.currentSector);
                    }
                });
            }
        };
        this._init(container, options);
    };
    $.fn.slider = function (method) {
        var _arguments = arguments;
        return $(this).each(function () {
            if (typeof method === 'string') {
                if (this.slider instanceof Slider) {
                    if (typeof this.slider[method] === 'function') {
                        var args = Array.prototype.slice.call(_arguments, 1);
                        this.slider[method].apply(this.slider, args);
                    } else {
                    }
                } else {
                }
            } else {
                this.slider = new Slider(this, method);
            }
        });
    };
})(jQuery);
var ContentSlider = {
    create: function (data, options) {
        var settings = $.extend({
            type: false,
            parent: {
                selector: '.wrapper-center.first + .wrapper-center > .wrapper-border',
                insertPosition: 'append'
            },
            tracking: {
                prevPage: false,
                nextPage: false
            },
            slideCallback: false,
            disablePaginationOnClick: false
        }, options);
        if (settings.type) {
            data.type = settings.type;
        }
        var template = 'content-slider-with-wrapper';
        var $slider = $(Mustache.render(ContentService.templates[template], data));
        $(settings.parent.selector)[settings.parent.insertPosition]($slider);
        $slider.slider({
            name: settings.type,
            listParent: '.slider',
            listItem: '.slider-item',
            visibleArea: '.slider-container',
            paginationContainer: $('.r4', $slider),
            paginationTemplate: 'pagination-content-slider',
            fillLastPage: true,
            touchGestures: true,
            cssTransitions: true,
            tracking: settings.tracking,
            slideCallback: settings.slideCallback,
            disablePaginationOnClick: settings.disablePaginationOnClick
        });
        $(window).trigger('contentloaded');
    },
};
$(document).ready(function () {
    var $contentSlider = $('.wrapper-indent > .content-slider');
    $contentSlider.each(function (i) {
        var $this = $(this);
        if (!$this.is('.vorteilswelt') && !$this.is('.games')) {
            if (!this.slider) {
                $this.slider({
                    listParent: '> .r4 > .slider-container > .slider',
                    listItem: '> *',
                    visibleArea: '> .r4 > .slider-container',
                    paginationContainer: $('.r4', this),
                    paginationTemplate: 'pagination-content-slider',
                    fillLastPage: true,
                    touchGestures: true,
                    cssTransitions: true,
                    tracking: {
                        prevPage: function () {
                            track('slide_' + i + '_left', 'event');
                        },
                        nextPage: function () {
                            track('slide_' + i + '_right', 'event');
                        }
                    },
                    slideCallback: function ($sliderContainer, direction, visibleSector) {
                        if (direction === 'next' && !$sliderContainer.teasersRendered) {
                            $sliderContainer.teasersRendered = true;
                            var channelId = $sliderContainer.attr('data-slider-channel-id');
                            if (channelId) {
                                var $loader = $('.loader', $sliderContainer);
                                var channelData = ContentService.getChannel(channelId);
                                if (channelData && channelData.teasers && channelData.teasers.length) {
                                    for (var i = 0; i < channelData.teasers.length; i++) {
                                        channelData.teasers[i] = ContentService.resizeTeaserImage(channelData.teasers[i], 300, 250);
                                    }
                                    channelData = ContentService.filterData(channelData, true);
                                    $loader.after(Mustache.render(ContentService.templates['news-fullsize'], channelData));
                                }
                                $loader.remove();
                                $sliderContainer.trigger('slider-update');
                            }
                        }
                    },
                    lazyLoad: function ($sliderContainer) {
                        var channelId = $sliderContainer.attr('data-slider-channel-id');
                        var channelData = ContentService.getChannel(channelId);
                        if (channelData && channelData.teasers && channelData.teasers.length) {
                            return true;
                        }
                    }
                });
            }
        }
    });
    $(window).on('resize', function () {
        $contentSlider.trigger('slider-update');
    });
});
    if (PageConfig.games) {
    var GamesSlider = {
        created: false,
        settings: {
            dataUrl: ((['qa', 'qa-bs', 'qa-ba', 'dev'].indexOf(SiteInfo.stage) !== -1) ? 'https://qa.games.gmx.net/restapi/export/available?max=20' : 'https://games.gmx.net/restapi/export/available?max=20') + (SiteInfo.country === 'ch' ? '&feed=gmxch' : '&gmx=true'),
            selector:  PageLayout.getSetPositionSelector(SiteInfo.gamesSliderOnTop ? '2' : '4'),
            insertPosition: 'before',
            lazyload: true,
            preLoading: ($.ua.browser.name === 'edge' || $.ua.browser.msie === 11) ? 200 : 100
        },
        init: function(options) {
            window.requestAnimationFrame(function() {
                GamesSlider.settings = $.extend({}, GamesSlider.settings, options);
                if (GamesSlider.settings.lazyload) {
                    GamesSlider.calcLazyloadOffset();
                    PageLayout.onchange(function() {
                        GamesSlider.calcLazyloadOffset();
                    });
                    $(window).on('scroll', GamesSlider.handleScroll);
                    GamesSlider.handleScroll();
                } else {
                    GamesSlider.create();
                }
            });
        },
        lazyloadOffset: false,
        $offsetBase: undefined,
        handleScroll: function() {
            if (GamesSlider.created) { return; }
            var $window = $(window);
            if ($window.scrollTop() + $window.innerHeight() > GamesSlider.lazyloadOffset) {
                GamesSlider.create();
            }
        },
        calcLazyloadOffset: function(options) {
            if (!GamesSlider.$offsetBase) {
                GamesSlider.$offsetBase = $(GamesSlider.settings.selector);
                if (GamesSlider.settings.insertPosition === 'after') {
                    GamesSlider.$offsetBase = GamesSlider.$offsetBase.next();
                }
            }
            var offset = GamesSlider.$offsetBase.offset();
            if (offset) {
                GamesSlider.lazyloadOffset = offset.top - GamesSlider.settings.preLoading;
            }
        },
        create: function() {
            GamesSlider.created = true;
            GamesSlider.settings.dataUrl = GamesSlider.settings.dataUrl + '&ts=' + (new Date()).getTime();
            $.ajax(GamesSlider.settings.dataUrl, {
                dataType : 'json',
                success: function(data, textStatus, jqXHR) {
                    if (data && data.channels && data.channels.length && data.teasers && data.teasers.length) {
                        data = ContentService.upgradeData(data);
                        ContentSlider.create(data, {
                            type: 'games',
                            parent: {
                                selector: GamesSlider.settings.selector,
                                insertPosition: GamesSlider.settings.insertPosition
                            },
                            tracking: {
                                prevPage: function() {
                                    track('gamesslider_left', 'event');
                                },
                                nextPage: function() {
                                    track('gamesslider_right', 'event');
                                }
                            }
                        });
                    }
                }
            });
        }
    };
    if (!PageConfig.vorteilswelt) {
        GamesSlider.settings.selector = PageLayout.getSetPositionSelector('2');
    }
}

    $(function () {
    var moveSearch = function () {
        var $searchField = $('#header .search-field, #loginsearch .search-field');
        var $loginsearchSearch = $('#header .search-wrapper, #loginsearch .search-wrapper');
        if (PageState.list.loginState && PageState.list.loginState[0] === 'fixed') {
            $loginsearchSearch.insertAfter('#loginsearch-ad');
            $searchField.trigger('focusout');
        } else {
            if ($('#header .search-wrapper').length === 0) {
                $loginsearchSearch.insertBefore('#rightnav');
                $searchField.trigger('focusout');
            }
        }
    };
    BodyStarted.add(function (nextState) {
        moveSearch();
    });
    StickyLogin.add(function (nextState) {
        moveSearch();
    });
});
    ContentService.FinishedHook.add(function () {
        $('.top-editorial .teaser-content').wrapLink({
            wrapLinkTo: ['.teaser-img', {
                selector: '.teaser-text',
                exclude: '.link-list'
            }]
        });
        $('.news:not(.hero) .teaser-content').wrapLink();
        $('.service.icons .icon-wrapper').wrapLink({
            linkSelector: 'figcaption header a'
        });
        $('.multi-news:not(.hero) .news-list-teaser').wrapLink({
            linkSelector: 'a'
        });
        $('.lotto .service-content').wrapLink({
            linkSelector: '.next-draw-content a',
            exclude: 'footer, .additional-links'
        });
    });
    ContentService.FinishedHook.add(function () {
        if (!AdService.isBlocked) {
            if (window.PageConfig.notificationPath) {
                AdService.createAd({
                    'type': 'notification',
                    'variant': 'topper',
                    'notification': {
                        'url': window.PageConfig.notificationPath,
                        '_': 0
                    }
                });
            }
        }
    });
$(document).ready(function () {
    $('.svg-inline img').each(function () {
        var $img = $(this),
            imgURL = $img.attr('src'),
            imgID = $img.attr('id');
        $.get(imgURL, function (data) {
            var $svg = $(data).find('svg');
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            $svg = $svg.removeAttr('xmlns:a');
            $img.replaceWith($svg);
        }, 'xml');
    });
});
var InfoLayer = function (name, data, settings) {
    this.create = function (name, data, options) {
        var self = this;
        self.settings = $.extend({
            callback: false,
            tracking: false,
            closeCallback: false,
            openDelay: 0
        }, options);
        if (typeof ContentService.templates[name] !== 'undefined') {
            self.$layer = $(Mustache.render(ContentService.templates[name], data)).hide();
            $('body').append(self.$layer);
            window.setTimeout(function () {
                self.open();
                if (typeof self.settings.openCallback === 'function') {
                    self.settings.openCallback(self.$layer);
                }
            }, self.settings.openDelay);
        } else {
        }
        $('.tooltip-closer', self.$layer).on('click', function () {
            self.close();
        });
        $(self.$layer).on('click', function (e) {
            if ($(e.target).is('.info-layer')) {
                self.close();
            }
        });
        checkButtonFix();
        if (typeof self.settings.callback === 'function') {
            self.settings.callback.apply(self);
        }
    };
    this.open = function () {
        var self = this;
        var $window = $(window);
        self.$layer.show();
        $('input:focus').blur();
        self.positionLayer();
        $window.on('resize scroll', self.positionLayer);
        if (self.settings.tracking && typeof self.settings.tracking.open !== 'undefined') {
            self.track(self.settings.tracking.open);
        }
        $('body').css({
            overflow: 'hidden',
            marginRight: PageLayout.getScrollbarWidth()
        });
        if ($('#loginsearch').length) {
            var offsetLeft = $('#loginsearch').offset().left;
            if (offsetLeft > 1) {
                $('html').attr('data-layer', 'inactivity');
            }
        }
        $window.trigger('layer-opened');
    };
    this.positionLayer = function () {
        if (PageLayout._isSmallScreen) {
            var $window = $(window);
            $('.info-layer').css({
                top: $window.scrollTop() - ((SiteInfo.brand === 'webde' && !$('html.adWithOutsideComponent').length) ? 4 : 0),
                height: window.innerHeight
            });
        }
    };
    this.close = function (silent) {
        var self = this;
        var $window = $(window);
        self.$layer.remove();
        if (!silent && self.settings.tracking && typeof self.settings.tracking.close !== 'undefined') {
            self.track(self.settings.tracking.close);
        }
        $window.off('resize scroll', self.positionLayer);
        if (typeof self.settings.closeCallback === 'function') {
            self.settings.closeCallback();
        }
        $('body').css({
            overflow: '',
            marginRight: 0
        });
        $('html').removeAttr('data-layer');
        $window.trigger('layer-closed');
    };
    this.track = function (pixel) {
        if (typeof pixel === 'function') {
            pixel();
        } else if (typeof pixel === 'string') {
            track.createImage(pixel);
        }
    }
    this.create(name, data, settings);
    return this;
};
$(document).ready(function () {
    var counter = 0;
    var timeout;
    var defaultDuration = getUrlParam('_inactivityLayerDuration') || 240000;
    var initInactivityLayer = function (duration, options) {
        var settings = $.extend({
            name: 'info-layer-inactive',
            teaserImageDimension: [{
                width: 300,
                height: 250
            }, {
                width: 125,
                height: 115
            }, {
                width: 125,
                height: 115
            }],
            callback: false
        }, options);
        if (((SiteInfo.portal === 'homepage' && !Storage.get('info-layer-home-inactive')) || (SiteInfo.portal !== 'homepage' && !Storage.get('info-layer-logout-inactive'))) &&
            !Storage.get('info-layer-inactive') &&
            !PageLayout._isSmallScreen &&
            ContentService.enoughDataAvailable({inactivityLayer: 3}) &&
            counter < 3 &&
            getWindowInnerWidth() >= 1000
        ) {
            timeout = window.setTimeout(function () {
                var now = (new Date()).getTime();
                if (now - SiteInfo.lastActivity < duration) {
                    initInactivityLayer(defaultDuration - (now - SiteInfo.lastActivity), settings);
                    return;
                }
                var teasers = [];
                for (var i = 0; i < 3; i++) {
                    var moduleData = ContentService.getNextModuleData('inactivityLayer');
                    moduleData = ContentService.filterData(moduleData);
                    moduleData.teasers = ContentService.resizeTeaserImage(moduleData.teasers, settings.teaserImageDimension[i].width, settings.teaserImageDimension[i].height);
                    teasers.push(moduleData.teasers[0]);
                }
                counter++;
                var layer = new InfoLayer(settings.name, {
                    homepageUrl: $('#logo a').attr('href'),
                    homepageButtonText: SiteInfo.portal === 'homepage' ? 'Homepage aktualisieren' : 'Zur Homepage',
                    isHomepage: SiteInfo.portal === 'homepage',
                    teaserGroup: [{
                        teasers: [teasers[0]]
                    }, {
                        teasers: [teasers[1], teasers[2]]
                    }],
                    localStorage: Storage.supportLocalStorage,
                    brand: 'GMX',
                    searchFormactionUrl: "https://suche.gmx." + (SiteInfo.country === 'de' ? "net" : SiteInfo.country) + "/web",
                    formSubmitWithIcon: "onlyIcon hasIcon",
                    glassInIcon: true
                }, {
                    callback: function () {
                        var self = this;
                        $('.blockInfoLayer', self.$layer).on('click', function (e) {
                            e.preventDefault();
                            SiteInfo.portal === 'homepage' ? Storage.save('info-layer-home-inactive', '1') : Storage.save('info-layer-logout-inactive', '1');
                            track('welcomelayer_optout', 'event');
                            self.close(true);
                        });
                        if (settings.callback && typeof settings.callback === 'function') {
                            settings.callback();
                        }
                    },
                    tracking: {
                        open: function () {
                            track('welcomelayer_show', 'event');
                        },
                        close: function () {
                            track('welcomelayer_close', 'event');
                        }
                    },
                    closeCallback: function () {
                        initInactivityLayer(defaultDuration, settings);
                    },
                    openDelay: PrebidConnector.isAllowed() ? PrebidConnector.timeout : 0
                });
            }, duration);
        }
    };
    initInactivityLayer(defaultDuration, {
        callback: function () {
            if (!PageLayout._isSmallScreen) {
                $('.info-layer-inactive input[name="q"]').focus();
            }
            $('.info-layer-inactive .search-field').valueChecker();
            AdService.newPageContext();
            AdService.setPositionParam('rectangle_layer', '_type', 'nfi');
            if (AdService.positions.rectangle_layer && AdService.positions.rectangle_layer.posCount >= 1) {
                PrebidConnector.resetPosition('rectangle_layer');
                ContentService.resetPosition('rectangle_layer');
            }
            if (ContentService.checkAdSlot('rectangle_layer', $('.layer-side'))) {
                ContentService.createPosition('rectangle_layer', $('.layer-side'), {});
            } else {
                PrebidConnector.startBidding(['rectangle_layer'], PrebidConnector.layerTimeout);
            }
        }
    });
});
if (Math.floor(Math.random() * 20) === 1 || getUrlParam('_performance') === '1') {
    BodyEnded.add(function () {
        try {
            track('bandwidth.js', 'event', {
                period: endProcessing - startProcessing
            }, {
                nct: true
            });
        } catch (e) {
        }
        if ($.ua.browser.name === 'chrome') {
            try {
                track('bandwidth.api', 'event', {
                    period: navigator.connection.downlink
                }, {
                    nct: true
                });
            } catch (e) {
            }
        }
    });
}

VisibiliyMonitoring = new function () {
    this.monitoredContainer = [];
    this.init = function () {
        var self = this;
        PostMessageHelper.add('startVisibiltyMonitor', function (source, messageName, messageData) {
            var iframe = PostMessageHelper.getIframe(source);
            self.add(iframe, {
                sendFraction: true,
                template: (messageData || {}).template
            });
        });
    };
    this.add = function (container, options) {
        var settings = $.extend({
            sendFraction: false
        }, options);
        this.monitoredContainer.push({
            container: container,
            options: settings
        });
        if (this.monitoredContainer.length === 1) {
            this.startMonitoring();
        }
        this.checkContainer(container, settings);
    };
    this.checkAllContainer = function () {
        for (var i = 0; i < this.monitoredContainer.length; i++) {
            this.checkContainer(this.monitoredContainer[i].container, this.monitoredContainer[i].options);
        }
    }
    this.checkContainer = function (container, options) {
        var self = this;
        window.requestAnimationFrame(function () {
            var containerRect = container.getBoundingClientRect();
            var visibleFraction = self.getVisibleFraction(containerRect);
            if (visibleFraction >= 0 && visibleFraction <= 100) {
                if (options.sendFraction) {
                    switch (options.template) {
                        case 'appnexus':
                            PostMessageHelper.send(container, {
                                'event': 'parentFrameGeometryChange',
                                'scrollY': window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
                                'offsetTop': containerRect.top + window.pageYOffset,
                                'windowHeight': window.innerHeight
                            });
                            break;
                        default:
                            PostMessageHelper.send(container, {
                                name: 'visibleFraction',
                                visibleFraction: visibleFraction
                            });
                    }
                }
            }
        });
    };
    this.getVisibleFraction = function (rect) {
        var winrect = {
            width: window.innerWidth || window.clientHeight,
            height: window.innerHeight || window.clientHeight
        };
        var rectSize = (rect.width || rect.right - rect.left) * (rect.height || rect.bottom - rect.top);
        var areaSize = (Math.min(rect.right, winrect.width) - Math.max(rect.left, 0)) * (Math.min(rect.bottom, winrect.height) - Math.max(rect.top, 0));
        if (areaSize >= 0) {
            var fraction = rectSize ? areaSize / rectSize : +(rect.left >= 0 && rect.right <= winrect.width && rect.top >= 0 && rect.bottom <= winrect.height);
            return Math.round(fraction * 100);
        } else {
            return 0;
        }
    };
    this.checkTimeout;
    this.startMonitoring = function () {
        var self = this;
        $(document).on('scroll resize', function () {
            if (self.checkTimeout) {
                window.clearTimeout(self.checkTimeout);
                self.checkTimeout = null;
            }
            self.checkTimeout = window.setTimeout(function () {
                self.checkAllContainer();
            }, 100);
        });
    };
    this.init();
};
$(document).ready(function () {
    var alreadyTracked = false;
    $('<a id="jumplabel" />').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, 500, 'swing');
        if (!alreadyTracked) {
            track('jumplabel', 'event');
            alreadyTracked = true;
        }
    }).appendTo('body');
    var $jumplabel = $('#jumplabel');
    $(window).on('scroll init-jumplabel', function (e) {
        var scroll = $(window).scrollTop();
        if (scroll >= 420) {
            $jumplabel.addClass('visible');
        } else {
            $jumplabel.removeClass('visible');
        }
    });
    $(window).on('init-jumplabel', function() {
        repositionLeft()
    });
    $(window).on('resize scroll init-jumplabel', function (e) {
        PageLayout.onchange(function () {
            repositionLeft();
        });
    }).trigger('init-jumplabel');
    function repositionLeft() {
        var $sourceContainer = $('.wrapper-center.first');
        if($sourceContainer.length) {
            var sitebarModulator = 0;
            var hasSitebar = document.querySelector('html').getAttribute('data-col-left') === 'true';
            var isThreeCol = document.querySelector('html').getAttribute('data-col-case') === '3col';
            if (hasSitebar && isThreeCol) {
                sitebarModulator = 2;
            }
            var left = $sourceContainer.offset().left + $sourceContainer.outerWidth() - 1  - $jumplabel.innerWidth() - document.body.scrollLeft - sitebarModulator;
            $jumplabel.css({left: left + 'px'});
        }
    }
});
BodyStarted.add(function () {
    $(document).on('click', '#mainnav li div.layer-more #more-content ul li', function () {
        $(this).toggleClass('active');
    });
    PageLayout.onchange(function (alignment, cols) {
        var linksToCopy = generateLinksToCopy(cols);
        var $moreContentContainer = $('#more #more-content');
        if (!linksToCopy.length) {
            $('#mainnav #more').hide();
            $moreContentContainer.empty();
        } else {
            $moreContentContainer.empty();
            $moreList = $('<ul id="more-content-list" />');
            for (var i = 0; i < linksToCopy.length; i++) {
                var $listPoint = $('<li />');
                if (linksToCopy[i].className) {
                    $listPoint.addClass(linksToCopy[i].className);
                }
                if (linksToCopy[i].title) {
                    if (linksToCopy[i].link) {
                        $listPoint.append('<a href="' + linksToCopy[i].link + '">' + linksToCopy[i].title + '</label>');
                        if (linksToCopy[i].target) {
                            $('a', $listPoint).attr('target', linksToCopy[i].target);
                        }
                    } else {
                        $listPoint.append('<label>' + linksToCopy[i].title + '</label>');
                    }
                    if (linksToCopy[i].icon) {
                        $('> a, > label', $listPoint).append('<span class="icon" style="background-image: url(' + linksToCopy[i].icon + ');" />');
                    }
                }
                if (linksToCopy[i].$childLinks) {
                    $listPoint.append(linksToCopy[i].$childLinks);
                }
                $moreList.append($listPoint);
            }
            $moreContentContainer.append($moreList);
            CartLayerProduct.initializeCart('#more-content .cart');
            $('#mainnav #more').show();
        }
    });
    BodyEnded.add(function() {
        Layer.init({
            name: 'user',
            layerContainer: '.header-inner .user',
            layerOpener: '> label',
            layer: '.layer',
            layerCloser: '.closer',
            closeOnOutsideClick: true
        });
        Layer.init({
            name: 'cart',
            layerContainer: '#header > .header-inner > .cart',
            layerOpener: '> label',
            layer: '.layer',
            layerCloser: '.closer',
            closeOnOutsideClick: true,
            on: {
                open: function () {
                    if (CartLayerProduct.isCartRetargetingLoaded) {
                        CartLayerProduct.firePixels();
                    }
                }
            }
        });
        Layer.init({
            name: 'netID',
            layerContainer: '#loginsearch-login .netID-container',
            layerOpener: '> label',
            layer: '.layer',
            layerCloser: '.closer',
            closeOnOutsideClick: true,
            on: {
                open: function () {
                    track('netID.open', 'event');
                    Tooltip.hide();
                }
            }
        });
        $('#demailLoginUsername').on('click', function() {
            $('.netID-container #layer-netID').prop('checked', false);
            $('.netID-container').removeClass('open');
        });
    });
    $(document).ready(function () {
        var $navSlider = $('#header .content-slider');
        for (var i = 0; i < $navSlider.length; i++) {
            if (!$navSlider[i].slider) {
                (function () {
                    try {
                        var $li = $($navSlider[i]).closest('#mainnav > ul > li');
                        var index = $li.index('#mainnav > ul > li');
                        var title = $.trim($('> label figcaption', $li).text());
                    } catch (e) {
                    }
                    $($navSlider[i]).slider({
                        listParent: '> .r4 > .slider-container > .slider',
                        listItem: '> *',
                        visibleArea: '> .r4 > .slider-container',
                        paginationContainer: $('.r4', $navSlider[i]),
                        paginationTemplate: 'pagination-content-slider',
                        fillLastPage: true,
                        touchGestures: true,
                        cssTransitions: true,
                        tracking: {
                            prevPage: function () {
                                track('header.' + index + '_' + title + '.slide_left', 'event');
                            },
                            nextPage: function () {
                                track('header.' + index + '_' + title + '.slide_right', 'event');
                            }
                        },
                        recalcOnLayerOpen: true
                    });
                })();
            }
        }
    });
});
CartLayerProduct = new function () {
    this.init = function () {
        this.cart = {};
        this.count = [];
        this.view = [];
        this.isCartRetargetingLoaded = false;
        this.layerOpenedFirstTime = false;
        this.isRetargeting = false;
        this.allRetargetingDeleted = false;
        var recheckCart = function () {
            CartLayerProduct.initializeCart('#cart-retargeting-menu-point');
        };
        BodyEnded.add(recheckCart);
        AdService.on('beforerender', function (data) {
            CartLayerProduct.prepareData(data);
        });
    };
    this.prepareData = function (data) {
        if (data.render._type === 'cart-count') {
            this.cartCount(data);
        }
        if (data.render._type === 'cart-products') {
            this.cartProducts(data);
        }
    };
    this.cartCount = function (data) {
        var products = data.render.products;
        var badgecount = 0;
        var deletedCount = 0;
        var emptyCount = 0;
        for (var i = 0; i < products.length; i++) {
            if (products[i] !== '' && products[i] !== 'deleted') {
                badgecount++;
            }
            if (products[i] === 'deleted') {
                deletedCount++;
            }
            if (products[i] === '') {
                emptyCount++;
            }
        }
        if (badgecount > 3) {
            badgecount = 3;
        }
        if (badgecount > 0) {
            CartLayerProduct.isRetargeting = true;
        }
        if (deletedCount === products.length || (deletedCount >= 1 && (deletedCount + emptyCount) === products.length)) {
            CartLayerProduct.allRetargetingDeleted = true;
        }
        if (badgecount > 0) {
            var html = '<header>' + badgecount + '</header>';
            $('.cart figure').append(html);
        }
    };
    this.cartProducts = function (data) {
        data.render.site = SiteInfo.brandName;
        var countOfNotShown = 0;
        for (var indexOfRender = 0; indexOfRender < data.render.products.length; indexOfRender++) {
            if (typeof data.render.products[indexOfRender].show === 'undefined') {
                data.render.products[indexOfRender].show = Object.keys(data.render.products[indexOfRender]).length > 0;
            }
            if (!data.render.products[indexOfRender].show) {
                countOfNotShown++;
            }
        }
        if (countOfNotShown === data.render.products.length) {
            CartLayerProduct.isRetargeting = true;
        }
        if (data.render.products && data.render.products.length) {
            CartLayerProduct.cart.products = [];
            data.render.retargeting = CartLayerProduct.isRetargeting;
            data.render.allDeleted = CartLayerProduct.allRetargetingDeleted;
            data.render.usualText = !CartLayerProduct.isRetargeting
                && !CartLayerProduct.allRetargetingDeleted;
            for (var indexOfCartProduct = 0; indexOfCartProduct < data.render.products.length; indexOfCartProduct++) {
                if (data.render.products[indexOfCartProduct].show) {
                    CartLayerProduct.cart.products.push(data.render.products[indexOfCartProduct]);
                    CartLayerProduct.count.push(CartLayerProduct.cart.products[indexOfCartProduct].count[0]);
                    CartLayerProduct.view.push(CartLayerProduct.cart.products[indexOfCartProduct].view[0]);
                    CartLayerProduct.cart.products[indexOfCartProduct].index = indexOfCartProduct;
                }
            }
            for (var indexOfView = 0; indexOfView < CartLayerProduct.view.length; indexOfView++) {
                if (CartLayerProduct.view[indexOfView].indexOf('&ts=') === -1) {
                    CartLayerProduct.view[indexOfView] += '&ts={ts}';
                } else {
                    CartLayerProduct.view[indexOfView] = CartLayerProduct.view[indexOfView].substr(0, CartLayerProduct.view[indexOfView].indexOf('&ts=')) + '&ts={ts}';
                }
            }
            this.isCartRetargetingLoaded = true;
            CartLayerProduct.firePixels();
        }
    };
    this.firePixels = function () {
        track('header.cart.open', 'event');
        if (!CartLayerProduct.layerOpenedFirstTime) {
            AdConstructor.count(CartLayerProduct.count);
            CartLayerProduct.layerOpenedFirstTime = true;
        }
        AdConstructor.count(CartLayerProduct.view);
    };
    this.initializeCart = function (selector) {
        $(selector).on('click touchstart', CartLayerProduct.loadCart);
    };
    this.loadCart = function () {
        if (!AdService.positions['cart']) {
            AdService.setPositionParam('cart', 'wi', Math.random().toString().substr(2, 9));
            var hasProducts = 0;
            var additionalParams = {};
            var cart = document.querySelector('#cart-retargeting-menu-point figure header');
            if (cart) {
                hasProducts = 1;
            }
            if (hasProducts) {
                additionalParams['prf[rtteaser]'] = 1;
            }
            ContentService.createPosition('cart', $('.statistics:last'), {}, additionalParams);
        }
    };
    this.goToPage = function () {
        $('input[type=checkbox]#layer-cart').prop('checked', false);
    };
    this.removeProduct = function (event, element) {
        event.stopPropagation();
        event.preventDefault();
        var index = parseInt($(element).data('index'));
        var productToDelete = {};
        for (var i = 0; i < this.cart.products.length; i++) {
            if (this.cart.products[i].index === index) {
                productToDelete = this.cart.products[i];
                break;
            }
        }
        AdConstructor.count(productToDelete.delete);
        this.cart.products.splice(this.cart.products.indexOf(productToDelete), 1);
        $(event.target.parentElement.parentElement.parentElement).remove();
        if (this.cart.products.length <= 0) {
            var html = '<div class="no-products">Ihr Warenkorb ist leer.</div>';
            $('.cart-inner').append(html);
            $('.cart figure header').remove();
        } else {
            $('.cart figure header').text(this.cart.products.length);
        }
    };
    this.init();
};
var Bubble;
document.addEventListener('create_bubble', function () {
    Bubble = new function () {
        this.count = [];
        this.clickcount = [];
        this.allowed = false;
        this.init = function () {
            var htmlTag = document.getElementsByTagName('html')[0];
            var prioAdType = htmlTag.getAttribute('data-prioad-type');
            var specialAdShowBubble = false;
            specialAdShowBubble = !(prioAdType === 'sitebar' || prioAdType === 'maxiad' || prioAdType === 'double-sitebar') && !AdService.isBlocked;
            if (parseInt(AdService.params.consentLevel) > 1 && AdService.positions['bubble'] && !AdService.positions['bubble']['_disabled'] && specialAdShowBubble) {
                Bubble.allowed = true;
                var bubbleTarget = $('.statistics:last')[0];
                AdService.createPosition('bubble', bubbleTarget);
                AdService.on('beforerender', function (data) {
                    if (data.render._type === 'bubble') {
                        this.makeBubble(data);
                    }
                });
                AdService.on('cleanup', function () {
                    setTimeout(function () {
                        if (Bubble.allowed) {
                            var bubble = $('#bubble');
                            if (bubble.length > 0) {
                                $('html').attr('data-bubble', 'true');
                            }
                            bubble.addClass('visible');
                        }
                    }, 2000);
                });
            }
        };
        this.makeBubble = function (data) {
            this.count = data.render.count;
            this.clickcount = data.render.clickcount;
            var imageUrl = '';
            if (data.render.imageUrl && data.render.imageUrl.trim() !== '') {
                imageUrl = data.render.imageUrl;
            }
            data.render.showImage = imageUrl !== '';
            var intern = getUrlParam('adv-src');
            var showImage = getUrlParam('showImage');
            if (intern && intern === 'int') {
                if (showImage) {
                    data.render.showImage = showImage + '' === 'true';
                }
            }
        };
        this.closeBubble = function (event) {
            event.stopPropagation();
            event.preventDefault();
            $('#bubble').remove();
        };
    };
    $(document).ready(function () {
        Bubble.init();
    });
});
AdService.on('beforerender', function (data) {
    data.render._splitlines = ['headline', 'subline'];
});
var endProcessing = new Date();
AdService.setAdHook('maxiad:prepare', function (data, meta) {
    var variantProperties = {};
    if (data.variant === 'xxl') {
        variantProperties = $.extend(true, {
            components: {
                maxiad: {
                    width: 1260,
                    height: 690,
                    variant: 'fullwidth',
                    minWidth: 1262
                }
            }
        }, variantProperties);
    }
    if (data.variant === 'xl') {
        variantProperties = $.extend(true, {
            components: {
                maxiad: {
                    width: 800,
                    height: 600,
                    variant: 'fullwidth',
                    minWidth: 682
                }
            }
        }, variantProperties);
    } else if (data.variant === 'video-channel') {
        variantProperties = $.extend(true, {
            postMessage: true,
            postMessageData: {
                videodata: $.extend(true, {
                    mejs: {
                        features: ['playpause', 'current', 'progress', 'duration', 'tracks', 'volume', 'fullscreen', 'sourcechooser', 'clickout', 'tracking']
                    },
                    autoselect: true,
                    autostart: true,
                    autocontinue: true,
                    autocycle: false,
                    autodelay: 0
                }, data.components.maxiad.videodata)
            },
            components: {
                maxiad: {
                    width: 980,
                    height: 650,
                    minWidth: 982,
                    variant: 'video-channel'
                }
            }
        }, variantProperties);
    }
    if (typeof data.components.bg !== 'undefined') {
        variantProperties = $.extend(true, {
            components: {
                bg: {
                    height: 650
                }
            }
        }, variantProperties);
    }
    data = $.extend(true, {}, variantProperties, data);
    return data;
});
var SkyBackfillAdHook = new function () {
    this.created = false;
    this.cleanupCalled = false;
};
AdService.setAdHook('sky:prepare', function (data, meta) {
    AdService.setPositionParam('sky_right', '_created', true);
    SkyBackfillAdHook.created = true;
    return data;
});
AdService.setAdHook('sky_right:prepare', function (data, meta) {
    SkyBackfillAdHook.created = true;
    var returnMe = {
        type: 'sky_right',
        components: {
            skyright: {
                dom: $('#' + AdService.advContainerId).get(0) || data.skyright.dom,
                width: (+meta.width || 160),
                height: (+meta.height || 600)
            }
        }
    };
    return returnMe
});
['sky_right:created', 'skyright:created'].forEach(function (component) {
    document.addEventListener(component,function () {
        AdService.cleanup();
    }, false);
});
AdService.on('cleanup', function () {
    if (SkyBackfillAdHook.created && !SkyBackfillAdHook.cleanupCalled) {
        PageLayout.forceRefresh();
        SkyBackfillAdHook.cleanupCalled = true;
    }
});
var mejs = mejs || {};
mejs.version = '2.16.3';
mejs.meIndex = 0;
mejs.plugins = {
	silverlight: [
		{version: [3,0], types: ['video/mp4','video/m4v','video/mov','video/wmv','audio/wma','audio/m4a','audio/mp3','audio/wav','audio/mpeg']}
	],
	flash: [
		{version: [9,0,124], types: ['video/mp4','video/m4v','video/mov','video/flv','video/rtmp','video/x-flv','audio/flv','audio/x-flv','audio/mp3','audio/m4a','audio/mpeg', 'video/youtube', 'video/x-youtube', 'application/x-mpegURL']}
	],
	youtube: [
		{version: null, types: ['video/youtube', 'video/x-youtube', 'audio/youtube', 'audio/x-youtube']}
	],
	vimeo: [
		{version: null, types: ['video/vimeo', 'video/x-vimeo']}
	]
};
mejs.Utility = {
	encodeUrl: function(url) {
		return encodeURIComponent(url);
	},
	escapeHTML: function(s) {
		return s.toString().split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;');
	},
	absolutizeUrl: function(url) {
		var el = document.createElement('div');
		el.innerHTML = '<a href="' + this.escapeHTML(url) + '">x</a>';
		return el.firstChild.href;
	},
	getScriptPath: function(scriptNames) {
		var
			i = 0,
			j,
			codePath = '',
			testname = '',
			slashPos,
			filenamePos,
			scriptUrl,
			scriptPath,
			scriptFilename,
			scripts = document.getElementsByTagName('script'),
			il = scripts.length,
			jl = scriptNames.length;
		for (; i < il; i++) {
			scriptUrl = scripts[i].src;
			slashPos = scriptUrl.lastIndexOf('/');
			if (slashPos > -1) {
				scriptFilename = scriptUrl.substring(slashPos + 1);
				scriptPath = scriptUrl.substring(0, slashPos + 1);
			} else {
				scriptFilename = scriptUrl;
				scriptPath = '';
			}
			for (j = 0; j < jl; j++) {
				testname = scriptNames[j];
				filenamePos = scriptFilename.indexOf(testname);
				if (filenamePos > -1) {
					codePath = scriptPath;
					break;
				}
			}
			if (codePath !== '') {
				break;
			}
		}
		return codePath;
	},
	secondsToTimeCode: function(time, forceHours, showFrameCount, fps) {
		if (typeof showFrameCount == 'undefined') {
		    showFrameCount=false;
		} else if(typeof fps == 'undefined') {
		    fps = 25;
		}
		var hours = Math.floor(time / 3600) % 24,
			minutes = Math.floor(time / 60) % 60,
			seconds = Math.floor(time % 60),
			frames = Math.floor(((time % 1)*fps).toFixed(3)),
			result =
					( (forceHours || hours > 0) ? (hours < 10 ? '0' + hours : hours) + ':' : '')
						+ (minutes < 10 ? '0' + minutes : minutes) + ':'
						+ (seconds < 10 ? '0' + seconds : seconds)
						+ ((showFrameCount) ? ':' + (frames < 10 ? '0' + frames : frames) : '');
		return result;
	},
	timeCodeToSeconds: function(hh_mm_ss_ff, forceHours, showFrameCount, fps){
		if (typeof showFrameCount == 'undefined') {
		    showFrameCount=false;
		} else if(typeof fps == 'undefined') {
		    fps = 25;
		}
		var tc_array = hh_mm_ss_ff.split(":"),
			tc_hh = parseInt(tc_array[0], 10),
			tc_mm = parseInt(tc_array[1], 10),
			tc_ss = parseInt(tc_array[2], 10),
			tc_ff = 0,
			tc_in_seconds = 0;
		if (showFrameCount) {
		    tc_ff = parseInt(tc_array[3])/fps;
		}
		tc_in_seconds = ( tc_hh * 3600 ) + ( tc_mm * 60 ) + tc_ss + tc_ff;
		return tc_in_seconds;
	},
	convertSMPTEtoSeconds: function (SMPTE) {
		if (typeof SMPTE != 'string')
			return false;
		SMPTE = SMPTE.replace(',', '.');
		var secs = 0,
			decimalLen = (SMPTE.indexOf('.') != -1) ? SMPTE.split('.')[1].length : 0,
			multiplier = 1;
		SMPTE = SMPTE.split(':').reverse();
		for (var i = 0; i < SMPTE.length; i++) {
			multiplier = 1;
			if (i > 0) {
				multiplier = Math.pow(60, i);
			}
			secs += Number(SMPTE[i]) * multiplier;
		}
		return Number(secs.toFixed(decimalLen));
	},
	removeSwf: function(id) {
		var obj = document.getElementById(id);
		if (obj && /object|embed/i.test(obj.nodeName)) {
			if (mejs.MediaFeatures.isIE) {
				obj.style.display = "none";
				(function(){
					if (obj.readyState == 4) {
						mejs.Utility.removeObjectInIE(id);
					} else {
						setTimeout(arguments.callee, 10);
					}
				})();
			} else {
				obj.parentNode.removeChild(obj);
			}
		}
	},
	removeObjectInIE: function(id) {
		var obj = document.getElementById(id);
		if (obj) {
			for (var i in obj) {
				if (typeof obj[i] == "function") {
					obj[i] = null;
				}
			}
			obj.parentNode.removeChild(obj);
		}
	}
};
mejs.PluginDetector = {
	hasPluginVersion: function(plugin, v) {
		var pv = this.plugins[plugin];
		v[1] = v[1] || 0;
		v[2] = v[2] || 0;
		return (pv[0] > v[0] || (pv[0] == v[0] && pv[1] > v[1]) || (pv[0] == v[0] && pv[1] == v[1] && pv[2] >= v[2])) ? true : false;
	},
	nav: window.navigator,
	ua: window.navigator.userAgent.toLowerCase(),
	plugins: [],
	addPlugin: function(p, pluginName, mimeType, activeX, axDetect) {
		this.plugins[p] = this.detectPlugin(pluginName, mimeType, activeX, axDetect);
	},
	detectPlugin: function(pluginName, mimeType, activeX, axDetect) {
		var version = [0,0,0],
			description,
			i,
			ax;
		if (typeof(this.nav.plugins) != 'undefined' && typeof this.nav.plugins[pluginName] == 'object') {
			description = this.nav.plugins[pluginName].description;
			if (description && !(typeof this.nav.mimeTypes != 'undefined' && this.nav.mimeTypes[mimeType] && !this.nav.mimeTypes[mimeType].enabledPlugin)) {
				version = description.replace(pluginName, '').replace(/^\s+/,'').replace(/\sr/gi,'.').split('.');
				for (i=0; i<version.length; i++) {
					version[i] = parseInt(version[i].match(/\d+/), 10);
				}
			}
		} else if (typeof(window.ActiveXObject) != 'undefined') {
			try {
				ax = new ActiveXObject(activeX);
				if (ax) {
					version = axDetect(ax);
				}
			}
			catch (e) { }
		}
		return version;
	}
};
mejs.PluginDetector.addPlugin('flash','Shockwave Flash','application/x-shockwave-flash','ShockwaveFlash.ShockwaveFlash', function(ax) {
	var version = [],
		d = ax.GetVariable("$version");
	if (d) {
		d = d.split(" ")[1].split(",");
		version = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
	}
	return version;
});
mejs.PluginDetector.addPlugin('silverlight','Silverlight Plug-In','application/x-silverlight-2','AgControl.AgControl', function (ax) {
	var v = [0,0,0,0],
		loopMatch = function(ax, v, i, n) {
			while(ax.isVersionSupported(v[0]+ "."+ v[1] + "." + v[2] + "." + v[3])){
				v[i]+=n;
			}
			v[i] -= n;
		};
	loopMatch(ax, v, 0, 1);
	loopMatch(ax, v, 1, 1);
	loopMatch(ax, v, 2, 10000);
	loopMatch(ax, v, 2, 1000);
	loopMatch(ax, v, 2, 100);
	loopMatch(ax, v, 2, 10);
	loopMatch(ax, v, 2, 1);
	loopMatch(ax, v, 3, 1);
	return v;
});
mejs.MediaFeatures = {
	init: function() {
		var
			t = this,
			d = document,
			nav = mejs.PluginDetector.nav,
			ua = mejs.PluginDetector.ua.toLowerCase(),
			i,
			v,
			html5Elements = ['source','track','audio','video'];
		t.isiPad = (ua.match(/ipad/i) !== null);
		t.isiPhone = (ua.match(/iphone/i) !== null);
		t.isiOS = t.isiPhone || t.isiPad;
		t.isAndroid = (ua.match(/android/i) !== null);
		t.isBustedAndroid = (ua.match(/android 2\.[12]/) !== null);
		t.isBustedNativeHTTPS = (location.protocol === 'https:' && (ua.match(/android [12]\./) !== null || ua.match(/macintosh.* version.* safari/) !== null));
		t.isIE = (nav.appName.toLowerCase().indexOf("microsoft") != -1 || nav.appName.toLowerCase().match(/trident/gi) !== null);
		t.isChrome = (ua.match(/chrome/gi) !== null);
		t.isChromium = (ua.match(/chromium/gi) !== null);
		t.isFirefox = (ua.match(/firefox/gi) !== null);
		t.isWebkit = (ua.match(/webkit/gi) !== null);
		t.isGecko = (ua.match(/gecko/gi) !== null) && !t.isWebkit && !t.isIE;
		t.isOpera = (ua.match(/opera/gi) !== null);
		t.hasTouch = ('ontouchstart' in window);
		t.svg = !! document.createElementNS &&
				!! document.createElementNS('http://www.w3.org/2000/svg','svg').createSVGRect;
		for (i=0; i<html5Elements.length; i++) {
			v = document.createElement(html5Elements[i]);
		}
		t.supportsMediaTag = (typeof v.canPlayType !== 'undefined' || t.isBustedAndroid);
		try{
			v.canPlayType("video/mp4");
		}catch(e){
			t.supportsMediaTag = false;
		}
		t.hasSemiNativeFullScreen = (typeof v.webkitEnterFullscreen !== 'undefined');
		t.hasNativeFullscreen = (typeof v.requestFullscreen !== 'undefined');
		t.hasWebkitNativeFullScreen = (typeof v.webkitRequestFullScreen !== 'undefined');
		t.hasMozNativeFullScreen = (typeof v.mozRequestFullScreen !== 'undefined');
		t.hasMsNativeFullScreen = (typeof v.msRequestFullscreen !== 'undefined');
		t.hasTrueNativeFullScreen = (t.hasWebkitNativeFullScreen || t.hasMozNativeFullScreen || t.hasMsNativeFullScreen);
		t.nativeFullScreenEnabled = t.hasTrueNativeFullScreen;
		if (t.hasMozNativeFullScreen) {
			t.nativeFullScreenEnabled = document.mozFullScreenEnabled;
		} else if (t.hasMsNativeFullScreen) {
			t.nativeFullScreenEnabled = document.msFullscreenEnabled;
		}
		if (t.isChrome) {
			t.hasSemiNativeFullScreen = false;
		}
		if (t.hasTrueNativeFullScreen) {
			t.fullScreenEventName = '';
			if (t.hasWebkitNativeFullScreen) {
				t.fullScreenEventName = 'webkitfullscreenchange';
			} else if (t.hasMozNativeFullScreen) {
				t.fullScreenEventName = 'mozfullscreenchange';
			} else if (t.hasMsNativeFullScreen) {
				t.fullScreenEventName = 'MSFullscreenChange';
			}
			t.isFullScreen = function() {
				if (t.hasMozNativeFullScreen) {
					return d.mozFullScreen;
				} else if (t.hasWebkitNativeFullScreen) {
					return d.webkitIsFullScreen;
				} else if (t.hasMsNativeFullScreen) {
					return d.msFullscreenElement !== null;
				}
			}
			t.requestFullScreen = function(el) {
				if (t.hasWebkitNativeFullScreen) {
					el.webkitRequestFullScreen();
				} else if (t.hasMozNativeFullScreen) {
					el.mozRequestFullScreen();
				} else if (t.hasMsNativeFullScreen) {
					el.msRequestFullscreen();
				}
			}
			t.cancelFullScreen = function() {
				if (t.hasWebkitNativeFullScreen) {
					document.webkitCancelFullScreen();
				} else if (t.hasMozNativeFullScreen) {
					document.mozCancelFullScreen();
				} else if (t.hasMsNativeFullScreen) {
					document.msExitFullscreen();
				}
			}
		}
		if (t.hasSemiNativeFullScreen && ua.match(/mac os x 10_5/i)) {
			t.hasNativeFullScreen = false;
			t.hasSemiNativeFullScreen = false;
		}
	}
};
mejs.MediaFeatures.init();
mejs.HtmlMediaElement = {
	pluginType: 'native',
	isFullScreen: false,
	setCurrentTime: function (time) {
		this.currentTime = time;
	},
	setMuted: function (muted) {
		this.muted = muted;
	},
	setVolume: function (volume) {
		this.volume = volume;
	},
	stop: function () {
		this.pause();
	},
	setSrc: function (url) {
		var
			existingSources = this.getElementsByTagName('source');
		while (existingSources.length > 0){
			this.removeChild(existingSources[0]);
		}
		if (typeof url == 'string') {
			this.src = url;
		} else {
			var i, media;
			for (i=0; i<url.length; i++) {
				media = url[i];
				if (this.canPlayType(media.type)) {
					this.src = media.src;
					break;
				}
			}
		}
	},
	setVideoSize: function (width, height) {
		this.width = width;
		this.height = height;
	}
};
mejs.PluginMediaElement = function (pluginid, pluginType, mediaUrl) {
	this.id = pluginid;
	this.pluginType = pluginType;
	this.src = mediaUrl;
	this.events = {};
	this.attributes = {};
};
mejs.PluginMediaElement.prototype = {
	pluginElement: null,
	pluginType: '',
	isFullScreen: false,
	playbackRate: -1,
	defaultPlaybackRate: -1,
	seekable: [],
	played: [],
	paused: true,
	ended: false,
	seeking: false,
	duration: 0,
	error: null,
	tagName: '',
	muted: false,
	volume: 1,
	currentTime: 0,
	play: function () {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
				this.pluginApi.playVideo();
			} else {
				this.pluginApi.playMedia();
			}
			this.paused = false;
		}
	},
	load: function () {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
			} else {
				this.pluginApi.loadMedia();
			}
			this.paused = false;
		}
	},
	pause: function () {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
				this.pluginApi.pauseVideo();
			} else {
				this.pluginApi.pauseMedia();
			}
			this.paused = true;
		}
	},
	stop: function () {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
				this.pluginApi.stopVideo();
			} else {
				this.pluginApi.stopMedia();
			}
			this.paused = true;
		}
	},
	canPlayType: function(type) {
		var i,
			j,
			pluginInfo,
			pluginVersions = mejs.plugins[this.pluginType];
		for (i=0; i<pluginVersions.length; i++) {
			pluginInfo = pluginVersions[i];
			if (mejs.PluginDetector.hasPluginVersion(this.pluginType, pluginInfo.version)) {
				for (j=0; j<pluginInfo.types.length; j++) {
					if (type == pluginInfo.types[j]) {
						return 'probably';
					}
				}
			}
		}
		return '';
	},
	positionFullscreenButton: function(x,y,visibleAndAbove) {
		if (this.pluginApi != null && this.pluginApi.positionFullscreenButton) {
			this.pluginApi.positionFullscreenButton(Math.floor(x),Math.floor(y),visibleAndAbove);
		}
	},
	hideFullscreenButton: function() {
		if (this.pluginApi != null && this.pluginApi.hideFullscreenButton) {
			this.pluginApi.hideFullscreenButton();
		}
	},
	setSrc: function (url) {
		if (typeof url == 'string') {
			this.pluginApi.setSrc(mejs.Utility.absolutizeUrl(url));
			this.src = mejs.Utility.absolutizeUrl(url);
		} else {
			var i, media;
			for (i=0; i<url.length; i++) {
				media = url[i];
				if (this.canPlayType(media.type)) {
					this.pluginApi.setSrc(mejs.Utility.absolutizeUrl(media.src));
					this.src = mejs.Utility.absolutizeUrl(url);
					break;
				}
			}
		}
	},
	setCurrentTime: function (time) {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
				this.pluginApi.seekTo(time);
			} else {
				this.pluginApi.setCurrentTime(time);
			}
			this.currentTime = time;
		}
	},
	setVolume: function (volume) {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube') {
				this.pluginApi.setVolume(volume * 100);
			} else {
				this.pluginApi.setVolume(volume);
			}
			this.volume = volume;
		}
	},
	setMuted: function (muted) {
		if (this.pluginApi != null) {
			if (this.pluginType == 'youtube') {
				if (muted) {
					this.pluginApi.mute();
				} else {
					this.pluginApi.unMute();
				}
				this.muted = muted;
				this.dispatchEvent('volumechange');
			} else {
				this.pluginApi.setMuted(muted);
			}
			this.muted = muted;
		}
	},
	setVideoSize: function (width, height) {
			if (this.pluginElement && this.pluginElement.style) {
				this.pluginElement.style.width = width + 'px';
				this.pluginElement.style.height = height + 'px';
			}
			if (this.pluginApi != null && this.pluginApi.setVideoSize) {
				this.pluginApi.setVideoSize(width, height);
			}
	},
	setFullscreen: function (fullscreen) {
		if (this.pluginApi != null && this.pluginApi.setFullscreen) {
			this.pluginApi.setFullscreen(fullscreen);
		}
	},
	enterFullScreen: function() {
		if (this.pluginApi != null && this.pluginApi.setFullscreen) {
			this.setFullscreen(true);
		}
	},
	exitFullScreen: function() {
		if (this.pluginApi != null && this.pluginApi.setFullscreen) {
			this.setFullscreen(false);
		}
	},
	addEventListener: function (eventName, callback, bubble) {
		this.events[eventName] = this.events[eventName] || [];
		this.events[eventName].push(callback);
	},
	removeEventListener: function (eventName, callback) {
		if (!eventName) { this.events = {}; return true; }
		var callbacks = this.events[eventName];
		if (!callbacks) return true;
		if (!callback) { this.events[eventName] = []; return true; }
		for (var i = 0; i < callbacks.length; i++) {
			if (callbacks[i] === callback) {
				this.events[eventName].splice(i, 1);
				return true;
			}
		}
		return false;
	},
	dispatchEvent: function (eventName) {
		var i,
			args,
			callbacks = this.events[eventName];
		if (callbacks) {
			args = Array.prototype.slice.call(arguments, 1);
			for (i = 0; i < callbacks.length; i++) {
				callbacks[i].apply(this, args);
			}
		}
	},
	hasAttribute: function(name){
		return (name in this.attributes);
	},
	removeAttribute: function(name){
		delete this.attributes[name];
	},
	getAttribute: function(name){
		if (this.hasAttribute(name)) {
			return this.attributes[name];
		}
		return '';
	},
	setAttribute: function(name, value){
		this.attributes[name] = value;
	},
	remove: function() {
		mejs.Utility.removeSwf(this.pluginElement.id);
		mejs.MediaPluginBridge.unregisterPluginElement(this.pluginElement.id);
	}
};
mejs.MediaPluginBridge = {
	pluginMediaElements:{},
	htmlMediaElements:{},
	registerPluginElement: function (id, pluginMediaElement, htmlMediaElement) {
		this.pluginMediaElements[id] = pluginMediaElement;
		this.htmlMediaElements[id] = htmlMediaElement;
	},
	unregisterPluginElement: function (id) {
		delete this.pluginMediaElements[id];
		delete this.htmlMediaElements[id];
	},
	initPlugin: function (id) {
		var pluginMediaElement = this.pluginMediaElements[id],
			htmlMediaElement = this.htmlMediaElements[id];
		if (pluginMediaElement) {
			switch (pluginMediaElement.pluginType) {
				case "flash":
					pluginMediaElement.pluginElement = pluginMediaElement.pluginApi = document.getElementById(id);
					break;
				case "silverlight":
					pluginMediaElement.pluginElement = document.getElementById(pluginMediaElement.id);
					pluginMediaElement.pluginApi = pluginMediaElement.pluginElement.Content.MediaElementJS;
					break;
			}
			if (pluginMediaElement.pluginApi != null && pluginMediaElement.success) {
				pluginMediaElement.success(pluginMediaElement, htmlMediaElement);
			}
		}
	},
	fireEvent: function (id, eventName, values) {
		var
			e,
			i,
			bufferedTime,
			pluginMediaElement = this.pluginMediaElements[id];
		if(!pluginMediaElement){
            return;
        }
		e = {
			type: eventName,
			target: pluginMediaElement
		};
		for (i in values) {
			pluginMediaElement[i] = values[i];
			e[i] = values[i];
		}
		bufferedTime = values.bufferedTime || 0;
		e.target.buffered = e.buffered = {
			start: function(index) {
				return 0;
			},
			end: function (index) {
				return bufferedTime;
			},
			length: 1
		};
		pluginMediaElement.dispatchEvent(e.type, e);
	}
};
mejs.MediaElementDefaults = {
	mode: 'auto',
	plugins: ['flash','silverlight','youtube','vimeo'],
	enablePluginDebug: false,
	httpsBasicAuthSite: false,
	type: '',
	pluginPath: mejs.Utility.getScriptPath(['mediaelement.js','mediaelement.min.js','mediaelement-and-player.js','mediaelement-and-player.min.js']),
	flashName: 'flashmediaelement.swf',
	flashStreamer: '',
	enablePluginSmoothing: false,
	enablePseudoStreaming: false,
	pseudoStreamingStartQueryParam: 'start',
	silverlightName: 'silverlightmediaelement.xap',
	defaultVideoWidth: 480,
	defaultVideoHeight: 270,
	pluginWidth: -1,
	pluginHeight: -1,
	pluginVars: [],
	timerRate: 250,
	startVolume: 0.8,
	success: function () { },
	error: function () { }
};
mejs.MediaElement = function (el, o) {
	return mejs.HtmlMediaElementShim.create(el,o);
};
mejs.HtmlMediaElementShim = {
	create: function(el, o) {
		var
			options = mejs.MediaElementDefaults,
			htmlMediaElement = (typeof(el) == 'string') ? document.getElementById(el) : el,
			tagName = htmlMediaElement.tagName.toLowerCase(),
			isMediaTag = (tagName === 'audio' || tagName === 'video'),
			src = (isMediaTag) ? htmlMediaElement.getAttribute('src') : htmlMediaElement.getAttribute('href'),
			poster = htmlMediaElement.getAttribute('poster'),
			autoplay =  htmlMediaElement.getAttribute('autoplay'),
			preload =  htmlMediaElement.getAttribute('preload'),
			controls =  htmlMediaElement.getAttribute('controls'),
			playback,
			prop;
		for (prop in o) {
			options[prop] = o[prop];
		}
		src = 		(typeof src == 'undefined' 	|| src === null || src == '') ? null : src;
		poster =	(typeof poster == 'undefined' 	|| poster === null) ? '' : poster;
		preload = 	(typeof preload == 'undefined' 	|| preload === null || preload === 'false') ? 'none' : preload;
		autoplay = 	!(typeof autoplay == 'undefined' || autoplay === null || autoplay === 'false');
		controls = 	!(typeof controls == 'undefined' || controls === null || controls === 'false');
		playback = this.determinePlayback(htmlMediaElement, options, mejs.MediaFeatures.supportsMediaTag, isMediaTag, src);
		playback.url = (playback.url !== null) ? mejs.Utility.absolutizeUrl(playback.url) : '';
		if (playback.method == 'native') {
			if (mejs.MediaFeatures.isBustedAndroid) {
				htmlMediaElement.src = playback.url;
				htmlMediaElement.addEventListener('click', function() {
					htmlMediaElement.play();
				}, false);
			}
			return this.updateNative(playback, options, autoplay, preload);
		} else if (playback.method !== '') {
			return this.createPlugin( playback,  options, poster, autoplay, preload, controls);
		} else {
			this.createErrorMessage( playback, options, poster );
			return this;
		}
	},
	determinePlayback: function(htmlMediaElement, options, supportsMediaTag, isMediaTag, src) {
		var
			mediaFiles = [],
			i,
			j,
			k,
			l,
			n,
			type,
			result = { method: '', url: '', htmlMediaElement: htmlMediaElement, isVideo: (htmlMediaElement.tagName.toLowerCase() != 'audio')},
			pluginName,
			pluginVersions,
			pluginInfo,
			dummy,
			media;
		if (typeof options.type != 'undefined' && options.type !== '') {
			if (typeof options.type == 'string') {
				mediaFiles.push({type:options.type, url:src});
			} else {
				for (i=0; i<options.type.length; i++) {
					mediaFiles.push({type:options.type[i], url:src});
				}
			}
		} else if (src !== null) {
			type = this.formatType(src, htmlMediaElement.getAttribute('type'));
			mediaFiles.push({type:type, url:src});
		} else {
			for (i = 0; i < htmlMediaElement.childNodes.length; i++) {
				n = htmlMediaElement.childNodes[i];
				if (n.nodeType == 1 && n.tagName.toLowerCase() == 'source') {
					src = n.getAttribute('src');
					type = this.formatType(src, n.getAttribute('type'));
					media = n.getAttribute('media');
					if (!media || !window.matchMedia || (window.matchMedia && window.matchMedia(media).matches)) {
						mediaFiles.push({type:type, url:src});
					}
				}
			}
		}
		if (!isMediaTag && mediaFiles.length > 0 && mediaFiles[0].url !== null && this.getTypeFromFile(mediaFiles[0].url).indexOf('audio') > -1) {
			result.isVideo = false;
		}
		if (mejs.MediaFeatures.isBustedAndroid) {
			htmlMediaElement.canPlayType = function(type) {
				return (type.match(/video\/(mp4|m4v)/gi) !== null) ? 'maybe' : '';
			};
		}
		if (mejs.MediaFeatures.isChromium) {
			htmlMediaElement.canPlayType = function(type) {
				return (type.match(/video\/(webm|ogv|ogg)/gi) !== null) ? 'maybe' : '';
			};
		}
		if (supportsMediaTag && (options.mode === 'auto' || options.mode === 'auto_plugin' || options.mode === 'native')  && !(mejs.MediaFeatures.isBustedNativeHTTPS && options.httpsBasicAuthSite === true)) {
			if (!isMediaTag) {
				dummy = document.createElement( result.isVideo ? 'video' : 'audio');
				htmlMediaElement.parentNode.insertBefore(dummy, htmlMediaElement);
				htmlMediaElement.style.display = 'none';
				result.htmlMediaElement = htmlMediaElement = dummy;
			}
			for (i=0; i<mediaFiles.length; i++) {
				if (mediaFiles[i].type == "video/m3u8" || htmlMediaElement.canPlayType(mediaFiles[i].type).replace(/no/, '') !== ''
					|| htmlMediaElement.canPlayType(mediaFiles[i].type.replace(/mp3/,'mpeg')).replace(/no/, '') !== ''
					|| htmlMediaElement.canPlayType(mediaFiles[i].type.replace(/m4a/,'mp4')).replace(/no/, '') !== '') {
					result.method = 'native';
					result.url = mediaFiles[i].url;
					break;
				}
			}
			if (result.method === 'native') {
				if (result.url !== null) {
					htmlMediaElement.src = result.url;
				}
				if (options.mode !== 'auto_plugin') {
					return result;
				}
			}
		}
		if (options.mode === 'auto' || options.mode === 'auto_plugin' || options.mode === 'shim') {
			for (i=0; i<mediaFiles.length; i++) {
				type = mediaFiles[i].type;
				for (j=0; j<options.plugins.length; j++) {
					pluginName = options.plugins[j];
					pluginVersions = mejs.plugins[pluginName];
					for (k=0; k<pluginVersions.length; k++) {
						pluginInfo = pluginVersions[k];
						if (pluginInfo.version == null ||
							mejs.PluginDetector.hasPluginVersion(pluginName, pluginInfo.version)) {
							for (l=0; l<pluginInfo.types.length; l++) {
								if (type == pluginInfo.types[l]) {
									result.method = pluginName;
									result.url = mediaFiles[i].url;
									return result;
								}
							}
						}
					}
				}
			}
		}
		if (options.mode === 'auto_plugin' && result.method === 'native') {
			return result;
		}
		if (result.method === '' && mediaFiles.length > 0) {
			result.url = mediaFiles[0].url;
		}
		return result;
	},
	formatType: function(url, type) {
		var ext;
		if (url && !type) {
			return this.getTypeFromFile(url);
		} else {
			if (type && ~type.indexOf(';')) {
				return type.substr(0, type.indexOf(';'));
			} else {
				return type;
			}
		}
	},
	getTypeFromFile: function(url) {
		url = url.split('?')[0];
		var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
		return (/(mp4|m4v|ogg|ogv|m3u8|webm|webmv|flv|wmv|mpeg|mov)/gi.test(ext) ? 'video' : 'audio') + '/' + this.getTypeFromExtension(ext);
	},
	getTypeFromExtension: function(ext) {
		switch (ext) {
			case 'mp4':
			case 'm4v':
			case 'm4a':
				return 'mp4';
			case 'webm':
			case 'webma':
			case 'webmv':
				return 'webm';
			case 'ogg':
			case 'oga':
			case 'ogv':
				return 'ogg';
			default:
				return ext;
		}
	},
	createErrorMessage: function(playback, options, poster) {
		var
			htmlMediaElement = playback.htmlMediaElement,
			errorContainer = document.createElement('div');
		errorContainer.className = 'me-cannotplay';
		try {
			errorContainer.style.width = htmlMediaElement.width + 'px';
			errorContainer.style.height = htmlMediaElement.height + 'px';
		} catch (e) {}
    if (options.customError) {
      errorContainer.innerHTML = options.customError;
    } else {
      errorContainer.innerHTML = (poster !== '') ?
        '<a href="' + playback.url + '"><img src="' + poster + '" width="100%" height="100%" /></a>' :
        '<a href="' + playback.url + '"><span>' + mejs.i18n.t('Download File') + '</span></a>';
    }
		htmlMediaElement.parentNode.insertBefore(errorContainer, htmlMediaElement);
		htmlMediaElement.style.display = 'none';
		options.error(htmlMediaElement);
	},
	createPlugin:function(playback, options, poster, autoplay, preload, controls) {
		var
			htmlMediaElement = playback.htmlMediaElement,
			width = 1,
			height = 1,
			pluginid = 'me_' + playback.method + '_' + (mejs.meIndex++),
			pluginMediaElement = new mejs.PluginMediaElement(pluginid, playback.method, playback.url),
			container = document.createElement('div'),
			specialIEContainer,
			node,
			initVars;
		pluginMediaElement.tagName = htmlMediaElement.tagName
		for (var i = 0; i < htmlMediaElement.attributes.length; i++) {
			var attribute = htmlMediaElement.attributes[i];
			if (attribute.specified == true) {
				pluginMediaElement.setAttribute(attribute.name, attribute.value);
			}
		}
		node = htmlMediaElement.parentNode;
		while (node !== null && node.tagName.toLowerCase() !== 'body' && node.parentNode != null) {
			if (node.parentNode.tagName.toLowerCase() === 'p') {
				node.parentNode.parentNode.insertBefore(node, node.parentNode);
				break;
			}
			node = node.parentNode;
		}
		if (playback.isVideo) {
			width = (options.pluginWidth > 0) ? options.pluginWidth : (options.videoWidth > 0) ? options.videoWidth : (htmlMediaElement.getAttribute('width') !== null) ? htmlMediaElement.getAttribute('width') : options.defaultVideoWidth;
			height = (options.pluginHeight > 0) ? options.pluginHeight : (options.videoHeight > 0) ? options.videoHeight : (htmlMediaElement.getAttribute('height') !== null) ? htmlMediaElement.getAttribute('height') : options.defaultVideoHeight;
			width = mejs.Utility.encodeUrl(width);
			height = mejs.Utility.encodeUrl(height);
		} else {
			if (options.enablePluginDebug) {
				width = 320;
				height = 240;
			}
		}
		pluginMediaElement.success = options.success;
		mejs.MediaPluginBridge.registerPluginElement(pluginid, pluginMediaElement, htmlMediaElement);
		container.className = 'me-plugin';
		container.id = pluginid + '_container';
		if (playback.isVideo) {
				htmlMediaElement.parentNode.insertBefore(container, htmlMediaElement);
		} else {
				document.body.insertBefore(container, document.body.childNodes[0]);
		}
		initVars = [
			'id=' + pluginid,
			'jsinitfunction=' + "mejs.MediaPluginBridge.initPlugin",
			'jscallbackfunction=' + "mejs.MediaPluginBridge.fireEvent",
			'isvideo=' + ((playback.isVideo) ? "true" : "false"),
			'autoplay=' + ((autoplay) ? "true" : "false"),
			'preload=' + preload,
			'width=' + width,
			'startvolume=' + options.startVolume,
			'timerrate=' + options.timerRate,
			'flashstreamer=' + options.flashStreamer,
			'height=' + height,
			'pseudostreamstart=' + options.pseudoStreamingStartQueryParam];
		if (playback.url !== null) {
			if (playback.method == 'flash') {
				initVars.push('file=' + mejs.Utility.encodeUrl(playback.url));
			} else {
				initVars.push('file=' + playback.url);
			}
		}
		if (options.enablePluginDebug) {
			initVars.push('debug=true');
		}
		if (options.enablePluginSmoothing) {
			initVars.push('smoothing=true');
		}
    if (options.enablePseudoStreaming) {
      initVars.push('pseudostreaming=true');
    }
		if (controls) {
			initVars.push('controls=true');
		}
		if (options.pluginVars) {
			initVars = initVars.concat(options.pluginVars);
		}
		switch (playback.method) {
			case 'silverlight':
				container.innerHTML =
'<object data="data:application/x-silverlight-2," type="application/x-silverlight-2" id="' + pluginid + '" name="' + pluginid + '" width="' + width + '" height="' + height + '" class="mejs-shim">' +
'<param name="initParams" value="' + initVars.join(',') + '" />' +
'<param name="windowless" value="true" />' +
'<param name="background" value="black" />' +
'<param name="minRuntimeVersion" value="3.0.0.0" />' +
'<param name="autoUpgrade" value="true" />' +
'<param name="source" value="' + options.pluginPath + options.silverlightName + '" />' +
'</object>';
					break;
			case 'flash':
				if (mejs.MediaFeatures.isIE) {
					specialIEContainer = document.createElement('div');
					container.appendChild(specialIEContainer);
					specialIEContainer.outerHTML =
'<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab" ' +
'id="' + pluginid + '" width="' + width + '" height="' + height + '" class="mejs-shim">' +
'<param name="movie" value="' + options.pluginPath + options.flashName + '?x=' + (new Date()) + '" />' +
'<param name="flashvars" value="' + initVars.join('&amp;') + '" />' +
'<param name="quality" value="high" />' +
'<param name="bgcolor" value="#000000" />' +
'<param name="wmode" value="transparent" />' +
'<param name="allowScriptAccess" value="always" />' +
'<param name="allowFullScreen" value="true" />' +
'<param name="scale" value="default" />' +
'</object>';
				} else {
					container.innerHTML =
'<embed id="' + pluginid + '" name="' + pluginid + '" ' +
'play="true" ' +
'loop="false" ' +
'quality="high" ' +
'bgcolor="#000000" ' +
'wmode="transparent" ' +
'allowScriptAccess="always" ' +
'allowFullScreen="true" ' +
'type="application/x-shockwave-flash" pluginspage="//www.macromedia.com/go/getflashplayer" ' +
'src="' + options.pluginPath + options.flashName + '" ' +
'flashvars="' + initVars.join('&') + '" ' +
'width="' + width + '" ' +
'height="' + height + '" ' +
'scale="default"' +
'class="mejs-shim"></embed>';
				}
				break;
			case 'youtube':
				var videoId;
				if (playback.url.lastIndexOf("youtu.be") != -1) {
					videoId = playback.url.substr(playback.url.lastIndexOf('/')+1);
					if (videoId.indexOf('?') != -1) {
						videoId = videoId.substr(0, videoId.indexOf('?'));
					}
				}
				else {
					videoId = playback.url.substr(playback.url.lastIndexOf('=')+1);
				}
				youtubeSettings = {
						container: container,
						containerId: container.id,
						pluginMediaElement: pluginMediaElement,
						pluginId: pluginid,
						videoId: videoId,
						height: height,
						width: width
					};
				if (mejs.PluginDetector.hasPluginVersion('flash', [10,0,0]) ) {
					mejs.YouTubeApi.createFlash(youtubeSettings);
				} else {
					mejs.YouTubeApi.enqueueIframe(youtubeSettings);
				}
				break;
			case 'vimeo':
				var player_id = pluginid + "_player";
				pluginMediaElement.vimeoid = playback.url.substr(playback.url.lastIndexOf('/')+1);
				container.innerHTML ='<iframe src="//player.vimeo.com/video/' + pluginMediaElement.vimeoid + '?api=1&portrait=0&byline=0&title=0&player_id=' + player_id + '" width="' + width +'" height="' + height +'" frameborder="0" class="mejs-shim" id="' + player_id + '" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
				if (typeof($f) == 'function') {
					var player = $f(container.childNodes[0]);
					player.addEvent('ready', function() {
						player.playVideo = function() {
							player.api( 'play' );
						}
						player.stopVideo = function() {
							player.api( 'unload' );
						}
						player.pauseVideo = function() {
							player.api( 'pause' );
						}
						player.seekTo = function( seconds ) {
							player.api( 'seekTo', seconds );
						}
						player.setVolume = function( volume ) {
							player.api( 'setVolume', volume );
						}
						player.setMuted = function( muted ) {
							if( muted ) {
								player.lastVolume = player.api( 'getVolume' );
								player.api( 'setVolume', 0 );
							} else {
								player.api( 'setVolume', player.lastVolume );
								delete player.lastVolume;
							}
						}
						function createEvent(player, pluginMediaElement, eventName, e) {
							var obj = {
								type: eventName,
								target: pluginMediaElement
							};
							if (eventName == 'timeupdate') {
								pluginMediaElement.currentTime = obj.currentTime = e.seconds;
								pluginMediaElement.duration = obj.duration = e.duration;
							}
							pluginMediaElement.dispatchEvent(obj.type, obj);
						}
						player.addEvent('play', function() {
							createEvent(player, pluginMediaElement, 'play');
							createEvent(player, pluginMediaElement, 'playing');
						});
						player.addEvent('pause', function() {
							createEvent(player, pluginMediaElement, 'pause');
						});
						player.addEvent('finish', function() {
							createEvent(player, pluginMediaElement, 'ended');
						});
						player.addEvent('playProgress', function(e) {
							createEvent(player, pluginMediaElement, 'timeupdate', e);
						});
						pluginMediaElement.pluginElement = container;
						pluginMediaElement.pluginApi = player;
						mejs.MediaPluginBridge.initPlugin(pluginid);
					});
				}
				else {
					console.warn("You need to include froogaloop for vimeo to work");
				}
				break;
		}
		htmlMediaElement.style.display = 'none';
		htmlMediaElement.removeAttribute('autoplay');
		return pluginMediaElement;
	},
	updateNative: function(playback, options, autoplay, preload) {
		var htmlMediaElement = playback.htmlMediaElement,
			m;
		for (m in mejs.HtmlMediaElement) {
			htmlMediaElement[m] = mejs.HtmlMediaElement[m];
		}
		options.success(htmlMediaElement, htmlMediaElement);
		return htmlMediaElement;
	}
};
mejs.YouTubeApi = {
	isIframeStarted: false,
	isIframeLoaded: false,
	loadIframeApi: function() {
		if (!this.isIframeStarted) {
			var tag = document.createElement('script');
			tag.src = "//www.youtube.com/player_api";
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			this.isIframeStarted = true;
		}
	},
	iframeQueue: [],
	enqueueIframe: function(yt) {
		if (this.isLoaded) {
			this.createIframe(yt);
		} else {
			this.loadIframeApi();
			this.iframeQueue.push(yt);
		}
	},
	createIframe: function(settings) {
		var
		pluginMediaElement = settings.pluginMediaElement,
		player = new YT.Player(settings.containerId, {
			height: settings.height,
			width: settings.width,
			videoId: settings.videoId,
			playerVars: {controls:0},
			events: {
				'onReady': function() {
					settings.pluginMediaElement.pluginApi = player;
					mejs.MediaPluginBridge.initPlugin(settings.pluginId);
					setInterval(function() {
						mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'timeupdate');
					}, 250);
				},
				'onStateChange': function(e) {
					mejs.YouTubeApi.handleStateChange(e.data, player, pluginMediaElement);
				}
			}
		});
	},
	createEvent: function (player, pluginMediaElement, eventName) {
		var obj = {
			type: eventName,
			target: pluginMediaElement
		};
		if (player && player.getDuration) {
			pluginMediaElement.currentTime = obj.currentTime = player.getCurrentTime();
			pluginMediaElement.duration = obj.duration = player.getDuration();
			obj.paused = pluginMediaElement.paused;
			obj.ended = pluginMediaElement.ended;
			obj.muted = player.isMuted();
			obj.volume = player.getVolume() / 100;
			obj.bytesTotal = player.getVideoBytesTotal();
			obj.bufferedBytes = player.getVideoBytesLoaded();
			var bufferedTime = obj.bufferedBytes / obj.bytesTotal * obj.duration;
			obj.target.buffered = obj.buffered = {
				start: function(index) {
					return 0;
				},
				end: function (index) {
					return bufferedTime;
				},
				length: 1
			};
		}
		pluginMediaElement.dispatchEvent(obj.type, obj);
	},
	iFrameReady: function() {
		this.isLoaded = true;
		this.isIframeLoaded = true;
		while (this.iframeQueue.length > 0) {
			var settings = this.iframeQueue.pop();
			this.createIframe(settings);
		}
	},
	flashPlayers: {},
	createFlash: function(settings) {
		this.flashPlayers[settings.pluginId] = settings;
		var specialIEContainer,
			youtubeUrl = '//www.youtube.com/apiplayer?enablejsapi=1&amp;playerapiid=' + settings.pluginId  + '&amp;version=3&amp;autoplay=0&amp;controls=0&amp;modestbranding=1&loop=0';
		if (mejs.MediaFeatures.isIE) {
			specialIEContainer = document.createElement('div');
			settings.container.appendChild(specialIEContainer);
			specialIEContainer.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab" ' +
'id="' + settings.pluginId + '" width="' + settings.width + '" height="' + settings.height + '" class="mejs-shim">' +
	'<param name="movie" value="' + youtubeUrl + '" />' +
	'<param name="wmode" value="transparent" />' +
	'<param name="allowScriptAccess" value="always" />' +
	'<param name="allowFullScreen" value="true" />' +
'</object>';
		} else {
		settings.container.innerHTML =
			'<object type="application/x-shockwave-flash" id="' + settings.pluginId + '" data="' + youtubeUrl + '" ' +
				'width="' + settings.width + '" height="' + settings.height + '" style="visibility: visible; " class="mejs-shim">' +
				'<param name="allowScriptAccess" value="always">' +
				'<param name="wmode" value="transparent">' +
			'</object>';
		}
	},
	flashReady: function(id) {
		var
			settings = this.flashPlayers[id],
			player = document.getElementById(id),
			pluginMediaElement = settings.pluginMediaElement;
		pluginMediaElement.pluginApi =
		pluginMediaElement.pluginElement = player;
		mejs.MediaPluginBridge.initPlugin(id);
		player.cueVideoById(settings.videoId);
		var callbackName = settings.containerId + '_callback';
		window[callbackName] = function(e) {
			mejs.YouTubeApi.handleStateChange(e, player, pluginMediaElement);
		}
		player.addEventListener('onStateChange', callbackName);
		setInterval(function() {
			mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'timeupdate');
		}, 250);
		mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'canplay');
	},
	handleStateChange: function(youTubeState, player, pluginMediaElement) {
		switch (youTubeState) {
			case -1:
				pluginMediaElement.paused = true;
				pluginMediaElement.ended = true;
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'loadedmetadata');
				break;
			case 0:
				pluginMediaElement.paused = false;
				pluginMediaElement.ended = true;
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'ended');
				break;
			case 1:
				pluginMediaElement.paused = false;
				pluginMediaElement.ended = false;
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'play');
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'playing');
				break;
			case 2:
				pluginMediaElement.paused = true;
				pluginMediaElement.ended = false;
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'pause');
				break;
			case 3:
				mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'progress');
				break;
			case 5:
				break;
		}
	}
}

function onYouTubePlayerAPIReady() {
	mejs.YouTubeApi.iFrameReady();
}

function onYouTubePlayerReady(id) {
	mejs.YouTubeApi.flashReady(id);
}

window.mejs = mejs;
window.MediaElement = mejs.MediaElement;
;(function(context, exports, undefined) {
    "use strict";
    var i18n = {
        "locale": {
            "language" : (exports.i18n && exports.i18n.locale.language) || '',
            "strings" : (exports.i18n && exports.i18n.locale.strings) || {}
        },
        "ietf_lang_regex" : /^(x\-)?[a-z]{2,}(\-\w{2,})?(\-\w{2,})?$/,
        "methods" : {}
    };
    i18n.getLanguage = function () {
        var language = i18n.locale.language || window.navigator.userLanguage || window.navigator.language;
        return i18n.ietf_lang_regex.exec(language) ? language : null;
    };
    if ( typeof mejsL10n != 'undefined' ) {
        i18n.locale.language = mejsL10n.language;
    }
    i18n.methods.checkPlain = function (str) {
        var character, regex,
        replace = {
            '&': '&amp;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;'
        };
        str = String(str);
        for (character in replace) {
            if (replace.hasOwnProperty(character)) {
                regex = new RegExp(character, 'g');
                str = str.replace(regex, replace[character]);
            }
        }
        return str;
    };
    i18n.methods.t = function (str, options) {
        if (i18n.locale.strings && i18n.locale.strings[options.context] && i18n.locale.strings[options.context][str]) {
            str = i18n.locale.strings[options.context][str];
        }
        return i18n.methods.checkPlain(str);
    };
    i18n.t = function(str, options) {
        if (typeof str === 'string' && str.length > 0) {
            var language = i18n.getLanguage();
            options = options || {
                "context" : language
            };
            return i18n.methods.t(str, options);
        }
        else {
            throw {
                "name" : 'InvalidArgumentException',
                "message" : 'First argument is either not a string or empty.'
            };
        }
    };
    exports.i18n = i18n;
}(document, mejs));
;(function(exports, undefined) {
    "use strict";
    if ( typeof mejsL10n != 'undefined' ) {
        exports[mejsL10n.language] = mejsL10n.strings;
    }
}(mejs.i18n.locale.strings));
;(function(exports, undefined) {
    "use strict";
    if (typeof exports.de === 'undefined') {
        exports.de = {
            "None" : "Entfällt",
            "Unmute" : "Lautstärke einschalten",
            "Fullscreen" : "Fullscreen",
            "Download File" : "Download der Datei",
            "Mute Toggle" : "Stummschalten",
            "Play/Pause" : "Abspielen/Pause",
            "Captions/Subtitles" : "Unterschriften/Untertitel",
            "Download Video" : "Video herunterladen",
            "Mute" : "Stummschalten",
            "Turn off Fullscreen" : "Fullscreen abschalten",
            "Go Fullscreen" : "Fullscreen einschalten",
            "Close" : "Schließen"
        };
    }
}(mejs.i18n.locale.strings));
;(function(exports, undefined) {
    "use strict";
    if (typeof exports.zh === 'undefined') {
        exports.zh = {
            "Fullscreen" : "全屏",
            "Go Fullscreen" : "轉向全屏",
            "Turn off Fullscreen" : "關閉全屏",
            "None" : "沒有",
            "Unmute" : "取消靜音",
            "Download File" : "下載文件",
            "Mute Toggle" : "靜音切換",
            "Play/Pause" : "播放/暫停",
            "Captions/Subtitles" : "字幕/標題",
            "Download Video" : "下載視頻",
            "Mute" : "靜音",
            "Close" : "關閉"
        };
    }
}(mejs.i18n.locale.strings));
if (typeof jQuery != 'undefined') {
	mejs.$ = jQuery;
} else if (typeof ender != 'undefined') {
	mejs.$ = ender;
}

(function ($) {
	mejs.MepDefaults = {
		poster: '',
		showPosterWhenEnded: false,
		defaultVideoWidth: 480,
		defaultVideoHeight: 270,
		videoWidth: -1,
		videoHeight: -1,
		defaultAudioWidth: 400,
		defaultAudioHeight: 30,
		defaultSeekBackwardInterval: function(media) {
			return (media.duration * 0.05);
		},
		defaultSeekForwardInterval: function(media) {
			return (media.duration * 0.05);
		},
		setDimensions: true,
		audioWidth: -1,
		audioHeight: -1,
		startVolume: 0.8,
		loop: false,
                autoRewind: true,
		enableAutosize: true,
		alwaysShowHours: false,
		showTimecodeFrameCount: false,
		framesPerSecond: 25,
		autosizeProgress : true,
		alwaysShowControls: false,
		hideVideoControlsOnLoad: false,
		clickToPlayPause: true,
		iPadUseNativeControls: false,
		iPhoneUseNativeControls: false,
		AndroidUseNativeControls: false,
		features: ['playpause','current','progress','duration','tracks','volume','fullscreen'],
		isVideo: true,
		enableKeyboard: true,
		pauseOtherPlayers: true,
		keyActions: [
				{
						keys: [
								32,
								179
							  ],
						action: function(player, media) {
								if (media.paused || media.ended) {
										player.play();
								} else {
										player.pause();
								}
						}
				},
				{
						keys: [38],
						action: function(player, media) {
								player.container.find('.mejs-volume-slider').css('display','block');
								if (player.isVideo) {
										player.showControls();
										player.startControlsTimer();
								}
								var newVolume = Math.min(media.volume + 0.1, 1);
								media.setVolume(newVolume);
						}
				},
				{
						keys: [40],
						action: function(player, media) {
								player.container.find('.mejs-volume-slider').css('display','block');
								if (player.isVideo) {
										player.showControls();
										player.startControlsTimer();
								}
								var newVolume = Math.max(media.volume - 0.1, 0);
								media.setVolume(newVolume);
						}
				},
				{
						keys: [
								37,
								227
						],
						action: function(player, media) {
								if (!isNaN(media.duration) && media.duration > 0) {
										if (player.isVideo) {
												player.showControls();
												player.startControlsTimer();
										}
										var newTime = Math.max(media.currentTime - player.options.defaultSeekBackwardInterval(media), 0);
										media.setCurrentTime(newTime);
								}
						}
				},
				{
						keys: [
								39,
								228
						],
						action: function(player, media) {
								if (!isNaN(media.duration) && media.duration > 0) {
										if (player.isVideo) {
												player.showControls();
												player.startControlsTimer();
										}
										var newTime = Math.min(media.currentTime + player.options.defaultSeekForwardInterval(media), media.duration);
										media.setCurrentTime(newTime);
								}
						}
				},
				{
						keys: [70],
						action: function(player, media) {
								if (typeof player.enterFullScreen != 'undefined') {
										if (player.isFullScreen) {
												player.exitFullScreen();
										} else {
												player.enterFullScreen();
										}
								}
						}
				},
				{
						keys: [77],
						action: function(player, media) {
								player.container.find('.mejs-volume-slider').css('display','block');
								if (player.isVideo) {
										player.showControls();
										player.startControlsTimer();
								}
								if (player.media.muted) {
										player.setMuted(false);
								} else {
										player.setMuted(true);
								}
						}
				}
		]
	};
	mejs.mepIndex = 0;
	mejs.players = {};
	mejs.MediaElementPlayer = function(node, o) {
		if ( !(this instanceof mejs.MediaElementPlayer) ) {
			return new mejs.MediaElementPlayer(node, o);
		}
		var t = this;
		t.$media = t.$node = $(node);
		t.node = t.media = t.$media[0];
		if (typeof t.node.player != 'undefined') {
			return t.node.player;
		} else {
			t.node.player = t;
		}
		if (typeof o == 'undefined') {
			o = t.$node.data('mejsoptions');
		}
		t.options = $.extend({},mejs.MepDefaults,o);
		t.id = 'mep_' + mejs.mepIndex++;
		mejs.players[t.id] = t;
		t.init();
		return t;
	};
	mejs.MediaElementPlayer.prototype = {
		hasFocus: false,
		controlsAreVisible: true,
		init: function() {
			var
				t = this,
				mf = mejs.MediaFeatures,
				meOptions = $.extend(true, {}, t.options, {
					success: function(media, domNode) { t.meReady(media, domNode); },
					error: function(e) { t.handleError(e);}
				}),
				tagName = t.media.tagName.toLowerCase();
			t.isDynamic = (tagName !== 'audio' && tagName !== 'video');
			if (t.isDynamic) {
				t.isVideo = t.options.isVideo;
			} else {
				t.isVideo = (tagName !== 'audio' && t.options.isVideo);
			}
			if ((mf.isiPad && t.options.iPadUseNativeControls) || (mf.isiPhone && t.options.iPhoneUseNativeControls)) {
				t.$media.attr('controls', 'controls');
				if (mf.isiPad && t.media.getAttribute('autoplay') !== null) {
					t.play();
				}
			} else if (mf.isAndroid && t.options.AndroidUseNativeControls) {
			} else {
				t.$media.removeAttr('controls');
				var videoPlayerTitle = t.isVideo ?
					mejs.i18n.t('Video Player') : mejs.i18n.t('Audio Player');
				$('<span class="mejs-offscreen">' + videoPlayerTitle + '</span>').insertBefore(t.$media);
				t.container =
					$('<div id="' + t.id + '" class="mejs-container ' + (mejs.MediaFeatures.svg ? 'svg' : 'no-svg') +
                      '" tabindex="0" role="application" aria-label="' + videoPlayerTitle + '">'+
						'<div class="mejs-inner">'+
							'<div class="mejs-mediaelement"></div>'+
							'<div class="mejs-layers"></div>'+
							'<div class="mejs-controls"></div>'+
							'<div class="mejs-clear"></div>'+
						'</div>' +
					'</div>')
					.addClass(t.$media[0].className)
					.insertBefore(t.$media)
					.focus(function ( e ) {
						if( !t.controlsAreVisible ) {
							t.showControls(true);
							var playButton = t.container.find('.mejs-playpause-button > button');
							playButton.focus();
						}
					});
				t.container.addClass(
					(mf.isAndroid ? 'mejs-android ' : '') +
					(mf.isiOS ? 'mejs-ios ' : '') +
					(mf.isiPad ? 'mejs-ipad ' : '') +
					(mf.isiPhone ? 'mejs-iphone ' : '') +
					(t.isVideo ? 'mejs-video ' : 'mejs-audio ')
				);
				if (mf.isiOS) {
					var $newMedia = t.$media.clone();
					t.container.find('.mejs-mediaelement').append($newMedia);
					t.$media.remove();
					t.$node = t.$media = $newMedia;
					t.node = t.media = $newMedia[0];
				} else {
					t.container.find('.mejs-mediaelement').append(t.$media);
				}
				t.controls = t.container.find('.mejs-controls');
				t.layers = t.container.find('.mejs-layers');
				var tagType = (t.isVideo ? 'video' : 'audio'),
					capsTagName = tagType.substring(0,1).toUpperCase() + tagType.substring(1);
				if (t.options[tagType + 'Width'] > 0 || t.options[tagType + 'Width'].toString().indexOf('%') > -1) {
					t.width = t.options[tagType + 'Width'];
				} else if (t.media.style.width !== '' && t.media.style.width !== null) {
					t.width = t.media.style.width;
				} else if (t.media.getAttribute('width') !== null) {
					t.width = t.$media.attr('width');
				} else {
					t.width = t.options['default' + capsTagName + 'Width'];
				}
				if (t.options[tagType + 'Height'] > 0 || t.options[tagType + 'Height'].toString().indexOf('%') > -1) {
					t.height = t.options[tagType + 'Height'];
				} else if (t.media.style.height !== '' && t.media.style.height !== null) {
					t.height = t.media.style.height;
				} else if (t.$media[0].getAttribute('height') !== null) {
					t.height = t.$media.attr('height');
				} else {
					t.height = t.options['default' + capsTagName + 'Height'];
				}
				t.setPlayerSize(t.width, t.height);
				meOptions.pluginWidth = t.width;
				meOptions.pluginHeight = t.height;
			}
			mejs.MediaElement(t.$media[0], meOptions);
			if (typeof(t.container) != 'undefined' && t.controlsAreVisible){
				t.container.trigger('controlsshown');
			}
		},
		showControls: function(doAnimation) {
			var t = this;
			doAnimation = typeof doAnimation == 'undefined' || doAnimation;
			if (t.controlsAreVisible)
				return;
			if (doAnimation) {
				t.controls
					.css('visibility','visible')
					.stop(true, true).fadeIn(200, function() {
						t.controlsAreVisible = true;
						t.container.trigger('controlsshown');
					});
				t.container.find('.mejs-control')
					.css('visibility','visible')
					.stop(true, true).fadeIn(200, function() {t.controlsAreVisible = true;});
			} else {
				t.controls
					.css('visibility','visible')
					.css('display','block');
				t.container.find('.mejs-control')
					.css('visibility','visible')
					.css('display','block');
				t.controlsAreVisible = true;
				t.container.trigger('controlsshown');
			}
			t.setControlsSize();
		},
		hideControls: function(doAnimation) {
			var t = this;
			doAnimation = typeof doAnimation == 'undefined' || doAnimation;
			if (!t.controlsAreVisible || t.options.alwaysShowControls || t.keyboardAction)
				return;
			if (doAnimation) {
				t.controls.stop(true, true).fadeOut(200, function() {
					$(this)
						.css('visibility','hidden')
						.css('display','block');
					t.controlsAreVisible = false;
					t.container.trigger('controlshidden');
				});
				t.container.find('.mejs-control').stop(true, true).fadeOut(200, function() {
					$(this)
						.css('visibility','hidden')
						.css('display','block');
				});
			} else {
				t.controls
					.css('visibility','hidden')
					.css('display','block');
				t.container.find('.mejs-control')
					.css('visibility','hidden')
					.css('display','block');
				t.controlsAreVisible = false;
				t.container.trigger('controlshidden');
			}
		},
		controlsTimer: null,
		startControlsTimer: function(timeout) {
			var t = this;
			timeout = typeof timeout != 'undefined' ? timeout : 1500;
			t.killControlsTimer('start');
			t.controlsTimer = setTimeout(function() {
				t.hideControls();
				t.killControlsTimer('hide');
			}, timeout);
		},
		killControlsTimer: function(src) {
			var t = this;
			if (t.controlsTimer !== null) {
				clearTimeout(t.controlsTimer);
				delete t.controlsTimer;
				t.controlsTimer = null;
			}
		},
		controlsEnabled: true,
		disableControls: function() {
			var t= this;
			t.killControlsTimer();
			t.hideControls(false);
			this.controlsEnabled = false;
		},
		enableControls: function() {
			var t= this;
			t.showControls(false);
			t.controlsEnabled = true;
		},
		meReady: function(media, domNode) {
			var t = this,
				mf = mejs.MediaFeatures,
				autoplayAttr = domNode.getAttribute('autoplay'),
				autoplay = !(typeof autoplayAttr == 'undefined' || autoplayAttr === null || autoplayAttr === 'false'),
				featureIndex,
				feature;
			if (t.created) {
				return;
			} else {
				t.created = true;
			}
			t.media = media;
			t.domNode = domNode;
			if (!(mf.isAndroid && t.options.AndroidUseNativeControls) && !(mf.isiPad && t.options.iPadUseNativeControls) && !(mf.isiPhone && t.options.iPhoneUseNativeControls)) {
				t.buildposter(t, t.controls, t.layers, t.media);
				t.buildkeyboard(t, t.controls, t.layers, t.media);
				t.buildoverlays(t, t.controls, t.layers, t.media);
				t.findTracks();
				for (featureIndex in t.options.features) {
					feature = t.options.features[featureIndex];
					if (t['build' + feature]) {
						try {
							t['build' + feature](t, t.controls, t.layers, t.media);
						} catch (e) {
						}
					}
				}
				t.container.trigger('controlsready');
				t.setPlayerSize(t.width, t.height);
				t.setControlsSize();
				if (t.isVideo) {
					if (mejs.MediaFeatures.hasTouch) {
						t.$media.bind('touchstart', function() {
							if (t.controlsAreVisible) {
								t.hideControls(false);
							} else {
								if (t.controlsEnabled) {
									t.showControls(false);
								}
							}
						});
					} else {
						t.clickToPlayPauseCallback = function() {
							if (t.options.clickToPlayPause) {
								if (t.media.paused) {
									t.play();
								} else {
									t.pause();
								}
							}
						};
						t.media.addEventListener('click', t.clickToPlayPauseCallback, false);
						t.container
							.bind('mouseenter mouseover', function () {
								if (t.controlsEnabled) {
									if (!t.options.alwaysShowControls ) {
										t.killControlsTimer('enter');
										t.showControls();
										t.startControlsTimer(2500);
									}
								}
							})
							.bind('mousemove', function() {
								if (t.controlsEnabled) {
									if (!t.controlsAreVisible) {
										t.showControls();
									}
									if (!t.options.alwaysShowControls) {
										t.startControlsTimer(2500);
									}
								}
							})
							.bind('mouseleave', function () {
								if (t.controlsEnabled) {
									if (!t.media.paused && !t.options.alwaysShowControls) {
										t.startControlsTimer(1000);
									}
								}
							});
					}
					if(t.options.hideVideoControlsOnLoad) {
						t.hideControls(false);
					}
					if (autoplay && !t.options.alwaysShowControls) {
						t.hideControls();
					}
					if (t.options.enableAutosize) {
						t.media.addEventListener('loadedmetadata', function(e) {
							if (t.options.videoHeight <= 0 && t.domNode.getAttribute('height') === null && !isNaN(e.target.videoHeight)) {
								t.setPlayerSize(e.target.videoWidth, e.target.videoHeight);
								t.setControlsSize();
								t.media.setVideoSize(e.target.videoWidth, e.target.videoHeight);
							}
						}, false);
					}
				}
				media.addEventListener('play', function() {
					var playerIndex;
					for (playerIndex in mejs.players) {
						var p = mejs.players[playerIndex];
						if (p.id != t.id && t.options.pauseOtherPlayers && !p.paused && !p.ended) {
							p.pause();
						}
						p.hasFocus = false;
					}
					t.hasFocus = true;
				},false);
				t.media.addEventListener('ended', function (e) {
					if(t.options.autoRewind) {
						try{
							t.media.setCurrentTime(0);
                            window.setTimeout(function(){
                                $(t.container).find('.mejs-overlay-loading').parent().hide();
                            }, 20);
						} catch (exp) {
						}
					}
					t.media.pause();
					if (t.setProgressRail) {
						t.setProgressRail();
					}
					if (t.setCurrentRail) {
						t.setCurrentRail();
					}
					if (t.options.loop) {
						t.play();
					} else if (!t.options.alwaysShowControls && t.controlsEnabled) {
						t.showControls();
					}
				}, false);
				t.media.addEventListener('loadedmetadata', function(e) {
					if (t.updateDuration) {
						t.updateDuration();
					}
					if (t.updateCurrent) {
						t.updateCurrent();
					}
					if (!t.isFullScreen) {
						t.setPlayerSize(t.width, t.height);
						t.setControlsSize();
					}
				}, false);
				t.container.focusout(function (e) {
					if( e.relatedTarget ) {
						var $target = $(e.relatedTarget);
						if (t.keyboardAction && $target.parents('.mejs-container').length === 0) {
							t.keyboardAction = false;
							t.hideControls(true);
						}
					}
				});
				setTimeout(function () {
					t.setPlayerSize(t.width, t.height);
					t.setControlsSize();
				}, 50);
				t.globalBind('resize', function() {
					if ( !(t.isFullScreen || (mejs.MediaFeatures.hasTrueNativeFullScreen && document.webkitIsFullScreen)) ) {
						t.setPlayerSize(t.width, t.height);
					}
					t.setControlsSize();
				});
				if (t.media.pluginType == 'youtube' && ( mf.isiOS || mf.isAndroid ) ) {
					t.container.find('.mejs-overlay-play').hide();
				}
			}
			if (autoplay && media.pluginType == 'native') {
				t.play();
			}
			if (t.options.success) {
				if (typeof t.options.success == 'string') {
					window[t.options.success](t.media, t.domNode, t);
				} else {
					t.options.success(t.media, t.domNode, t);
				}
			}
		},
		handleError: function(e) {
			var t = this;
			t.controls.hide();
			if (t.options.error) {
				t.options.error(e);
			}
		},
		setPlayerSize: function(width,height) {
			var t = this;
			if( !t.options.setDimensions ) {
				return false;
			}
			if (typeof width != 'undefined') {
				t.width = width;
			}
			if (typeof height != 'undefined') {
				t.height = height;
			}
			if (t.height.toString().indexOf('%') > 0 || t.$node.css('max-width') === '100%' || (t.$node[0].currentStyle && t.$node[0].currentStyle.maxWidth === '100%')) {
				var nativeWidth = (function() {
					if (t.isVideo) {
						if (t.media.videoWidth && t.media.videoWidth > 0) {
							return t.media.videoWidth;
						} else if (t.media.getAttribute('width') !== null) {
							return t.media.getAttribute('width');
						} else {
							return t.options.defaultVideoWidth;
						}
					} else {
						return t.options.defaultAudioWidth;
					}
				})();
				var nativeHeight = (function() {
					if (t.isVideo) {
						if (t.media.videoHeight && t.media.videoHeight > 0) {
							return t.media.videoHeight;
						} else if (t.media.getAttribute('height') !== null) {
							return t.media.getAttribute('height');
						} else {
							return t.options.defaultVideoHeight;
						}
					} else {
						return t.options.defaultAudioHeight;
					}
				})();
				var
					parentWidth = t.container.parent().closest(':visible').width(),
					parentHeight = t.container.parent().closest(':visible').height(),
					newHeight = t.isVideo || !t.options.autosizeProgress ? parseInt(parentWidth * nativeHeight/nativeWidth, 10) : nativeHeight;
				if (isNaN(newHeight)) {
					newHeight = parentHeight;
				}
				if (t.container.parent()[0].tagName.toLowerCase() === 'body') {
					parentWidth = $(window).width();
					newHeight = $(window).height();
				}
				if ( newHeight && parentWidth ) {
					t.container
						.width(parentWidth)
						.height(newHeight);
					t.$media.add(t.container.find('.mejs-shim'))
						.width('100%')
						.height('100%');
					if (t.isVideo) {
						if (t.media.setVideoSize) {
							t.media.setVideoSize(parentWidth, newHeight);
						}
					}
					t.layers.children('.mejs-layer')
						.width('100%')
						.height('100%');
				}
			} else {
				t.container
					.width(t.width)
					.height(t.height);
				t.layers.children('.mejs-layer')
					.width(t.width)
					.height(t.height);
			}
			var playLayer = t.layers.find('.mejs-overlay-play'),
				playButton = playLayer.find('.mejs-overlay-button');
			playLayer.height(t.container.height() - t.controls.height());
			playButton.css('margin-top', '-' + (playButton.height()/2 - t.controls.height()/2).toString() + 'px'  );
		},
		setControlsSize: function() {
			var t = this,
				usedWidth = 0,
				railWidth = 0,
				rail = t.controls.find('.mejs-time-rail'),
				total = t.controls.find('.mejs-time-total'),
				current = t.controls.find('.mejs-time-current'),
				loaded = t.controls.find('.mejs-time-loaded'),
				others = rail.siblings(),
				lastControl = others.last(),
				lastControlPosition = null;
			if (!t.container.is(':visible') || !rail.length || !rail.is(':visible')) {
				return;
			}
			if (t.options && !t.options.autosizeProgress) {
				railWidth = parseInt(rail.css('width'), 10);
			}
			if (railWidth === 0 || !railWidth) {
				others.each(function() {
					var $this = $(this);
					if ($this.css('position') != 'absolute' && $this.is(':visible')) {
						usedWidth += $(this).outerWidth(true);
					}
				});
				railWidth = t.controls.width() - usedWidth - (rail.outerWidth(true) - rail.width());
			}
			do {
				rail.width(railWidth);
				total.width(railWidth - (total.outerWidth(true) - total.width()));
				if (lastControl.css('position') != 'absolute') {
					lastControlPosition = lastControl.position();
					railWidth--;
				}
			} while (lastControlPosition !== null && lastControlPosition.top > 0 && railWidth > 0);
			if (t.setProgressRail)
				t.setProgressRail();
			if (t.setCurrentRail)
				t.setCurrentRail();
		},
		buildposter: function(player, controls, layers, media) {
			var t = this,
				poster =
				$('<div class="mejs-poster mejs-layer">' +
				'</div>')
					.appendTo(layers),
				posterUrl = player.$media.attr('poster');
			if (player.options.poster !== '') {
				posterUrl = player.options.poster;
			}
			if ( posterUrl ) {
				t.setPoster(posterUrl);
			} else {
				poster.hide();
			}
			media.addEventListener('play',function() {
				poster.hide();
			}, false);
			if(player.options.showPosterWhenEnded && player.options.autoRewind){
				media.addEventListener('ended',function() {
					poster.show();
				}, false);
			}
		},
		setPoster: function(url) {
			var t = this,
				posterDiv = t.container.find('.mejs-poster'),
				posterImg = posterDiv.find('img');
			if (posterImg.length === 0) {
				posterImg = $('<img width="100%" height="100%" />').appendTo(posterDiv);
			}
			posterImg.attr('src', url);
			posterDiv.css({'background-image' : 'url(' + url + ')'});
		},
		buildoverlays: function(player, controls, layers, media) {
            var t = this;
			if (!player.isVideo)
				return;
			var
			loading =
				$('<div class="mejs-overlay mejs-layer">'+
					'<div class="mejs-overlay-loading"><span></span></div>'+
				'</div>')
				.hide()
				.appendTo(layers),
			error =
				$('<div class="mejs-overlay mejs-layer">'+
					'<div class="mejs-overlay-error"></div>'+
				'</div>')
				.hide()
				.appendTo(layers),
			bigPlay =
				$('<div class="mejs-overlay mejs-layer mejs-overlay-play">'+
					'<div class="mejs-overlay-button"></div>'+
				'</div>')
				.appendTo(layers)
				.bind('click', function() {
					if (t.options.clickToPlayPause) {
						if (media.paused) {
							media.play();
						}
					}
				});
			media.addEventListener('play',function() {
				bigPlay.hide();
				loading.hide();
				controls.find('.mejs-time-buffering').hide();
				error.hide();
			}, false);
			media.addEventListener('playing', function() {
				bigPlay.hide();
				loading.hide();
				controls.find('.mejs-time-buffering').hide();
				error.hide();
			}, false);
			media.addEventListener('seeking', function() {
				loading.show();
				controls.find('.mejs-time-buffering').show();
			}, false);
			media.addEventListener('seeked', function() {
				loading.hide();
				controls.find('.mejs-time-buffering').hide();
			}, false);
			media.addEventListener('pause',function() {
				if (!mejs.MediaFeatures.isiPhone) {
					bigPlay.show();
				}
			}, false);
			media.addEventListener('waiting', function() {
				loading.show();
				controls.find('.mejs-time-buffering').show();
			}, false);
			media.addEventListener('loadeddata',function() {
				loading.show();
				controls.find('.mejs-time-buffering').show();
                if (mejs.MediaFeatures.isAndroid) {
                    media.canplayTimeout = window.setTimeout(
                        function() {
                            if (document.createEvent) {
                                var evt = document.createEvent('HTMLEvents');
                                evt.initEvent('canplay', true, true);
                                return media.dispatchEvent(evt);
                            }
                        }, 300
                    );
                }
			}, false);
			media.addEventListener('canplay',function() {
				loading.hide();
				controls.find('.mejs-time-buffering').hide();
                clearTimeout(media.canplayTimeout);
			}, false);
			media.addEventListener('error',function() {
				loading.hide();
				controls.find('.mejs-time-buffering').hide();
				error.show();
				error.find('mejs-overlay-error').html("Error loading this resource");
			}, false);
			media.addEventListener('keydown', function(e) {
				t.onkeydown(player, media, e);
			}, false);
		},
		buildkeyboard: function(player, controls, layers, media) {
				var t = this;
				t.container.keydown(function () {
					t.keyboardAction = true;
				});
				t.globalBind('keydown', function(e) {
					return t.onkeydown(player, media, e);
				});
				t.globalBind('click', function(event) {
					player.hasFocus = $(event.target).closest('.mejs-container').length !== 0;
				});
		},
		onkeydown: function(player, media, e) {
			if (player.hasFocus && player.options.enableKeyboard) {
				for (var i = 0, il = player.options.keyActions.length; i < il; i++) {
					var keyAction = player.options.keyActions[i];
					for (var j = 0, jl = keyAction.keys.length; j < jl; j++) {
						if (e.keyCode == keyAction.keys[j]) {
							if (typeof(e.preventDefault) == "function") e.preventDefault();
							keyAction.action(player, media, e.keyCode);
							return false;
						}
					}
				}
			}
			return true;
		},
		findTracks: function() {
			var t = this,
				tracktags = t.$media.find('track');
			t.tracks = [];
			tracktags.each(function(index, track) {
				track = $(track);
				t.tracks.push({
					srclang: (track.attr('srclang')) ? track.attr('srclang').toLowerCase() : '',
					src: track.attr('src'),
					kind: track.attr('kind'),
					label: track.attr('label') || '',
					entries: [],
					isLoaded: false
				});
			});
		},
		changeSkin: function(className) {
			this.container[0].className = 'mejs-container ' + className;
			this.setPlayerSize(this.width, this.height);
			this.setControlsSize();
		},
		play: function() {
			this.load();
			this.media.play();
		},
		pause: function() {
			try {
				this.media.pause();
			} catch (e) {}
		},
		load: function() {
			if (!this.isLoaded) {
				this.media.load();
			}
			this.isLoaded = true;
		},
		setMuted: function(muted) {
			this.media.setMuted(muted);
		},
		setCurrentTime: function(time) {
			this.media.setCurrentTime(time);
		},
		getCurrentTime: function() {
			return this.media.currentTime;
		},
		setVolume: function(volume) {
			this.media.setVolume(volume);
		},
		getVolume: function() {
			return this.media.volume;
		},
		setSrc: function(src) {
			this.media.setSrc(src);
		},
		remove: function() {
			var t = this, featureIndex, feature;
			for (featureIndex in t.options.features) {
				feature = t.options.features[featureIndex];
				if (t['clean' + feature]) {
					try {
						t['clean' + feature](t);
					} catch (e) {
					}
				}
			}
			if (!t.isDynamic) {
				t.$media.prop('controls', true);
				t.$node.clone().insertBefore(t.container).show();
				t.$node.remove();
			} else {
				t.$node.insertBefore(t.container);
			}
			if (t.media.pluginType !== 'native') {
				t.media.remove();
			}
			delete mejs.players[t.id];
			if (typeof t.container == 'object') {
				t.container.remove();
			}
			t.globalUnbind();
			delete t.node.player;
		}
	};
	(function(){
		var rwindow = /^((after|before)print|(before)?unload|hashchange|message|o(ff|n)line|page(hide|show)|popstate|resize|storage)\b/;
		function splitEvents(events, id) {
			var ret = {d: [], w: []};
			$.each((events || '').split(' '), function(k, v){
				var eventname = v + '.' + id;
				if (eventname.indexOf('.') === 0) {
					ret.d.push(eventname);
					ret.w.push(eventname);
				}
				else {
					ret[rwindow.test(v) ? 'w' : 'd'].push(eventname);
				}
			});
			ret.d = ret.d.join(' ');
			ret.w = ret.w.join(' ');
			return ret;
		}
		mejs.MediaElementPlayer.prototype.globalBind = function(events, data, callback) {
			var t = this;
			events = splitEvents(events, t.id);
			if (events.d) $(document).bind(events.d, data, callback);
			if (events.w) $(window).bind(events.w, data, callback);
		};
		mejs.MediaElementPlayer.prototype.globalUnbind = function(events, callback) {
			var t = this;
			events = splitEvents(events, t.id);
			if (events.d) $(document).unbind(events.d, callback);
			if (events.w) $(window).unbind(events.w, callback);
		};
	})();
	if (typeof $ != 'undefined') {
		$.fn.mediaelementplayer = function (options) {
			if (options === false) {
				this.each(function () {
					var player = $(this).data('mediaelementplayer');
					if (player) {
						player.remove();
					}
					$(this).removeData('mediaelementplayer');
				});
			}
			else {
				this.each(function () {
					$(this).data('mediaelementplayer', new mejs.MediaElementPlayer(this, options));
				});
			}
			return this;
		};
		$(document).ready(function() {
			$('.mejs-player').mediaelementplayer();
		});
	}
	window.MediaElementPlayer = mejs.MediaElementPlayer;
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		playText: mejs.i18n.t('Play'),
		pauseText: mejs.i18n.t('Pause')
	});
	$.extend(MediaElementPlayer.prototype, {
		buildplaypause: function(player, controls, layers, media) {
			var
				t = this,
				op = t.options,
				play =
				$('<div class="mejs-button mejs-playpause-button mejs-play" >' +
					'<button type="button" aria-controls="' + t.id + '" title="' + op.playText + '" aria-label="' + op.playText + '"></button>' +
				'</div>')
				.appendTo(controls)
				.click(function(e) {
					e.preventDefault();
					if (media.paused) {
						media.play();
					} else {
						media.pause();
					}
					return false;
				}),
				play_btn = play.find('button');
			function togglePlayPause(which) {
				if ('play' === which) {
					play.removeClass('mejs-play').addClass('mejs-pause');
					play_btn.attr({
						'title': op.pauseText,
						'aria-label': op.pauseText
					});
				} else {
					play.removeClass('mejs-pause').addClass('mejs-play');
					play_btn.attr({
						'title': op.playText,
						'aria-label': op.playText
					});
				}
			};
			togglePlayPause('pse');
			media.addEventListener('play',function() {
				togglePlayPause('play');
			}, false);
			media.addEventListener('playing',function() {
				togglePlayPause('play');
			}, false);
			media.addEventListener('pause',function() {
				togglePlayPause('pse');
			}, false);
			media.addEventListener('paused',function() {
				togglePlayPause('pse');
			}, false);
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		stopText: 'Stop'
	});
	$.extend(MediaElementPlayer.prototype, {
		buildstop: function(player, controls, layers, media) {
			var t = this,
				stop =
				$('<div class="mejs-button mejs-stop-button mejs-stop">' +
					'<button type="button" aria-controls="' + t.id + '" title="' + t.options.stopText + '" aria-label="' + t.options.stopText + '"></button>' +
				'</div>')
				.appendTo(controls)
				.click(function() {
					if (!media.paused) {
						media.pause();
					}
					if (media.currentTime > 0) {
						media.setCurrentTime(0);
                        media.pause();
						controls.find('.mejs-time-current').width('0px');
						controls.find('.mejs-time-handle').css('left', '0px');
						controls.find('.mejs-time-float-current').html( mejs.Utility.secondsToTimeCode(0) );
						controls.find('.mejs-currenttime').html( mejs.Utility.secondsToTimeCode(0) );
						layers.find('.mejs-poster').show();
					}
				});
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		progessHelpText: mejs.i18n.t(
		'Use Left/Right Arrow keys to advance one second, Up/Down arrows to advance ten seconds.')
	});
	$.extend(MediaElementPlayer.prototype, {
		buildprogress: function(player, controls, layers, media) {
			$('<div class="mejs-time-rail">' +
				'<a href="javascript:void(0);" class="mejs-time-total mejs-time-slider">' +
				'<span class="mejs-offscreen">' + this.options.progessHelpText + '</span>' +
				'<span class="mejs-time-buffering"></span>' +
				'<span class="mejs-time-loaded"></span>' +
				'<span class="mejs-time-current"></span>' +
				'<span class="mejs-time-handle"></span>' +
				'<span class="mejs-time-float">' +
				'<span class="mejs-time-float-current">00:00</span>' +
				'<span class="mejs-time-float-corner"></span>' +
				'</span>' +
				'</a>' +
				'</div>')
				.appendTo(controls);
			controls.find('.mejs-time-buffering').hide();
			var
				t = this,
				total = controls.find('.mejs-time-total'),
				loaded  = controls.find('.mejs-time-loaded'),
				current  = controls.find('.mejs-time-current'),
				handle  = controls.find('.mejs-time-handle'),
				timefloat  = controls.find('.mejs-time-float'),
				timefloatcurrent  = controls.find('.mejs-time-float-current'),
                slider = controls.find('.mejs-time-slider'),
				handleMouseMove = function (e) {
                    var offset = total.offset(),
						width = total.outerWidth(true),
						percentage = 0,
						newTime = 0,
						pos = 0,
                        x;
					if (e.originalEvent.changedTouches) {
						x = e.originalEvent.changedTouches[0].pageX;
					}else{
						x = e.pageX;
					}
					if (media.duration) {
						if (x < offset.left) {
							x = offset.left;
						} else if (x > width + offset.left) {
							x = width + offset.left;
						}
						pos = x - offset.left;
						percentage = (pos / width);
						newTime = (percentage <= 0.02) ? 0 : percentage * media.duration;
						if (mouseIsDown && newTime !== media.currentTime) {
							media.setCurrentTime(newTime);
						}
						if (!mejs.MediaFeatures.hasTouch) {
								timefloat.css('left', pos);
								timefloatcurrent.html( mejs.Utility.secondsToTimeCode(newTime) );
								timefloat.show();
						}
					}
				},
				mouseIsDown = false,
				mouseIsOver = false,
				lastKeyPressTime = 0,
				startedPaused = false,
				autoRewindInitial = player.options.autoRewind;
            var updateSlider = function (e) {
				var seconds = media.currentTime,
					timeSliderText = mejs.i18n.t('Time Slider'),
					time = mejs.Utility.secondsToTimeCode(seconds),
					duration = media.duration;
				slider.attr({
					'aria-label': timeSliderText,
					'aria-valuemin': 0,
					'aria-valuemax': duration,
					'aria-valuenow': seconds,
					'aria-valuetext': time,
					'role': 'slider',
					'tabindex': 0
				});
			};
            var restartPlayer = function () {
				var now = new Date();
				if (now - lastKeyPressTime >= 1000) {
					media.play();
				}
			};
			slider.bind('focus', function (e) {
				player.options.autoRewind = false;
			});
			slider.bind('blur', function (e) {
				player.options.autoRewind = autoRewindInitial;
			});
			slider.bind('keydown', function (e) {
				if ((new Date() - lastKeyPressTime) >= 1000) {
					startedPaused = media.paused;
				}
				var keyCode = e.keyCode,
					duration = media.duration,
					seekTime = media.currentTime;
				switch (keyCode) {
				case 37:
					seekTime -= 1;
					break;
				case 39:
					seekTime += 1;
					break;
				case 38:
					seekTime += Math.floor(duration * 0.1);
					break;
				case 40:
					seekTime -= Math.floor(duration * 0.1);
					break;
				case 36:
					seekTime = 0;
					break;
				case 35:
					seekTime = duration;
					break;
				case 10:
					media.paused ? media.play() : media.pause();
					return;
				case 13:
					media.paused ? media.play() : media.pause();
					return;
				default:
					return;
				}
				seekTime = seekTime < 0 ? 0 : (seekTime >= duration ? duration : Math.floor(seekTime));
				lastKeyPressTime = new Date();
				if (!startedPaused) {
					media.pause();
				}
				if (seekTime < media.duration && !startedPaused) {
					setTimeout(restartPlayer, 1100);
				}
				media.setCurrentTime(seekTime);
				e.preventDefault();
				e.stopPropagation();
				return false;
			});
			total
				.bind('mousedown touchstart', function (e) {
					if (e.which === 1 || e.which === 0) {
						mouseIsDown = true;
						handleMouseMove(e);
						t.globalBind('mousemove.dur touchmove.dur', function(e) {
							handleMouseMove(e);
						});
						t.globalBind('mouseup.dur touchend.dur', function (e) {
							mouseIsDown = false;
							timefloat.hide();
							t.globalUnbind('.dur');
						});
					}
				})
				.bind('mouseenter', function(e) {
					mouseIsOver = true;
					t.globalBind('mousemove.dur', function(e) {
						handleMouseMove(e);
					});
					if (!mejs.MediaFeatures.hasTouch) {
						timefloat.show();
					}
				})
				.bind('mouseleave',function(e) {
					mouseIsOver = false;
					if (!mouseIsDown) {
						t.globalUnbind('.dur');
						timefloat.hide();
					}
				});
			media.addEventListener('progress', function (e) {
				player.setProgressRail(e);
				player.setCurrentRail(e);
			}, false);
			media.addEventListener('timeupdate', function(e) {
				player.setProgressRail(e);
				player.setCurrentRail(e);
				updateSlider(e);
			}, false);
			t.loaded = loaded;
			t.total = total;
			t.current = current;
			t.handle = handle;
		},
		setProgressRail: function(e) {
			var
				t = this,
				target = (e !== undefined) ? e.target : t.media,
				percent = null;
			if (target && target.buffered && target.buffered.length > 0 && target.buffered.end && target.duration) {
				percent = target.buffered.end(0) / target.duration;
			}
			else if (target && target.bytesTotal !== undefined && target.bytesTotal > 0 && target.bufferedBytes !== undefined) {
				percent = target.bufferedBytes / target.bytesTotal;
			}
			else if (e && e.lengthComputable && e.total !== 0) {
				percent = e.loaded / e.total;
			}
			if (percent !== null) {
				percent = Math.min(1, Math.max(0, percent));
				if (t.loaded && t.total) {
					t.loaded.width(t.total.width() * percent);
				}
			}
		},
		setCurrentRail: function() {
			var t = this;
			if (t.media.currentTime !== undefined && t.media.duration) {
				if (t.total && t.handle) {
					var
						newWidth = Math.round(t.total.width() * t.media.currentTime / t.media.duration),
						handlePos = newWidth - Math.round(t.handle.outerWidth(true) / 2);
					t.current.width(newWidth);
					t.handle.css('left', handlePos);
				}
			}
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		duration: -1,
		timeAndDurationSeparator: '<span> | </span>'
	});
	$.extend(MediaElementPlayer.prototype, {
		buildcurrent: function(player, controls, layers, media) {
			var t = this;
			$('<div class="mejs-time" role="timer" aria-live="off">' +
					'<span class="mejs-currenttime">' +
                        (player.options.alwaysShowHours ? '00:' : '') +
                        (player.options.showTimecodeFrameCount? '00:00:00':'00:00') +
                    '</span>'+
				'</div>')
			.appendTo(controls);
			t.currenttime = t.controls.find('.mejs-currenttime');
			media.addEventListener('timeupdate',function() {
				player.updateCurrent();
			}, false);
		},
		buildduration: function(player, controls, layers, media) {
			var t = this;
			if (controls.children().last().find('.mejs-currenttime').length > 0) {
				$(t.options.timeAndDurationSeparator +
					'<span class="mejs-duration">' +
						(t.options.duration > 0 ?
							mejs.Utility.secondsToTimeCode(t.options.duration, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount,  t.options.framesPerSecond || 25) :
							((player.options.alwaysShowHours ? '00:' : '') + (player.options.showTimecodeFrameCount? '00:00:00':'00:00'))
						) +
					'</span>')
					.appendTo(controls.find('.mejs-time'));
			} else {
				controls.find('.mejs-currenttime').parent().addClass('mejs-currenttime-container');
				$('<div class="mejs-time mejs-duration-container">'+
					'<span class="mejs-duration">' +
						(t.options.duration > 0 ?
							mejs.Utility.secondsToTimeCode(t.options.duration, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount,  t.options.framesPerSecond || 25) :
							((player.options.alwaysShowHours ? '00:' : '') + (player.options.showTimecodeFrameCount? '00:00:00':'00:00'))
						) +
					'</span>' +
				'</div>')
				.appendTo(controls);
			}
			t.durationD = t.controls.find('.mejs-duration');
			media.addEventListener('timeupdate',function() {
				player.updateDuration();
			}, false);
		},
		updateCurrent:  function() {
			var t = this;
			if (t.currenttime) {
				t.currenttime.html(mejs.Utility.secondsToTimeCode(t.media.currentTime, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount,  t.options.framesPerSecond || 25));
			}
		},
		updateDuration: function() {
			var t = this;
			t.container.toggleClass("mejs-long-video", t.media.duration > 3600);
			if (t.durationD && (t.options.duration > 0 || t.media.duration)) {
				t.durationD.html(mejs.Utility.secondsToTimeCode(t.options.duration > 0 ? t.options.duration : t.media.duration, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond || 25));
			}
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		muteText: mejs.i18n.t('Mute Toggle'),
        allyVolumeControlText: mejs.i18n.t('Use Up/Down Arrow keys to increase or decrease volume.'),
		hideVolumeOnTouchDevices: true,
		audioVolume: 'horizontal',
		videoVolume: 'vertical'
	});
	$.extend(MediaElementPlayer.prototype, {
		buildvolume: function(player, controls, layers, media) {
			if ((mejs.MediaFeatures.isAndroid || mejs.MediaFeatures.isiOS) && this.options.hideVolumeOnTouchDevices)
				return;
			var t = this,
				mode = (t.isVideo) ? t.options.videoVolume : t.options.audioVolume,
				mute = (mode == 'horizontal') ?
				$('<div class="mejs-button mejs-volume-button mejs-mute">' +
					'<button type="button" aria-controls="' + t.id +
						'" title="' + t.options.muteText +
						'" aria-label="' + t.options.muteText +
					'"></button>'+
				'</div>' +
                  '<a href="javascript:void(0);" class="mejs-horizontal-volume-slider">' +
					'<span class="mejs-offscreen">' + t.options.allyVolumeControlText + '</span>' +
					'<div class="mejs-horizontal-volume-total"></div>'+
					'<div class="mejs-horizontal-volume-current"></div>'+
					'<div class="mejs-horizontal-volume-handle"></div>'+
				'</a>'
				)
					.appendTo(controls) :
				$('<div class="mejs-button mejs-volume-button mejs-mute">'+
					'<button type="button" aria-controls="' + t.id +
						'" title="' + t.options.muteText +
						'" aria-label="' + t.options.muteText +
					'"></button>'+
					'<a href="javascript:void(0);" class="mejs-volume-slider">'+
						'<span class="mejs-offscreen">' + t.options.allyVolumeControlText + '</span>' +
						'<div class="mejs-volume-total"></div>'+
						'<div class="mejs-volume-current"></div>'+
						'<div class="mejs-volume-handle"></div>'+
					'</a>'+
				'</div>')
					.appendTo(controls),
			volumeSlider = t.container.find('.mejs-volume-slider, .mejs-horizontal-volume-slider'),
			volumeTotal = t.container.find('.mejs-volume-total, .mejs-horizontal-volume-total'),
			volumeCurrent = t.container.find('.mejs-volume-current, .mejs-horizontal-volume-current'),
			volumeHandle = t.container.find('.mejs-volume-handle, .mejs-horizontal-volume-handle'),
			positionVolumeHandle = function(volume, secondTry) {
				if (!volumeSlider.is(':visible') && typeof secondTry == 'undefined') {
					volumeSlider.show();
					positionVolumeHandle(volume, true);
					volumeSlider.hide();
					return;
				}
				volume = Math.max(0,volume);
				volume = Math.min(volume,1);
				if (volume === 0) {
					mute.removeClass('mejs-mute').addClass('mejs-unmute');
				} else {
					mute.removeClass('mejs-unmute').addClass('mejs-mute');
				}
                var totalPosition = volumeTotal.position();
				if (mode == 'vertical') {
					var
						totalHeight = volumeTotal.height(),
						newTop = totalHeight - (totalHeight * volume);
					volumeHandle.css('top', Math.round(totalPosition.top + newTop - (volumeHandle.height() / 2)));
					volumeCurrent.height(totalHeight - newTop );
					volumeCurrent.css('top', totalPosition.top + newTop);
				} else {
                    var
						totalWidth = volumeTotal.width(),
						newLeft = totalWidth * volume;
					volumeHandle.css('left', Math.round(totalPosition.left + newLeft - (volumeHandle.width() / 2)));
					volumeCurrent.width( Math.round(newLeft) );
				}
			},
			handleVolumeMove = function(e) {
				var volume = null,
					totalOffset = volumeTotal.offset();
				if (mode === 'vertical') {
					var
						railHeight = volumeTotal.height(),
						totalTop = parseInt(volumeTotal.css('top').replace(/px/,''),10),
						newY = e.pageY - totalOffset.top;
					volume = (railHeight - newY) / railHeight;
					if (totalOffset.top === 0 || totalOffset.left === 0) {
						return;
                    }
				} else {
					var
						railWidth = volumeTotal.width(),
						newX = e.pageX - totalOffset.left;
					volume = newX / railWidth;
				}
				volume = Math.max(0,volume);
				volume = Math.min(volume,1);
				positionVolumeHandle(volume);
				if (volume === 0) {
					media.setMuted(true);
				} else {
					media.setMuted(false);
				}
				media.setVolume(volume);
			},
			mouseIsDown = false,
			mouseIsOver = false;
			mute
				.hover(function() {
					volumeSlider.show();
					mouseIsOver = true;
				}, function() {
					mouseIsOver = false;
					if (!mouseIsDown && mode == 'vertical')	{
						volumeSlider.hide();
					}
				});
            var updateVolumeSlider = function (e) {
                var volume = Math.floor(media.volume*100);
				volumeSlider.attr({
					'aria-label': mejs.i18n.t('volumeSlider'),
					'aria-valuemin': 0,
					'aria-valuemax': 100,
					'aria-valuenow': volume,
					'aria-valuetext': volume+'%',
					'role': 'slider',
					'tabindex': 0
				});
			};
			volumeSlider
				.bind('mouseover', function() {
					mouseIsOver = true;
				})
				.bind('mousedown', function (e) {
					handleVolumeMove(e);
					t.globalBind('mousemove.vol', function(e) {
						handleVolumeMove(e);
					});
					t.globalBind('mouseup.vol', function () {
						mouseIsDown = false;
						t.globalUnbind('.vol');
						if (!mouseIsOver && mode == 'vertical') {
							volumeSlider.hide();
						}
					});
					mouseIsDown = true;
					return false;
				})
				.bind('keydown', function (e) {
					var keyCode = e.keyCode;
					var volume = media.volume;
					switch (keyCode) {
                        case 38:
                            volume += 0.1;
                            break;
                        case 40:
                            volume = volume - 0.1;
                            break;
                        default:
                            return true;
                    }
					mouseIsDown = false;
					positionVolumeHandle(volume);
					media.setVolume(volume);
					return false;
				})
				.bind('blur', function () {
					volumeSlider.hide();
				});
			mute.find('button').click(function() {
				media.setMuted( !media.muted );
			});
            mute.find('button').bind('focus', function () {
				volumeSlider.show();
			});
			media.addEventListener('volumechange', function(e) {
				if (!mouseIsDown) {
					if (media.muted) {
						positionVolumeHandle(0);
						mute.removeClass('mejs-mute').addClass('mejs-unmute');
					} else {
						positionVolumeHandle(media.volume);
						mute.removeClass('mejs-unmute').addClass('mejs-mute');
					}
				}
				updateVolumeSlider(e);
			}, false);
			if (t.container.is(':visible')) {
				positionVolumeHandle(player.options.startVolume);
				if (player.options.startVolume === 0) {
					media.setMuted(true);
				}
				if (media.pluginType === 'native') {
					media.setVolume(player.options.startVolume);
				}
			}
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		usePluginFullScreen: true,
		newWindowCallback: function() { return '';},
		fullscreenText: mejs.i18n.t('Fullscreen')
	});
	$.extend(MediaElementPlayer.prototype, {
		isFullScreen: false,
		isNativeFullScreen: false,
		isInIframe: false,
		buildfullscreen: function(player, controls, layers, media) {
			if (!player.isVideo)
				return;
			player.isInIframe = (window.location != window.parent.location);
			if (mejs.MediaFeatures.hasTrueNativeFullScreen) {
				var func = function(e) {
					if (player.isFullScreen) {
						if (mejs.MediaFeatures.isFullScreen()) {
							player.isNativeFullScreen = true;
							player.setControlsSize();
						} else {
							player.isNativeFullScreen = false;
							player.exitFullScreen();
						}
					}
				};
				player.globalBind(mejs.MediaFeatures.fullScreenEventName, func);
			}
			var t = this,
				normalHeight = 0,
				normalWidth = 0,
				container = player.container,
				fullscreenBtn =
					$('<div class="mejs-button mejs-fullscreen-button">' +
						'<button type="button" aria-controls="' + t.id + '" title="' + t.options.fullscreenText + '" aria-label="' + t.options.fullscreenText + '"></button>' +
					'</div>')
					.appendTo(controls);
				if (t.media.pluginType === 'native' || (!t.options.usePluginFullScreen && !mejs.MediaFeatures.isFirefox)) {
					fullscreenBtn.click(function() {
						var isFullScreen = (mejs.MediaFeatures.hasTrueNativeFullScreen && mejs.MediaFeatures.isFullScreen()) || player.isFullScreen;
						if (isFullScreen) {
							player.exitFullScreen();
						} else {
							player.enterFullScreen();
						}
					});
				} else {
					var hideTimeout = null,
						supportsPointerEvents = (function() {
							var element = document.createElement('x'),
								documentElement = document.documentElement,
								getComputedStyle = window.getComputedStyle,
								supports;
							if(!('pointerEvents' in element.style)){
								return false;
							}
							element.style.pointerEvents = 'auto';
							element.style.pointerEvents = 'x';
							documentElement.appendChild(element);
							supports = getComputedStyle &&
								getComputedStyle(element, '').pointerEvents === 'auto';
							documentElement.removeChild(element);
							return !!supports;
						})();
					if (supportsPointerEvents && !mejs.MediaFeatures.isOpera) {
						var fullscreenIsDisabled = false,
							restoreControls = function() {
								if (fullscreenIsDisabled) {
									for (var i in hoverDivs) {
										hoverDivs[i].hide();
									}
									fullscreenBtn.css('pointer-events', '');
									t.controls.css('pointer-events', '');
									t.media.removeEventListener('click', t.clickToPlayPauseCallback);
									fullscreenIsDisabled = false;
								}
							},
							hoverDivs = {},
							hoverDivNames = ['top', 'left', 'right', 'bottom'],
							i, len,
							positionHoverDivs = function() {
								var fullScreenBtnOffsetLeft = fullscreenBtn.offset().left - t.container.offset().left,
									fullScreenBtnOffsetTop = fullscreenBtn.offset().top - t.container.offset().top,
									fullScreenBtnWidth = fullscreenBtn.outerWidth(true),
									fullScreenBtnHeight = fullscreenBtn.outerHeight(true),
									containerWidth = t.container.width(),
									containerHeight = t.container.height();
								for (i in hoverDivs) {
									hoverDivs[i].css({position: 'absolute', top: 0, left: 0});
								}
								hoverDivs['top']
									.width( containerWidth )
									.height( fullScreenBtnOffsetTop );
								hoverDivs['left']
									.width( fullScreenBtnOffsetLeft )
									.height( fullScreenBtnHeight )
									.css({top: fullScreenBtnOffsetTop});
								hoverDivs['right']
									.width( containerWidth - fullScreenBtnOffsetLeft - fullScreenBtnWidth )
									.height( fullScreenBtnHeight )
									.css({top: fullScreenBtnOffsetTop,
										 left: fullScreenBtnOffsetLeft + fullScreenBtnWidth});
								hoverDivs['bottom']
									.width( containerWidth )
									.height( containerHeight - fullScreenBtnHeight - fullScreenBtnOffsetTop )
									.css({top: fullScreenBtnOffsetTop + fullScreenBtnHeight});
							};
						t.globalBind('resize', function() {
							positionHoverDivs();
						});
						for (i = 0, len = hoverDivNames.length; i < len; i++) {
							hoverDivs[hoverDivNames[i]] = $('<div class="mejs-fullscreen-hover" />').appendTo(t.container).mouseover(restoreControls).hide();
						}
						fullscreenBtn.on('mouseover',function() {
							if (!t.isFullScreen) {
								var buttonPos = fullscreenBtn.offset(),
									containerPos = player.container.offset();
								media.positionFullscreenButton(buttonPos.left - containerPos.left, buttonPos.top - containerPos.top, false);
								fullscreenBtn.css('pointer-events', 'none');
								t.controls.css('pointer-events', 'none');
								t.media.addEventListener('click', t.clickToPlayPauseCallback);
								for (i in hoverDivs) {
									hoverDivs[i].show();
								}
								positionHoverDivs();
								fullscreenIsDisabled = true;
							}
						});
						media.addEventListener('fullscreenchange', function(e) {
							t.isFullScreen = !t.isFullScreen;
							if (t.isFullScreen) {
								t.media.removeEventListener('click', t.clickToPlayPauseCallback);
							} else {
								t.media.addEventListener('click', t.clickToPlayPauseCallback);
							}
							restoreControls();
						});
						t.globalBind('mousemove', function(e) {
							if (fullscreenIsDisabled) {
								var fullscreenBtnPos = fullscreenBtn.offset();
								if (e.pageY < fullscreenBtnPos.top || e.pageY > fullscreenBtnPos.top + fullscreenBtn.outerHeight(true) ||
									e.pageX < fullscreenBtnPos.left || e.pageX > fullscreenBtnPos.left + fullscreenBtn.outerWidth(true)
									) {
									fullscreenBtn.css('pointer-events', '');
									t.controls.css('pointer-events', '');
									fullscreenIsDisabled = false;
								}
							}
						});
					} else {
						fullscreenBtn
							.on('mouseover', function() {
								if (hideTimeout !== null) {
									clearTimeout(hideTimeout);
									delete hideTimeout;
								}
								var buttonPos = fullscreenBtn.offset(),
									containerPos = player.container.offset();
								media.positionFullscreenButton(buttonPos.left - containerPos.left, buttonPos.top - containerPos.top, true);
							})
							.on('mouseout', function() {
								if (hideTimeout !== null) {
									clearTimeout(hideTimeout);
									delete hideTimeout;
								}
								hideTimeout = setTimeout(function() {
									media.hideFullscreenButton();
								}, 1500);
							});
					}
				}
			player.fullscreenBtn = fullscreenBtn;
			t.globalBind('keydown',function (e) {
				if (((mejs.MediaFeatures.hasTrueNativeFullScreen && mejs.MediaFeatures.isFullScreen()) || t.isFullScreen) && e.keyCode == 27) {
					player.exitFullScreen();
				}
			});
		},
		cleanfullscreen: function(player) {
			player.exitFullScreen();
		},
        containerSizeTimeout: null,
		enterFullScreen: function() {
			var t = this;
			if (t.media.pluginType !== 'native' && (mejs.MediaFeatures.isFirefox || t.options.usePluginFullScreen)) {
				return;
			}
            $(document.documentElement).addClass('mejs-fullscreen');
			normalHeight = t.container.height();
			normalWidth = t.container.width();
			if (t.media.pluginType === 'native') {
				if (mejs.MediaFeatures.hasTrueNativeFullScreen) {
					mejs.MediaFeatures.requestFullScreen(t.container[0]);
					if (t.isInIframe) {
						setTimeout(function checkFullscreen() {
							if (t.isNativeFullScreen) {
								var zoomMultiplier = window["devicePixelRatio"] || 1;
								var percentErrorMargin = 0.002;
								var windowWidth = zoomMultiplier * $(window).width();
								var screenWidth = screen.width;
								var absDiff = Math.abs(screenWidth - windowWidth);
								var marginError = screenWidth * percentErrorMargin;
								if (absDiff > marginError) {
									t.exitFullScreen();
								} else {
									setTimeout(checkFullscreen, 500);
								}
							}
						}, 500);
					}
				} else if (mejs.MediaFeatures.hasSemiNativeFullScreen) {
					t.media.webkitEnterFullscreen();
					return;
				}
			}
			if (t.isInIframe) {
				var url = t.options.newWindowCallback(this);
				if (url !== '') {
					if (!mejs.MediaFeatures.hasTrueNativeFullScreen) {
						t.pause();
						window.open(url, t.id, 'top=0,left=0,width=' + screen.availWidth + ',height=' + screen.availHeight + ',resizable=yes,scrollbars=no,status=no,toolbar=no');
						return;
					} else {
						setTimeout(function() {
							if (!t.isNativeFullScreen) {
								t.pause();
								window.open(url, t.id, 'top=0,left=0,width=' + screen.availWidth + ',height=' + screen.availHeight + ',resizable=yes,scrollbars=no,status=no,toolbar=no');
							}
						}, 250);
					}
				}
			}
			t.container
				.addClass('mejs-container-fullscreen')
				.width('100%')
				.height('100%');
				t.containerSizeTimeout = setTimeout(function() {
					t.container.css({width: '100%', height: '100%'});
					t.setControlsSize();
				}, 500);
			if (t.media.pluginType === 'native') {
				t.$media
					.width('100%')
					.height('100%');
			} else {
				t.container.find('.mejs-shim')
					.width('100%')
					.height('100%');
					t.media.setVideoSize($(window).width(),$(window).height());
			}
			t.layers.children('div')
				.width('100%')
				.height('100%');
			if (t.fullscreenBtn) {
				t.fullscreenBtn
					.removeClass('mejs-fullscreen')
					.addClass('mejs-unfullscreen');
			}
			t.setControlsSize();
			t.isFullScreen = true;
			t.container.find('.mejs-captions-text').css('font-size', screen.width / t.width * 1.00 * 100 + '%');
			t.container.find('.mejs-captions-position').css('bottom', '45px');
		},
		exitFullScreen: function() {
			var t = this;
            clearTimeout(t.containerSizeTimeout);
			if (t.media.pluginType !== 'native' && mejs.MediaFeatures.isFirefox) {
				t.media.setFullscreen(false);
				return;
			}
			if (mejs.MediaFeatures.hasTrueNativeFullScreen && (mejs.MediaFeatures.isFullScreen() || t.isFullScreen)) {
				mejs.MediaFeatures.cancelFullScreen();
			}
            $(document.documentElement).removeClass('mejs-fullscreen');
			t.container
				.removeClass('mejs-container-fullscreen')
				.width(normalWidth)
				.height(normalHeight);
			if (t.media.pluginType === 'native') {
				t.$media
					.width(normalWidth)
					.height(normalHeight);
			} else {
				t.container.find('.mejs-shim')
					.width(normalWidth)
					.height(normalHeight);
				t.media.setVideoSize(normalWidth, normalHeight);
			}
			t.layers.children('div')
				.width(normalWidth)
				.height(normalHeight);
			t.fullscreenBtn
				.removeClass('mejs-unfullscreen')
				.addClass('mejs-fullscreen');
			t.setControlsSize();
			t.isFullScreen = false;
			t.container.find('.mejs-captions-text').css('font-size','');
			t.container.find('.mejs-captions-position').css('bottom', '');
		}
	});
})(mejs.$);
(function($) {
	$.extend(mejs.MepDefaults, {
		startLanguage: '',
		tracksText: mejs.i18n.t('Captions/Subtitles'),
		hideCaptionsButtonWhenEmpty: true,
		toggleCaptionsButtonWhenOnlyOne: false,
		slidesSelector: ''
	});
	$.extend(MediaElementPlayer.prototype, {
		hasChapters: false,
		buildtracks: function(player, controls, layers, media) {
			if (player.tracks.length === 0)
				return;
			var t = this,
				i,
				options = '';
			if (t.domNode.textTracks) {
				for (i = t.domNode.textTracks.length - 1; i >= 0; i--) {
					t.domNode.textTracks[i].mode = "hidden";
				}
			}
			player.chapters =
					$('<div class="mejs-chapters mejs-layer"></div>')
						.prependTo(layers).hide();
			player.captions =
					$('<div class="mejs-captions-layer mejs-layer"><div class="mejs-captions-position mejs-captions-position-hover" role="log" aria-live="assertive" aria-atomic="false"><span class="mejs-captions-text"></span></div></div>')
						.prependTo(layers).hide();
			player.captionsText = player.captions.find('.mejs-captions-text');
			player.captionsButton =
					$('<div class="mejs-button mejs-captions-button">'+
						'<button type="button" aria-controls="' + t.id + '" title="' + t.options.tracksText + '" aria-label="' + t.options.tracksText + '"></button>'+
						'<div class="mejs-captions-selector">'+
							'<ul>'+
								'<li>'+
									'<input type="radio" name="' + player.id + '_captions" id="' + player.id + '_captions_none" value="none" checked="checked" />' +
									'<label for="' + player.id + '_captions_none">' + mejs.i18n.t('None') +'</label>'+
								'</li>'	+
							'</ul>'+
						'</div>'+
					'</div>')
						.appendTo(controls);
			var subtitleCount = 0;
			for (i=0; i<player.tracks.length; i++) {
				if (player.tracks[i].kind == 'subtitles') {
					subtitleCount++;
				}
			}
			if (t.options.toggleCaptionsButtonWhenOnlyOne && subtitleCount == 1){
				player.captionsButton.on('click',function() {
					if (player.selectedTrack === null) {
						lang = player.tracks[0].srclang;
					} else {
						lang = 'none';
					}
					player.setTrack(lang);
				});
			} else {
				player.captionsButton.on( 'mouseenter focusin', function() {
					$(this).find('.mejs-captions-selector').css('visibility','visible');
				})
				.on('click','input[type=radio]',function() {
					lang = this.value;
					player.setTrack(lang);
				});
				player.captionsButton.on( 'mouseleave focusout', function() {
					$(this).find(".mejs-captions-selector").css("visibility","hidden");
				});
			}
			if (!player.options.alwaysShowControls) {
				player.container
					.bind('controlsshown', function () {
						player.container.find('.mejs-captions-position').addClass('mejs-captions-position-hover');
					})
					.bind('controlshidden', function () {
						if (!media.paused) {
							player.container.find('.mejs-captions-position').removeClass('mejs-captions-position-hover');
						}
					});
			} else {
				player.container.find('.mejs-captions-position').addClass('mejs-captions-position-hover');
			}
			player.trackToLoad = -1;
			player.selectedTrack = null;
			player.isLoadingTrack = false;
			for (i=0; i<player.tracks.length; i++) {
				if (player.tracks[i].kind == 'subtitles') {
					player.addTrackButton(player.tracks[i].srclang, player.tracks[i].label);
				}
			}
			player.loadNextTrack();
			media.addEventListener('timeupdate',function(e) {
				player.displayCaptions();
			}, false);
			if (player.options.slidesSelector !== '') {
				player.slidesContainer = $(player.options.slidesSelector);
				media.addEventListener('timeupdate',function(e) {
					player.displaySlides();
				}, false);
			}
			media.addEventListener('loadedmetadata', function(e) {
				player.displayChapters();
			}, false);
			player.container.hover(
				function () {
					if (player.hasChapters) {
						player.chapters.css('visibility','visible');
						player.chapters.fadeIn(200).height(player.chapters.find('.mejs-chapter').outerHeight());
					}
				},
				function () {
					if (player.hasChapters && !media.paused) {
						player.chapters.fadeOut(200, function() {
							$(this).css('visibility','hidden');
							$(this).css('display','block');
						});
					}
				});
			if (player.node.getAttribute('autoplay') !== null) {
				player.chapters.css('visibility','hidden');
			}
		},
		setTrack: function(lang){
			var t = this,
				i;
			if (lang == 'none') {
				t.selectedTrack = null;
				t.captionsButton.removeClass('mejs-captions-enabled');
			} else {
				for (i=0; i<t.tracks.length; i++) {
					if (t.tracks[i].srclang == lang) {
						if (t.selectedTrack === null)
							t.captionsButton.addClass('mejs-captions-enabled');
						t.selectedTrack = t.tracks[i];
						t.captions.attr('lang', t.selectedTrack.srclang);
						t.displayCaptions();
						break;
					}
				}
			}
		},
		loadNextTrack: function() {
			var t = this;
			t.trackToLoad++;
			if (t.trackToLoad < t.tracks.length) {
				t.isLoadingTrack = true;
				t.loadTrack(t.trackToLoad);
			} else {
				t.isLoadingTrack = false;
				t.checkForTracks();
			}
		},
		loadTrack: function(index){
			var
				t = this,
				track = t.tracks[index],
				after = function() {
					track.isLoaded = true;
					t.enableTrackButton(track.srclang, track.label);
					t.loadNextTrack();
				};
			$.ajax({
				url: track.src,
				dataType: "text",
				success: function(d) {
					if (typeof d == "string" && (/<tt\s+xml/ig).exec(d)) {
						track.entries = mejs.TrackFormatParser.dfxp.parse(d);
					} else {
						track.entries = mejs.TrackFormatParser.webvtt.parse(d);
					}
					after();
					if (track.kind == 'chapters') {
						t.media.addEventListener('play', function(e) {
							if (t.media.duration > 0) {
								t.displayChapters(track);
							}
						}, false);
					}
					if (track.kind == 'slides') {
						t.setupSlides(track);
					}
				},
				error: function() {
					t.loadNextTrack();
				}
			});
		},
		enableTrackButton: function(lang, label) {
			var t = this;
			if (label === '') {
				label = mejs.language.codes[lang] || lang;
			}
			t.captionsButton
				.find('input[value=' + lang + ']')
					.prop('disabled',false)
				.siblings('label')
					.html( label );
			if (t.options.startLanguage == lang) {
				$('#' + t.id + '_captions_' + lang).prop('checked', true).trigger('click');
			}
			t.adjustLanguageBox();
		},
		addTrackButton: function(lang, label) {
			var t = this;
			if (label === '') {
				label = mejs.language.codes[lang] || lang;
			}
			t.captionsButton.find('ul').append(
				$('<li>'+
					'<input type="radio" name="' + t.id + '_captions" id="' + t.id + '_captions_' + lang + '" value="' + lang + '" disabled="disabled" />' +
					'<label for="' + t.id + '_captions_' + lang + '">' + label + ' (loading)' + '</label>'+
				'</li>')
			);
			t.adjustLanguageBox();
			t.container.find('.mejs-captions-translations option[value=' + lang + ']').remove();
		},
		adjustLanguageBox:function() {
			var t = this;
			t.captionsButton.find('.mejs-captions-selector').height(
				t.captionsButton.find('.mejs-captions-selector ul').outerHeight(true) +
				t.captionsButton.find('.mejs-captions-translations').outerHeight(true)
			);
		},
		checkForTracks: function() {
			var
				t = this,
				hasSubtitles = false;
			if (t.options.hideCaptionsButtonWhenEmpty) {
				for (i=0; i<t.tracks.length; i++) {
					if (t.tracks[i].kind == 'subtitles') {
						hasSubtitles = true;
						break;
					}
				}
				if (!hasSubtitles) {
					t.captionsButton.hide();
					t.setControlsSize();
				}
			}
		},
		displayCaptions: function() {
			if (typeof this.tracks == 'undefined')
				return;
			var
				t = this,
				i,
				track = t.selectedTrack;
			if (track !== null && track.isLoaded) {
				for (i=0; i<track.entries.times.length; i++) {
					if (t.media.currentTime >= track.entries.times[i].start && t.media.currentTime <= track.entries.times[i].stop) {
						t.captionsText.html(track.entries.text[i]).attr('class', 'mejs-captions-text ' + (track.entries.times[i].identifier || ''));
						t.captions.show().height(0);
						return;
					}
				}
				t.captions.hide();
			} else {
				t.captions.hide();
			}
		},
		setupSlides: function(track) {
			var t = this;
			t.slides = track;
			t.slides.entries.imgs = [t.slides.entries.text.length];
			t.showSlide(0);
		},
		showSlide: function(index) {
			if (typeof this.tracks == 'undefined' || typeof this.slidesContainer == 'undefined') {
				return;
			}
			var t = this,
				url = t.slides.entries.text[index],
				img = t.slides.entries.imgs[index];
			if (typeof img == 'undefined' || typeof img.fadeIn == 'undefined') {
				t.slides.entries.imgs[index] = img = $('<img src="' + url + '">')
						.on('load', function() {
							img.appendTo(t.slidesContainer)
								.hide()
								.fadeIn()
								.siblings(':visible')
									.fadeOut();
						});
			} else {
				if (!img.is(':visible') && !img.is(':animated')) {
					img.fadeIn()
						.siblings(':visible')
							.fadeOut();
				}
			}
		},
		displaySlides: function() {
			if (typeof this.slides == 'undefined')
				return;
			var
				t = this,
				slides = t.slides,
				i;
			for (i=0; i<slides.entries.times.length; i++) {
				if (t.media.currentTime >= slides.entries.times[i].start && t.media.currentTime <= slides.entries.times[i].stop){
					t.showSlide(i);
					return;
				}
			}
		},
		displayChapters: function() {
			var
				t = this,
				i;
			for (i=0; i<t.tracks.length; i++) {
				if (t.tracks[i].kind == 'chapters' && t.tracks[i].isLoaded) {
					t.drawChapters(t.tracks[i]);
					t.hasChapters = true;
					break;
				}
			}
		},
		drawChapters: function(chapters) {
			var
				t = this,
				i,
				dur,
				percent = 0,
				usedPercent = 0;
			t.chapters.empty();
			for (i=0; i<chapters.entries.times.length; i++) {
				dur = chapters.entries.times[i].stop - chapters.entries.times[i].start;
				percent = Math.floor(dur / t.media.duration * 100);
				if (percent + usedPercent > 100 ||
					i == chapters.entries.times.length-1 && percent + usedPercent < 100)
					{
					percent = 100 - usedPercent;
				}
				t.chapters.append( $(
					'<div class="mejs-chapter" rel="' + chapters.entries.times[i].start + '" style="left: ' + usedPercent.toString() + '%;width: ' + percent.toString() + '%;">' +
						'<div class="mejs-chapter-block' + ((i==chapters.entries.times.length-1) ? ' mejs-chapter-block-last' : '') + '">' +
							'<span class="ch-title">' + chapters.entries.text[i] + '</span>' +
							'<span class="ch-time">' + mejs.Utility.secondsToTimeCode(chapters.entries.times[i].start) + '&ndash;' + mejs.Utility.secondsToTimeCode(chapters.entries.times[i].stop) + '</span>' +
						'</div>' +
					'</div>'));
				usedPercent += percent;
			}
			t.chapters.find('div.mejs-chapter').click(function() {
				t.media.setCurrentTime( parseFloat( $(this).attr('rel') ) );
				if (t.media.paused) {
					t.media.play();
				}
			});
			t.chapters.show();
		}
	});
	mejs.language = {
		codes:  {
			af:'Afrikaans',
			sq:'Albanian',
			ar:'Arabic',
			be:'Belarusian',
			bg:'Bulgarian',
			ca:'Catalan',
			zh:'Chinese',
			'zh-cn':'Chinese Simplified',
			'zh-tw':'Chinese Traditional',
			hr:'Croatian',
			cs:'Czech',
			da:'Danish',
			nl:'Dutch',
			en:'English',
			et:'Estonian',
			fl:'Filipino',
			fi:'Finnish',
			fr:'French',
			gl:'Galician',
			de:'German',
			el:'Greek',
			ht:'Haitian Creole',
			iw:'Hebrew',
			hi:'Hindi',
			hu:'Hungarian',
			is:'Icelandic',
			id:'Indonesian',
			ga:'Irish',
			it:'Italian',
			ja:'Japanese',
			ko:'Korean',
			lv:'Latvian',
			lt:'Lithuanian',
			mk:'Macedonian',
			ms:'Malay',
			mt:'Maltese',
			no:'Norwegian',
			fa:'Persian',
			pl:'Polish',
			pt:'Portuguese',
			ro:'Romanian',
			ru:'Russian',
			sr:'Serbian',
			sk:'Slovak',
			sl:'Slovenian',
			es:'Spanish',
			sw:'Swahili',
			sv:'Swedish',
			tl:'Tagalog',
			th:'Thai',
			tr:'Turkish',
			uk:'Ukrainian',
			vi:'Vietnamese',
			cy:'Welsh',
			yi:'Yiddish'
		}
	};
	mejs.TrackFormatParser = {
		webvtt: {
			pattern_timecode: /^((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{1,3})?) --\> ((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{3})?)(.*)$/,
			parse: function(trackText) {
				var
					i = 0,
					lines = mejs.TrackFormatParser.split2(trackText, /\r?\n/),
					entries = {text:[], times:[]},
					timecode,
					text,
					identifier;
				for(; i<lines.length; i++) {
					timecode = this.pattern_timecode.exec(lines[i]);
					if (timecode && i<lines.length) {
						if ((i - 1) >= 0 && lines[i - 1] !== '') {
							identifier = lines[i - 1];
						}
						i++;
						text = lines[i];
						i++;
						while(lines[i] !== '' && i<lines.length){
							text = text + '\n' + lines[i];
							i++;
						}
						text = $.trim(text).replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
						entries.text.push(text);
						entries.times.push(
						{
							identifier: identifier,
							start: (mejs.Utility.convertSMPTEtoSeconds(timecode[1]) === 0) ? 0.200 : mejs.Utility.convertSMPTEtoSeconds(timecode[1]),
							stop: mejs.Utility.convertSMPTEtoSeconds(timecode[3]),
							settings: timecode[5]
						});
					}
					identifier = '';
				}
				return entries;
			}
		},
		dfxp: {
			parse: function(trackText) {
				trackText = $(trackText).filter("tt");
				var
					i = 0,
					container = trackText.children("div").eq(0),
					lines = container.find("p"),
					styleNode = trackText.find("#" + container.attr("style")),
					styles,
					begin,
					end,
					text,
					entries = {text:[], times:[]};
				if (styleNode.length) {
					var attributes = styleNode.removeAttr("id").get(0).attributes;
					if (attributes.length) {
						styles = {};
						for (i = 0; i < attributes.length; i++) {
							styles[attributes[i].name.split(":")[1]] = attributes[i].value;
						}
					}
				}
				for(i = 0; i<lines.length; i++) {
					var style;
					var _temp_times = {
						start: null,
						stop: null,
						style: null
					};
					if (lines.eq(i).attr("begin")) _temp_times.start = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i).attr("begin"));
					if (!_temp_times.start && lines.eq(i-1).attr("end")) _temp_times.start = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i-1).attr("end"));
					if (lines.eq(i).attr("end")) _temp_times.stop = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i).attr("end"));
					if (!_temp_times.stop && lines.eq(i+1).attr("begin")) _temp_times.stop = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i+1).attr("begin"));
					if (styles) {
						style = "";
						for (var _style in styles) {
							style += _style + ":" + styles[_style] + ";";
						}
					}
					if (style) _temp_times.style = style;
					if (_temp_times.start === 0) _temp_times.start = 0.200;
					entries.times.push(_temp_times);
					text = $.trim(lines.eq(i).html()).replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
					entries.text.push(text);
					if (entries.times.start === 0) entries.times.start = 2;
				}
				return entries;
			}
		},
		split2: function (text, regex) {
			return text.split(regex);
		}
	};
	if ('x\n\ny'.split(/\n/gi).length != 3) {
		mejs.TrackFormatParser.split2 = function(text, regex) {
			var
				parts = [],
				chunk = '',
				i;
			for (i=0; i<text.length; i++) {
				chunk += text.substring(i,i+1);
				if (regex.test(chunk)) {
					parts.push(chunk.replace(regex, ''));
					chunk = '';
				}
			}
			parts.push(chunk);
			return parts;
		};
	}
})(mejs.$);
(function($) {
    $.extend(MediaElementPlayer.prototype, {
        buildtracking: function(player, controls, layers, media) {
            var t = this;
            if (typeof t.options.tracking != 'object') {
                return;
            }
            var requestTrackingPixel = function (url) {
                if (typeof url === 'string') {
                    url = [url];
                }
                if ($.isArray(url) === false) {
                    return;
                }
                for (var i = url.length - 1; i >= 0; i--) {
                    url[i] += (url[i].indexOf('?') + 1 ? '&' : '?') + 'ts=' + new Date().getTime();
                    new Image(1,1).src=url[i];
                };
            };
            t.media.addEventListener('play', function(e) {
                t.trackingInterval = 100;
                t.progressTracker = window.setInterval(function() {
                    var currentPos = t.media.currentTime / t.media.duration;
                    if (!t.trackingProgress0 && currentPos >= 0.01) {
                        if (!t.trackingProgress100) {
                            requestTrackingPixel(t.options.tracking.trackingUrlProgress0);
                            t.trackingProgress0 = true;
                        }
                        else {
                            requestTrackingPixel(t.options.tracking.trackingUrlReplay);
                            t.trackingProgress0 = true;
                        }
                    }
                    else if (!t.trackingProgress25 && currentPos >= 0.25) {
                        requestTrackingPixel(t.options.tracking.trackingUrlProgress25);
                        t.trackingProgress25 = true;
                    }
                    else if (!t.trackingProgress50 && currentPos >= 0.5) {
                        requestTrackingPixel(t.options.tracking.trackingUrlProgress50);
                        t.trackingProgress50 = true;
                    }
                    else if (!t.trackingProgress75 && currentPos >= 0.75) {
                        requestTrackingPixel(t.options.tracking.trackingUrlProgress75);
                        t.trackingProgress75 = true;
                    }
                }, t.trackingInterval);
            });
            t.media.addEventListener('ended', function(e) {
                if (!t.trackingProgress100) {
                    clearInterval(t.progressTracker);
                    requestTrackingPixel(t.options.tracking.trackingUrlProgress100);
                    t.trackingProgress100 = true;
                }
                t.trackingProgress0 = false;
            });
            t.media.addEventListener('pause', function(e) {
                clearInterval(t.progressTracker);
            });
            if (controls.find('.mejs-volume-button button').length) {
                controls.find('.mejs-volume-button button').on('click', function(){
                    if ($(this).parent().hasClass('mejs-unmute')) {
                        requestTrackingPixel(t.options.tracking.trackingUrlUnMute);
                    }
                    else if ($(this).parent().hasClass('mejs-mute')) {
                        requestTrackingPixel(t.options.tracking.trackingUrlMute);
                    }
                });
            }
            if (controls.find('.mejs-sourcechooser-button').length) {
                controls.find('.mejs-sourcechooser-button').on('click', function(){
                    if ($(this).find('button[data-switch-to-video-quality="hd"]').length) {
                        requestTrackingPixel(t.options.tracking.trackingUrlHdOff);
                    }
                    else if ($(this).find('button[data-switch-to-video-quality="sd"]').length) {
                        requestTrackingPixel(t.options.tracking.trackingUrlHdOn);
                    }
                });
            }
        }
    });
})(mejs.$);
(function($) {
    $.extend(MediaElementPlayer.prototype, {
        buildclickout: function(player, controls, layers, media) {
            var
                t = this,
                clickoutContent = t.container.find('div[rel="clickout"]').html();
            if (typeof clickoutContent !== 'undefined') {
                player.clickout =
                    $('<div class="mejs-postroll-layer mejs-layer"><div class="mejs-postroll-layer-content"></div></div>').prependTo(layers).hide();
                function showClickout() {
                    layers.find('.mejs-postroll-layer-content').html(clickoutContent);
                    player.clickout.show();
                    if (mejs.MediaFeatures.hasWebkitNativeFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (mejs.MediaFeatures.hasMozNativeFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (mejs.MediaFeatures.hasMsNativeFullScreen) {
                        document.msExitFullscreen();
                    }
                }
                t.media.addEventListener('ended', function (e) {
                    showClickout();
                }, false);
                if (/Android 4.4.2/.test(navigator.userAgent)) {
                    t.media.addEventListener('play', function(){
                        clearInterval(t.endedInterval);
                        t.endedInterval = setInterval(function(){
                            if (media.currentTime >= media.duration - 0.1) {
                                showClickout();
                                clearInterval(t.endedInterval);
                            }
                        }, 700);
                    });
                    t.media.addEventListener('pause', function(){
                        clearInterval(t.endedInterval);
                    });
                    t.media.addEventListener('ended', function () {
                        clearInterval(t.endedInterval);
                    });
                }
            }
        }
    });
})(mejs.$);
(function($, w) {
    $.extend(MediaElementPlayer.prototype, {
        buildpostMessageEvents: function(player, controls, layers, media) {
            function postMessageListener(e) {
                var data = JSON.parse(e.data);
                if (data.bannerId) {
                    if (data.events) {
                        var events = data.events ? data.events : ['loadstart', 'play','pause', 'ended'];
                        for (var i=0, il=events.length; i<il; i++) {
                            media.addEventListener(events[i], function(e) {
                                var dataToParent = JSON.stringify({
                                    'bannerId' : data.bannerId,
                                    'event': e.type
                                });
                                parent.postMessage(dataToParent, "*");
                            });
                        }
                    }
                    else if (data.executeEvent) {
                        if (data.executeEvent === 'pause') {
                            media.pause();
                        }
                        if (data.executeEvent === 'play') {
                            media.play();
                        }
                    }
                }
            }
            if (w.addEventListener) {
                w.addEventListener("message", postMessageListener, false);
            } else {
                w.attachEvent("onmessage", postMessageListener)
            }
        }
    });
})(mejs.$, window);
(function($) {
    $.extend(mejs.MepDefaults, {
        sourcechooserTextHd: 'Zu HD Qualität wechseln',
        sourcechooserTextSd: 'Zu normaler Qualität wechseln'
    });
    $.extend(MediaElementPlayer.prototype, {
        buildsourcechooser: function(player, controls, layers, media) {
            var t = this;
            t.initialVideoSrc         = $('#' + player.id + ' source[src="'+ $(media).attr('src') +'"]')[0];
            t.initialVideoSrcType     = t.initialVideoSrc.type;
            t.initialVideoSrcQuality  = $(t.initialVideoSrc).data('video-quality');
            t.newVideo                = $('#' + player.id + ' source[type="'+ t.initialVideoSrcType +'"]:not([src="'+ $(media).attr('src') +'"][data-video-quality="'+ t.initialVideoSrcQuality +'"])');
            t.newVideoSrc             = t.newVideo.attr('src');
            t.newVideoQuality         = t.newVideo.attr('data-video-quality');
            if (!t.newVideoSrc) {return;}
            $(media)
                .attr('data-video-quality', t.initialVideoSrcQuality)
                .attr('data-video-type', t.initialVideoSrcType);
            if (t.initialVideoSrcQuality === 'sd') {
                t.options.sourcechooserText     = t.options.sourcechooserTextHd;
                t.options.sourcechooserTextAlt  = t.options.sourcechooserTextSd;
            }
            else {
                t.options.sourcechooserText     = t.options.sourcechooserTextSd;
                t.options.sourcechooserTextAlt  = t.options.sourcechooserTextHd;
            }
            player.sourcechooserButton =
                $('<div class="mejs-button mejs-sourcechooser-button">'+
                    '<button type="button" aria-controls="' + t.id + '" title="' + t.options.sourcechooserText + '" aria-label="' + t.options.sourcechooserText + '" data-switch-to-label="'+ t.options.sourcechooserTextAlt +'" value="'+ t.newVideoSrc +'" data-alt-video-src="'+  $(t.initialVideoSrc).attr("src")  +'" data-switch-to-video-quality="'+ t.newVideoQuality +'" data-current-video-quality="'+ t.initialVideoSrcQuality +'"></button>'+
                '</div>')
                    .appendTo(controls)
                    .delegate('button', 'click', function() {
                        var src                 = this.value,
                            newVideoQuality     = $(this).attr('data-switch-to-video-quality'),
                            currentVideoQuality = $(this).attr('data-current-video-quality'),
                            currentButtonText   = $(this).attr('aria-label'),
                            newButtonText       = $(this).attr('data-switch-to-label');
                        if (media.currentSrc != src) {
                            currentTime = media.currentTime;
                            paused = media.paused;
                            media.setSrc(src);
                            media.load();
                            media.addEventListener('loadedmetadata', function(e) {
                                media.currentTime = currentTime;
                                if (this.currentTime !== currentTime && this.currentTime == 1) {
                                    var currentTimeInterval = window.setInterval(function(){
                                        media.currentTime = currentTime;
                                        if (media.currentTime === currentTime) {
                                            window.clearInterval(currentTimeInterval);
                                        }
                                    }, 50);
                                }
                            }, true);
                            media.addEventListener('ended', function(e){
                               paused = true;
                            }, true);
                            media.addEventListener('canplay', function(e){
                                if (!paused) {
                                    this.play();
                                }
                            }, true);
                        }
                        this.value = $(this).attr('data-alt-video-src');
                        $(this).attr({
                            'data-alt-video-src'            : src,
                            'data-current-video-quality'    : newVideoQuality,
                            'data-switch-to-video-quality'  : currentVideoQuality,
                            'title'                         : newButtonText,
                            'aria-label'                    : newButtonText,
                            'data-switch-to-label'          : currentButtonText
                        });
                    });
        }
    });
})(mejs.$);
(function($, w) {
    $.extend(MediaElementPlayer.prototype, {
        buildexternalResize: function(player, controls, layers, media) {
            $(document).on('externalResize', function(){
                $(window).trigger('resize');
            });
        }
    });
})(mejs.$, window);
PageLayout.onchange(function (alignment, cols) {
    if (parseInt(cols) === 2) {
        $('.wrapper-center.first + .wrapper-center .wrapper-indent > .news-fullsize:last').show();
    } else {
        $('.wrapper-center.first + .wrapper-center .wrapper-indent > .news-fullsize:last').hide();
    }
    moveMaxiAd(cols);
});
var moveMaxiAd = function (cols) {
    var width = $('.wrapper-center.first').width();
    var useCols = 4;
    if (width <= 1002) {
        useCols = 3;
    }
    var isMaxiAd = $('#maxiadcontent').length;
    if (useCols === 3 && isMaxiAd > 0) {
        var $anchorContainer = $('.teaser.news.multi-news.hero');
        var $containerToMove = $('.teaser.news.multi-news:eq(1)');
        if ($anchorContainer.next()[0] !== $containerToMove[0]) {
            $anchorContainer.after($containerToMove);
        }
    }
    if (useCols === 4 && isMaxiAd > 0) {
        var $anchorContainer = $('#maxiadcontent-position');
        var $containerToMove = $('.teaser.news.multi-news:eq(1)');
        if ($anchorContainer.prev()[0] !== $containerToMove[0]) {
            $anchorContainer.before($containerToMove);
        }
    }
};